/*
    AUTOGENERATED - DO NOT EDIT: this file is auto-generated by the local type agent.
    @Copyright 2015 ORCA Intel orca-intel.com All Rights Reserved.
*/

RQImported = RQImport.Import(
     null
    ,null
);

RQService
    = { };

RQService.Auth
    = { };

RQService.Auth.RQLogin
    = RQImported.RQLogin;

RQService.Auth.PopulateRQLoginRow = function (row) {
    var entry = { };

    entry.IsAuthenticated            = row.IsAuthenticated;
    entry.RQueryAuthToken            = row.RQueryAuthToken;
    entry.RQueryAPIKey               = row.RQueryAPIKey;
    entry.EntityTypeID               = row.EntityTypeID;
    entry.EntityGroupID              = row.EntityGroupID;
    entry.EntityID                   = row.EntityID;
    entry.RoleID                     = row.RoleID;
    entry.AccountID                  = row.AccountID;
    entry.AccountName                = row.AccountName;
    entry.HasExtendedRolePermissions = row.HasExtendedRolePermissions;
    entry.AccountNotFound            = row.AccountNotFound;
    entry.BadCredentials             = row.BadCredentials;

    return entry;
};

RQService.Auth.RQSession
    = RQImported.RQSession;

RQService.Auth.PopulateRQSessionRow = function (row) {
    var entry = { };

    entry.IsAuthenticated            = row.IsAuthenticated;
    entry.RQueryAuthToken            = row.RQueryAuthToken;
    entry.RQueryAPIKey               = row.RQueryAPIKey;
    entry.EntityTypeID               = row.EntityTypeID;
    entry.EntityGroupID              = row.EntityGroupID;
    entry.EntityID                   = row.EntityID;
    entry.RoleID                     = row.RoleID;
    entry.AccountID                  = row.AccountID;
    entry.AccountName                = row.AccountName;
    entry.HasExtendedRolePermissions = row.HasExtendedRolePermissions;
    entry.AccountNotFound            = row.AccountNotFound;
    entry.BadCredentials             = row.BadCredentials;

    return entry;
};

RQService.Auth.RQConfig
    = RQImported.RQConfig;

RQService.Auth.PopulateRQConfigRow = function (row) {
    var entry = { };

    entry.APIKeyFound       = row.APIKeyFound;
    entry.EntityTypeID      = row.EntityTypeID;
    entry.EntityGroupID     = row.EntityGroupID;
    entry.EntityID          = row.EntityID;
    entry.RoleID            = row.RoleID;
    entry.AccountID         = row.AccountID;
    entry.AccountName       = row.AccountName;
    entry.LangID            = row.LangID;
    entry.ApplicationTypeID = row.ApplicationTypeID;
    entry.FormFactorTypeID  = row.FormFactorTypeID;
    entry.HasExtendedConfig = row.HasExtendedConfig;
    entry.IsDebugClient     = row.IsDebugClient;

    return entry;
};

RQService.Auth.RQLogout
    = RQImported.RQLogout;

RQService.Auth.PopulateRQLogoutRow = function (row) {
    var entry = { };

    entry.LoggedOutOK = row.LoggedOutOK;

    return entry;
};

RQService.Extensions
    = { };

RQService.Extensions.TranslateDescription
    = RQImported.ExtensionsTranslateDescription;

RQService.Extensions.MakeGroupBooking
    = RQImported.ExtensionsMakeGroupBooking;

RQService.Extensions.CancelBooking
    = RQImported.ExtensionsCancelBooking;

RQService.Extensions.UploadHotelPhoto
    = RQImported.ExtensionsUploadHotelPhoto;

RQService.Extensions.UploadUserPhoto
    = RQImported.ExtensionsUploadUserPhoto;

RQService.Extensions.UploadUserPhotoDirect
    = RQImported.ExtensionsUploadUserPhotoDirect;

RQService.Extensions.UploadHotelMap
    = RQImported.ExtensionsUploadHotelMap;

RQService.Extensions.UploadHotelDoc
    = RQImported.ExtensionsUploadHotelDoc;

RQService.Extensions.RetrieveProfilePicture
    = RQImported.ExtensionsRetrieveProfilePicture;

RQService.Extensions.MakePayment
    = RQImported.ExtensionsMakePayment;

RQService.Extensions.PopulateUploadHotelPhotoRow = function (row) {
    var entry = { };

    entry.FileID            = row.FileID;
    entry.FileLength        = row.FileLength;
    entry.FileName          = row.FileName;
    entry.FileUploadedOK    = row.FileUploadedOK;
    entry.FileUploadErrorNo = row.FileUploadErrorNo;
    entry.FileUploadError   = row.FileUploadError;

    return entry;
};

RQService.Extensions.PopulateUploadUserPhotoRow = function (row) {
    var entry = { };

    entry.FileID            = row.FileID;
    entry.FileLength        = row.FileLength;
    entry.FileName          = row.FileName;
    entry.FileUploadedOK    = row.FileUploadedOK;
    entry.FileUploadErrorNo = row.FileUploadErrorNo;
    entry.FileUploadError   = row.FileUploadError;

    return entry;
};

RQService.Extensions.PopulateUploadHotelMapRow = function (row) {
    var entry = { };

    entry.FileID            = row.FileID;
    entry.FileLength        = row.FileLength;
    entry.FileName          = row.FileName;
    entry.FileUploadedOK    = row.FileUploadedOK;
    entry.FileUploadErrorNo = row.FileUploadErrorNo;
    entry.FileUploadError   = row.FileUploadError;

    return entry;
};

RQService.Extensions.PopulateUploadHotelDocRow = function (row) {
    var entry = { };

    entry.FileID            = row.FileID;
    entry.FileLength        = row.FileLength;
    entry.FileName          = row.FileName;
    entry.FileUploadedOK    = row.FileUploadedOK;
    entry.FileUploadErrorNo = row.FileUploadErrorNo;
    entry.FileUploadError   = row.FileUploadError;

    return entry;
};

RQService.Pms
    = { };

RQService.Pms.AcceptAvUpdateDaysViaGrid
    = RQImported.PmsAcceptAvUpdateDaysViaGrid;

RQService.Pms.AcceptAvUpdateDaysViaManualEntry
    = RQImported.PmsAcceptAvUpdateDaysViaManualEntry;

RQService.Pms.AcceptRateUpdateDaysViaManualEntry
    = RQImported.PmsAcceptRateUpdateDaysViaManualEntry;

RQService.Pms.AcceptRateUpdateDaysViaManualEntryFull
    = RQImported.PmsAcceptRateUpdateDaysViaManualEntryFull;

RQService.Pms.AcceptRateUpdateWeekDaysViaManualEntry
    = RQImported.PmsAcceptRateUpdateWeekDaysViaManualEntry;

RQService.Pms.AcceptRateUpdateWeekDaysViaManualEntryFull
    = RQImported.PmsAcceptRateUpdateWeekDaysViaManualEntryFull;

RQService.Pms.AdaptLocalAllotment
    = RQImported.PmsAdaptLocalAllotment;

RQService.Pms.AdaptLocalStopSell
    = RQImported.PmsAdaptLocalStopSell;

RQService.Pms.AlertModificationHavingLocalPMSEdit
    = RQImported.PmsAlertModificationHavingLocalPMSEdit;

RQService.Pms.AlterDailyPriceInfo
    = RQImported.PmsAlterDailyPriceInfo;

RQService.Pms.AlterRoomReservationStatus
    = RQImported.PmsAlterRoomReservationStatus;

RQService.Pms.AlterRoomTypeStopSell
    = RQImported.PmsAlterRoomTypeStopSell;

RQService.Pms.AppendToReservationNotes
    = RQImported.PmsAppendToReservationNotes;

RQService.Pms.AssignGuestToReservation
    = RQImported.PmsAssignGuestToReservation;

RQService.Pms.AssignGuestToRoomByRoomReservation
    = RQImported.PmsAssignGuestToRoomByRoomReservation;

RQService.Pms.AssignPartnerToChannel
    = RQImported.PmsAssignPartnerToChannel;

RQService.Pms.AssignReservationToOwningGuest
    = RQImported.PmsAssignReservationToOwningGuest;

RQService.Pms.AssignRoomReservationToOwningGuest
    = RQImported.PmsAssignRoomReservationToOwningGuest;

RQService.Pms.AttachRoomReservationSegment
    = RQImported.PmsAttachRoomReservationSegment;

RQService.Pms.AuthenticateAdminPassword
    = RQImported.PmsAuthenticateAdminPassword;

RQService.Pms.PopulateAuthenticateAdminPasswordRow = function (row) {
    var entry = { };

    entry.AdminOK  = row.AdminOK;

    return entry;
};

RQService.Pms.BackupDataBase
    = RQImported.PmsBackupDataBase;

RQService.Pms.BlockOutOfOrderRoom
    = RQImported.PmsBlockOutOfOrderRoom;

RQService.Pms.CancelReservation
    = RQImported.PmsCancelReservation;

RQService.Pms.CancelRoomReservation
    = RQImported.PmsCancelRoomReservation;

RQService.Pms.CheckAvailability
    = RQImported.PmsCheckAvailability;

RQService.Pms.PopulateCheckAvailabilityRow = function (row) {
    var entry = { };

    entry.Availability  = row.Availability;

    return entry;
};

RQService.Pms.CheckAvailabilityMove
    = RQImported.PmsCheckAvailabilityMove;

RQService.Pms.PopulateCheckAvailabilityMoveRow = function (row) {
    var entry = { };

    entry.AvailabilityMoveOK  = row.AvailabilityMoveOK;

    return entry;
};

RQService.Pms.CheckAvailableRooms
    = RQImported.PmsCheckAvailableRooms;

RQService.Pms.PopulateCheckAvailableRoomsRow = function (row) {
    var entry = { };

    entry.RoomID                 = row.RoomID;
    entry.RoomNumber             = row.RoomNumber;
    entry.RoomTypeID             = row.RoomTypeID;
    entry.RoomTypeName           = row.RoomTypeName;
    entry.RoomTypeAvailability   = row.RoomTypeAvailability;
    entry.ResultHasMNRates       = row.ResultHasMNRates;
    entry.RoomTypeHasMNRates     = row.RoomTypeHasMNRates;
    entry.MaxPersons             = row.MaxPersons;
    entry.MaxPersonsRateName     = row.MaxPersonsRateName;
    entry.PersonsNormal          = row.PersonsNormal;
    entry.Selected               = row.Selected;
    entry.Total                  = row.Total;
    entry.IsAvailable            = row.IsAvailable;
    entry.CanMakeSplitSwap       = row.CanMakeSplitSwap;
    entry.OfferCoversPeriod      = row.OfferCoversPeriod;
    entry.RateCoversPeriod       = row.RateCoversPeriod;
    entry.CapacityCoversRequest  = row.CapacityCoversRequest;
    entry.InsufficientAllotment  = row.InsufficientAllotment;
    entry.MLOS                   = row.MLOS;
    entry.MaxStay                = row.MaxStay;
    entry.NoArr                  = row.NoArr;
    entry.NoDep                  = row.NoDep;
    entry.AdvanceDays            = row.AdvanceDays;

    return entry;
};

RQService.Pms.CheckInRoomReservation
    = RQImported.PmsCheckInRoomReservation;

RQService.Pms.CheckOfferTypeCacheDataStatus
    = RQImported.PmsCheckOfferTypeCacheDataStatus;

RQService.Pms.PopulateCheckOfferTypeCacheDataStatusRow = function (row) {
    var entry = { };

    entry.OfferTypeID   = row.OfferTypeID;
    entry.HasCacheData  = row.HasCacheData;

    return entry;
};

RQService.Pms.CheckOutRoomReservation
    = RQImported.PmsCheckOutRoomReservation;

RQService.Pms.CheckResConstraints
    = RQImported.PmsCheckResConstraints;

RQService.Pms.PopulateCheckResConstraintsRow = function (row) {
    var entry = { };

    entry.InvalidParams          = row.InvalidParams;
    entry.OfferCoversPeriod      = row.OfferCoversPeriod;
    entry.RateCoversPeriod       = row.RateCoversPeriod;
    entry.CapacityCoversRequest  = row.CapacityCoversRequest;
    entry.InsufficientAllotment  = row.InsufficientAllotment;
    entry.MLOS                   = row.MLOS;
    entry.MaxStay                = row.MaxStay;
    entry.NoArr                  = row.NoArr;
    entry.NoDep                  = row.NoDep;
    entry.AdvanceDays            = row.AdvanceDays;

    return entry;
};

RQService.Pms.CheckRoomAvailability
    = RQImported.PmsCheckRoomAvailability;

RQService.Pms.PopulateCheckRoomAvailabilityRow = function (row) {
    var entry = { };

    entry.Availability  = row.Availability;

    return entry;
};

RQService.Pms.CheckRoomTypeCacheDataStatus
    = RQImported.PmsCheckRoomTypeCacheDataStatus;

RQService.Pms.PopulateCheckRoomTypeCacheDataStatusRow = function (row) {
    var entry = { };

    entry.RoomTypeID    = row.RoomTypeID;
    entry.HasCacheData  = row.HasCacheData;

    return entry;
};

RQService.Pms.ConfirmOTAReservationRetrieval
    = RQImported.PmsConfirmOTAReservationRetrieval;

RQService.Pms.ConfirmOTAReservationRetrievalWithToken
    = RQImported.PmsConfirmOTAReservationRetrievalWithToken;

RQService.Pms.ConfirmReservation
    = RQImported.PmsConfirmReservation;

RQService.Pms.CountPendingChannelActions
    = RQImported.PmsCountPendingChannelActions;

RQService.Pms.PopulateCountPendingChannelActionsRow = function (row) {
    var entry = { };

    entry.NumPending  = row.NumPending;

    return entry;
};

RQService.Pms.CreateAccount
    = RQImported.PmsCreateAccount;

RQService.Pms.CreateOrChangeGuiMessage
    = RQImported.PmsCreateOrChangeGuiMessage;

RQService.Pms.PopulateCreateOrChangeGuiMessageRow = function (row) {
    var entry = { };

    entry.GuiMessageID  = row.GuiMessageID;

    return entry;
};

RQService.Pms.CreateOrEditCPolicyByOfferType
    = RQImported.PmsCreateOrEditCPolicyByOfferType;

RQService.Pms.CreateOrGetFormElementID
    = RQImported.PmsCreateOrGetFormElementID;

RQService.Pms.PopulateCreateOrGetFormElementIDRow = function (row) {
    var entry = { };

    entry.FormElementID  = row.FormElementID;

    return entry;
};

RQService.Pms.CreateOrGetFormID
    = RQImported.PmsCreateOrGetFormID;

RQService.Pms.PopulateCreateOrGetFormIDRow = function (row) {
    var entry = { };

    entry.FormID  = row.FormID;

    return entry;
};

RQService.Pms.DeleteAddons
    = RQImported.PmsDeleteAddons;

RQService.Pms.DeleteExhibitionPeriod
    = RQImported.PmsDeleteExhibitionPeriod;

RQService.Pms.DeleteOfferType
    = RQImported.PmsDeleteOfferType;

RQService.Pms.DeletePartner
    = RQImported.PmsDeletePartner;

RQService.Pms.DeleteRackRatePeriod
    = RQImported.PmsDeleteRackRatePeriod;

RQService.Pms.DeleteReservationInCreation
    = RQImported.PmsDeleteReservationInCreation;

RQService.Pms.DeleteRoom
    = RQImported.PmsDeleteRoom;

RQService.Pms.DeleteRoomPeriodNote
    = RQImported.PmsDeleteRoomPeriodNote;

RQService.Pms.DeleteRoomReservation
    = RQImported.PmsDeleteRoomReservation;

RQService.Pms.DeleteRoomType
    = RQImported.PmsDeleteRoomType;

RQService.Pms.DeleteRoomTypeName
    = RQImported.PmsDeleteRoomTypeName;

RQService.Pms.DeleteSMTPServer
    = RQImported.PmsDeleteSMTPServer;

RQService.Pms.DeleteTemplate
    = RQImported.PmsDeleteTemplate;

RQService.Pms.DeleteUser
    = RQImported.PmsDeleteUser;

RQService.Pms.DetachRoomReservationSegment
    = RQImported.PmsDetachRoomReservationSegment;

RQService.Pms.DowngradeRoomResWithExpiredHoldUntil
    = RQImported.PmsDowngradeRoomResWithExpiredHoldUntil;

RQService.Pms.PopulateDowngradeRoomResWithExpiredHoldUntilRow = function (row) {
    var entry = { };

    entry.NumExpiredRoomRes  = row.NumExpiredRoomRes;

    return entry;
};

RQService.Pms.EditCustomer
    = RQImported.PmsEditCustomer;

RQService.Pms.EditCustomerPassword
    = RQImported.PmsEditCustomerPassword;

RQService.Pms.EditExhibitionPeriod
    = RQImported.PmsEditExhibitionPeriod;

RQService.Pms.EditExternalReservationID
    = RQImported.PmsEditExternalReservationID;

RQService.Pms.EditGuest
    = RQImported.PmsEditGuest;

RQService.Pms.EditHotelDetails
    = RQImported.PmsEditHotelDetails;

RQService.Pms.EditHotelFinancialDetails
    = RQImported.PmsEditHotelFinancialDetails;

RQService.Pms.EditHotelPassword
    = RQImported.PmsEditHotelPassword;

RQService.Pms.EditMLViewText
    = RQImported.PmsEditMLViewText;

RQService.Pms.EditNumPersonsStaying
    = RQImported.PmsEditNumPersonsStaying;

RQService.Pms.EditOfferType
    = RQImported.PmsEditOfferType;

RQService.Pms.EditOfferTypeAsDiscount
    = RQImported.PmsEditOfferTypeAsDiscount;

RQService.Pms.EditOfferTypeName
    = RQImported.PmsEditOfferTypeName;

RQService.Pms.EditPartner
    = RQImported.PmsEditPartner;

RQService.Pms.EditPriorityNotes
    = RQImported.PmsEditPriorityNotes;

RQService.Pms.EditRackRate
    = RQImported.PmsEditRackRate;

RQService.Pms.EditRackRateFilterAllotment
    = RQImported.PmsEditRackRateFilterAllotment;

RQService.Pms.EditRackRatePeriod
    = RQImported.PmsEditRackRatePeriod;

RQService.Pms.EditReservationDetails
    = RQImported.PmsEditReservationDetails;

RQService.Pms.EditReservationPartner
    = RQImported.PmsEditReservationPartner;

RQService.Pms.EditRoom
    = RQImported.PmsEditRoom;

RQService.Pms.EditRoomPeriodNote
    = RQImported.PmsEditRoomPeriodNote;

RQService.Pms.EditRoomReservationParams
    = RQImported.PmsEditRoomReservationParams;

RQService.Pms.EditRoomType
    = RQImported.PmsEditRoomType;

RQService.Pms.EditRoomTypeName
    = RQImported.PmsEditRoomTypeName;

RQService.Pms.EditRoomTypeNameAndParams
    = RQImported.PmsEditRoomTypeNameAndParams;

RQService.Pms.EditSMTPServer
    = RQImported.PmsEditSMTPServer;

RQService.Pms.EditTemplate
    = RQImported.PmsEditTemplate;

RQService.Pms.EditThirdPartyRoomReservationParams
    = RQImported.PmsEditThirdPartyRoomReservationParams;

RQService.Pms.EditUser
    = RQImported.PmsEditUser;

RQService.Pms.ExistBrokenRes
    = RQImported.PmsExistBrokenRes;

RQService.Pms.PopulateExistBrokenResRow = function (row) {
    var entry = { };

    entry.ExistBrokenRes  = row.ExistBrokenRes;

    return entry;
};

RQService.Pms.ExistNewNotifications
    = RQImported.PmsExistNewNotifications;

RQService.Pms.PopulateExistNewNotificationsRow = function (row) {
    var entry = { };

    entry.ExistNewNotifications  = row.ExistNewNotifications;

    return entry;
};

RQService.Pms.ExistUnverifiedNotifications
    = RQImported.PmsExistUnverifiedNotifications;

RQService.Pms.PopulateExistUnverifiedNotificationsRow = function (row) {
    var entry = { };

    entry.ExistUnverifiedNotifications  = row.ExistUnverifiedNotifications;

    return entry;
};

RQService.Pms.FinaliseFormTextExtractionPass
    = RQImported.PmsFinaliseFormTextExtractionPass;

RQService.Pms.GetActiveBookingDotComReservations
    = RQImported.PmsGetActiveBookingDotComReservations;

RQService.Pms.PopulateGetActiveBookingDotComReservationsRow = function (row) {
    var entry = { };

    entry.ReservationID          = row.ReservationID;
    entry.ExternalReservationID  = row.ExternalReservationID;

    return entry;
};

RQService.Pms.GetActiveMonitoredHotels
    = RQImported.PmsGetActiveMonitoredHotels;

RQService.Pms.PopulateGetActiveMonitoredHotelsRow = function (row) {
    var entry = { };

    entry.HotelID                              = row.HotelID;
    entry.Active                               = row.Active;
    entry.ServiceTypeID                        = row.ServiceTypeID;
    entry.IsMonitored                          = row.IsMonitored;
    entry.HotelName                            = row.HotelName;
    entry.Title                                = row.Title;
    entry.PostCode                             = row.PostCode;
    entry.Address                              = row.Address;
    entry.Location                             = row.Location;
    entry.CountryID                            = row.CountryID;
    entry.PhoneICode                           = row.PhoneICode;
    entry.PhoneNumber                          = row.PhoneNumber;
    entry.FaxICode                             = row.FaxICode;
    entry.FaxNumber                            = row.FaxNumber;
    entry.Email                                = row.Email;
    entry.Web                                  = row.Web;
    entry.ChamberOfCommerceNumber              = row.ChamberOfCommerceNumber;
    entry.FiscalNumber                         = row.FiscalNumber;
    entry.BankIBAN1                            = row.BankIBAN1;
    entry.BankSwift1                           = row.BankSwift1;
    entry.BankLocation1                        = row.BankLocation1;
    entry.BankCountryID1                       = row.BankCountryID1;
    entry.BankIBAN2                            = row.BankIBAN2;
    entry.BankSwift2                           = row.BankSwift2;
    entry.BankLocation2                        = row.BankLocation2;
    entry.BankCountryID2                       = row.BankCountryID2;
    entry.FiscalPostCode                       = row.FiscalPostCode;
    entry.FiscalAddress                        = row.FiscalAddress;
    entry.FiscalLocation                       = row.FiscalLocation;
    entry.FiscalCountryID                      = row.FiscalCountryID;
    entry.DefaultCheckOutTime                  = row.DefaultCheckOutTime;
    entry.PermissiveReconfirmationConstraints  = row.PermissiveReconfirmationConstraints;
    entry.HasThermalPrinter                    = row.HasThermalPrinter;
    entry.BackupDirectory                      = row.BackupDirectory;
    entry.IsEngineCustomer                     = row.IsEngineCustomer;
    entry.LocationGeoCodeID                    = row.LocationGeoCodeID;
    entry.Classification                       = row.Classification;
    entry.RateEntryTypeID                      = row.RateEntryTypeID;
    entry.TurnoverProjectionByDep              = row.TurnoverProjectionByDep;
    entry.HasTurkishPoliceReport               = row.HasTurkishPoliceReport;
    entry.TrFacilityCode                       = row.TrFacilityCode;
    entry.TrPoliceReportProgram                = row.TrPoliceReportProgram;
    entry.TrPoliceReportProgramVersion         = row.TrPoliceReportProgramVersion;
    entry.CountryCode                          = row.CountryCode;
    entry.Country                              = row.Country;
    entry.FiscalCountry                        = row.FiscalCountry;
    entry.BankCountry1                         = row.BankCountry1;
    entry.BankCountry2                         = row.BankCountry2;
    entry.RateEntryIncludesProductSpread       = row.RateEntryIncludesProductSpread;
    entry.CVCRequired                          = row.CVCRequired;
    entry.DeriveRatesFromTobookCache           = row.DeriveRatesFromTobookCache;

    return entry;
};

RQService.Pms.GetActiveRemotePartners
    = RQImported.PmsGetActiveRemotePartners;

RQService.Pms.PopulateGetActiveRemotePartnersRow = function (row) {
    var entry = { };

    entry.HotelID                     = row.HotelID;
    entry.PartnerID                   = row.PartnerID;
    entry.Partner                     = row.Partner;
    entry.Expired                     = row.Expired;
    entry.Builtin                     = row.Builtin;
    entry.IsRemote                    = row.IsRemote;
    entry.RemotePropertyID            = row.RemotePropertyID;
    entry.SupportsMLOS                = row.SupportsMLOS;
    entry.SupportsMaxStay             = row.SupportsMaxStay;
    entry.SupportsAdvanceDays         = row.SupportsAdvanceDays;
    entry.SupportsNoArr               = row.SupportsNoArr;
    entry.SupportsNoDep               = row.SupportsNoDep;
    entry.SupportsMaxPersons          = row.SupportsMaxPersons;
    entry.CommissionPrepaid           = row.CommissionPrepaid;
    entry.CommissionPercentage        = row.CommissionPercentage;
    entry.CommissionPerReservation    = row.CommissionPerReservation;
    entry.CommissionVAT               = row.CommissionVAT;
    entry.UserName                    = row.UserName;
    entry.Credentials                 = row.Credentials;
    entry.LastPull                    = row.LastPull;
    entry.NeedsExplicitMap            = row.NeedsExplicitMap;
    entry.Deactivated                 = row.Deactivated;
    entry.PushWithoutAdditionalTaxes  = row.PushWithoutAdditionalTaxes;
    entry.PushActive                  = row.PushActive;
    entry.PullActive                  = row.PullActive;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Pms.GetAgeBasedOccupancy
    = RQImported.PmsGetAgeBasedOccupancy;

RQService.Pms.PopulateGetAgeBasedOccupancyRow = function (row) {
    var entry = { };

    entry.TotalOccupancyNights       = row.TotalOccupancyNights;
    entry.TotalAdultNights           = row.TotalAdultNights;
    entry.TotalMinorNights           = row.TotalMinorNights;
    entry.TotalTaxExemptAdultNights  = row.TotalTaxExemptAdultNights;

    return entry;
};

RQService.Pms.GetAllOfferTypeBucketData
    = RQImported.PmsGetAllOfferTypeBucketData;

RQService.Pms.PopulateGetAllOfferTypeBucketDataRow = function (row) {
    var entry = { };

    entry.OfferTypeID          = row.OfferTypeID;
    entry.RoomTypeID           = row.RoomTypeID;
    entry.MaxPersons           = row.MaxPersons;
    entry.ResDay               = row.ResDay;
    entry.HasRateData          = row.HasRateData;
    entry.Price                = row.Price;
    entry.MLOS                 = row.MLOS;
    entry.MaxStay              = row.MaxStay;
    entry.AdvanceDays          = row.AdvanceDays;
    entry.NoArr                = row.NoArr;
    entry.NoDep                = row.NoDep;
    entry.Allotment            = row.Allotment;
    entry.StopSell             = row.StopSell;
    entry.SeasonalPrice        = row.SeasonalPrice;
    entry.SeasonalMLOS         = row.SeasonalMLOS;
    entry.SeasonalMaxStay      = row.SeasonalMaxStay;
    entry.SeasonalAdvanceDays  = row.SeasonalAdvanceDays;
    entry.SeasonalNoArr        = row.SeasonalNoArr;
    entry.SeasonalNoDep        = row.SeasonalNoDep;
    entry.SeasonalAllotment    = row.SeasonalAllotment;
    entry.Availability         = row.Availability;
    entry.Uptake               = row.Uptake;
    entry.Capacity             = row.Capacity;
    entry.IsFineTunedRateDay   = row.IsFineTunedRateDay;
    entry.IsExhibitionDay      = row.IsExhibitionDay;

    return entry;
};

RQService.Pms.GetAssignedPartnersByOfferType
    = RQImported.PmsGetAssignedPartnersByOfferType;

RQService.Pms.PopulateGetAssignedPartnersByOfferTypeRow = function (row) {
    var entry = { };

    entry.HotelID                     = row.HotelID;
    entry.PartnerID                   = row.PartnerID;
    entry.Partner                     = row.Partner;
    entry.Expired                     = row.Expired;
    entry.Builtin                     = row.Builtin;
    entry.IsRemote                    = row.IsRemote;
    entry.RemotePropertyID            = row.RemotePropertyID;
    entry.SupportsMLOS                = row.SupportsMLOS;
    entry.SupportsMaxStay             = row.SupportsMaxStay;
    entry.SupportsAdvanceDays         = row.SupportsAdvanceDays;
    entry.SupportsNoArr               = row.SupportsNoArr;
    entry.SupportsNoDep               = row.SupportsNoDep;
    entry.SupportsMaxPersons          = row.SupportsMaxPersons;
    entry.CommissionPrepaid           = row.CommissionPrepaid;
    entry.CommissionPercentage        = row.CommissionPercentage;
    entry.CommissionPerReservation    = row.CommissionPerReservation;
    entry.CommissionVAT               = row.CommissionVAT;
    entry.UserName                    = row.UserName;
    entry.Credentials                 = row.Credentials;
    entry.LastPull                    = row.LastPull;
    entry.NeedsExplicitMap            = row.NeedsExplicitMap;
    entry.Deactivated                 = row.Deactivated;
    entry.PushWithoutAdditionalTaxes  = row.PushWithoutAdditionalTaxes;
    entry.PushActive                  = row.PushActive;
    entry.PullActive                  = row.PullActive;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Pms.GetAvailabilityPeriod
    = RQImported.PmsGetAvailabilityPeriod;

RQService.Pms.PopulateGetAvailabilityPeriodRow = function (row) {
    var entry = { };

    entry.ResDay        = row.ResDay;
    entry.Availability  = row.Availability;

    return entry;
};

RQService.Pms.GetAvailableRoomEditTotals
    = RQImported.PmsGetAvailableRoomEditTotals;

RQService.Pms.PopulateGetAvailableRoomEditTotalsRow = function (row) {
    var entry = { };

    entry.RoomID                 = row.RoomID;
    entry.RoomNumber             = row.RoomNumber;
    entry.RoomTypeID             = row.RoomTypeID;
    entry.RoomTypeName           = row.RoomTypeName;
    entry.RoomTypeAvailability   = row.RoomTypeAvailability;
    entry.ResultHasMNRates       = row.ResultHasMNRates;
    entry.RoomTypeHasMNRates     = row.RoomTypeHasMNRates;
    entry.MaxPersons             = row.MaxPersons;
    entry.MaxPersonsRateName     = row.MaxPersonsRateName;
    entry.PersonsNormal          = row.PersonsNormal;
    entry.Selected               = row.Selected;
    entry.Total                  = row.Total;
    entry.IsAvailable            = row.IsAvailable;
    entry.CanMakeSplitSwap       = row.CanMakeSplitSwap;
    entry.OfferCoversPeriod      = row.OfferCoversPeriod;
    entry.RateCoversPeriod       = row.RateCoversPeriod;
    entry.CapacityCoversRequest  = row.CapacityCoversRequest;
    entry.InsufficientAllotment  = row.InsufficientAllotment;
    entry.MLOS                   = row.MLOS;
    entry.MaxStay                = row.MaxStay;
    entry.NoArr                  = row.NoArr;
    entry.NoDep                  = row.NoDep;
    entry.AdvanceDays            = row.AdvanceDays;

    return entry;
};

RQService.Pms.GetAvailableRoomTotals
    = RQImported.PmsGetAvailableRoomTotals;

RQService.Pms.PopulateGetAvailableRoomTotalsRow = function (row) {
    var entry = { };

    entry.RoomID                 = row.RoomID;
    entry.RoomNumber             = row.RoomNumber;
    entry.RoomTypeID             = row.RoomTypeID;
    entry.RoomTypeName           = row.RoomTypeName;
    entry.RoomTypeAvailability   = row.RoomTypeAvailability;
    entry.ResultHasMNRates       = row.ResultHasMNRates;
    entry.RoomTypeHasMNRates     = row.RoomTypeHasMNRates;
    entry.MaxPersons             = row.MaxPersons;
    entry.MaxPersonsRateName     = row.MaxPersonsRateName;
    entry.PersonsNormal          = row.PersonsNormal;
    entry.Selected               = row.Selected;
    entry.Total                  = row.Total;
    entry.IsAvailable            = row.IsAvailable;
    entry.CanMakeSplitSwap       = row.CanMakeSplitSwap;
    entry.OfferCoversPeriod      = row.OfferCoversPeriod;
    entry.RateCoversPeriod       = row.RateCoversPeriod;
    entry.CapacityCoversRequest  = row.CapacityCoversRequest;
    entry.InsufficientAllotment  = row.InsufficientAllotment;
    entry.MLOS                   = row.MLOS;
    entry.MaxStay                = row.MaxStay;
    entry.NoArr                  = row.NoArr;
    entry.NoDep                  = row.NoDep;
    entry.AdvanceDays            = row.AdvanceDays;

    return entry;
};

RQService.Pms.GetBookingDotComDeviceCookie
    = RQImported.PmsGetBookingDotComDeviceCookie;

RQService.Pms.PopulateGetBookingDotComDeviceCookieRow = function (row) {
    var entry = { };

    entry.HotelID  = row.HotelID;
    entry.Name     = row.Name;
    entry.Value    = row.Value;
    entry.Expires  = row.Expires;

    return entry;
};

RQService.Pms.GetCancellationFee
    = RQImported.PmsGetCancellationFee;

RQService.Pms.PopulateGetCancellationFeeRow = function (row) {
    var entry = { };

    entry.CancellationFee  = row.CancellationFee;

    return entry;
};

RQService.Pms.GetCCTypes
    = RQImported.PmsGetCCTypes;

RQService.Pms.PopulateGetCCTypesRow = function (row) {
    var entry = { };

    entry.CCTypeID  = row.CCTypeID;
    entry.CCType    = row.CCType;

    return entry;
};

RQService.Pms.GetChannelBucketNavigationData
    = RQImported.PmsGetChannelBucketNavigationData;

RQService.Pms.PopulateGetChannelBucketNavigationDataRow = function (row) {
    var entry = { };

    entry.PartnerID                     = row.PartnerID;
    entry.OfferTypeID                   = row.OfferTypeID;
    entry.RoomTypeID                    = row.RoomTypeID;
    entry.MaxPersons                    = row.MaxPersons;
    entry.Partner                       = row.Partner;
    entry.OfferTypeName                 = row.OfferTypeName;
    entry.OfferTypeDescription          = row.OfferTypeDescription;
    entry.RoomTypeName                  = row.RoomTypeName;
    entry.NumRooms                      = row.NumRooms;
    entry.MaxPersonsRateName            = row.MaxPersonsRateName;
    entry.PaymentSchemeID               = row.PaymentSchemeID;
    entry.PaymentSchemeName             = row.PaymentSchemeName;
    entry.PaymentSchemeDescription      = row.PaymentSchemeDescription;
    entry.IsRemote                      = row.IsRemote;
    entry.HasSharedAllotment            = row.HasSharedAllotment;
    entry.PartnerSupportsMaxPersons     = row.PartnerSupportsMaxPersons;
    entry.PartnerSupportsMLOS           = row.PartnerSupportsMLOS;
    entry.PartnerSupportsMaxStay        = row.PartnerSupportsMaxStay;
    entry.PartnerSupportsAdvanceDays    = row.PartnerSupportsAdvanceDays;
    entry.PartnerSupportsNoArr          = row.PartnerSupportsNoArr;
    entry.PartnerSupportsNoDep          = row.PartnerSupportsNoDep;
    entry.IsOfferTypeUnmapped           = row.IsOfferTypeUnmapped;
    entry.CancelConsumesAvailability    = row.CancelConsumesAvailability;
    entry.ReleaseDays                   = row.ReleaseDays;
    entry.MaxPersonsAllotmentLinked     = row.MaxPersonsAllotmentLinked;
    entry.DerivedAllotmentOfferTypeID   = row.DerivedAllotmentOfferTypeID;
    entry.OfferTypeSupportsMLOS         = row.OfferTypeSupportsMLOS;
    entry.OfferTypeSupportsMaxStay      = row.OfferTypeSupportsMaxStay;
    entry.OfferTypeSupportsAdvanceDays  = row.OfferTypeSupportsAdvanceDays;
    entry.OfferTypeSupportsNoArr        = row.OfferTypeSupportsNoArr;
    entry.OfferTypeSupportsNoDep        = row.OfferTypeSupportsNoDep;
    entry.IsDiscountFilter              = row.IsDiscountFilter;
    entry.SourceOfferTypeID             = row.SourceOfferTypeID;
    entry.Surcharge                     = row.Surcharge;
    entry.SourceMLOS                    = row.SourceMLOS;
    entry.SourceMaxStay                 = row.SourceMaxStay;
    entry.SourceAdvanceDays             = row.SourceAdvanceDays;
    entry.SourceNoArr                   = row.SourceNoArr;
    entry.SourceNoDep                   = row.SourceNoDep;
    entry.PersonsNormal                 = row.PersonsNormal;
    entry.MaxPersonsNormal              = row.MaxPersonsNormal;
    entry.MinPrice                      = row.MinPrice;
    entry.MaxPrice                      = row.MaxPrice;

    return entry;
};

RQService.Pms.GetCountries
    = RQImported.PmsGetCountries;

RQService.Pms.PopulateGetCountriesRow = function (row) {
    var entry = { };

    entry.CountryID     = row.CountryID;
    entry.ISOCode       = row.ISOCode;
    entry.InternetCode  = row.InternetCode;
    entry.Alpha3Code    = row.Alpha3Code;
    entry.CountryCode   = row.CountryCode;
    entry.LangID        = row.LangID;
    entry.Country       = row.Country;
    entry.Lat           = row.Lat;
    entry.Lng           = row.Lng;
    entry.CountryPName  = row.CountryPName;

    return entry;
};

RQService.Pms.GetCountryIDByCode
    = RQImported.PmsGetCountryIDByCode;

RQService.Pms.PopulateGetCountryIDByCodeRow = function (row) {
    var entry = { };

    entry.CountryID  = row.CountryID;
    entry.Country    = row.Country;
    entry.Lat        = row.Lat;
    entry.Lng        = row.Lng;

    return entry;
};

RQService.Pms.GetCountryIDByEnName
    = RQImported.PmsGetCountryIDByEnName;

RQService.Pms.PopulateGetCountryIDByEnNameRow = function (row) {
    var entry = { };

    entry.CountryID  = row.CountryID;
    entry.Country    = row.Country;
    entry.Lat        = row.Lat;
    entry.Lng        = row.Lng;

    return entry;
};

RQService.Pms.GetCountryIDByISOCode
    = RQImported.PmsGetCountryIDByISOCode;

RQService.Pms.PopulateGetCountryIDByISOCodeRow = function (row) {
    var entry = { };

    entry.CountryID  = row.CountryID;
    entry.Country    = row.Country;
    entry.Lat        = row.Lat;
    entry.Lng        = row.Lng;

    return entry;
};

RQService.Pms.GetCountryParamsFromPath
    = RQImported.PmsGetCountryParamsFromPath;

RQService.Pms.PopulateGetCountryParamsFromPathRow = function (row) {
    var entry = { };

    entry.CountryID  = row.CountryID;
    entry.Country    = row.Country;
    entry.Lat        = row.Lat;
    entry.Lng        = row.Lng;

    return entry;
};

RQService.Pms.GetCPolicyByOfferTypeID
    = RQImported.PmsGetCPolicyByOfferTypeID;

RQService.Pms.PopulateGetCPolicyByOfferTypeIDRow = function (row) {
    var entry = { };

    entry.HotelID                = row.HotelID;
    entry.CPolicyID              = row.CPolicyID;
    entry.IsNonRefundable        = row.IsNonRefundable;
    entry.ThresholdDay           = row.ThresholdDay;
    entry.ThresholdHour          = row.ThresholdHour;
    entry.PenaltyTypeID          = row.PenaltyTypeID;
    entry.Percentage             = row.Percentage;
    entry.IsNoShowNonRefundable  = row.IsNoShowNonRefundable;

    return entry;
};

RQService.Pms.GetCTMAccountSettings
    = RQImported.PmsGetCTMAccountSettings;

RQService.Pms.PopulateGetCTMAccountSettingsRow = function (row) {
    var entry = { };

    entry.APIKey  = row.APIKey;

    return entry;
};

RQService.Pms.GetCurrentCacheWindow
    = RQImported.PmsGetCurrentCacheWindow;

RQService.Pms.PopulateGetCurrentCacheWindowRow = function (row) {
    var entry = { };

    entry.Today       = row.Today;
    entry.CacheLimit  = row.CacheLimit;

    return entry;
};

RQService.Pms.GetCurrentShift
    = RQImported.PmsGetCurrentShift;

RQService.Pms.PopulateGetCurrentShiftRow = function (row) {
    var entry = { };

    entry.ShiftID      = row.ShiftID;
    entry.ShiftStart   = row.ShiftStart;
    entry.ShiftEnd     = row.ShiftEnd;
    entry.BusinessDay  = row.BusinessDay;
    entry.Users        = row.Users;

    return entry;
};

RQService.Pms.GetCurrentShiftStart
    = RQImported.PmsGetCurrentShiftStart;

RQService.Pms.PopulateGetCurrentShiftStartRow = function (row) {
    var entry = { };

    entry.ShiftStart  = row.ShiftStart;

    return entry;
};

RQService.Pms.GetCustomer
    = RQImported.PmsGetCustomer;

RQService.Pms.PopulateGetCustomerRow = function (row) {
    var entry = { };

    entry.HotelID             = row.HotelID;
    entry.CustomerID          = row.CustomerID;
    entry.Email               = row.Email;
    entry.FirstName           = row.FirstName;
    entry.LastName            = row.LastName;
    entry.CountryID           = row.CountryID;
    entry.Mobile              = row.Mobile;
    entry.CCTypeID            = row.CCTypeID;
    entry.CCName              = row.CCName;
    entry.IsGlocal            = row.IsGlocal;
    entry.IsTeam              = row.IsTeam;
    entry.ProfilePicturePath  = row.ProfilePicturePath;
    entry.ProfilePictureURL   = row.ProfilePictureURL;
    entry.NumUnreadMessages   = row.NumUnreadMessages;

    return entry;
};

RQService.Pms.GetCustomerBookingHotels
    = RQImported.PmsGetCustomerBookingHotels;

RQService.Pms.PopulateGetCustomerBookingHotelsRow = function (row) {
    var entry = { };

    entry.HotelID    = row.HotelID;
    entry.HotelName  = row.HotelName;

    return entry;
};

RQService.Pms.GetCustomerBookings
    = RQImported.PmsGetCustomerBookings;

RQService.Pms.PopulateGetCustomerBookingsRow = function (row) {
    var entry = { };

    entry.HotelID                        = row.HotelID;
    entry.ReservationID                  = row.ReservationID;
    entry.ExternalReservationID          = row.ExternalReservationID;
    entry.NumRoomRes                     = row.NumRoomRes;
    entry.FirstArr                       = row.FirstArr;
    entry.LastDep                        = row.LastDep;
    entry.RoomNumberList                 = row.RoomNumberList;
    entry.HasHoldUntil                   = row.HasHoldUntil;
    entry.FirstHoldUntil                 = row.FirstHoldUntil;
    entry.OwningGuestID                  = row.OwningGuestID;
    entry.ReservationStatusID            = row.ReservationStatusID;
    entry.ReservationStatusName          = row.ReservationStatusName;
    entry.PaymentSchemeID                = row.PaymentSchemeID;
    entry.PaymentSchemeName              = row.PaymentSchemeName;
    entry.ServiceTotal                   = row.ServiceTotal;
    entry.SumRoomTotal                   = row.SumRoomTotal;
    entry.ReservationTotal               = row.ReservationTotal;
    entry.LetterSent                     = row.LetterSent;
    entry.NotePriorityLevel              = row.NotePriorityLevel;
    entry.Notes                          = row.Notes;
    entry.PriorityNotes                  = row.PriorityNotes;
    entry.HousekeepingNotes              = row.HousekeepingNotes;
    entry.KitchenNotes                   = row.KitchenNotes;
    entry.EngineGuestComments            = row.EngineGuestComments;
    entry.PartnerID                      = row.PartnerID;
    entry.Partner                        = row.Partner;
    entry.IsEngineRes                    = row.IsEngineRes;
    entry.IsChannelRes                   = row.IsChannelRes;
    entry.ThirdPartyCancelReceived       = row.ThirdPartyCancelReceived;
    entry.ResConfirmedToThirdParty       = row.ResConfirmedToThirdParty;
    entry.CancelConfirmedToThirdParty    = row.CancelConfirmedToThirdParty;
    entry.HasLocalPMSEdit                = row.HasLocalPMSEdit;
    entry.HasLocalPMSEditAlerted         = row.HasLocalPMSEditAlerted;
    entry.HasThirdPartyGroupBookingEdit  = row.HasThirdPartyGroupBookingEdit;
    entry.ThirdPartyEditFailure          = row.ThirdPartyEditFailure;
    entry.Created                        = row.Created;
    entry.Modified                       = row.Modified;
    entry.IsBroken                       = row.IsBroken;

    return entry;
};

RQService.Pms.GetCustomerIDByEmail
    = RQImported.PmsGetCustomerIDByEmail;

RQService.Pms.PopulateGetCustomerIDByEmailRow = function (row) {
    var entry = { };

    entry.CustomerID  = row.CustomerID;

    return entry;
};

RQService.Pms.GetCustomerOffersByArrDep
    = RQImported.PmsGetCustomerOffersByArrDep;

RQService.Pms.PopulateGetCustomerOffersByArrDepRow = function (row) {
    var entry = { };

    entry.RoomTypeID                   = row.RoomTypeID;
    entry.RoomTypeName                 = row.RoomTypeName;
    entry.PersonsNormal                = row.PersonsNormal;
    entry.MaxPersonsNormal             = row.MaxPersonsNormal;
    entry.OfferTypeID                  = row.OfferTypeID;
    entry.OfferTypeName                = row.OfferTypeName;
    entry.PaymentSchemeID              = row.PaymentSchemeID;
    entry.PaymentSchemeNameShort       = row.PaymentSchemeNameShort;
    entry.MaxPersons                   = row.MaxPersons;
    entry.MaxPersonsRateName           = row.MaxPersonsRateName;
    entry.PriceExclusive               = row.PriceExclusive;
    entry.PriceInclusive               = row.PriceInclusive;
    entry.PriceExclusiveHotelCurrency  = row.PriceExclusiveHotelCurrency;
    entry.PriceInclusiveHotelCurrency  = row.PriceInclusiveHotelCurrency;
    entry.PriceInclusiveEuros          = row.PriceInclusiveEuros;
    entry.NumRooms                     = row.NumRooms;
    entry.MaxRoomsToSell               = row.MaxRoomsToSell;
    entry.CapacityCoversRequest        = row.CapacityCoversRequest;
    entry.InsufficientAllotment        = row.InsufficientAllotment;
    entry.MLOS                         = row.MLOS;
    entry.MaxStay                      = row.MaxStay;
    entry.AdvanceDays                  = row.AdvanceDays;
    entry.NoArr                        = row.NoArr;
    entry.NoDep                        = row.NoDep;
    entry.MatchLevel                   = row.MatchLevel;
    entry.MaxMatchLevel                = row.MaxMatchLevel;
    entry.IsMarkedAsMatch              = row.IsMarkedAsMatch;

    return entry;
};

RQService.Pms.GetCustomerOffersByArrDepBoundsCoordsFullWithDiscount
    = RQImported.PmsGetCustomerOffersByArrDepBoundsCoordsFullWithDiscount;

RQService.Pms.PopulateGetCustomerOffersByArrDepBoundsCoordsFullWithDiscountRow = function (row) {
    var entry = { };

    entry.HotelID                           = row.HotelID;
    entry.HotelName                         = row.HotelName;
    entry.RoomTypeID                        = row.RoomTypeID;
    entry.RoomTypeName                      = row.RoomTypeName;
    entry.PersonsNormal                     = row.PersonsNormal;
    entry.MaxPersonsNormal                  = row.MaxPersonsNormal;
    entry.OfferTypeID                       = row.OfferTypeID;
    entry.OfferTypeName                     = row.OfferTypeName;
    entry.PaymentSchemeID                   = row.PaymentSchemeID;
    entry.PaymentSchemeNameShort            = row.PaymentSchemeNameShort;
    entry.MaxPersons                        = row.MaxPersons;
    entry.MaxPersonsRateName                = row.MaxPersonsRateName;
    entry.PriceExclusive                    = row.PriceExclusive;
    entry.PriceInclusive                    = row.PriceInclusive;
    entry.PriceInclusiveConverted           = row.PriceInclusiveConverted;
    entry.PriceInclusiveEuros               = row.PriceInclusiveEuros;
    entry.NumDiscountDays                   = row.NumDiscountDays;
    entry.PriceExclusiveDiscount            = row.PriceExclusiveDiscount;
    entry.PriceInclusiveDiscount            = row.PriceInclusiveDiscount;
    entry.PriceInclusiveConvertedDiscount   = row.PriceInclusiveConvertedDiscount;
    entry.PriceInclusiveEurosDiscount       = row.PriceInclusiveEurosDiscount;
    entry.HasLastMinute                     = row.HasLastMinute;
    entry.PriceExclusivePLM                 = row.PriceExclusivePLM;
    entry.PriceInclusivePLM                 = row.PriceInclusivePLM;
    entry.PriceInclusiveConvertedPLM        = row.PriceInclusiveConvertedPLM;
    entry.PriceInclusiveEurosPLM            = row.PriceInclusiveEurosPLM;
    entry.MaxRoomsToSell                    = row.MaxRoomsToSell;
    entry.CapacityCoversRequest             = row.CapacityCoversRequest;
    entry.InsufficientAllotment             = row.InsufficientAllotment;
    entry.MLOS                              = row.MLOS;
    entry.MaxStay                           = row.MaxStay;
    entry.AdvanceDays                       = row.AdvanceDays;
    entry.NoArr                             = row.NoArr;
    entry.NoDep                             = row.NoDep;
    entry.PriceIncreaseOverRecentBase       = row.PriceIncreaseOverRecentBase;
    entry.PercentageIncreaseOverRecentBase  = row.PercentageIncreaseOverRecentBase;
    entry.MatchLevel                        = row.MatchLevel;
    entry.HotelMaxMatchLevel                = row.HotelMaxMatchLevel;
    entry.MaxMatchLevel                     = row.MaxMatchLevel;
    entry.IsMarkedAsMatch                   = row.IsMarkedAsMatch;
    entry.Classification                    = row.Classification;
    entry.DistanceToCenter                  = row.DistanceToCenter;
    entry.IconFileName                      = row.IconFileName;
    entry.MinMatchPrice                     = row.MinMatchPrice;
    entry.Address                           = row.Address;
    entry.ZIP                               = row.ZIP;
    entry.Telephone                         = row.Telephone;
    entry.HotelLat                          = row.HotelLat;
    entry.HotelLng                          = row.HotelLng;
    entry.HotelCoordsUnknown                = row.HotelCoordsUnknown;
    entry.HotelHasPhotos                    = row.HotelHasPhotos;
    entry.HotelPhotoID                      = row.HotelPhotoID;
    entry.HotelPhotoFilename                = row.HotelPhotoFilename;
    entry.HotelPhotoDescription             = row.HotelPhotoDescription;
    entry.CityCoordsUnknown                 = row.CityCoordsUnknown;
    entry.CityLat                           = row.CityLat;
    entry.CityLng                           = row.CityLng;
    entry.AccommodationTypeID               = row.AccommodationTypeID;
    entry.AccommodationTypeName             = row.AccommodationTypeName;
    entry.NumHits                           = row.NumHits;
    entry.HotelRating                       = row.HotelRating;
    entry.NumReviews                        = row.NumReviews;
    entry.HotelPName                        = row.HotelPName;
    entry.LocationPName                     = row.LocationPName;
    entry.WithMapMarker                     = row.WithMapMarker;

    return entry;
};

RQService.Pms.GetCustomerOffersByArrDepCoordsFullWithDiscount
    = RQImported.PmsGetCustomerOffersByArrDepCoordsFullWithDiscount;

RQService.Pms.PopulateGetCustomerOffersByArrDepCoordsFullWithDiscountRow = function (row) {
    var entry = { };

    entry.HotelID                           = row.HotelID;
    entry.HotelName                         = row.HotelName;
    entry.RoomTypeID                        = row.RoomTypeID;
    entry.RoomTypeName                      = row.RoomTypeName;
    entry.PersonsNormal                     = row.PersonsNormal;
    entry.MaxPersonsNormal                  = row.MaxPersonsNormal;
    entry.OfferTypeID                       = row.OfferTypeID;
    entry.OfferTypeName                     = row.OfferTypeName;
    entry.PaymentSchemeID                   = row.PaymentSchemeID;
    entry.PaymentSchemeNameShort            = row.PaymentSchemeNameShort;
    entry.MaxPersons                        = row.MaxPersons;
    entry.MaxPersonsRateName                = row.MaxPersonsRateName;
    entry.PriceExclusive                    = row.PriceExclusive;
    entry.PriceInclusive                    = row.PriceInclusive;
    entry.PriceInclusiveConverted           = row.PriceInclusiveConverted;
    entry.PriceInclusiveEuros               = row.PriceInclusiveEuros;
    entry.NumDiscountDays                   = row.NumDiscountDays;
    entry.PriceExclusiveDiscount            = row.PriceExclusiveDiscount;
    entry.PriceInclusiveDiscount            = row.PriceInclusiveDiscount;
    entry.PriceInclusiveConvertedDiscount   = row.PriceInclusiveConvertedDiscount;
    entry.PriceInclusiveEurosDiscount       = row.PriceInclusiveEurosDiscount;
    entry.HasLastMinute                     = row.HasLastMinute;
    entry.PriceExclusivePLM                 = row.PriceExclusivePLM;
    entry.PriceInclusivePLM                 = row.PriceInclusivePLM;
    entry.PriceInclusiveConvertedPLM        = row.PriceInclusiveConvertedPLM;
    entry.PriceInclusiveEurosPLM            = row.PriceInclusiveEurosPLM;
    entry.MaxRoomsToSell                    = row.MaxRoomsToSell;
    entry.CapacityCoversRequest             = row.CapacityCoversRequest;
    entry.InsufficientAllotment             = row.InsufficientAllotment;
    entry.MLOS                              = row.MLOS;
    entry.MaxStay                           = row.MaxStay;
    entry.AdvanceDays                       = row.AdvanceDays;
    entry.NoArr                             = row.NoArr;
    entry.NoDep                             = row.NoDep;
    entry.PriceIncreaseOverRecentBase       = row.PriceIncreaseOverRecentBase;
    entry.PercentageIncreaseOverRecentBase  = row.PercentageIncreaseOverRecentBase;
    entry.MatchLevel                        = row.MatchLevel;
    entry.HotelMaxMatchLevel                = row.HotelMaxMatchLevel;
    entry.MaxMatchLevel                     = row.MaxMatchLevel;
    entry.IsMarkedAsMatch                   = row.IsMarkedAsMatch;
    entry.Classification                    = row.Classification;
    entry.DistanceToCenter                  = row.DistanceToCenter;
    entry.IconFileName                      = row.IconFileName;
    entry.MinMatchPrice                     = row.MinMatchPrice;
    entry.Address                           = row.Address;
    entry.ZIP                               = row.ZIP;
    entry.Telephone                         = row.Telephone;
    entry.HotelLat                          = row.HotelLat;
    entry.HotelLng                          = row.HotelLng;
    entry.HotelCoordsUnknown                = row.HotelCoordsUnknown;
    entry.HotelHasPhotos                    = row.HotelHasPhotos;
    entry.HotelPhotoID                      = row.HotelPhotoID;
    entry.HotelPhotoFilename                = row.HotelPhotoFilename;
    entry.HotelPhotoDescription             = row.HotelPhotoDescription;
    entry.CityCoordsUnknown                 = row.CityCoordsUnknown;
    entry.CityLat                           = row.CityLat;
    entry.CityLng                           = row.CityLng;
    entry.AccommodationTypeID               = row.AccommodationTypeID;
    entry.AccommodationTypeName             = row.AccommodationTypeName;
    entry.NumHits                           = row.NumHits;
    entry.HotelRating                       = row.HotelRating;
    entry.NumReviews                        = row.NumReviews;
    entry.HotelPName                        = row.HotelPName;
    entry.LocationPName                     = row.LocationPName;
    entry.WithMapMarker                     = row.WithMapMarker;

    return entry;
};

RQService.Pms.GetCustomerOffersByArrDepWithDiscountInfo
    = RQImported.PmsGetCustomerOffersByArrDepWithDiscountInfo;

RQService.Pms.PopulateGetCustomerOffersByArrDepWithDiscountInfoRow = function (row) {
    var entry = { };

    entry.RoomTypeID                           = row.RoomTypeID;
    entry.RoomTypeName                         = row.RoomTypeName;
    entry.PersonsNormal                        = row.PersonsNormal;
    entry.MaxPersonsNormal                     = row.MaxPersonsNormal;
    entry.OfferTypeID                          = row.OfferTypeID;
    entry.OfferTypeName                        = row.OfferTypeName;
    entry.PaymentSchemeID                      = row.PaymentSchemeID;
    entry.PaymentSchemeNameShort               = row.PaymentSchemeNameShort;
    entry.MaxPersons                           = row.MaxPersons;
    entry.MaxPersonsRateName                   = row.MaxPersonsRateName;
    entry.PriceExclusive                       = row.PriceExclusive;
    entry.PriceInclusive                       = row.PriceInclusive;
    entry.PriceExclusiveHotelCurrency          = row.PriceExclusiveHotelCurrency;
    entry.PriceInclusiveHotelCurrency          = row.PriceInclusiveHotelCurrency;
    entry.PriceInclusiveEuros                  = row.PriceInclusiveEuros;
    entry.NumDiscountDays                      = row.NumDiscountDays;
    entry.PriceExclusiveDiscount               = row.PriceExclusiveDiscount;
    entry.PriceInclusiveDiscount               = row.PriceInclusiveDiscount;
    entry.PriceExclusiveHotelCurrencyDiscount  = row.PriceExclusiveHotelCurrencyDiscount;
    entry.PriceInclusiveHotelCurrencyDiscount  = row.PriceInclusiveHotelCurrencyDiscount;
    entry.PriceInclusiveEurosDiscount          = row.PriceInclusiveEurosDiscount;
    entry.HasLastMinute                        = row.HasLastMinute;
    entry.PriceExclusivePLM                    = row.PriceExclusivePLM;
    entry.PriceInclusivePLM                    = row.PriceInclusivePLM;
    entry.PriceExclusiveHotelCurrencyPLM       = row.PriceExclusiveHotelCurrencyPLM;
    entry.PriceInclusiveHotelCurrencyPLM       = row.PriceInclusiveHotelCurrencyPLM;
    entry.PriceInclusiveEurosPLM               = row.PriceInclusiveEurosPLM;
    entry.NumRooms                             = row.NumRooms;
    entry.MaxRoomsToSell                       = row.MaxRoomsToSell;
    entry.CapacityCoversRequest                = row.CapacityCoversRequest;
    entry.InsufficientAllotment                = row.InsufficientAllotment;
    entry.MLOS                                 = row.MLOS;
    entry.MaxStay                              = row.MaxStay;
    entry.AdvanceDays                          = row.AdvanceDays;
    entry.NoArr                                = row.NoArr;
    entry.NoDep                                = row.NoDep;
    entry.MatchLevel                           = row.MatchLevel;
    entry.MaxMatchLevel                        = row.MaxMatchLevel;
    entry.IsMarkedAsMatch                      = row.IsMarkedAsMatch;
    entry.IsWalkIn                             = row.IsWalkIn;

    return entry;
};

RQService.Pms.GetCustomerOffersByLocationArrDepFullWithDiscount
    = RQImported.PmsGetCustomerOffersByLocationArrDepFullWithDiscount;

RQService.Pms.PopulateGetCustomerOffersByLocationArrDepFullWithDiscountRow = function (row) {
    var entry = { };

    entry.HotelID                           = row.HotelID;
    entry.HotelName                         = row.HotelName;
    entry.RoomTypeID                        = row.RoomTypeID;
    entry.RoomTypeName                      = row.RoomTypeName;
    entry.PersonsNormal                     = row.PersonsNormal;
    entry.MaxPersonsNormal                  = row.MaxPersonsNormal;
    entry.OfferTypeID                       = row.OfferTypeID;
    entry.OfferTypeName                     = row.OfferTypeName;
    entry.PaymentSchemeID                   = row.PaymentSchemeID;
    entry.PaymentSchemeNameShort            = row.PaymentSchemeNameShort;
    entry.MaxPersons                        = row.MaxPersons;
    entry.MaxPersonsRateName                = row.MaxPersonsRateName;
    entry.PriceExclusive                    = row.PriceExclusive;
    entry.PriceInclusive                    = row.PriceInclusive;
    entry.PriceInclusiveConverted           = row.PriceInclusiveConverted;
    entry.PriceInclusiveEuros               = row.PriceInclusiveEuros;
    entry.NumDiscountDays                   = row.NumDiscountDays;
    entry.PriceExclusiveDiscount            = row.PriceExclusiveDiscount;
    entry.PriceInclusiveDiscount            = row.PriceInclusiveDiscount;
    entry.PriceInclusiveConvertedDiscount   = row.PriceInclusiveConvertedDiscount;
    entry.PriceInclusiveEurosDiscount       = row.PriceInclusiveEurosDiscount;
    entry.HasLastMinute                     = row.HasLastMinute;
    entry.PriceExclusivePLM                 = row.PriceExclusivePLM;
    entry.PriceInclusivePLM                 = row.PriceInclusivePLM;
    entry.PriceInclusiveConvertedPLM        = row.PriceInclusiveConvertedPLM;
    entry.PriceInclusiveEurosPLM            = row.PriceInclusiveEurosPLM;
    entry.MaxRoomsToSell                    = row.MaxRoomsToSell;
    entry.CapacityCoversRequest             = row.CapacityCoversRequest;
    entry.InsufficientAllotment             = row.InsufficientAllotment;
    entry.MLOS                              = row.MLOS;
    entry.MaxStay                           = row.MaxStay;
    entry.AdvanceDays                       = row.AdvanceDays;
    entry.NoArr                             = row.NoArr;
    entry.NoDep                             = row.NoDep;
    entry.PriceIncreaseOverRecentBase       = row.PriceIncreaseOverRecentBase;
    entry.PercentageIncreaseOverRecentBase  = row.PercentageIncreaseOverRecentBase;
    entry.MatchLevel                        = row.MatchLevel;
    entry.HotelMaxMatchLevel                = row.HotelMaxMatchLevel;
    entry.MaxMatchLevel                     = row.MaxMatchLevel;
    entry.IsMarkedAsMatch                   = row.IsMarkedAsMatch;
    entry.Classification                    = row.Classification;
    entry.DistanceToCenter                  = row.DistanceToCenter;
    entry.IconFileName                      = row.IconFileName;
    entry.MinMatchPrice                     = row.MinMatchPrice;
    entry.Address                           = row.Address;
    entry.ZIP                               = row.ZIP;
    entry.Telephone                         = row.Telephone;
    entry.HotelLat                          = row.HotelLat;
    entry.HotelLng                          = row.HotelLng;
    entry.HotelCoordsUnknown                = row.HotelCoordsUnknown;
    entry.HotelHasPhotos                    = row.HotelHasPhotos;
    entry.HotelPhotoID                      = row.HotelPhotoID;
    entry.HotelPhotoFilename                = row.HotelPhotoFilename;
    entry.HotelPhotoDescription             = row.HotelPhotoDescription;
    entry.CityCoordsUnknown                 = row.CityCoordsUnknown;
    entry.CityLat                           = row.CityLat;
    entry.CityLng                           = row.CityLng;
    entry.AccommodationTypeID               = row.AccommodationTypeID;
    entry.AccommodationTypeName             = row.AccommodationTypeName;
    entry.NumHits                           = row.NumHits;
    entry.HotelRating                       = row.HotelRating;
    entry.NumReviews                        = row.NumReviews;
    entry.HotelPName                        = row.HotelPName;
    entry.LocationPName                     = row.LocationPName;
    entry.WithMapMarker                     = row.WithMapMarker;

    return entry;
};

RQService.Pms.GetCustomerOffersBySearchLocationArrDepCoordsFullWithDiscount
    = RQImported.PmsGetCustomerOffersBySearchLocationArrDepCoordsFullWithDiscount;

RQService.Pms.PopulateGetCustomerOffersBySearchLocationArrDepCoordsFullWithDiscountRow = function (row) {
    var entry = { };

    entry.HotelID                           = row.HotelID;
    entry.HotelName                         = row.HotelName;
    entry.RoomTypeID                        = row.RoomTypeID;
    entry.RoomTypeName                      = row.RoomTypeName;
    entry.PersonsNormal                     = row.PersonsNormal;
    entry.MaxPersonsNormal                  = row.MaxPersonsNormal;
    entry.OfferTypeID                       = row.OfferTypeID;
    entry.OfferTypeName                     = row.OfferTypeName;
    entry.PaymentSchemeID                   = row.PaymentSchemeID;
    entry.PaymentSchemeNameShort            = row.PaymentSchemeNameShort;
    entry.MaxPersons                        = row.MaxPersons;
    entry.MaxPersonsRateName                = row.MaxPersonsRateName;
    entry.PriceExclusive                    = row.PriceExclusive;
    entry.PriceInclusive                    = row.PriceInclusive;
    entry.PriceInclusiveConverted           = row.PriceInclusiveConverted;
    entry.PriceInclusiveEuros               = row.PriceInclusiveEuros;
    entry.NumDiscountDays                   = row.NumDiscountDays;
    entry.PriceExclusiveDiscount            = row.PriceExclusiveDiscount;
    entry.PriceInclusiveDiscount            = row.PriceInclusiveDiscount;
    entry.PriceInclusiveConvertedDiscount   = row.PriceInclusiveConvertedDiscount;
    entry.PriceInclusiveEurosDiscount       = row.PriceInclusiveEurosDiscount;
    entry.HasLastMinute                     = row.HasLastMinute;
    entry.PriceExclusivePLM                 = row.PriceExclusivePLM;
    entry.PriceInclusivePLM                 = row.PriceInclusivePLM;
    entry.PriceInclusiveConvertedPLM        = row.PriceInclusiveConvertedPLM;
    entry.PriceInclusiveEurosPLM            = row.PriceInclusiveEurosPLM;
    entry.MaxRoomsToSell                    = row.MaxRoomsToSell;
    entry.CapacityCoversRequest             = row.CapacityCoversRequest;
    entry.InsufficientAllotment             = row.InsufficientAllotment;
    entry.MLOS                              = row.MLOS;
    entry.MaxStay                           = row.MaxStay;
    entry.AdvanceDays                       = row.AdvanceDays;
    entry.NoArr                             = row.NoArr;
    entry.NoDep                             = row.NoDep;
    entry.PriceIncreaseOverRecentBase       = row.PriceIncreaseOverRecentBase;
    entry.PercentageIncreaseOverRecentBase  = row.PercentageIncreaseOverRecentBase;
    entry.MatchLevel                        = row.MatchLevel;
    entry.HotelMaxMatchLevel                = row.HotelMaxMatchLevel;
    entry.MaxMatchLevel                     = row.MaxMatchLevel;
    entry.IsMarkedAsMatch                   = row.IsMarkedAsMatch;
    entry.Classification                    = row.Classification;
    entry.DistanceToCenter                  = row.DistanceToCenter;
    entry.IconFileName                      = row.IconFileName;
    entry.MinMatchPrice                     = row.MinMatchPrice;
    entry.Address                           = row.Address;
    entry.ZIP                               = row.ZIP;
    entry.Telephone                         = row.Telephone;
    entry.HotelLat                          = row.HotelLat;
    entry.HotelLng                          = row.HotelLng;
    entry.HotelCoordsUnknown                = row.HotelCoordsUnknown;
    entry.HotelHasPhotos                    = row.HotelHasPhotos;
    entry.HotelPhotoID                      = row.HotelPhotoID;
    entry.HotelPhotoFilename                = row.HotelPhotoFilename;
    entry.HotelPhotoDescription             = row.HotelPhotoDescription;
    entry.CityCoordsUnknown                 = row.CityCoordsUnknown;
    entry.CityLat                           = row.CityLat;
    entry.CityLng                           = row.CityLng;
    entry.AccommodationTypeID               = row.AccommodationTypeID;
    entry.AccommodationTypeName             = row.AccommodationTypeName;
    entry.NumHits                           = row.NumHits;
    entry.HotelRating                       = row.HotelRating;
    entry.NumReviews                        = row.NumReviews;
    entry.HotelPName                        = row.HotelPName;
    entry.LocationPName                     = row.LocationPName;
    entry.WithMapMarker                     = row.WithMapMarker;

    return entry;
};

RQService.Pms.GetCustomerOffersBySearchLocationArrDepFullWithDiscount
    = RQImported.PmsGetCustomerOffersBySearchLocationArrDepFullWithDiscount;

RQService.Pms.PopulateGetCustomerOffersBySearchLocationArrDepFullWithDiscountRow = function (row) {
    var entry = { };

    entry.HotelID                           = row.HotelID;
    entry.HotelName                         = row.HotelName;
    entry.RoomTypeID                        = row.RoomTypeID;
    entry.RoomTypeName                      = row.RoomTypeName;
    entry.PersonsNormal                     = row.PersonsNormal;
    entry.MaxPersonsNormal                  = row.MaxPersonsNormal;
    entry.OfferTypeID                       = row.OfferTypeID;
    entry.OfferTypeName                     = row.OfferTypeName;
    entry.PaymentSchemeID                   = row.PaymentSchemeID;
    entry.PaymentSchemeNameShort            = row.PaymentSchemeNameShort;
    entry.MaxPersons                        = row.MaxPersons;
    entry.MaxPersonsRateName                = row.MaxPersonsRateName;
    entry.PriceExclusive                    = row.PriceExclusive;
    entry.PriceInclusive                    = row.PriceInclusive;
    entry.PriceInclusiveConverted           = row.PriceInclusiveConverted;
    entry.PriceInclusiveEuros               = row.PriceInclusiveEuros;
    entry.NumDiscountDays                   = row.NumDiscountDays;
    entry.PriceExclusiveDiscount            = row.PriceExclusiveDiscount;
    entry.PriceInclusiveDiscount            = row.PriceInclusiveDiscount;
    entry.PriceInclusiveConvertedDiscount   = row.PriceInclusiveConvertedDiscount;
    entry.PriceInclusiveEurosDiscount       = row.PriceInclusiveEurosDiscount;
    entry.HasLastMinute                     = row.HasLastMinute;
    entry.PriceExclusivePLM                 = row.PriceExclusivePLM;
    entry.PriceInclusivePLM                 = row.PriceInclusivePLM;
    entry.PriceInclusiveConvertedPLM        = row.PriceInclusiveConvertedPLM;
    entry.PriceInclusiveEurosPLM            = row.PriceInclusiveEurosPLM;
    entry.MaxRoomsToSell                    = row.MaxRoomsToSell;
    entry.CapacityCoversRequest             = row.CapacityCoversRequest;
    entry.InsufficientAllotment             = row.InsufficientAllotment;
    entry.MLOS                              = row.MLOS;
    entry.MaxStay                           = row.MaxStay;
    entry.AdvanceDays                       = row.AdvanceDays;
    entry.NoArr                             = row.NoArr;
    entry.NoDep                             = row.NoDep;
    entry.PriceIncreaseOverRecentBase       = row.PriceIncreaseOverRecentBase;
    entry.PercentageIncreaseOverRecentBase  = row.PercentageIncreaseOverRecentBase;
    entry.MatchLevel                        = row.MatchLevel;
    entry.HotelMaxMatchLevel                = row.HotelMaxMatchLevel;
    entry.MaxMatchLevel                     = row.MaxMatchLevel;
    entry.IsMarkedAsMatch                   = row.IsMarkedAsMatch;
    entry.Classification                    = row.Classification;
    entry.DistanceToCenter                  = row.DistanceToCenter;
    entry.IconFileName                      = row.IconFileName;
    entry.MinMatchPrice                     = row.MinMatchPrice;
    entry.Address                           = row.Address;
    entry.ZIP                               = row.ZIP;
    entry.Telephone                         = row.Telephone;
    entry.HotelLat                          = row.HotelLat;
    entry.HotelLng                          = row.HotelLng;
    entry.HotelCoordsUnknown                = row.HotelCoordsUnknown;
    entry.HotelHasPhotos                    = row.HotelHasPhotos;
    entry.HotelPhotoID                      = row.HotelPhotoID;
    entry.HotelPhotoFilename                = row.HotelPhotoFilename;
    entry.HotelPhotoDescription             = row.HotelPhotoDescription;
    entry.CityCoordsUnknown                 = row.CityCoordsUnknown;
    entry.CityLat                           = row.CityLat;
    entry.CityLng                           = row.CityLng;
    entry.AccommodationTypeID               = row.AccommodationTypeID;
    entry.AccommodationTypeName             = row.AccommodationTypeName;
    entry.NumHits                           = row.NumHits;
    entry.HotelRating                       = row.HotelRating;
    entry.NumReviews                        = row.NumReviews;
    entry.HotelPName                        = row.HotelPName;
    entry.LocationPName                     = row.LocationPName;
    entry.WithMapMarker                     = row.WithMapMarker;

    return entry;
};

RQService.Pms.GetCustomerOffersBySearchLocationArrDepFullWithDiscountAndPageHint
    = RQImported.PmsGetCustomerOffersBySearchLocationArrDepFullWithDiscountAndPageHint;

RQService.Pms.PopulateGetCustomerOffersBySearchLocationArrDepFullWithDiscountAndPageHintRow = function (row) {
    var entry = { };

    entry.HotelID                           = row.HotelID;
    entry.HotelName                         = row.HotelName;
    entry.RoomTypeID                        = row.RoomTypeID;
    entry.RoomTypeName                      = row.RoomTypeName;
    entry.PersonsNormal                     = row.PersonsNormal;
    entry.MaxPersonsNormal                  = row.MaxPersonsNormal;
    entry.OfferTypeID                       = row.OfferTypeID;
    entry.OfferTypeName                     = row.OfferTypeName;
    entry.PaymentSchemeID                   = row.PaymentSchemeID;
    entry.PaymentSchemeNameShort            = row.PaymentSchemeNameShort;
    entry.MaxPersons                        = row.MaxPersons;
    entry.MaxPersonsRateName                = row.MaxPersonsRateName;
    entry.PriceExclusive                    = row.PriceExclusive;
    entry.PriceInclusive                    = row.PriceInclusive;
    entry.PriceInclusiveConverted           = row.PriceInclusiveConverted;
    entry.PriceInclusiveEuros               = row.PriceInclusiveEuros;
    entry.NumDiscountDays                   = row.NumDiscountDays;
    entry.PriceExclusiveDiscount            = row.PriceExclusiveDiscount;
    entry.PriceInclusiveDiscount            = row.PriceInclusiveDiscount;
    entry.PriceInclusiveConvertedDiscount   = row.PriceInclusiveConvertedDiscount;
    entry.PriceInclusiveEurosDiscount       = row.PriceInclusiveEurosDiscount;
    entry.HasLastMinute                     = row.HasLastMinute;
    entry.PriceExclusivePLM                 = row.PriceExclusivePLM;
    entry.PriceInclusivePLM                 = row.PriceInclusivePLM;
    entry.PriceInclusiveConvertedPLM        = row.PriceInclusiveConvertedPLM;
    entry.PriceInclusiveEurosPLM            = row.PriceInclusiveEurosPLM;
    entry.MaxRoomsToSell                    = row.MaxRoomsToSell;
    entry.CapacityCoversRequest             = row.CapacityCoversRequest;
    entry.InsufficientAllotment             = row.InsufficientAllotment;
    entry.MLOS                              = row.MLOS;
    entry.MaxStay                           = row.MaxStay;
    entry.AdvanceDays                       = row.AdvanceDays;
    entry.NoArr                             = row.NoArr;
    entry.NoDep                             = row.NoDep;
    entry.PriceIncreaseOverRecentBase       = row.PriceIncreaseOverRecentBase;
    entry.PercentageIncreaseOverRecentBase  = row.PercentageIncreaseOverRecentBase;
    entry.MatchLevel                        = row.MatchLevel;
    entry.HotelMaxMatchLevel                = row.HotelMaxMatchLevel;
    entry.MaxMatchLevel                     = row.MaxMatchLevel;
    entry.IsMarkedAsMatch                   = row.IsMarkedAsMatch;
    entry.Classification                    = row.Classification;
    entry.DistanceToCenter                  = row.DistanceToCenter;
    entry.IconFileName                      = row.IconFileName;
    entry.MinMatchPrice                     = row.MinMatchPrice;
    entry.Address                           = row.Address;
    entry.ZIP                               = row.ZIP;
    entry.Telephone                         = row.Telephone;
    entry.HotelLat                          = row.HotelLat;
    entry.HotelLng                          = row.HotelLng;
    entry.HotelCoordsUnknown                = row.HotelCoordsUnknown;
    entry.HotelHasPhotos                    = row.HotelHasPhotos;
    entry.HotelPhotoID                      = row.HotelPhotoID;
    entry.HotelPhotoFilename                = row.HotelPhotoFilename;
    entry.HotelPhotoDescription             = row.HotelPhotoDescription;
    entry.CityCoordsUnknown                 = row.CityCoordsUnknown;
    entry.CityLat                           = row.CityLat;
    entry.CityLng                           = row.CityLng;
    entry.AccommodationTypeID               = row.AccommodationTypeID;
    entry.AccommodationTypeName             = row.AccommodationTypeName;
    entry.NumHits                           = row.NumHits;
    entry.HotelRating                       = row.HotelRating;
    entry.NumReviews                        = row.NumReviews;
    entry.HotelPName                        = row.HotelPName;
    entry.LocationPName                     = row.LocationPName;
    entry.WithMapMarker                     = row.WithMapMarker;

    return entry;
};

RQService.Pms.GetDaysWithFineTunedRateData
    = RQImported.PmsGetDaysWithFineTunedRateData;

RQService.Pms.PopulateGetDaysWithFineTunedRateDataRow = function (row) {
    var entry = { };

    entry.ResDay                = row.ResDay;
    entry.ExhibitionPeriodID    = row.ExhibitionPeriodID;
    entry.ExhibitionPeriodName  = row.ExhibitionPeriodName;
    entry.IsFineTunedDay        = row.IsFineTunedDay;

    return entry;
};

RQService.Pms.GetEarlyBirdOfferType
    = RQImported.PmsGetEarlyBirdOfferType;

RQService.Pms.PopulateGetEarlyBirdOfferTypeRow = function (row) {
    var entry = { };

    entry.OfferTypeID                  = row.OfferTypeID;
    entry.Expired                      = row.Expired;
    entry.ReleaseDays                  = row.ReleaseDays;
    entry.CancelConsumesAvailability   = row.CancelConsumesAvailability;
    entry.Credentials                  = row.Credentials;
    entry.OfferTypeName                = row.OfferTypeName;
    entry.OfferTypeNameFull            = row.OfferTypeNameFull;
    entry.OfferTypeDescription         = row.OfferTypeDescription;
    entry.RackRatePaymentSchemeID      = row.RackRatePaymentSchemeID;
    entry.SourceOfferTypeID            = row.SourceOfferTypeID;
    entry.DiscountTypeID               = row.DiscountTypeID;
    entry.Surcharge                    = row.Surcharge;
    entry.SourceMLOS                   = row.SourceMLOS;
    entry.SourceMaxStay                = row.SourceMaxStay;
    entry.SourceAdvanceDays            = row.SourceAdvanceDays;
    entry.SourceNoArr                  = row.SourceNoArr;
    entry.SourceNoDep                  = row.SourceNoDep;
    entry.SourceMaxPersons             = row.SourceMaxPersons;
    entry.InitialiseAllotmentToZero    = row.InitialiseAllotmentToZero;
    entry.DerivedAllotmentOfferTypeID  = row.DerivedAllotmentOfferTypeID;
    entry.MaxPersonsAllotmentLinked    = row.MaxPersonsAllotmentLinked;
    entry.PaymentSchemeName            = row.PaymentSchemeName;
    entry.PaymentSchemeDescription     = row.PaymentSchemeDescription;
    entry.IsDiscountFilter             = row.IsDiscountFilter;
    entry.HasProductSpread             = row.HasProductSpread;
    entry.OfferTypeAutoNameID          = row.OfferTypeAutoNameID;
    entry.PackageLevelAdvanceDays      = row.PackageLevelAdvanceDays;

    return entry;
};

RQService.Pms.GetEasyNonRefOfferType
    = RQImported.PmsGetEasyNonRefOfferType;

RQService.Pms.PopulateGetEasyNonRefOfferTypeRow = function (row) {
    var entry = { };

    entry.OfferTypeID                  = row.OfferTypeID;
    entry.Expired                      = row.Expired;
    entry.ReleaseDays                  = row.ReleaseDays;
    entry.CancelConsumesAvailability   = row.CancelConsumesAvailability;
    entry.Credentials                  = row.Credentials;
    entry.OfferTypeName                = row.OfferTypeName;
    entry.OfferTypeNameFull            = row.OfferTypeNameFull;
    entry.OfferTypeDescription         = row.OfferTypeDescription;
    entry.RackRatePaymentSchemeID      = row.RackRatePaymentSchemeID;
    entry.SourceOfferTypeID            = row.SourceOfferTypeID;
    entry.DiscountTypeID               = row.DiscountTypeID;
    entry.Surcharge                    = row.Surcharge;
    entry.SourceMLOS                   = row.SourceMLOS;
    entry.SourceMaxStay                = row.SourceMaxStay;
    entry.SourceAdvanceDays            = row.SourceAdvanceDays;
    entry.SourceNoArr                  = row.SourceNoArr;
    entry.SourceNoDep                  = row.SourceNoDep;
    entry.SourceMaxPersons             = row.SourceMaxPersons;
    entry.InitialiseAllotmentToZero    = row.InitialiseAllotmentToZero;
    entry.DerivedAllotmentOfferTypeID  = row.DerivedAllotmentOfferTypeID;
    entry.MaxPersonsAllotmentLinked    = row.MaxPersonsAllotmentLinked;
    entry.PaymentSchemeName            = row.PaymentSchemeName;
    entry.PaymentSchemeDescription     = row.PaymentSchemeDescription;
    entry.IsDiscountFilter             = row.IsDiscountFilter;
    entry.HasProductSpread             = row.HasProductSpread;
    entry.OfferTypeAutoNameID          = row.OfferTypeAutoNameID;
    entry.PackageLevelAdvanceDays      = row.PackageLevelAdvanceDays;

    return entry;
};

RQService.Pms.GetExclusiveRateChannelData
    = RQImported.PmsGetExclusiveRateChannelData;

RQService.Pms.PopulateGetExclusiveRateChannelDataRow = function (row) {
    var entry = { };

    entry.CDay         = row.CDay;
    entry.WeekDay      = row.WeekDay;
    entry.BeforeTax    = row.BeforeTax;
    entry.AfterTax     = row.AfterTax;
    entry.Price        = row.Price;
    entry.MLOS         = row.MLOS;
    entry.MaxStay      = row.MaxStay;
    entry.AdvanceDays  = row.AdvanceDays;
    entry.NoArr        = row.NoArr;
    entry.NoDep        = row.NoDep;
    entry.Capacity     = row.Capacity;
    entry.StopSell     = row.StopSell;

    return entry;
};

RQService.Pms.GetExclusiveRateDiscountFilters
    = RQImported.PmsGetExclusiveRateDiscountFilters;

RQService.Pms.PopulateGetExclusiveRateDiscountFiltersRow = function (row) {
    var entry = { };

    entry.RoomTypeID             = row.RoomTypeID;
    entry.MaxPersons             = row.MaxPersons;
    entry.PersonsNormal          = row.PersonsNormal;
    entry.RoomTypeName           = row.RoomTypeName;
    entry.MaxPersonsRateName     = row.MaxPersonsRateName;
    entry.ExclusiveRatePeriodID  = row.ExclusiveRatePeriodID;
    entry.Surcharge              = row.Surcharge;
    entry.AdvanceDays            = row.AdvanceDays;
    entry.MLOS                   = row.MLOS;
    entry.Allotment              = row.Allotment;
    entry.Defined                = row.Defined;

    return entry;
};

RQService.Pms.GetExclusiveRatePeriods
    = RQImported.PmsGetExclusiveRatePeriods;

RQService.Pms.PopulateGetExclusiveRatePeriodsRow = function (row) {
    var entry = { };

    entry.HotelID                         = row.HotelID;
    entry.Expired                         = row.Expired;
    entry.ExclusiveRatePeriodID           = row.ExclusiveRatePeriodID;
    entry.StartDate                       = row.StartDate;
    entry.EndDate                         = row.EndDate;
    entry.PeriodCoversCache               = row.PeriodCoversCache;
    entry.PaymentSchemeID                 = row.PaymentSchemeID;
    entry.PaymentSchemeName               = row.PaymentSchemeName;
    entry.FilterType                      = row.FilterType;
    entry.ExclusiveRatePeriodName         = row.ExclusiveRatePeriodName;
    entry.ExclusiveRatePeriodDescription  = row.ExclusiveRatePeriodDescription;
    entry.Label                           = row.Label;

    return entry;
};

RQService.Pms.GetExhibitionDayWindow
    = RQImported.PmsGetExhibitionDayWindow;

RQService.Pms.PopulateGetExhibitionDayWindowRow = function (row) {
    var entry = { };

    entry.PDay                  = row.PDay;
    entry.ExhibitionPeriodID    = row.ExhibitionPeriodID;
    entry.ExhibitionPeriodName  = row.ExhibitionPeriodName;
    entry.ColorID               = row.ColorID;

    return entry;
};

RQService.Pms.GetExhibitionPeriods
    = RQImported.PmsGetExhibitionPeriods;

RQService.Pms.PopulateGetExhibitionPeriodsRow = function (row) {
    var entry = { };

    entry.ExhibitionPeriodID    = row.ExhibitionPeriodID;
    entry.StartDate             = row.StartDate;
    entry.EndDate               = row.EndDate;
    entry.ExhibitionPeriodName  = row.ExhibitionPeriodName;
    entry.ColorID               = row.ColorID;
    entry.Created               = row.Created;

    return entry;
};

RQService.Pms.GetFirstBusinessDay
    = RQImported.PmsGetFirstBusinessDay;

RQService.Pms.PopulateGetFirstBusinessDayRow = function (row) {
    var entry = { };

    entry.FirstBusinessDay  = row.FirstBusinessDay;

    return entry;
};

RQService.Pms.GetGuest
    = RQImported.PmsGetGuest;

RQService.Pms.PopulateGetGuestRow = function (row) {
    var entry = { };

    entry.HotelID                 = row.HotelID;
    entry.GuestID                 = row.GuestID;
    entry.GuestTitleID            = row.GuestTitleID;
    entry.Gender                  = row.Gender;
    entry.Minor                   = row.Minor;
    entry.FirstName               = row.FirstName;
    entry.LastName                = row.LastName;
    entry.Company                 = row.Company;
    entry.CompanyVAT              = row.CompanyVAT;
    entry.CountryID               = row.CountryID;
    entry.Address                 = row.Address;
    entry.Location                = row.Location;
    entry.PostCode                = row.PostCode;
    entry.Telephone               = row.Telephone;
    entry.TelephoneAlt            = row.TelephoneAlt;
    entry.Mobile                  = row.Mobile;
    entry.Fax                     = row.Fax;
    entry.Email                   = row.Email;
    entry.BirthPlace              = row.BirthPlace;
    entry.DateOfBirth             = row.DateOfBirth;
    entry.IdentificationTypeID    = row.IdentificationTypeID;
    entry.Identification          = row.Identification;
    entry.NationalIDNo            = row.NationalIDNo;
    entry.IDRegistrationCity      = row.IDRegistrationCity;
    entry.IDRegistrationDistrict  = row.IDRegistrationDistrict;
    entry.TaxIdentification       = row.TaxIdentification;
    entry.MothersName             = row.MothersName;
    entry.FathersName             = row.FathersName;
    entry.Occupation              = row.Occupation;
    entry.Notes                   = row.Notes;
    entry.CCTypeID                = row.CCTypeID;
    entry.CCNumber                = row.CCNumber;
    entry.CCName                  = row.CCName;
    entry.CCExpiryYear            = row.CCExpiryYear;
    entry.CCExpiryMonth           = row.CCExpiryMonth;
    entry.CCCVC                   = row.CCCVC;
    entry.Created                 = row.Created;
    entry.FullGuestName           = row.FullGuestName;
    entry.IsOwningGuest           = row.IsOwningGuest;
    entry.Country                 = row.Country;
    entry.InternetCode            = row.InternetCode;
    entry.CCType                  = row.CCType;
    entry.GuestTitleName          = row.GuestTitleName;
    entry.HasTaxExemption         = row.HasTaxExemption;

    return entry;
};

RQService.Pms.GetGuestByReservation
    = RQImported.PmsGetGuestByReservation;

RQService.Pms.PopulateGetGuestByReservationRow = function (row) {
    var entry = { };

    entry.HotelID                 = row.HotelID;
    entry.GuestID                 = row.GuestID;
    entry.GuestTitleID            = row.GuestTitleID;
    entry.Gender                  = row.Gender;
    entry.Minor                   = row.Minor;
    entry.FirstName               = row.FirstName;
    entry.LastName                = row.LastName;
    entry.Company                 = row.Company;
    entry.CompanyVAT              = row.CompanyVAT;
    entry.CountryID               = row.CountryID;
    entry.Address                 = row.Address;
    entry.Location                = row.Location;
    entry.PostCode                = row.PostCode;
    entry.Telephone               = row.Telephone;
    entry.TelephoneAlt            = row.TelephoneAlt;
    entry.Mobile                  = row.Mobile;
    entry.Fax                     = row.Fax;
    entry.Email                   = row.Email;
    entry.BirthPlace              = row.BirthPlace;
    entry.DateOfBirth             = row.DateOfBirth;
    entry.IdentificationTypeID    = row.IdentificationTypeID;
    entry.Identification          = row.Identification;
    entry.NationalIDNo            = row.NationalIDNo;
    entry.IDRegistrationCity      = row.IDRegistrationCity;
    entry.IDRegistrationDistrict  = row.IDRegistrationDistrict;
    entry.TaxIdentification       = row.TaxIdentification;
    entry.MothersName             = row.MothersName;
    entry.FathersName             = row.FathersName;
    entry.Occupation              = row.Occupation;
    entry.Notes                   = row.Notes;
    entry.CCTypeID                = row.CCTypeID;
    entry.CCNumber                = row.CCNumber;
    entry.CCName                  = row.CCName;
    entry.CCExpiryYear            = row.CCExpiryYear;
    entry.CCExpiryMonth           = row.CCExpiryMonth;
    entry.CCCVC                   = row.CCCVC;
    entry.Created                 = row.Created;
    entry.FullGuestName           = row.FullGuestName;
    entry.IsOwningGuest           = row.IsOwningGuest;
    entry.Country                 = row.Country;
    entry.InternetCode            = row.InternetCode;
    entry.CCType                  = row.CCType;
    entry.GuestTitleName          = row.GuestTitleName;
    entry.HasTaxExemption         = row.HasTaxExemption;

    return entry;
};

RQService.Pms.GetGuestIdentificationTypes
    = RQImported.PmsGetGuestIdentificationTypes;

RQService.Pms.PopulateGetGuestIdentificationTypesRow = function (row) {
    var entry = { };

    entry.GuestIdentificationTypeID    = row.GuestIdentificationTypeID;
    entry.GuestIdentificationTypeName  = row.GuestIdentificationTypeName;
    entry.IsDefaultIDType              = row.IsDefaultIDType;

    return entry;
};

RQService.Pms.GetGuestTitles
    = RQImported.PmsGetGuestTitles;

RQService.Pms.PopulateGetGuestTitlesRow = function (row) {
    var entry = { };

    entry.GuestTitleID    = row.GuestTitleID;
    entry.SortOrder       = row.SortOrder;
    entry.LangID          = row.LangID;
    entry.GuestTitleName  = row.GuestTitleName;

    return entry;
};

RQService.Pms.GetHotel
    = RQImported.PmsGetHotel;

RQService.Pms.PopulateGetHotelRow = function (row) {
    var entry = { };

    entry.HotelID                              = row.HotelID;
    entry.Active                               = row.Active;
    entry.ServiceTypeID                        = row.ServiceTypeID;
    entry.IsMonitored                          = row.IsMonitored;
    entry.HotelName                            = row.HotelName;
    entry.Title                                = row.Title;
    entry.PostCode                             = row.PostCode;
    entry.Address                              = row.Address;
    entry.Location                             = row.Location;
    entry.CountryID                            = row.CountryID;
    entry.PhoneICode                           = row.PhoneICode;
    entry.PhoneNumber                          = row.PhoneNumber;
    entry.FaxICode                             = row.FaxICode;
    entry.FaxNumber                            = row.FaxNumber;
    entry.Email                                = row.Email;
    entry.Web                                  = row.Web;
    entry.ChamberOfCommerceNumber              = row.ChamberOfCommerceNumber;
    entry.FiscalNumber                         = row.FiscalNumber;
    entry.BankIBAN1                            = row.BankIBAN1;
    entry.BankSwift1                           = row.BankSwift1;
    entry.BankLocation1                        = row.BankLocation1;
    entry.BankCountryID1                       = row.BankCountryID1;
    entry.BankIBAN2                            = row.BankIBAN2;
    entry.BankSwift2                           = row.BankSwift2;
    entry.BankLocation2                        = row.BankLocation2;
    entry.BankCountryID2                       = row.BankCountryID2;
    entry.FiscalPostCode                       = row.FiscalPostCode;
    entry.FiscalAddress                        = row.FiscalAddress;
    entry.FiscalLocation                       = row.FiscalLocation;
    entry.FiscalCountryID                      = row.FiscalCountryID;
    entry.DefaultCheckOutTime                  = row.DefaultCheckOutTime;
    entry.PermissiveReconfirmationConstraints  = row.PermissiveReconfirmationConstraints;
    entry.HasThermalPrinter                    = row.HasThermalPrinter;
    entry.BackupDirectory                      = row.BackupDirectory;
    entry.IsEngineCustomer                     = row.IsEngineCustomer;
    entry.LocationGeoCodeID                    = row.LocationGeoCodeID;
    entry.Classification                       = row.Classification;
    entry.RateEntryTypeID                      = row.RateEntryTypeID;
    entry.TurnoverProjectionByDep              = row.TurnoverProjectionByDep;
    entry.HasTurkishPoliceReport               = row.HasTurkishPoliceReport;
    entry.TrFacilityCode                       = row.TrFacilityCode;
    entry.TrPoliceReportProgram                = row.TrPoliceReportProgram;
    entry.TrPoliceReportProgramVersion         = row.TrPoliceReportProgramVersion;
    entry.CountryCode                          = row.CountryCode;
    entry.Country                              = row.Country;
    entry.FiscalCountry                        = row.FiscalCountry;
    entry.BankCountry1                         = row.BankCountry1;
    entry.BankCountry2                         = row.BankCountry2;
    entry.RateEntryIncludesProductSpread       = row.RateEntryIncludesProductSpread;
    entry.CVCRequired                          = row.CVCRequired;
    entry.DeriveRatesFromTobookCache           = row.DeriveRatesFromTobookCache;

    return entry;
};

RQService.Pms.GetHotelBreakfastData
    = RQImported.PmsGetHotelBreakfastData;

RQService.Pms.PopulateGetHotelBreakfastDataRow = function (row) {
    var entry = { };

    entry.RoomID                     = row.RoomID;
    entry.RoomNumber                 = row.RoomNumber;
    entry.RoomReservationID          = row.RoomReservationID;
    entry.IsArr                      = row.IsArr;
    entry.IsDep                      = row.IsDep;
    entry.IsCheckedIn                = row.IsCheckedIn;
    entry.IsCheckedOut               = row.IsCheckedOut;
    entry.NumPersonsStaying          = row.NumPersonsStaying;
    entry.NumPersonsHavingBreakfast  = row.NumPersonsHavingBreakfast;
    entry.ResDay                     = row.ResDay;

    return entry;
};

RQService.Pms.GetHotelBreakfastDefault
    = RQImported.PmsGetHotelBreakfastDefault;

RQService.Pms.PopulateGetHotelBreakfastDefaultRow = function (row) {
    var entry = { };

    entry.HotelID                = row.HotelID;
    entry.DefaultBreakfastPrice  = row.DefaultBreakfastPrice;
    entry.AsDiscount             = row.AsDiscount;

    return entry;
};

RQService.Pms.GetHotelModules
    = RQImported.PmsGetHotelModules;

RQService.Pms.PopulateGetHotelModulesRow = function (row) {
    var entry = { };

    entry.ModuleID  = row.ModuleID;

    return entry;
};

RQService.Pms.GetHotelOccupancyAndBreakfastTotals
    = RQImported.PmsGetHotelOccupancyAndBreakfastTotals;

RQService.Pms.PopulateGetHotelOccupancyAndBreakfastTotalsRow = function (row) {
    var entry = { };

    entry.BreakfastTotal       = row.BreakfastTotal;
    entry.OccupancyTotal       = row.OccupancyTotal;
    entry.NumArrivalDayGuests  = row.NumArrivalDayGuests;
    entry.NumCheckedInGuests   = row.NumCheckedInGuests;

    return entry;
};

RQService.Pms.GetHotelOccupancyData
    = RQImported.PmsGetHotelOccupancyData;

RQService.Pms.PopulateGetHotelOccupancyDataRow = function (row) {
    var entry = { };

    entry.RoomID             = row.RoomID;
    entry.RoomNumber         = row.RoomNumber;
    entry.RoomReservationID  = row.RoomReservationID;
    entry.IsArr              = row.IsArr;
    entry.IsDep              = row.IsDep;
    entry.IsCheckedIn        = row.IsCheckedIn;
    entry.IsCheckedOut       = row.IsCheckedOut;
    entry.NumPersonsStaying  = row.NumPersonsStaying;
    entry.ResDay             = row.ResDay;
    entry.GuestID            = row.GuestID;
    entry.GuestTitleName     = row.GuestTitleName;
    entry.FirstName          = row.FirstName;
    entry.LastName           = row.LastName;
    entry.Gender             = row.Gender;
    entry.Minor              = row.Minor;
    entry.Country            = row.Country;
    entry.Address            = row.Address;
    entry.Location           = row.Location;
    entry.PostCode           = row.PostCode;
    entry.Telephone          = row.Telephone;
    entry.Mobile             = row.Mobile;
    entry.Company            = row.Company;
    entry.GuestNumber        = row.GuestNumber;
    entry.AmountOwing        = row.AmountOwing;

    return entry;
};

RQService.Pms.GetHotelsAndActiveRemotePartners
    = RQImported.PmsGetHotelsAndActiveRemotePartners;

RQService.Pms.PopulateGetHotelsAndActiveRemotePartnersRow = function (row) {
    var entry = { };

    entry.HotelID    = row.HotelID;
    entry.PartnerID  = row.PartnerID;

    return entry;
};

RQService.Pms.GetHotelsNeedingConfigCacheSync
    = RQImported.PmsGetHotelsNeedingConfigCacheSync;

RQService.Pms.PopulateGetHotelsNeedingConfigCacheSyncRow = function (row) {
    var entry = { };

    entry.HotelID  = row.HotelID;

    return entry;
};

RQService.Pms.GetIntersectingRoomRates
    = RQImported.PmsGetIntersectingRoomRates;

RQService.Pms.PopulateGetIntersectingRoomRatesRow = function (row) {
    var entry = { };

    entry.ExclusiveRatePeriodID           = row.ExclusiveRatePeriodID;
    entry.PaymentSchemeID                 = row.PaymentSchemeID;
    entry.ExclusiveRatePeriodName         = row.ExclusiveRatePeriodName;
    entry.ExclusiveRatePeriodDescription  = row.ExclusiveRatePeriodDescription;
    entry.PaymentSchemeName               = row.PaymentSchemeName;
    entry.PaymentSchemeDescription        = row.PaymentSchemeDescription;

    return entry;
};

RQService.Pms.GetJobs
    = RQImported.PmsGetJobs;

RQService.Pms.PopulateGetJobsRow = function (row) {
    var entry = { };

    entry.JobID       = row.JobID;
    entry.HotelID     = row.HotelID;
    entry.Name        = row.Name;
    entry.Enabled     = row.Enabled;
    entry.JobType     = row.JobType;
    entry.RunAtHour   = row.RunAtHour;
    entry.RunAtMin    = row.RunAtMin;
    entry.RecurValue  = row.RecurValue;
    entry.Monday      = row.Monday;
    entry.Tuesday     = row.Tuesday;
    entry.Wednesday   = row.Wednesday;
    entry.Thursday    = row.Thursday;
    entry.Friday      = row.Friday;
    entry.Saturday    = row.Saturday;
    entry.Sunday      = row.Sunday;
    entry.RepeatHour  = row.RepeatHour;
    entry.RepeatMin   = row.RepeatMin;
    entry.Created     = row.Created;
    entry.Modified    = row.Modified;

    return entry;
};

RQService.Pms.GetLanguages
    = RQImported.PmsGetLanguages;

RQService.Pms.PopulateGetLanguagesRow = function (row) {
    var entry = { };

    entry.LangID       = row.LangID;
    entry.Language     = row.Language;
    entry.LangISOCode  = row.LangISOCode;

    return entry;
};

RQService.Pms.GetLocalPartnerFromGatewayPartner
    = RQImported.PmsGetLocalPartnerFromGatewayPartner;

RQService.Pms.PopulateGetLocalPartnerFromGatewayPartnerRow = function (row) {
    var entry = { };

    entry.LocalPartnerID  = row.LocalPartnerID;

    return entry;
};

RQService.Pms.GetLocationAndHotelParamsFromPath
    = RQImported.PmsGetLocationAndHotelParamsFromPath;

RQService.Pms.PopulateGetLocationAndHotelParamsFromPathRow = function (row) {
    var entry = { };

    entry.CountryID          = row.CountryID;
    entry.LocationGeoCodeID  = row.LocationGeoCodeID;
    entry.HotelID            = row.HotelID;

    return entry;
};

RQService.Pms.GetLocationAndHotelParamsFromPathML
    = RQImported.PmsGetLocationAndHotelParamsFromPathML;

RQService.Pms.PopulateGetLocationAndHotelParamsFromPathMLRow = function (row) {
    var entry = { };

    entry.CountryID          = row.CountryID;
    entry.LocationGeoCodeID  = row.LocationGeoCodeID;
    entry.HotelID            = row.HotelID;

    return entry;
};

RQService.Pms.GetLocationParamsFromPath
    = RQImported.PmsGetLocationParamsFromPath;

RQService.Pms.PopulateGetLocationParamsFromPathRow = function (row) {
    var entry = { };

    entry.CountryID          = row.CountryID;
    entry.LocationGeoCodeID  = row.LocationGeoCodeID;

    return entry;
};

RQService.Pms.GetLocationParamsFromPathML
    = RQImported.PmsGetLocationParamsFromPathML;

RQService.Pms.PopulateGetLocationParamsFromPathMLRow = function (row) {
    var entry = { };

    entry.CountryID          = row.CountryID;
    entry.LocationGeoCodeID  = row.LocationGeoCodeID;

    return entry;
};

RQService.Pms.GetMaxPersonsRateNames
    = RQImported.PmsGetMaxPersonsRateNames;

RQService.Pms.PopulateGetMaxPersonsRateNamesRow = function (row) {
    var entry = { };

    entry.MaxPersons          = row.MaxPersons;
    entry.MaxPersonsRateName  = row.MaxPersonsRateName;

    return entry;
};

RQService.Pms.GetMaxPersonsRateNamesByRoomType
    = RQImported.PmsGetMaxPersonsRateNamesByRoomType;

RQService.Pms.PopulateGetMaxPersonsRateNamesByRoomTypeRow = function (row) {
    var entry = { };

    entry.MaxPersons          = row.MaxPersons;
    entry.MaxPersonsRateName  = row.MaxPersonsRateName;

    return entry;
};

RQService.Pms.GetMessageByErrorCode
    = RQImported.PmsGetMessageByErrorCode;

RQService.Pms.PopulateGetMessageByErrorCodeRow = function (row) {
    var entry = { };

    entry.ErrorMessage  = row.ErrorMessage;

    return entry;
};

RQService.Pms.GetMixedRoomRateOfferDayInfoAll
    = RQImported.PmsGetMixedRoomRateOfferDayInfoAll;

RQService.Pms.PopulateGetMixedRoomRateOfferDayInfoAllRow = function (row) {
    var entry = { };

    entry.CDay                  = row.CDay;
    entry.Price                 = row.Price;
    entry.MLOS                  = row.MLOS;
    entry.MaxStay               = row.MaxStay;
    entry.AdvanceDays           = row.AdvanceDays;
    entry.NoArr                 = row.NoArr;
    entry.NoDep                 = row.NoDep;
    entry.Allotment             = row.Allotment;
    entry.Uptake                = row.Uptake;
    entry.Capacity              = row.Capacity;
    entry.FreeSale              = row.FreeSale;
    entry.Availability          = row.Availability;
    entry.IsFineTunedRateDay    = row.IsFineTunedRateDay;
    entry.ExhibitionPeriodID    = row.ExhibitionPeriodID;
    entry.ExhibitionPeriodName  = row.ExhibitionPeriodName;

    return entry;
};

RQService.Pms.GetMixedRoomRateOfferInfo
    = RQImported.PmsGetMixedRoomRateOfferInfo;

RQService.Pms.PopulateGetMixedRoomRateOfferInfoRow = function (row) {
    var entry = { };

    entry.RoomTypeID   = row.RoomTypeID;
    entry.CDay         = row.CDay;
    entry.Price        = row.Price;
    entry.MLOS         = row.MLOS;
    entry.MaxStay      = row.MaxStay;
    entry.AdvanceDays  = row.AdvanceDays;
    entry.NoArr        = row.NoArr;
    entry.NoDep        = row.NoDep;

    return entry;
};

RQService.Pms.GetMixedRoomRateOfferInfoAll
    = RQImported.PmsGetMixedRoomRateOfferInfoAll;

RQService.Pms.PopulateGetMixedRoomRateOfferInfoAllRow = function (row) {
    var entry = { };

    entry.CDay                  = row.CDay;
    entry.Price                 = row.Price;
    entry.MLOS                  = row.MLOS;
    entry.MaxStay               = row.MaxStay;
    entry.AdvanceDays           = row.AdvanceDays;
    entry.NoArr                 = row.NoArr;
    entry.NoDep                 = row.NoDep;
    entry.Allotment             = row.Allotment;
    entry.Uptake                = row.Uptake;
    entry.Capacity              = row.Capacity;
    entry.FreeSale              = row.FreeSale;
    entry.Availability          = row.Availability;
    entry.IsFineTunedRateDay    = row.IsFineTunedRateDay;
    entry.ExhibitionPeriodID    = row.ExhibitionPeriodID;
    entry.ExhibitionPeriodName  = row.ExhibitionPeriodName;

    return entry;
};

RQService.Pms.GetMixedRoomRateOfferTotal
    = RQImported.PmsGetMixedRoomRateOfferTotal;

RQService.Pms.PopulateGetMixedRoomRateOfferTotalRow = function (row) {
    var entry = { };

    entry.Total  = row.Total;

    return entry;
};

RQService.Pms.GetMixedRoomRateOfferTotalWithDiscount
    = RQImported.PmsGetMixedRoomRateOfferTotalWithDiscount;

RQService.Pms.PopulateGetMixedRoomRateOfferTotalWithDiscountRow = function (row) {
    var entry = { };

    entry.Total         = row.Total;
    entry.DiscountDays  = row.DiscountDays;

    return entry;
};

RQService.Pms.GetMLViews
    = RQImported.PmsGetMLViews;

RQService.Pms.PopulateGetMLViewsRow = function (row) {
    var entry = { };

    entry.FormID    = row.FormID;
    entry.FormName  = row.FormName;

    return entry;
};

RQService.Pms.GetMLViewTexts
    = RQImported.PmsGetMLViewTexts;

RQService.Pms.PopulateGetMLViewTextsRow = function (row) {
    var entry = { };

    entry.FormID          = row.FormID;
    entry.FormName        = row.FormName;
    entry.MLTextID        = row.MLTextID;
    entry.MLTextName      = row.MLTextName;
    entry.English         = row.English;
    entry.Translation     = row.Translation;
    entry.HasTranslation  = row.HasTranslation;
    entry.NeedsReview     = row.NeedsReview;
    entry.LangID          = row.LangID;

    return entry;
};

RQService.Pms.GetNotificationEvent
    = RQImported.PmsGetNotificationEvent;

RQService.Pms.PopulateGetNotificationEventRow = function (row) {
    var entry = { };

    entry.NotificationEventID            = row.NotificationEventID;
    entry.NotificationID                 = row.NotificationID;
    entry.Message                        = row.Message;
    entry.Description                    = row.Description;
    entry.IsToday                        = row.IsToday;
    entry.IsYesterday                    = row.IsYesterday;
    entry.IsLast7Days                    = row.IsLast7Days;
    entry.Month                          = row.Month;
    entry.Year                           = row.Year;
    entry.IsError                        = row.IsError;
    entry.ReservationID                  = row.ReservationID;
    entry.ReservationRoomNumberList      = row.ReservationRoomNumberList;
    entry.NumRoomRes                     = row.NumRoomRes;
    entry.ExternalReservationID          = row.ExternalReservationID;
    entry.FirstArr                       = row.FirstArr;
    entry.LastDep                        = row.LastDep;
    entry.IsBroken                       = row.IsBroken;
    entry.OwningGuestID                  = row.OwningGuestID;
    entry.FullGuestName                  = row.FullGuestName;
    entry.ReservationStatusID            = row.ReservationStatusID;
    entry.ReservationStatusName          = row.ReservationStatusName;
    entry.PaymentSchemeID                = row.PaymentSchemeID;
    entry.PaymentSchemeName              = row.PaymentSchemeName;
    entry.NotePriorityLevel              = row.NotePriorityLevel;
    entry.PriorityNotes                  = row.PriorityNotes;
    entry.EngineGuestComments            = row.EngineGuestComments;
    entry.ServiceTotal                   = row.ServiceTotal;
    entry.SumRoomTotal                   = row.SumRoomTotal;
    entry.ReservationTotal               = row.ReservationTotal;
    entry.PriceDiscrepency               = row.PriceDiscrepency;
    entry.InsufficientContiguity         = row.InsufficientContiguity;
    entry.ConstraintViolation            = row.ConstraintViolation;
    entry.PaymentSchemeBroken            = row.PaymentSchemeBroken;
    entry.InsufficientAllotment          = row.InsufficientAllotment;
    entry.OfferTypeExpired               = row.OfferTypeExpired;
    entry.ExclusiveRatePeriodExpired     = row.ExclusiveRatePeriodExpired;
    entry.RoomReservationID              = row.RoomReservationID;
    entry.RoomID                         = row.RoomID;
    entry.RoomNumber                     = row.RoomNumber;
    entry.RoomTypeID                     = row.RoomTypeID;
    entry.RoomTypeName                   = row.RoomTypeName;
    entry.RoomReservationRoomNumberList  = row.RoomReservationRoomNumberList;
    entry.MaxPersons                     = row.MaxPersons;
    entry.MaxPersonsRateName             = row.MaxPersonsRateName;
    entry.Arr                            = row.Arr;
    entry.Dep                            = row.Dep;
    entry.RoomReservationStatusID        = row.RoomReservationStatusID;
    entry.RoomReservationStatusName      = row.RoomReservationStatusName;
    entry.RoomTotal                      = row.RoomTotal;
    entry.RoomServiceTotal               = row.RoomServiceTotal;
    entry.RRIsBroken                     = row.RRIsBroken;
    entry.RoomTypeInvalid                = row.RoomTypeInvalid;
    entry.RoomInvalid                    = row.RoomInvalid;
    entry.OfferTypeInvalid               = row.OfferTypeInvalid;
    entry.ExclusiveRatePeriodInvalid     = row.ExclusiveRatePeriodInvalid;
    entry.IsDetached                     = row.IsDetached;
    entry.InsufficientAvailability       = row.InsufficientAvailability;
    entry.RoomTypeExpired                = row.RoomTypeExpired;
    entry.PartnerID                      = row.PartnerID;
    entry.RoomPeriodNoteID               = row.RoomPeriodNoteID;
    entry.Partner                        = row.Partner;
    entry.Verified                       = row.Verified;
    entry.VerificationTime               = row.VerificationTime;
    entry.UserID                         = row.UserID;
    entry.UserName                       = row.UserName;
    entry.Created                        = row.Created;

    return entry;
};

RQService.Pms.GetNotificationEvents
    = RQImported.PmsGetNotificationEvents;

RQService.Pms.PopulateGetNotificationEventsRow = function (row) {
    var entry = { };

    entry.NotificationEventID            = row.NotificationEventID;
    entry.NotificationID                 = row.NotificationID;
    entry.Message                        = row.Message;
    entry.Description                    = row.Description;
    entry.IsToday                        = row.IsToday;
    entry.IsYesterday                    = row.IsYesterday;
    entry.IsLast7Days                    = row.IsLast7Days;
    entry.Month                          = row.Month;
    entry.Year                           = row.Year;
    entry.IsError                        = row.IsError;
    entry.ReservationID                  = row.ReservationID;
    entry.ReservationRoomNumberList      = row.ReservationRoomNumberList;
    entry.NumRoomRes                     = row.NumRoomRes;
    entry.ExternalReservationID          = row.ExternalReservationID;
    entry.FirstArr                       = row.FirstArr;
    entry.LastDep                        = row.LastDep;
    entry.IsBroken                       = row.IsBroken;
    entry.OwningGuestID                  = row.OwningGuestID;
    entry.FullGuestName                  = row.FullGuestName;
    entry.ReservationStatusID            = row.ReservationStatusID;
    entry.ReservationStatusName          = row.ReservationStatusName;
    entry.PaymentSchemeID                = row.PaymentSchemeID;
    entry.PaymentSchemeName              = row.PaymentSchemeName;
    entry.NotePriorityLevel              = row.NotePriorityLevel;
    entry.PriorityNotes                  = row.PriorityNotes;
    entry.EngineGuestComments            = row.EngineGuestComments;
    entry.ServiceTotal                   = row.ServiceTotal;
    entry.SumRoomTotal                   = row.SumRoomTotal;
    entry.ReservationTotal               = row.ReservationTotal;
    entry.PriceDiscrepency               = row.PriceDiscrepency;
    entry.InsufficientContiguity         = row.InsufficientContiguity;
    entry.ConstraintViolation            = row.ConstraintViolation;
    entry.PaymentSchemeBroken            = row.PaymentSchemeBroken;
    entry.InsufficientAllotment          = row.InsufficientAllotment;
    entry.OfferTypeExpired               = row.OfferTypeExpired;
    entry.ExclusiveRatePeriodExpired     = row.ExclusiveRatePeriodExpired;
    entry.RoomReservationID              = row.RoomReservationID;
    entry.RoomID                         = row.RoomID;
    entry.RoomNumber                     = row.RoomNumber;
    entry.RoomTypeID                     = row.RoomTypeID;
    entry.RoomTypeName                   = row.RoomTypeName;
    entry.RoomReservationRoomNumberList  = row.RoomReservationRoomNumberList;
    entry.MaxPersons                     = row.MaxPersons;
    entry.MaxPersonsRateName             = row.MaxPersonsRateName;
    entry.Arr                            = row.Arr;
    entry.Dep                            = row.Dep;
    entry.RoomReservationStatusID        = row.RoomReservationStatusID;
    entry.RoomReservationStatusName      = row.RoomReservationStatusName;
    entry.RoomTotal                      = row.RoomTotal;
    entry.RoomServiceTotal               = row.RoomServiceTotal;
    entry.RRIsBroken                     = row.RRIsBroken;
    entry.RoomTypeInvalid                = row.RoomTypeInvalid;
    entry.RoomInvalid                    = row.RoomInvalid;
    entry.OfferTypeInvalid               = row.OfferTypeInvalid;
    entry.ExclusiveRatePeriodInvalid     = row.ExclusiveRatePeriodInvalid;
    entry.IsDetached                     = row.IsDetached;
    entry.InsufficientAvailability       = row.InsufficientAvailability;
    entry.RoomTypeExpired                = row.RoomTypeExpired;
    entry.PartnerID                      = row.PartnerID;
    entry.RoomPeriodNoteID               = row.RoomPeriodNoteID;
    entry.Partner                        = row.Partner;
    entry.Verified                       = row.Verified;
    entry.VerificationTime               = row.VerificationTime;
    entry.UserID                         = row.UserID;
    entry.UserName                       = row.UserName;
    entry.Created                        = row.Created;

    return entry;
};

RQService.Pms.GetOccupancyData
    = RQImported.PmsGetOccupancyData;

RQService.Pms.PopulateGetOccupancyDataRow = function (row) {
    var entry = { };

    entry.RoomID                     = row.RoomID;
    entry.SortOrder                  = row.SortOrder;
    entry.Detached                   = row.Detached;
    entry.RoomNumber                 = row.RoomNumber;
    entry.RoomTypeID                 = row.RoomTypeID;
    entry.MaxPersons                 = row.MaxPersons;
    entry.PersonsNormal              = row.PersonsNormal;
    entry.RoomTypeName               = row.RoomTypeName;
    entry.MaxPersonsRateName         = row.MaxPersonsRateName;
    entry.ResDay                     = row.ResDay;
    entry.ReservationID              = row.ReservationID;
    entry.BackwardPointsUp           = row.BackwardPointsUp;
    entry.BackwardPointsDown         = row.BackwardPointsDown;
    entry.ForwardPointsUp            = row.ForwardPointsUp;
    entry.ForwardPointsDown          = row.ForwardPointsDown;
    entry.ReservationStatusID        = row.ReservationStatusID;
    entry.ReservationStatusName      = row.ReservationStatusName;
    entry.PaymentSchemeID            = row.PaymentSchemeID;
    entry.PaymentSchemeName          = row.PaymentSchemeName;
    entry.ReservationTotal           = row.ReservationTotal;
    entry.OwningGuestID              = row.OwningGuestID;
    entry.FullOwningGuestName        = row.FullOwningGuestName;
    entry.OwningGuestFirstName       = row.OwningGuestFirstName;
    entry.OwningGuestLastName        = row.OwningGuestLastName;
    entry.RoomReservationID          = row.RoomReservationID;
    entry.Arr                        = row.Arr;
    entry.Dep                        = row.Dep;
    entry.RoomTotal                  = row.RoomTotal;
    entry.RoomReservationStatusID    = row.RoomReservationStatusID;
    entry.RoomReservationStatusName  = row.RoomReservationStatusName;
    entry.RoomCharge                 = row.RoomCharge;
    entry.IsCheckedIn                = row.IsCheckedIn;
    entry.CheckedIn                  = row.CheckedIn;
    entry.IsCheckedOut               = row.IsCheckedOut;
    entry.CheckedOut                 = row.CheckedOut;
    entry.IsNoShow                   = row.IsNoShow;
    entry.NoShow                     = row.NoShow;
    entry.IsSameDayCheckout          = row.IsSameDayCheckout;
    entry.GuestID                    = row.GuestID;
    entry.FullGuestName              = row.FullGuestName;
    entry.GuestFirstName             = row.GuestFirstName;
    entry.GuestLastName              = row.GuestLastName;
    entry.InquiryGuestID             = row.InquiryGuestID;
    entry.InquiryFullGuestName       = row.InquiryFullGuestName;
    entry.InquiryGuestFirstName      = row.InquiryGuestFirstName;
    entry.InquiryGuestLastName       = row.InquiryGuestLastName;
    entry.RoomPeriodNoteID           = row.RoomPeriodNoteID;
    entry.NotePriorityLevel          = row.NotePriorityLevel;
    entry.Notes                      = row.Notes;
    entry.IsFirstDay                 = row.IsFirstDay;
    entry.IsLastDay                  = row.IsLastDay;
    entry.EffectivePriority          = row.EffectivePriority;

    return entry;
};

RQService.Pms.GetOccupancyDataWindow
    = RQImported.PmsGetOccupancyDataWindow;

RQService.Pms.PopulateGetOccupancyDataWindowRow = function (row) {
    var entry = { };

    entry.RoomID                     = row.RoomID;
    entry.SortOrder                  = row.SortOrder;
    entry.Detached                   = row.Detached;
    entry.RoomNumber                 = row.RoomNumber;
    entry.RoomTypeID                 = row.RoomTypeID;
    entry.MaxPersons                 = row.MaxPersons;
    entry.PersonsNormal              = row.PersonsNormal;
    entry.RoomTypeName               = row.RoomTypeName;
    entry.MaxPersonsRateName         = row.MaxPersonsRateName;
    entry.ResDay                     = row.ResDay;
    entry.ReservationID              = row.ReservationID;
    entry.BackwardPointsUp           = row.BackwardPointsUp;
    entry.BackwardPointsDown         = row.BackwardPointsDown;
    entry.ForwardPointsUp            = row.ForwardPointsUp;
    entry.ForwardPointsDown          = row.ForwardPointsDown;
    entry.ReservationStatusID        = row.ReservationStatusID;
    entry.ReservationStatusName      = row.ReservationStatusName;
    entry.PaymentSchemeID            = row.PaymentSchemeID;
    entry.PaymentSchemeName          = row.PaymentSchemeName;
    entry.ReservationTotal           = row.ReservationTotal;
    entry.OwningGuestID              = row.OwningGuestID;
    entry.FullOwningGuestName        = row.FullOwningGuestName;
    entry.OwningGuestFirstName       = row.OwningGuestFirstName;
    entry.OwningGuestLastName        = row.OwningGuestLastName;
    entry.RoomReservationID          = row.RoomReservationID;
    entry.Arr                        = row.Arr;
    entry.Dep                        = row.Dep;
    entry.RoomTotal                  = row.RoomTotal;
    entry.RoomReservationStatusID    = row.RoomReservationStatusID;
    entry.RoomReservationStatusName  = row.RoomReservationStatusName;
    entry.RoomCharge                 = row.RoomCharge;
    entry.IsCheckedIn                = row.IsCheckedIn;
    entry.CheckedIn                  = row.CheckedIn;
    entry.IsCheckedOut               = row.IsCheckedOut;
    entry.CheckedOut                 = row.CheckedOut;
    entry.IsNoShow                   = row.IsNoShow;
    entry.NoShow                     = row.NoShow;
    entry.IsSameDayCheckout          = row.IsSameDayCheckout;
    entry.GuestID                    = row.GuestID;
    entry.FullGuestName              = row.FullGuestName;
    entry.GuestFirstName             = row.GuestFirstName;
    entry.GuestLastName              = row.GuestLastName;
    entry.InquiryGuestID             = row.InquiryGuestID;
    entry.InquiryFullGuestName       = row.InquiryFullGuestName;
    entry.InquiryGuestFirstName      = row.InquiryGuestFirstName;
    entry.InquiryGuestLastName       = row.InquiryGuestLastName;
    entry.RoomPeriodNoteID           = row.RoomPeriodNoteID;
    entry.NotePriorityLevel          = row.NotePriorityLevel;
    entry.Notes                      = row.Notes;
    entry.IsFirstDay                 = row.IsFirstDay;
    entry.IsLastDay                  = row.IsLastDay;
    entry.EffectivePriority          = row.EffectivePriority;

    return entry;
};

RQService.Pms.GetOfferType
    = RQImported.PmsGetOfferType;

RQService.Pms.PopulateGetOfferTypeRow = function (row) {
    var entry = { };

    entry.OfferTypeID                  = row.OfferTypeID;
    entry.Expired                      = row.Expired;
    entry.ReleaseDays                  = row.ReleaseDays;
    entry.CancelConsumesAvailability   = row.CancelConsumesAvailability;
    entry.Credentials                  = row.Credentials;
    entry.OfferTypeName                = row.OfferTypeName;
    entry.OfferTypeNameFull            = row.OfferTypeNameFull;
    entry.OfferTypeDescription         = row.OfferTypeDescription;
    entry.RackRatePaymentSchemeID      = row.RackRatePaymentSchemeID;
    entry.SourceOfferTypeID            = row.SourceOfferTypeID;
    entry.DiscountTypeID               = row.DiscountTypeID;
    entry.Surcharge                    = row.Surcharge;
    entry.SourceMLOS                   = row.SourceMLOS;
    entry.SourceMaxStay                = row.SourceMaxStay;
    entry.SourceAdvanceDays            = row.SourceAdvanceDays;
    entry.SourceNoArr                  = row.SourceNoArr;
    entry.SourceNoDep                  = row.SourceNoDep;
    entry.SourceMaxPersons             = row.SourceMaxPersons;
    entry.InitialiseAllotmentToZero    = row.InitialiseAllotmentToZero;
    entry.DerivedAllotmentOfferTypeID  = row.DerivedAllotmentOfferTypeID;
    entry.MaxPersonsAllotmentLinked    = row.MaxPersonsAllotmentLinked;
    entry.PaymentSchemeName            = row.PaymentSchemeName;
    entry.PaymentSchemeDescription     = row.PaymentSchemeDescription;
    entry.IsDiscountFilter             = row.IsDiscountFilter;
    entry.HasProductSpread             = row.HasProductSpread;
    entry.OfferTypeAutoNameID          = row.OfferTypeAutoNameID;
    entry.PackageLevelAdvanceDays      = row.PackageLevelAdvanceDays;

    return entry;
};

RQService.Pms.GetOfferTypeAutoNames
    = RQImported.PmsGetOfferTypeAutoNames;

RQService.Pms.PopulateGetOfferTypeAutoNamesRow = function (row) {
    var entry = { };

    entry.OfferTypeAutoNameID  = row.OfferTypeAutoNameID;
    entry.OfferTypeName        = row.OfferTypeName;
    entry.PaymentSchemeID      = row.PaymentSchemeID;

    return entry;
};

RQService.Pms.GetOfferTypeIDByPartnerOfferTypeID
    = RQImported.PmsGetOfferTypeIDByPartnerOfferTypeID;

RQService.Pms.PopulateGetOfferTypeIDByPartnerOfferTypeIDRow = function (row) {
    var entry = { };

    entry.OfferTypeID         = row.OfferTypeID;
    entry.SpecificMaxPersons  = row.SpecificMaxPersons;

    return entry;
};

RQService.Pms.GetOfferTypeIDByPartnerOfferTypeName
    = RQImported.PmsGetOfferTypeIDByPartnerOfferTypeName;

RQService.Pms.PopulateGetOfferTypeIDByPartnerOfferTypeNameRow = function (row) {
    var entry = { };

    entry.OfferTypeID         = row.OfferTypeID;
    entry.SpecificMaxPersons  = row.SpecificMaxPersons;

    return entry;
};

RQService.Pms.GetOfferTypeListeners
    = RQImported.PmsGetOfferTypeListeners;

RQService.Pms.PopulateGetOfferTypeListenersRow = function (row) {
    var entry = { };

    entry.OfferTypeID           = row.OfferTypeID;
    entry.ListeningOfferTypeID  = row.ListeningOfferTypeID;
    entry.ListeningToRates      = row.ListeningToRates;
    entry.ListeningToAllotment  = row.ListeningToAllotment;

    return entry;
};

RQService.Pms.GetOfferTypeMemberDiscountDays
    = RQImported.PmsGetOfferTypeMemberDiscountDays;

RQService.Pms.PopulateGetOfferTypeMemberDiscountDaysRow = function (row) {
    var entry = { };

    entry.ResDay   = row.ResDay;
    entry.Blocked  = row.Blocked;

    return entry;
};

RQService.Pms.GetOfferTypeMemberDiscounts
    = RQImported.PmsGetOfferTypeMemberDiscounts;

RQService.Pms.PopulateGetOfferTypeMemberDiscountsRow = function (row) {
    var entry = { };

    entry.OfferTypeID           = row.OfferTypeID;
    entry.OfferTypeName         = row.OfferTypeName;
    entry.OfferTypeDescription  = row.OfferTypeDescription;
    entry.AllowDiscount         = row.AllowDiscount;
    entry.DiscountPercentage    = row.DiscountPercentage;

    return entry;
};

RQService.Pms.GetOfferTypeMemberDiscountWindow
    = RQImported.PmsGetOfferTypeMemberDiscountWindow;

RQService.Pms.PopulateGetOfferTypeMemberDiscountWindowRow = function (row) {
    var entry = { };

    entry.ResDay   = row.ResDay;
    entry.Blocked  = row.Blocked;

    return entry;
};

RQService.Pms.GetOfferTypeName
    = RQImported.PmsGetOfferTypeName;

RQService.Pms.PopulateGetOfferTypeNameRow = function (row) {
    var entry = { };

    entry.OfferTypeName         = row.OfferTypeName;
    entry.OfferTypeDescription  = row.OfferTypeDescription;

    return entry;
};

RQService.Pms.GetOfferTypeNamesAll
    = RQImported.PmsGetOfferTypeNamesAll;

RQService.Pms.PopulateGetOfferTypeNamesAllRow = function (row) {
    var entry = { };

    entry.HotelID               = row.HotelID;
    entry.OfferTypeID           = row.OfferTypeID;
    entry.LangID                = row.LangID;
    entry.LangISOCode           = row.LangISOCode;
    entry.OfferTypeName         = row.OfferTypeName;
    entry.OfferTypeDescription  = row.OfferTypeDescription;
    entry.Created               = row.Created;

    return entry;
};

RQService.Pms.GetOfferTypeNavigationData
    = RQImported.PmsGetOfferTypeNavigationData;

RQService.Pms.PopulateGetOfferTypeNavigationDataRow = function (row) {
    var entry = { };

    entry.OfferTypeID                   = row.OfferTypeID;
    entry.RoomTypeID                    = row.RoomTypeID;
    entry.MaxPersons                    = row.MaxPersons;
    entry.OfferTypeName                 = row.OfferTypeName;
    entry.OfferTypeDescription          = row.OfferTypeDescription;
    entry.RoomTypeName                  = row.RoomTypeName;
    entry.NumRooms                      = row.NumRooms;
    entry.MaxPersonsRateName            = row.MaxPersonsRateName;
    entry.PaymentSchemeID               = row.PaymentSchemeID;
    entry.PaymentSchemeName             = row.PaymentSchemeName;
    entry.PaymentSchemeDescription      = row.PaymentSchemeDescription;
    entry.HasRemoteListeners            = row.HasRemoteListeners;
    entry.IsOfferTypeUnmapped           = row.IsOfferTypeUnmapped;
    entry.CancelConsumesAvailability    = row.CancelConsumesAvailability;
    entry.ReleaseDays                   = row.ReleaseDays;
    entry.MaxPersonsAllotmentLinked     = row.MaxPersonsAllotmentLinked;
    entry.DerivedAllotmentOfferTypeID   = row.DerivedAllotmentOfferTypeID;
    entry.OfferTypeSupportsMLOS         = row.OfferTypeSupportsMLOS;
    entry.OfferTypeSupportsMaxStay      = row.OfferTypeSupportsMaxStay;
    entry.OfferTypeSupportsAdvanceDays  = row.OfferTypeSupportsAdvanceDays;
    entry.OfferTypeSupportsNoArr        = row.OfferTypeSupportsNoArr;
    entry.OfferTypeSupportsNoDep        = row.OfferTypeSupportsNoDep;
    entry.IsDiscountFilter              = row.IsDiscountFilter;
    entry.SourceOfferTypeID             = row.SourceOfferTypeID;
    entry.Surcharge                     = row.Surcharge;
    entry.SourceMLOS                    = row.SourceMLOS;
    entry.SourceMaxStay                 = row.SourceMaxStay;
    entry.SourceAdvanceDays             = row.SourceAdvanceDays;
    entry.SourceNoArr                   = row.SourceNoArr;
    entry.SourceNoDep                   = row.SourceNoDep;
    entry.PersonsNormal                 = row.PersonsNormal;
    entry.MaxPersonsNormal              = row.MaxPersonsNormal;
    entry.MinPrice                      = row.MinPrice;
    entry.MaxPrice                      = row.MaxPrice;

    return entry;
};

RQService.Pms.GetOfferTypePartners
    = RQImported.PmsGetOfferTypePartners;

RQService.Pms.PopulateGetOfferTypePartnersRow = function (row) {
    var entry = { };

    entry.OfferTypeID           = row.OfferTypeID;
    entry.PartnerID             = row.PartnerID;
    entry.IsDirect              = row.IsDirect;
    entry.ListeningToRates      = row.ListeningToRates;
    entry.ListeningToAllotment  = row.ListeningToAllotment;

    return entry;
};

RQService.Pms.GetOfferTypes
    = RQImported.PmsGetOfferTypes;

RQService.Pms.PopulateGetOfferTypesRow = function (row) {
    var entry = { };

    entry.OfferTypeID                  = row.OfferTypeID;
    entry.Expired                      = row.Expired;
    entry.ReleaseDays                  = row.ReleaseDays;
    entry.CancelConsumesAvailability   = row.CancelConsumesAvailability;
    entry.Credentials                  = row.Credentials;
    entry.OfferTypeName                = row.OfferTypeName;
    entry.OfferTypeNameFull            = row.OfferTypeNameFull;
    entry.OfferTypeDescription         = row.OfferTypeDescription;
    entry.RackRatePaymentSchemeID      = row.RackRatePaymentSchemeID;
    entry.SourceOfferTypeID            = row.SourceOfferTypeID;
    entry.DiscountTypeID               = row.DiscountTypeID;
    entry.Surcharge                    = row.Surcharge;
    entry.SourceMLOS                   = row.SourceMLOS;
    entry.SourceMaxStay                = row.SourceMaxStay;
    entry.SourceAdvanceDays            = row.SourceAdvanceDays;
    entry.SourceNoArr                  = row.SourceNoArr;
    entry.SourceNoDep                  = row.SourceNoDep;
    entry.SourceMaxPersons             = row.SourceMaxPersons;
    entry.InitialiseAllotmentToZero    = row.InitialiseAllotmentToZero;
    entry.DerivedAllotmentOfferTypeID  = row.DerivedAllotmentOfferTypeID;
    entry.MaxPersonsAllotmentLinked    = row.MaxPersonsAllotmentLinked;
    entry.PaymentSchemeName            = row.PaymentSchemeName;
    entry.PaymentSchemeDescription     = row.PaymentSchemeDescription;
    entry.IsDiscountFilter             = row.IsDiscountFilter;
    entry.HasProductSpread             = row.HasProductSpread;
    entry.OfferTypeAutoNameID          = row.OfferTypeAutoNameID;
    entry.PackageLevelAdvanceDays      = row.PackageLevelAdvanceDays;

    return entry;
};

RQService.Pms.GetOfferTypesByPartner
    = RQImported.PmsGetOfferTypesByPartner;

RQService.Pms.PopulateGetOfferTypesByPartnerRow = function (row) {
    var entry = { };

    entry.OfferTypeID                 = row.OfferTypeID;
    entry.OfferTypeAutoNameID         = row.OfferTypeAutoNameID;
    entry.ReleaseDays                 = row.ReleaseDays;
    entry.CancelConsumesAvailability  = row.CancelConsumesAvailability;
    entry.Credentials                 = row.Credentials;
    entry.RackRatePaymentSchemeID     = row.RackRatePaymentSchemeID;
    entry.OfferTypeName               = row.OfferTypeName;
    entry.OfferTypeDescription        = row.OfferTypeDescription;
    entry.HasProductSpread            = row.HasProductSpread;
    entry.IsBreakfast                 = row.IsBreakfast;

    return entry;
};

RQService.Pms.GetOfferTypeSharedAllotmentGroups
    = RQImported.PmsGetOfferTypeSharedAllotmentGroups;

RQService.Pms.PopulateGetOfferTypeSharedAllotmentGroupsRow = function (row) {
    var entry = { };

    entry.DerivedAllotmentOfferTypeID  = row.DerivedAllotmentOfferTypeID;
    entry.SharedAllotmentOfferTypeID   = row.SharedAllotmentOfferTypeID;

    return entry;
};

RQService.Pms.GetOfferTypeSharedRateGroups
    = RQImported.PmsGetOfferTypeSharedRateGroups;

RQService.Pms.PopulateGetOfferTypeSharedRateGroupsRow = function (row) {
    var entry = { };

    entry.SourceOfferTypeID  = row.SourceOfferTypeID;
    entry.FilterOfferTypeID  = row.FilterOfferTypeID;

    return entry;
};

RQService.Pms.GetPartner
    = RQImported.PmsGetPartner;

RQService.Pms.PopulateGetPartnerRow = function (row) {
    var entry = { };

    entry.HotelID                     = row.HotelID;
    entry.PartnerID                   = row.PartnerID;
    entry.Partner                     = row.Partner;
    entry.Expired                     = row.Expired;
    entry.Builtin                     = row.Builtin;
    entry.IsRemote                    = row.IsRemote;
    entry.RemotePropertyID            = row.RemotePropertyID;
    entry.SupportsMLOS                = row.SupportsMLOS;
    entry.SupportsMaxStay             = row.SupportsMaxStay;
    entry.SupportsAdvanceDays         = row.SupportsAdvanceDays;
    entry.SupportsNoArr               = row.SupportsNoArr;
    entry.SupportsNoDep               = row.SupportsNoDep;
    entry.SupportsMaxPersons          = row.SupportsMaxPersons;
    entry.CommissionPrepaid           = row.CommissionPrepaid;
    entry.CommissionPercentage        = row.CommissionPercentage;
    entry.CommissionPerReservation    = row.CommissionPerReservation;
    entry.CommissionVAT               = row.CommissionVAT;
    entry.UserName                    = row.UserName;
    entry.Credentials                 = row.Credentials;
    entry.LastPull                    = row.LastPull;
    entry.NeedsExplicitMap            = row.NeedsExplicitMap;
    entry.Deactivated                 = row.Deactivated;
    entry.PushWithoutAdditionalTaxes  = row.PushWithoutAdditionalTaxes;
    entry.PushActive                  = row.PushActive;
    entry.PullActive                  = row.PullActive;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Pms.GetPartnerOfferTypeID
    = RQImported.PmsGetPartnerOfferTypeID;

RQService.Pms.PopulateGetPartnerOfferTypeIDRow = function (row) {
    var entry = { };

    entry.PartnerOfferTypeID    = row.PartnerOfferTypeID;
    entry.PartnerOfferTypeName  = row.PartnerOfferTypeName;

    return entry;
};

RQService.Pms.GetPartners
    = RQImported.PmsGetPartners;

RQService.Pms.PopulateGetPartnersRow = function (row) {
    var entry = { };

    entry.HotelID                     = row.HotelID;
    entry.PartnerID                   = row.PartnerID;
    entry.Partner                     = row.Partner;
    entry.Expired                     = row.Expired;
    entry.Builtin                     = row.Builtin;
    entry.IsRemote                    = row.IsRemote;
    entry.RemotePropertyID            = row.RemotePropertyID;
    entry.SupportsMLOS                = row.SupportsMLOS;
    entry.SupportsMaxStay             = row.SupportsMaxStay;
    entry.SupportsAdvanceDays         = row.SupportsAdvanceDays;
    entry.SupportsNoArr               = row.SupportsNoArr;
    entry.SupportsNoDep               = row.SupportsNoDep;
    entry.SupportsMaxPersons          = row.SupportsMaxPersons;
    entry.CommissionPrepaid           = row.CommissionPrepaid;
    entry.CommissionPercentage        = row.CommissionPercentage;
    entry.CommissionPerReservation    = row.CommissionPerReservation;
    entry.CommissionVAT               = row.CommissionVAT;
    entry.UserName                    = row.UserName;
    entry.Credentials                 = row.Credentials;
    entry.LastPull                    = row.LastPull;
    entry.NeedsExplicitMap            = row.NeedsExplicitMap;
    entry.Deactivated                 = row.Deactivated;
    entry.PushWithoutAdditionalTaxes  = row.PushWithoutAdditionalTaxes;
    entry.PushActive                  = row.PushActive;
    entry.PullActive                  = row.PullActive;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Pms.GetPartnersWithPendingChannelActions
    = RQImported.PmsGetPartnersWithPendingChannelActions;

RQService.Pms.PopulateGetPartnersWithPendingChannelActionsRow = function (row) {
    var entry = { };

    entry.PartnerID  = row.PartnerID;

    return entry;
};

RQService.Pms.GetPaymentSchemes
    = RQImported.PmsGetPaymentSchemes;

RQService.Pms.PopulateGetPaymentSchemesRow = function (row) {
    var entry = { };

    entry.PaymentSchemeID           = row.PaymentSchemeID;
    entry.PaymentSchemeName         = row.PaymentSchemeName;
    entry.PaymentSchemeDescription  = row.PaymentSchemeDescription;

    return entry;
};

RQService.Pms.GetPaymentSchemesOTA
    = RQImported.PmsGetPaymentSchemesOTA;

RQService.Pms.PopulateGetPaymentSchemesOTARow = function (row) {
    var entry = { };

    entry.PaymentSchemeID           = row.PaymentSchemeID;
    entry.PaymentSchemeName         = row.PaymentSchemeName;
    entry.PaymentSchemeDescription  = row.PaymentSchemeDescription;

    return entry;
};

RQService.Pms.GetPendingChannelActions
    = RQImported.PmsGetPendingChannelActions;

RQService.Pms.PopulateGetPendingChannelActionsRow = function (row) {
    var entry = { };

    entry.ChannelActionID               = row.ChannelActionID;
    entry.PartnerID                     = row.PartnerID;
    entry.NeedsExplicitMap              = row.NeedsExplicitMap;
    entry.RemotePropertyID              = row.RemotePropertyID;
    entry.UserName                      = row.UserName;
    entry.Credentials                   = row.Credentials;
    entry.OfferTypeID                   = row.OfferTypeID;
    entry.PartnerOfferTypeID            = row.PartnerOfferTypeID;
    entry.PartnerOfferTypeName          = row.PartnerOfferTypeName;
    entry.ExclusiveRatePeriodID         = row.ExclusiveRatePeriodID;
    entry.PartnerExclusiveRatePeriodID  = row.PartnerExclusiveRatePeriodID;
    entry.CreateEditDelete              = row.CreateEditDelete;
    entry.RoomTypeID                    = row.RoomTypeID;
    entry.PersonsNormal                 = row.PersonsNormal;
    entry.PartnerRoomTypeName           = row.PartnerRoomTypeName;
    entry.PartnerRoomTypeID             = row.PartnerRoomTypeID;
    entry.MaxPersons                    = row.MaxPersons;
    entry.StartDate                     = row.StartDate;
    entry.EndDate                       = row.EndDate;
    entry.CloseOut                      = row.CloseOut;
    entry.DontPush                      = row.DontPush;
    entry.IsExplicitMap                 = row.IsExplicitMap;
    entry.Attempts                      = row.Attempts;
    entry.Created                       = row.Created;

    return entry;
};

RQService.Pms.GetPMSOverviewDataFull
    = RQImported.PmsGetPMSOverviewDataFull;

RQService.Pms.PopulateGetPMSOverviewDataFullRow = function (row) {
    var entry = { };

    entry.NotificationEventID            = row.NotificationEventID;
    entry.NotificationID                 = row.NotificationID;
    entry.Message                        = row.Message;
    entry.Description                    = row.Description;
    entry.IsToday                        = row.IsToday;
    entry.IsYesterday                    = row.IsYesterday;
    entry.IsLast7Days                    = row.IsLast7Days;
    entry.Month                          = row.Month;
    entry.Year                           = row.Year;
    entry.IsError                        = row.IsError;
    entry.ReservationID                  = row.ReservationID;
    entry.ReservationRoomNumberList      = row.ReservationRoomNumberList;
    entry.NumRoomRes                     = row.NumRoomRes;
    entry.ExternalReservationID          = row.ExternalReservationID;
    entry.FirstArr                       = row.FirstArr;
    entry.LastDep                        = row.LastDep;
    entry.IsBroken                       = row.IsBroken;
    entry.OwningGuestID                  = row.OwningGuestID;
    entry.FullGuestName                  = row.FullGuestName;
    entry.ReservationStatusID            = row.ReservationStatusID;
    entry.ReservationStatusName          = row.ReservationStatusName;
    entry.PaymentSchemeID                = row.PaymentSchemeID;
    entry.PaymentSchemeName              = row.PaymentSchemeName;
    entry.NotePriorityLevel              = row.NotePriorityLevel;
    entry.PriorityNotes                  = row.PriorityNotes;
    entry.EngineGuestComments            = row.EngineGuestComments;
    entry.ServiceTotal                   = row.ServiceTotal;
    entry.SumRoomTotal                   = row.SumRoomTotal;
    entry.ReservationTotal               = row.ReservationTotal;
    entry.PriceDiscrepency               = row.PriceDiscrepency;
    entry.InsufficientContiguity         = row.InsufficientContiguity;
    entry.ConstraintViolation            = row.ConstraintViolation;
    entry.PaymentSchemeBroken            = row.PaymentSchemeBroken;
    entry.InsufficientAllotment          = row.InsufficientAllotment;
    entry.OfferTypeExpired               = row.OfferTypeExpired;
    entry.ExclusiveRatePeriodExpired     = row.ExclusiveRatePeriodExpired;
    entry.RoomReservationID              = row.RoomReservationID;
    entry.RoomID                         = row.RoomID;
    entry.RoomNumber                     = row.RoomNumber;
    entry.RoomTypeID                     = row.RoomTypeID;
    entry.RoomTypeName                   = row.RoomTypeName;
    entry.RoomReservationRoomNumberList  = row.RoomReservationRoomNumberList;
    entry.MaxPersons                     = row.MaxPersons;
    entry.MaxPersonsRateName             = row.MaxPersonsRateName;
    entry.Arr                            = row.Arr;
    entry.Dep                            = row.Dep;
    entry.RoomReservationStatusID        = row.RoomReservationStatusID;
    entry.RoomReservationStatusName      = row.RoomReservationStatusName;
    entry.RoomTotal                      = row.RoomTotal;
    entry.RoomServiceTotal               = row.RoomServiceTotal;
    entry.RRIsBroken                     = row.RRIsBroken;
    entry.RoomTypeInvalid                = row.RoomTypeInvalid;
    entry.RoomInvalid                    = row.RoomInvalid;
    entry.OfferTypeInvalid               = row.OfferTypeInvalid;
    entry.ExclusiveRatePeriodInvalid     = row.ExclusiveRatePeriodInvalid;
    entry.IsDetached                     = row.IsDetached;
    entry.InsufficientAvailability       = row.InsufficientAvailability;
    entry.RoomTypeExpired                = row.RoomTypeExpired;
    entry.PartnerID                      = row.PartnerID;
    entry.RoomPeriodNoteID               = row.RoomPeriodNoteID;
    entry.Partner                        = row.Partner;
    entry.Verified                       = row.Verified;
    entry.VerificationTime               = row.VerificationTime;
    entry.UserID                         = row.UserID;
    entry.UserName                       = row.UserName;
    entry.Created                        = row.Created;

    return entry;
};

RQService.Pms.GetPMSOverviewDataSlim
    = RQImported.PmsGetPMSOverviewDataSlim;

RQService.Pms.PopulateGetPMSOverviewDataSlimRow = function (row) {
    var entry = { };

    entry.NotificationEventID            = row.NotificationEventID;
    entry.NotificationID                 = row.NotificationID;
    entry.Message                        = row.Message;
    entry.Description                    = row.Description;
    entry.IsToday                        = row.IsToday;
    entry.IsYesterday                    = row.IsYesterday;
    entry.IsLast7Days                    = row.IsLast7Days;
    entry.Month                          = row.Month;
    entry.Year                           = row.Year;
    entry.IsError                        = row.IsError;
    entry.ReservationID                  = row.ReservationID;
    entry.ReservationRoomNumberList      = row.ReservationRoomNumberList;
    entry.NumRoomRes                     = row.NumRoomRes;
    entry.ExternalReservationID          = row.ExternalReservationID;
    entry.FirstArr                       = row.FirstArr;
    entry.LastDep                        = row.LastDep;
    entry.IsBroken                       = row.IsBroken;
    entry.OwningGuestID                  = row.OwningGuestID;
    entry.FullGuestName                  = row.FullGuestName;
    entry.ReservationStatusID            = row.ReservationStatusID;
    entry.ReservationStatusName          = row.ReservationStatusName;
    entry.PaymentSchemeID                = row.PaymentSchemeID;
    entry.PaymentSchemeName              = row.PaymentSchemeName;
    entry.NotePriorityLevel              = row.NotePriorityLevel;
    entry.PriorityNotes                  = row.PriorityNotes;
    entry.EngineGuestComments            = row.EngineGuestComments;
    entry.ServiceTotal                   = row.ServiceTotal;
    entry.SumRoomTotal                   = row.SumRoomTotal;
    entry.ReservationTotal               = row.ReservationTotal;
    entry.PriceDiscrepency               = row.PriceDiscrepency;
    entry.InsufficientContiguity         = row.InsufficientContiguity;
    entry.ConstraintViolation            = row.ConstraintViolation;
    entry.PaymentSchemeBroken            = row.PaymentSchemeBroken;
    entry.InsufficientAllotment          = row.InsufficientAllotment;
    entry.OfferTypeExpired               = row.OfferTypeExpired;
    entry.ExclusiveRatePeriodExpired     = row.ExclusiveRatePeriodExpired;
    entry.RoomReservationID              = row.RoomReservationID;
    entry.RoomID                         = row.RoomID;
    entry.RoomNumber                     = row.RoomNumber;
    entry.RoomTypeID                     = row.RoomTypeID;
    entry.RoomTypeName                   = row.RoomTypeName;
    entry.RoomReservationRoomNumberList  = row.RoomReservationRoomNumberList;
    entry.MaxPersons                     = row.MaxPersons;
    entry.MaxPersonsRateName             = row.MaxPersonsRateName;
    entry.Arr                            = row.Arr;
    entry.Dep                            = row.Dep;
    entry.RoomReservationStatusID        = row.RoomReservationStatusID;
    entry.RoomReservationStatusName      = row.RoomReservationStatusName;
    entry.RoomTotal                      = row.RoomTotal;
    entry.RoomServiceTotal               = row.RoomServiceTotal;
    entry.RRIsBroken                     = row.RRIsBroken;
    entry.RoomTypeInvalid                = row.RoomTypeInvalid;
    entry.RoomInvalid                    = row.RoomInvalid;
    entry.OfferTypeInvalid               = row.OfferTypeInvalid;
    entry.ExclusiveRatePeriodInvalid     = row.ExclusiveRatePeriodInvalid;
    entry.IsDetached                     = row.IsDetached;
    entry.InsufficientAvailability       = row.InsufficientAvailability;
    entry.RoomTypeExpired                = row.RoomTypeExpired;
    entry.PartnerID                      = row.PartnerID;
    entry.RoomPeriodNoteID               = row.RoomPeriodNoteID;
    entry.Partner                        = row.Partner;
    entry.Verified                       = row.Verified;
    entry.VerificationTime               = row.VerificationTime;
    entry.UserID                         = row.UserID;
    entry.UserName                       = row.UserName;
    entry.Created                        = row.Created;

    return entry;
};

RQService.Pms.GetPMSOverviewRateData
    = RQImported.PmsGetPMSOverviewRateData;

RQService.Pms.PopulateGetPMSOverviewRateDataRow = function (row) {
    var entry = { };

    entry.RoomTypeID            = row.RoomTypeID;
    entry.PersonsNormal         = row.PersonsNormal;
    entry.MaxPersonsNormal      = row.MaxPersonsNormal;
    entry.MinPrice              = row.MinPrice;
    entry.MaxPrice              = row.MaxPrice;
    entry.DefaultPersonsNormal  = row.DefaultPersonsNormal;
    entry.RoomTypeName          = row.RoomTypeName;
    entry.RoomTypeNameID        = row.RoomTypeNameID;
    entry.NrOfRooms             = row.NrOfRooms;
    entry.SortOrder             = row.SortOrder;
    entry.HasRoomTypeAutoName   = row.HasRoomTypeAutoName;

    return entry;
};

RQService.Pms.GetPrimarySMTPServer
    = RQImported.PmsGetPrimarySMTPServer;

RQService.Pms.PopulateGetPrimarySMTPServerRow = function (row) {
    var entry = { };

    entry.HotelID         = row.HotelID;
    entry.SMTPServerID    = row.SMTPServerID;
    entry.Description     = row.Description;
    entry.ServerName      = row.ServerName;
    entry.Port            = row.Port;
    entry.EnableSSL       = row.EnableSSL;
    entry.UseCredentials  = row.UseCredentials;
    entry.Username        = row.Username;
    entry.Password        = row.Password;
    entry.IsPrimary       = row.IsPrimary;
    entry.Created         = row.Created;

    return entry;
};

RQService.Pms.GetProjectedTurnover
    = RQImported.PmsGetProjectedTurnover;

RQService.Pms.PopulateGetProjectedTurnoverRow = function (row) {
    var entry = { };

    entry.ResDay               = row.ResDay;
    entry.RoomTypeID           = row.RoomTypeID;
    entry.RoomTypeName         = row.RoomTypeName;
    entry.PersonsNormal        = row.PersonsNormal;
    entry.Total                = row.Total;
    entry.AverageRoomPrice     = row.AverageRoomPrice;
    entry.Occupancy            = row.Occupancy;
    entry.PercentageOccupancy  = row.PercentageOccupancy;

    return entry;
};

RQService.Pms.GetProjectedTurnoverByPartner
    = RQImported.PmsGetProjectedTurnoverByPartner;

RQService.Pms.PopulateGetProjectedTurnoverByPartnerRow = function (row) {
    var entry = { };

    entry.PartnerID                     = row.PartnerID;
    entry.Partner                       = row.Partner;
    entry.NumReservations               = row.NumReservations;
    entry.NumRoomReservations           = row.NumRoomReservations;
    entry.Total                         = row.Total;
    entry.Base                          = row.Base;
    entry.Tax                           = row.Tax;
    entry.PercentageOfReservations      = row.PercentageOfReservations;
    entry.PercentageOfRoomReservations  = row.PercentageOfRoomReservations;
    entry.Commission                    = row.Commission;

    return entry;
};

RQService.Pms.GetProjectedTurnoverTotals
    = RQImported.PmsGetProjectedTurnoverTotals;

RQService.Pms.PopulateGetProjectedTurnoverTotalsRow = function (row) {
    var entry = { };

    entry.ResDay               = row.ResDay;
    entry.Total                = row.Total;
    entry.Occupancy            = row.Occupancy;
    entry.PercentageOccupancy  = row.PercentageOccupancy;
    entry.AverageRoomPrice     = row.AverageRoomPrice;

    return entry;
};

RQService.Pms.GetRackRateChannelData
    = RQImported.PmsGetRackRateChannelData;

RQService.Pms.PopulateGetRackRateChannelDataRow = function (row) {
    var entry = { };

    entry.CDay         = row.CDay;
    entry.WeekDay      = row.WeekDay;
    entry.BeforeTax    = row.BeforeTax;
    entry.AfterTax     = row.AfterTax;
    entry.Price        = row.Price;
    entry.MLOS         = row.MLOS;
    entry.MaxStay      = row.MaxStay;
    entry.AdvanceDays  = row.AdvanceDays;
    entry.NoArr        = row.NoArr;
    entry.NoDep        = row.NoDep;
    entry.Capacity     = row.Capacity;
    entry.StopSell     = row.StopSell;

    return entry;
};

RQService.Pms.GetRackRatePeriodsWithMissingRateInfo
    = RQImported.PmsGetRackRatePeriodsWithMissingRateInfo;

RQService.Pms.PopulateGetRackRatePeriodsWithMissingRateInfoRow = function (row) {
    var entry = { };

    entry.RackRatePeriodID    = row.RackRatePeriodID;
    entry.StartDate           = row.StartDate;
    entry.EndDate             = row.EndDate;
    entry.Period              = row.Period;
    entry.HasMissingRateData  = row.HasMissingRateData;
    entry.Created             = row.Created;

    return entry;
};

RQService.Pms.GetRackRates
    = RQImported.PmsGetRackRates;

RQService.Pms.PopulateGetRackRatesRow = function (row) {
    var entry = { };

    entry.RateID       = row.RateID;
    entry.Allotment    = row.Allotment;
    entry.DayOfWeek    = row.DayOfWeek;
    entry.Price        = row.Price;
    entry.MLOS         = row.MLOS;
    entry.MaxStay      = row.MaxStay;
    entry.AdvanceDays  = row.AdvanceDays;
    entry.NoArr        = row.NoArr;
    entry.NoDep        = row.NoDep;

    return entry;
};

RQService.Pms.GetRatePeriod
    = RQImported.PmsGetRatePeriod;

RQService.Pms.PopulateGetRatePeriodRow = function (row) {
    var entry = { };

    entry.CDay                  = row.CDay;
    entry.Price                 = row.Price;
    entry.MLOS                  = row.MLOS;
    entry.MaxStay               = row.MaxStay;
    entry.AdvanceDays           = row.AdvanceDays;
    entry.NoArr                 = row.NoArr;
    entry.NoDep                 = row.NoDep;
    entry.Allotment             = row.Allotment;
    entry.Uptake                = row.Uptake;
    entry.Capacity              = row.Capacity;
    entry.FreeSale              = row.FreeSale;
    entry.StopSell              = row.StopSell;
    entry.Availability          = row.Availability;
    entry.IsFineTunedRateDay    = row.IsFineTunedRateDay;
    entry.ExhibitionPeriodID    = row.ExhibitionPeriodID;
    entry.ExhibitionPeriodName  = row.ExhibitionPeriodName;
    entry.WeekDayNumber         = row.WeekDayNumber;
    entry.WeekDayName           = row.WeekDayName;
    entry.WeekDayShort          = row.WeekDayShort;

    return entry;
};

RQService.Pms.GetRatePeriods
    = RQImported.PmsGetRatePeriods;

RQService.Pms.PopulateGetRatePeriodsRow = function (row) {
    var entry = { };

    entry.RackRatePeriodID  = row.RackRatePeriodID;
    entry.HotelID           = row.HotelID;
    entry.StartDate         = row.StartDate;
    entry.EndDate           = row.EndDate;
    entry.Created           = row.Created;
    entry.Period            = row.Period;

    return entry;
};

RQService.Pms.GetReports
    = RQImported.PmsGetReports;

RQService.Pms.PopulateGetReportsRow = function (row) {
    var entry = { };

    entry.ReportID    = row.ReportID;
    entry.ReportName  = row.ReportName;

    return entry;
};

RQService.Pms.GetResDayCheckedInGuests
    = RQImported.PmsGetResDayCheckedInGuests;

RQService.Pms.PopulateGetResDayCheckedInGuestsRow = function (row) {
    var entry = { };

    entry.RecordNumber            = row.RecordNumber;
    entry.ReservationID           = row.ReservationID;
    entry.RoomReservationID       = row.RoomReservationID;
    entry.GuestID                 = row.GuestID;
    entry.IsOwningGuest           = row.IsOwningGuest;
    entry.ArrivalRoomID           = row.ArrivalRoomID;
    entry.RoomNumber              = row.RoomNumber;
    entry.CheckinTime             = row.CheckinTime;
    entry.Dep                     = row.Dep;
    entry.GuestTitleID            = row.GuestTitleID;
    entry.GuestTitleName          = row.GuestTitleName;
    entry.Gender                  = row.Gender;
    entry.Minor                   = row.Minor;
    entry.FirstName               = row.FirstName;
    entry.LastName                = row.LastName;
    entry.Company                 = row.Company;
    entry.CompanyVAT              = row.CompanyVAT;
    entry.CountryID               = row.CountryID;
    entry.Country                 = row.Country;
    entry.ISOCode                 = row.ISOCode;
    entry.InternetCode            = row.InternetCode;
    entry.Alpha3Code              = row.Alpha3Code;
    entry.Address                 = row.Address;
    entry.Location                = row.Location;
    entry.PostCode                = row.PostCode;
    entry.Email                   = row.Email;
    entry.Telephone               = row.Telephone;
    entry.TelephoneAlt            = row.TelephoneAlt;
    entry.Mobile                  = row.Mobile;
    entry.Fax                     = row.Fax;
    entry.BirthPlace              = row.BirthPlace;
    entry.DateOfBirth             = row.DateOfBirth;
    entry.MothersName             = row.MothersName;
    entry.FathersName             = row.FathersName;
    entry.Occupation              = row.Occupation;
    entry.IdentificationTypeID    = row.IdentificationTypeID;
    entry.IsIDType1TheSysDefault  = row.IsIDType1TheSysDefault;
    entry.IDTypeName1             = row.IDTypeName1;
    entry.Identification          = row.Identification;
    entry.NationalIDNo            = row.NationalIDNo;
    entry.IDRegistrationCity      = row.IDRegistrationCity;
    entry.IDRegistrationDistrict  = row.IDRegistrationDistrict;

    return entry;
};

RQService.Pms.GetReservation
    = RQImported.PmsGetReservation;

RQService.Pms.PopulateGetReservationRow = function (row) {
    var entry = { };

    entry.ReservationID                  = row.ReservationID;
    entry.ExternalReservationID          = row.ExternalReservationID;
    entry.NumRoomRes                     = row.NumRoomRes;
    entry.FirstArr                       = row.FirstArr;
    entry.LastDep                        = row.LastDep;
    entry.RoomNumberList                 = row.RoomNumberList;
    entry.HasHoldUntil                   = row.HasHoldUntil;
    entry.FirstHoldUntil                 = row.FirstHoldUntil;
    entry.OwningGuestID                  = row.OwningGuestID;
    entry.Gender                         = row.Gender;
    entry.FullGuestName                  = row.FullGuestName;
    entry.Telephone                      = row.Telephone;
    entry.Mobile                         = row.Mobile;
    entry.Email                          = row.Email;
    entry.ReservationStatusID            = row.ReservationStatusID;
    entry.ReservationStatusName          = row.ReservationStatusName;
    entry.PaymentSchemeID                = row.PaymentSchemeID;
    entry.PaymentSchemeName              = row.PaymentSchemeName;
    entry.ServiceTotal                   = row.ServiceTotal;
    entry.SumRoomTotal                   = row.SumRoomTotal;
    entry.ReservationTotal               = row.ReservationTotal;
    entry.LetterSent                     = row.LetterSent;
    entry.NotePriorityLevel              = row.NotePriorityLevel;
    entry.Notes                          = row.Notes;
    entry.PriorityNotes                  = row.PriorityNotes;
    entry.HousekeepingNotes              = row.HousekeepingNotes;
    entry.KitchenNotes                   = row.KitchenNotes;
    entry.EngineGuestComments            = row.EngineGuestComments;
    entry.PartnerID                      = row.PartnerID;
    entry.Partner                        = row.Partner;
    entry.IsEngineRes                    = row.IsEngineRes;
    entry.IsChannelRes                   = row.IsChannelRes;
    entry.ThirdPartyCancelReceived       = row.ThirdPartyCancelReceived;
    entry.ResConfirmedToThirdParty       = row.ResConfirmedToThirdParty;
    entry.CancelConfirmedToThirdParty    = row.CancelConfirmedToThirdParty;
    entry.HasLocalPMSEdit                = row.HasLocalPMSEdit;
    entry.HasLocalPMSEditAlerted         = row.HasLocalPMSEditAlerted;
    entry.HasThirdPartyGroupBookingEdit  = row.HasThirdPartyGroupBookingEdit;
    entry.ThirdPartyEditFailure          = row.ThirdPartyEditFailure;
    entry.Created                        = row.Created;
    entry.Modified                       = row.Modified;
    entry.IsBroken                       = row.IsBroken;

    return entry;
};

RQService.Pms.GetReservationCharges
    = RQImported.PmsGetReservationCharges;

RQService.Pms.PopulateGetReservationChargesRow = function (row) {
    var entry = { };

    entry.RoomReservationID   = row.RoomReservationID;
    entry.MaxPersons          = row.MaxPersons;
    entry.PersonsNormal       = row.PersonsNormal;
    entry.Description         = row.Description;
    entry.MaxPersonsRateName  = row.MaxPersonsRateName;
    entry.RoomNumber          = row.RoomNumber;
    entry.Cost                = row.Cost;

    return entry;
};

RQService.Pms.GetReservationFull
    = RQImported.PmsGetReservationFull;

RQService.Pms.PopulateGetReservationFullRow = function (row) {
    var entry = { };

    entry.ReservationID                  = row.ReservationID;
    entry.ExternalReservationID          = row.ExternalReservationID;
    entry.NumRoomRes                     = row.NumRoomRes;
    entry.FirstArr                       = row.FirstArr;
    entry.LastDep                        = row.LastDep;
    entry.RoomNumberList                 = row.RoomNumberList;
    entry.HasHoldUntil                   = row.HasHoldUntil;
    entry.FirstHoldUntil                 = row.FirstHoldUntil;
    entry.OwningGuestID                  = row.OwningGuestID;
    entry.Gender                         = row.Gender;
    entry.FullGuestName                  = row.FullGuestName;
    entry.Telephone                      = row.Telephone;
    entry.Mobile                         = row.Mobile;
    entry.Email                          = row.Email;
    entry.ReservationStatusID            = row.ReservationStatusID;
    entry.ReservationStatusName          = row.ReservationStatusName;
    entry.PaymentSchemeID                = row.PaymentSchemeID;
    entry.PaymentSchemeName              = row.PaymentSchemeName;
    entry.ServiceTotal                   = row.ServiceTotal;
    entry.SumRoomTotal                   = row.SumRoomTotal;
    entry.ReservationTotal               = row.ReservationTotal;
    entry.LetterSent                     = row.LetterSent;
    entry.NotePriorityLevel              = row.NotePriorityLevel;
    entry.Notes                          = row.Notes;
    entry.PriorityNotes                  = row.PriorityNotes;
    entry.HousekeepingNotes              = row.HousekeepingNotes;
    entry.KitchenNotes                   = row.KitchenNotes;
    entry.EngineGuestComments            = row.EngineGuestComments;
    entry.PartnerID                      = row.PartnerID;
    entry.Partner                        = row.Partner;
    entry.IsEngineRes                    = row.IsEngineRes;
    entry.IsChannelRes                   = row.IsChannelRes;
    entry.ThirdPartyCancelReceived       = row.ThirdPartyCancelReceived;
    entry.ResConfirmedToThirdParty       = row.ResConfirmedToThirdParty;
    entry.CancelConfirmedToThirdParty    = row.CancelConfirmedToThirdParty;
    entry.HasLocalPMSEdit                = row.HasLocalPMSEdit;
    entry.HasLocalPMSEditAlerted         = row.HasLocalPMSEditAlerted;
    entry.HasThirdPartyGroupBookingEdit  = row.HasThirdPartyGroupBookingEdit;
    entry.ThirdPartyEditFailure          = row.ThirdPartyEditFailure;
    entry.Created                        = row.Created;
    entry.Modified                       = row.Modified;
    entry.IsBroken                       = row.IsBroken;

    return entry;
};

RQService.Pms.GetReservationGuest
    = RQImported.PmsGetReservationGuest;

RQService.Pms.PopulateGetReservationGuestRow = function (row) {
    var entry = { };

    entry.HotelID                 = row.HotelID;
    entry.GuestID                 = row.GuestID;
    entry.GuestTitleID            = row.GuestTitleID;
    entry.Gender                  = row.Gender;
    entry.Minor                   = row.Minor;
    entry.FirstName               = row.FirstName;
    entry.LastName                = row.LastName;
    entry.Company                 = row.Company;
    entry.CompanyVAT              = row.CompanyVAT;
    entry.CountryID               = row.CountryID;
    entry.Address                 = row.Address;
    entry.Location                = row.Location;
    entry.PostCode                = row.PostCode;
    entry.Telephone               = row.Telephone;
    entry.TelephoneAlt            = row.TelephoneAlt;
    entry.Mobile                  = row.Mobile;
    entry.Fax                     = row.Fax;
    entry.Email                   = row.Email;
    entry.BirthPlace              = row.BirthPlace;
    entry.DateOfBirth             = row.DateOfBirth;
    entry.IdentificationTypeID    = row.IdentificationTypeID;
    entry.Identification          = row.Identification;
    entry.NationalIDNo            = row.NationalIDNo;
    entry.IDRegistrationCity      = row.IDRegistrationCity;
    entry.IDRegistrationDistrict  = row.IDRegistrationDistrict;
    entry.TaxIdentification       = row.TaxIdentification;
    entry.MothersName             = row.MothersName;
    entry.FathersName             = row.FathersName;
    entry.Occupation              = row.Occupation;
    entry.Notes                   = row.Notes;
    entry.CCTypeID                = row.CCTypeID;
    entry.CCNumber                = row.CCNumber;
    entry.CCName                  = row.CCName;
    entry.CCExpiryYear            = row.CCExpiryYear;
    entry.CCExpiryMonth           = row.CCExpiryMonth;
    entry.CCCVC                   = row.CCCVC;
    entry.Created                 = row.Created;
    entry.FullGuestName           = row.FullGuestName;
    entry.IsOwningGuest           = row.IsOwningGuest;
    entry.Country                 = row.Country;
    entry.InternetCode            = row.InternetCode;
    entry.CCType                  = row.CCType;
    entry.GuestTitleName          = row.GuestTitleName;
    entry.HasTaxExemption         = row.HasTaxExemption;

    return entry;
};

RQService.Pms.GetReservationGuests
    = RQImported.PmsGetReservationGuests;

RQService.Pms.PopulateGetReservationGuestsRow = function (row) {
    var entry = { };

    entry.HotelID                 = row.HotelID;
    entry.GuestID                 = row.GuestID;
    entry.GuestTitleID            = row.GuestTitleID;
    entry.Gender                  = row.Gender;
    entry.Minor                   = row.Minor;
    entry.FirstName               = row.FirstName;
    entry.LastName                = row.LastName;
    entry.Company                 = row.Company;
    entry.CompanyVAT              = row.CompanyVAT;
    entry.CountryID               = row.CountryID;
    entry.Address                 = row.Address;
    entry.Location                = row.Location;
    entry.PostCode                = row.PostCode;
    entry.Telephone               = row.Telephone;
    entry.TelephoneAlt            = row.TelephoneAlt;
    entry.Mobile                  = row.Mobile;
    entry.Fax                     = row.Fax;
    entry.Email                   = row.Email;
    entry.BirthPlace              = row.BirthPlace;
    entry.DateOfBirth             = row.DateOfBirth;
    entry.IdentificationTypeID    = row.IdentificationTypeID;
    entry.Identification          = row.Identification;
    entry.NationalIDNo            = row.NationalIDNo;
    entry.IDRegistrationCity      = row.IDRegistrationCity;
    entry.IDRegistrationDistrict  = row.IDRegistrationDistrict;
    entry.TaxIdentification       = row.TaxIdentification;
    entry.MothersName             = row.MothersName;
    entry.FathersName             = row.FathersName;
    entry.Occupation              = row.Occupation;
    entry.Notes                   = row.Notes;
    entry.CCTypeID                = row.CCTypeID;
    entry.CCNumber                = row.CCNumber;
    entry.CCName                  = row.CCName;
    entry.CCExpiryYear            = row.CCExpiryYear;
    entry.CCExpiryMonth           = row.CCExpiryMonth;
    entry.CCCVC                   = row.CCCVC;
    entry.Created                 = row.Created;
    entry.FullGuestName           = row.FullGuestName;
    entry.IsOwningGuest           = row.IsOwningGuest;
    entry.Country                 = row.Country;
    entry.InternetCode            = row.InternetCode;
    entry.CCType                  = row.CCType;
    entry.GuestTitleName          = row.GuestTitleName;
    entry.HasTaxExemption         = row.HasTaxExemption;

    return entry;
};

RQService.Pms.GetReservationIDByExternalReservationID
    = RQImported.PmsGetReservationIDByExternalReservationID;

RQService.Pms.PopulateGetReservationIDByExternalReservationIDRow = function (row) {
    var entry = { };

    entry.ReservationID  = row.ReservationID;

    return entry;
};

RQService.Pms.GetReservationList
    = RQImported.PmsGetReservationList;

RQService.Pms.PopulateGetReservationListRow = function (row) {
    var entry = { };

    entry.ReservationID                  = row.ReservationID;
    entry.ExternalReservationID          = row.ExternalReservationID;
    entry.NumRoomRes                     = row.NumRoomRes;
    entry.FirstArr                       = row.FirstArr;
    entry.LastDep                        = row.LastDep;
    entry.RoomNumberList                 = row.RoomNumberList;
    entry.HasHoldUntil                   = row.HasHoldUntil;
    entry.FirstHoldUntil                 = row.FirstHoldUntil;
    entry.OwningGuestID                  = row.OwningGuestID;
    entry.Gender                         = row.Gender;
    entry.FullGuestName                  = row.FullGuestName;
    entry.Telephone                      = row.Telephone;
    entry.Mobile                         = row.Mobile;
    entry.Email                          = row.Email;
    entry.ReservationStatusID            = row.ReservationStatusID;
    entry.ReservationStatusName          = row.ReservationStatusName;
    entry.PaymentSchemeID                = row.PaymentSchemeID;
    entry.PaymentSchemeName              = row.PaymentSchemeName;
    entry.ServiceTotal                   = row.ServiceTotal;
    entry.SumRoomTotal                   = row.SumRoomTotal;
    entry.ReservationTotal               = row.ReservationTotal;
    entry.LetterSent                     = row.LetterSent;
    entry.NotePriorityLevel              = row.NotePriorityLevel;
    entry.Notes                          = row.Notes;
    entry.PriorityNotes                  = row.PriorityNotes;
    entry.HousekeepingNotes              = row.HousekeepingNotes;
    entry.KitchenNotes                   = row.KitchenNotes;
    entry.EngineGuestComments            = row.EngineGuestComments;
    entry.PartnerID                      = row.PartnerID;
    entry.Partner                        = row.Partner;
    entry.IsEngineRes                    = row.IsEngineRes;
    entry.IsChannelRes                   = row.IsChannelRes;
    entry.ThirdPartyCancelReceived       = row.ThirdPartyCancelReceived;
    entry.ResConfirmedToThirdParty       = row.ResConfirmedToThirdParty;
    entry.CancelConfirmedToThirdParty    = row.CancelConfirmedToThirdParty;
    entry.HasLocalPMSEdit                = row.HasLocalPMSEdit;
    entry.HasLocalPMSEditAlerted         = row.HasLocalPMSEditAlerted;
    entry.HasThirdPartyGroupBookingEdit  = row.HasThirdPartyGroupBookingEdit;
    entry.ThirdPartyEditFailure          = row.ThirdPartyEditFailure;
    entry.Created                        = row.Created;
    entry.Modified                       = row.Modified;
    entry.IsBroken                       = row.IsBroken;

    return entry;
};

RQService.Pms.GetReservationStatuses
    = RQImported.PmsGetReservationStatuses;

RQService.Pms.PopulateGetReservationStatusesRow = function (row) {
    var entry = { };

    entry.ReservationStatusID    = row.ReservationStatusID;
    entry.SortOrder              = row.SortOrder;
    entry.LangID                 = row.LangID;
    entry.ReservationStatusName  = row.ReservationStatusName;

    return entry;
};

RQService.Pms.GetRoom
    = RQImported.PmsGetRoom;

RQService.Pms.PopulateGetRoomRow = function (row) {
    var entry = { };

    entry.RoomTypeID            = row.RoomTypeID;
    entry.HotelID               = row.HotelID;
    entry.Expired               = row.Expired;
    entry.RoomTypeNameID        = row.RoomTypeNameID;
    entry.PersonsNormal         = row.PersonsNormal;
    entry.MaxPersonsNormal      = row.MaxPersonsNormal;
    entry.MinPrice              = row.MinPrice;
    entry.MaxPrice              = row.MaxPrice;
    entry.SortOrder             = row.SortOrder;
    entry.Created               = row.Created;
    entry.RoomID                = row.RoomID;
    entry.RoomNumber            = row.RoomNumber;
    entry.Builtin               = row.Builtin;
    entry.DefaultPersonsNormal  = row.DefaultPersonsNormal;
    entry.RoomTypeName          = row.RoomTypeName;
    entry.RoomSortOrder         = row.RoomSortOrder;

    return entry;
};

RQService.Pms.GetRoomOccupancySummary
    = RQImported.PmsGetRoomOccupancySummary;

RQService.Pms.PopulateGetRoomOccupancySummaryRow = function (row) {
    var entry = { };

    entry.RoomTypeID                    = row.RoomTypeID;
    entry.RoomTypeName                  = row.RoomTypeName;
    entry.PersonsNormal                 = row.PersonsNormal;
    entry.NumRooms                      = row.NumRooms;
    entry.ProjectedOccupancyAtDayStart  = row.ProjectedOccupancyAtDayStart;
    entry.ProjectedOccupancyAtDayEnd    = row.ProjectedOccupancyAtDayEnd;
    entry.RecordedOccupancyAtDayStart   = row.RecordedOccupancyAtDayStart;
    entry.RecordedOccupancyAtDayEnd     = row.RecordedOccupancyAtDayEnd;

    return entry;
};

RQService.Pms.GetRoomPeriodNote
    = RQImported.PmsGetRoomPeriodNote;

RQService.Pms.PopulateGetRoomPeriodNoteRow = function (row) {
    var entry = { };

    entry.HotelID            = row.HotelID;
    entry.RoomPeriodNoteID   = row.RoomPeriodNoteID;
    entry.RoomID             = row.RoomID;
    entry.StartDate          = row.StartDate;
    entry.EndDate            = row.EndDate;
    entry.NotePriorityLevel  = row.NotePriorityLevel;
    entry.Notes              = row.Notes;
    entry.RoomNumber         = row.RoomNumber;

    return entry;
};

RQService.Pms.GetRoomPeriodNoteByRoomIDAndPeriod
    = RQImported.PmsGetRoomPeriodNoteByRoomIDAndPeriod;

RQService.Pms.PopulateGetRoomPeriodNoteByRoomIDAndPeriodRow = function (row) {
    var entry = { };

    entry.HotelID            = row.HotelID;
    entry.RoomPeriodNoteID   = row.RoomPeriodNoteID;
    entry.RoomID             = row.RoomID;
    entry.StartDate          = row.StartDate;
    entry.EndDate            = row.EndDate;
    entry.NotePriorityLevel  = row.NotePriorityLevel;
    entry.Notes              = row.Notes;
    entry.RoomNumber         = row.RoomNumber;

    return entry;
};

RQService.Pms.GetRoomPeriodNotes
    = RQImported.PmsGetRoomPeriodNotes;

RQService.Pms.PopulateGetRoomPeriodNotesRow = function (row) {
    var entry = { };

    entry.HotelID            = row.HotelID;
    entry.RoomPeriodNoteID   = row.RoomPeriodNoteID;
    entry.RoomID             = row.RoomID;
    entry.StartDate          = row.StartDate;
    entry.EndDate            = row.EndDate;
    entry.NotePriorityLevel  = row.NotePriorityLevel;
    entry.Notes              = row.Notes;
    entry.RoomNumber         = row.RoomNumber;

    return entry;
};

RQService.Pms.GetRoomPeriodNotesByWindow
    = RQImported.PmsGetRoomPeriodNotesByWindow;

RQService.Pms.PopulateGetRoomPeriodNotesByWindowRow = function (row) {
    var entry = { };

    entry.HotelID            = row.HotelID;
    entry.RoomPeriodNoteID   = row.RoomPeriodNoteID;
    entry.RoomID             = row.RoomID;
    entry.StartDate          = row.StartDate;
    entry.EndDate            = row.EndDate;
    entry.NotePriorityLevel  = row.NotePriorityLevel;
    entry.Notes              = row.Notes;
    entry.RoomNumber         = row.RoomNumber;

    return entry;
};

RQService.Pms.GetRoomReservation
    = RQImported.PmsGetRoomReservation;

RQService.Pms.PopulateGetRoomReservationRow = function (row) {
    var entry = { };

    entry.RoomReservationID              = row.RoomReservationID;
    entry.ExternalRoomReservationID      = row.ExternalRoomReservationID;
    entry.RoomID                         = row.RoomID;
    entry.RoomReservationRoomNumberList  = row.RoomReservationRoomNumberList;
    entry.MaxPersons                     = row.MaxPersons;
    entry.Arr                            = row.Arr;
    entry.Dep                            = row.Dep;
    entry.RoomReservationStatusID        = row.RoomReservationStatusID;
    entry.RoomReservationStatusName      = row.RoomReservationStatusName;
    entry.OfferTypeID                    = row.OfferTypeID;
    entry.ExclusiveRatePeriodID          = row.ExclusiveRatePeriodID;
    entry.RoomTypeName                   = row.RoomTypeName;
    entry.MaxPersonsRateName             = row.MaxPersonsRateName;
    entry.PersonsNormal                  = row.PersonsNormal;
    entry.MaxPersonsNormal               = row.MaxPersonsNormal;
    entry.RoomNumber                     = row.RoomNumber;
    entry.ManualTotal                    = row.ManualTotal;
    entry.ManualTotalSuppliedInclusive   = row.ManualTotalSuppliedInclusive;
    entry.RoomTotal                      = row.RoomTotal;
    entry.ServiceTotal                   = row.ServiceTotal;
    entry.InclusiveDisplayTotal          = row.InclusiveDisplayTotal;
    entry.IsHoldUntil                    = row.IsHoldUntil;
    entry.HoldUntil                      = row.HoldUntil;
    entry.IsCheckedIn                    = row.IsCheckedIn;
    entry.CheckedIn                      = row.CheckedIn;
    entry.IsCheckedOut                   = row.IsCheckedOut;
    entry.CheckedOut                     = row.CheckedOut;
    entry.IsNoShow                       = row.IsNoShow;
    entry.NoShow                         = row.NoShow;
    entry.RoomTypeID                     = row.RoomTypeID;
    entry.OriginalRoomTypeID             = row.OriginalRoomTypeID;
    entry.LastSeenThirdPartyRoomTypeID   = row.LastSeenThirdPartyRoomTypeID;
    entry.NeedsCheckIn                   = row.NeedsCheckIn;
    entry.NeedsCheckOut                  = row.NeedsCheckOut;
    entry.OwningGuestID                  = row.OwningGuestID;
    entry.OwningGuestFullName            = row.OwningGuestFullName;
    entry.NumPersonsStaying              = row.NumPersonsStaying;
    entry.NumPersonsHavingBreakfast      = row.NumPersonsHavingBreakfast;
    entry.RoomReservationOwningGuestID   = row.RoomReservationOwningGuestID;
    entry.MaxAssignedGuests              = row.MaxAssignedGuests;
    entry.IsBroken                       = row.IsBroken;
    entry.RoomTypeInvalid                = row.RoomTypeInvalid;
    entry.RoomInvalid                    = row.RoomInvalid;
    entry.OfferTypeInvalid               = row.OfferTypeInvalid;
    entry.ExclusiveRatePeriodInvalid     = row.ExclusiveRatePeriodInvalid;
    entry.IsDetached                     = row.IsDetached;
    entry.IsDeletable                    = row.IsDeletable;

    return entry;
};

RQService.Pms.GetRoomReservationArrivalGuests
    = RQImported.PmsGetRoomReservationArrivalGuests;

RQService.Pms.PopulateGetRoomReservationArrivalGuestsRow = function (row) {
    var entry = { };

    entry.HotelID                 = row.HotelID;
    entry.GuestID                 = row.GuestID;
    entry.GuestTitleID            = row.GuestTitleID;
    entry.Gender                  = row.Gender;
    entry.Minor                   = row.Minor;
    entry.FirstName               = row.FirstName;
    entry.LastName                = row.LastName;
    entry.Company                 = row.Company;
    entry.CompanyVAT              = row.CompanyVAT;
    entry.CountryID               = row.CountryID;
    entry.Address                 = row.Address;
    entry.Location                = row.Location;
    entry.PostCode                = row.PostCode;
    entry.Telephone               = row.Telephone;
    entry.TelephoneAlt            = row.TelephoneAlt;
    entry.Mobile                  = row.Mobile;
    entry.Fax                     = row.Fax;
    entry.Email                   = row.Email;
    entry.BirthPlace              = row.BirthPlace;
    entry.DateOfBirth             = row.DateOfBirth;
    entry.IdentificationTypeID    = row.IdentificationTypeID;
    entry.Identification          = row.Identification;
    entry.NationalIDNo            = row.NationalIDNo;
    entry.IDRegistrationCity      = row.IDRegistrationCity;
    entry.IDRegistrationDistrict  = row.IDRegistrationDistrict;
    entry.TaxIdentification       = row.TaxIdentification;
    entry.MothersName             = row.MothersName;
    entry.FathersName             = row.FathersName;
    entry.Occupation              = row.Occupation;
    entry.Notes                   = row.Notes;
    entry.CCTypeID                = row.CCTypeID;
    entry.CCNumber                = row.CCNumber;
    entry.CCName                  = row.CCName;
    entry.CCExpiryYear            = row.CCExpiryYear;
    entry.CCExpiryMonth           = row.CCExpiryMonth;
    entry.CCCVC                   = row.CCCVC;
    entry.Created                 = row.Created;
    entry.FullGuestName           = row.FullGuestName;
    entry.IsOwningGuest           = row.IsOwningGuest;
    entry.Country                 = row.Country;
    entry.InternetCode            = row.InternetCode;
    entry.CCType                  = row.CCType;
    entry.GuestTitleName          = row.GuestTitleName;
    entry.HasTaxExemption         = row.HasTaxExemption;

    return entry;
};

RQService.Pms.GetRoomReservationBreakdown
    = RQImported.PmsGetRoomReservationBreakdown;

RQService.Pms.PopulateGetRoomReservationBreakdownRow = function (row) {
    var entry = { };

    entry.ResDay      = row.ResDay;
    entry.RoomCharge  = row.RoomCharge;

    return entry;
};

RQService.Pms.GetRoomReservations
    = RQImported.PmsGetRoomReservations;

RQService.Pms.PopulateGetRoomReservationsRow = function (row) {
    var entry = { };

    entry.RoomReservationID              = row.RoomReservationID;
    entry.ExternalRoomReservationID      = row.ExternalRoomReservationID;
    entry.RoomID                         = row.RoomID;
    entry.RoomReservationRoomNumberList  = row.RoomReservationRoomNumberList;
    entry.MaxPersons                     = row.MaxPersons;
    entry.Arr                            = row.Arr;
    entry.Dep                            = row.Dep;
    entry.RoomReservationStatusID        = row.RoomReservationStatusID;
    entry.RoomReservationStatusName      = row.RoomReservationStatusName;
    entry.OfferTypeID                    = row.OfferTypeID;
    entry.ExclusiveRatePeriodID          = row.ExclusiveRatePeriodID;
    entry.RoomTypeName                   = row.RoomTypeName;
    entry.MaxPersonsRateName             = row.MaxPersonsRateName;
    entry.PersonsNormal                  = row.PersonsNormal;
    entry.MaxPersonsNormal               = row.MaxPersonsNormal;
    entry.RoomNumber                     = row.RoomNumber;
    entry.ManualTotal                    = row.ManualTotal;
    entry.ManualTotalSuppliedInclusive   = row.ManualTotalSuppliedInclusive;
    entry.RoomTotal                      = row.RoomTotal;
    entry.ServiceTotal                   = row.ServiceTotal;
    entry.InclusiveDisplayTotal          = row.InclusiveDisplayTotal;
    entry.IsHoldUntil                    = row.IsHoldUntil;
    entry.HoldUntil                      = row.HoldUntil;
    entry.IsCheckedIn                    = row.IsCheckedIn;
    entry.CheckedIn                      = row.CheckedIn;
    entry.IsCheckedOut                   = row.IsCheckedOut;
    entry.CheckedOut                     = row.CheckedOut;
    entry.IsNoShow                       = row.IsNoShow;
    entry.NoShow                         = row.NoShow;
    entry.RoomTypeID                     = row.RoomTypeID;
    entry.OriginalRoomTypeID             = row.OriginalRoomTypeID;
    entry.LastSeenThirdPartyRoomTypeID   = row.LastSeenThirdPartyRoomTypeID;
    entry.NeedsCheckIn                   = row.NeedsCheckIn;
    entry.NeedsCheckOut                  = row.NeedsCheckOut;
    entry.OwningGuestID                  = row.OwningGuestID;
    entry.OwningGuestFullName            = row.OwningGuestFullName;
    entry.NumPersonsStaying              = row.NumPersonsStaying;
    entry.NumPersonsHavingBreakfast      = row.NumPersonsHavingBreakfast;
    entry.RoomReservationOwningGuestID   = row.RoomReservationOwningGuestID;
    entry.MaxAssignedGuests              = row.MaxAssignedGuests;
    entry.IsBroken                       = row.IsBroken;
    entry.RoomTypeInvalid                = row.RoomTypeInvalid;
    entry.RoomInvalid                    = row.RoomInvalid;
    entry.OfferTypeInvalid               = row.OfferTypeInvalid;
    entry.ExclusiveRatePeriodInvalid     = row.ExclusiveRatePeriodInvalid;
    entry.IsDetached                     = row.IsDetached;
    entry.IsDeletable                    = row.IsDeletable;

    return entry;
};

RQService.Pms.GetRoomReservationStatuses
    = RQImported.PmsGetRoomReservationStatuses;

RQService.Pms.PopulateGetRoomReservationStatusesRow = function (row) {
    var entry = { };

    entry.RoomReservationStatusID    = row.RoomReservationStatusID;
    entry.SortOrder                  = row.SortOrder;
    entry.LangID                     = row.LangID;
    entry.RoomReservationStatusName  = row.RoomReservationStatusName;

    return entry;
};

RQService.Pms.GetRooms
    = RQImported.PmsGetRooms;

RQService.Pms.PopulateGetRoomsRow = function (row) {
    var entry = { };

    entry.RoomTypeID            = row.RoomTypeID;
    entry.HotelID               = row.HotelID;
    entry.Expired               = row.Expired;
    entry.RoomTypeNameID        = row.RoomTypeNameID;
    entry.PersonsNormal         = row.PersonsNormal;
    entry.MaxPersonsNormal      = row.MaxPersonsNormal;
    entry.MinPrice              = row.MinPrice;
    entry.MaxPrice              = row.MaxPrice;
    entry.SortOrder             = row.SortOrder;
    entry.Created               = row.Created;
    entry.RoomID                = row.RoomID;
    entry.RoomNumber            = row.RoomNumber;
    entry.Builtin               = row.Builtin;
    entry.DefaultPersonsNormal  = row.DefaultPersonsNormal;
    entry.RoomTypeName          = row.RoomTypeName;
    entry.RoomSortOrder         = row.RoomSortOrder;

    return entry;
};

RQService.Pms.GetRoomsByRoomTypeID
    = RQImported.PmsGetRoomsByRoomTypeID;

RQService.Pms.PopulateGetRoomsByRoomTypeIDRow = function (row) {
    var entry = { };

    entry.RoomTypeID            = row.RoomTypeID;
    entry.HotelID               = row.HotelID;
    entry.Expired               = row.Expired;
    entry.RoomTypeNameID        = row.RoomTypeNameID;
    entry.PersonsNormal         = row.PersonsNormal;
    entry.MaxPersonsNormal      = row.MaxPersonsNormal;
    entry.MinPrice              = row.MinPrice;
    entry.MaxPrice              = row.MaxPrice;
    entry.SortOrder             = row.SortOrder;
    entry.Created               = row.Created;
    entry.RoomID                = row.RoomID;
    entry.RoomNumber            = row.RoomNumber;
    entry.Builtin               = row.Builtin;
    entry.DefaultPersonsNormal  = row.DefaultPersonsNormal;
    entry.RoomTypeName          = row.RoomTypeName;
    entry.RoomSortOrder         = row.RoomSortOrder;

    return entry;
};

RQService.Pms.GetRoomType
    = RQImported.PmsGetRoomType;

RQService.Pms.PopulateGetRoomTypeRow = function (row) {
    var entry = { };

    entry.RoomTypeID            = row.RoomTypeID;
    entry.PersonsNormal         = row.PersonsNormal;
    entry.MaxPersonsNormal      = row.MaxPersonsNormal;
    entry.MinPrice              = row.MinPrice;
    entry.MaxPrice              = row.MaxPrice;
    entry.DefaultPersonsNormal  = row.DefaultPersonsNormal;
    entry.RoomTypeName          = row.RoomTypeName;
    entry.RoomTypeNameID        = row.RoomTypeNameID;
    entry.NrOfRooms             = row.NrOfRooms;
    entry.SortOrder             = row.SortOrder;
    entry.HasRoomTypeAutoName   = row.HasRoomTypeAutoName;

    return entry;
};

RQService.Pms.GetRoomTypeBaseNames
    = RQImported.PmsGetRoomTypeBaseNames;

RQService.Pms.PopulateGetRoomTypeBaseNamesRow = function (row) {
    var entry = { };

    entry.RoomBaseID            = row.RoomBaseID;
    entry.RoomBase              = row.RoomBase;
    entry.DefaultPersonsNormal  = row.DefaultPersonsNormal;

    return entry;
};

RQService.Pms.GetRoomTypeClassNames
    = RQImported.PmsGetRoomTypeClassNames;

RQService.Pms.PopulateGetRoomTypeClassNamesRow = function (row) {
    var entry = { };

    entry.RoomClassID  = row.RoomClassID;
    entry.RoomClass    = row.RoomClass;

    return entry;
};

RQService.Pms.GetRoomTypeIDByPartnerRoomTypeID
    = RQImported.PmsGetRoomTypeIDByPartnerRoomTypeID;

RQService.Pms.PopulateGetRoomTypeIDByPartnerRoomTypeIDRow = function (row) {
    var entry = { };

    entry.RoomTypeID     = row.RoomTypeID;
    entry.PersonsNormal  = row.PersonsNormal;

    return entry;
};

RQService.Pms.GetRoomTypeIDByPartnerRoomTypeName
    = RQImported.PmsGetRoomTypeIDByPartnerRoomTypeName;

RQService.Pms.PopulateGetRoomTypeIDByPartnerRoomTypeNameRow = function (row) {
    var entry = { };

    entry.RoomTypeID     = row.RoomTypeID;
    entry.PersonsNormal  = row.PersonsNormal;

    return entry;
};

RQService.Pms.GetRoomTypeMappingByPartner
    = RQImported.PmsGetRoomTypeMappingByPartner;

RQService.Pms.PopulateGetRoomTypeMappingByPartnerRow = function (row) {
    var entry = { };

    entry.HotelID              = row.HotelID;
    entry.RoomTypeID           = row.RoomTypeID;
    entry.PartnerID            = row.PartnerID;
    entry.PartnerRoomTypeID    = row.PartnerRoomTypeID;
    entry.RoomTypeName         = row.RoomTypeName;
    entry.PartnerRoomTypeName  = row.PartnerRoomTypeName;

    return entry;
};

RQService.Pms.GetRoomTypeName
    = RQImported.PmsGetRoomTypeName;

RQService.Pms.PopulateGetRoomTypeNameRow = function (row) {
    var entry = { };

    entry.HotelID               = row.HotelID;
    entry.RoomTypeNameID        = row.RoomTypeNameID;
    entry.LangID                = row.LangID;
    entry.RoomTypeName          = row.RoomTypeName;
    entry.DefaultPersonsNormal  = row.DefaultPersonsNormal;
    entry.SortOrder             = row.SortOrder;
    entry.Builtin               = row.Builtin;
    entry.Created               = row.Created;

    return entry;
};

RQService.Pms.GetRoomTypeNames
    = RQImported.PmsGetRoomTypeNames;

RQService.Pms.PopulateGetRoomTypeNamesRow = function (row) {
    var entry = { };

    entry.HotelID               = row.HotelID;
    entry.RoomTypeNameID        = row.RoomTypeNameID;
    entry.LangID                = row.LangID;
    entry.RoomTypeName          = row.RoomTypeName;
    entry.DefaultPersonsNormal  = row.DefaultPersonsNormal;
    entry.SortOrder             = row.SortOrder;
    entry.Builtin               = row.Builtin;
    entry.Created               = row.Created;

    return entry;
};

RQService.Pms.GetRoomTypeNamesUnused
    = RQImported.PmsGetRoomTypeNamesUnused;

RQService.Pms.PopulateGetRoomTypeNamesUnusedRow = function (row) {
    var entry = { };

    entry.HotelID               = row.HotelID;
    entry.RoomTypeNameID        = row.RoomTypeNameID;
    entry.LangID                = row.LangID;
    entry.RoomTypeName          = row.RoomTypeName;
    entry.DefaultPersonsNormal  = row.DefaultPersonsNormal;
    entry.SortOrder             = row.SortOrder;
    entry.Builtin               = row.Builtin;
    entry.Created               = row.Created;

    return entry;
};

RQService.Pms.GetRoomTypes
    = RQImported.PmsGetRoomTypes;

RQService.Pms.PopulateGetRoomTypesRow = function (row) {
    var entry = { };

    entry.RoomTypeID            = row.RoomTypeID;
    entry.PersonsNormal         = row.PersonsNormal;
    entry.MaxPersonsNormal      = row.MaxPersonsNormal;
    entry.MinPrice              = row.MinPrice;
    entry.MaxPrice              = row.MaxPrice;
    entry.DefaultPersonsNormal  = row.DefaultPersonsNormal;
    entry.RoomTypeName          = row.RoomTypeName;
    entry.RoomTypeNameID        = row.RoomTypeNameID;
    entry.NrOfRooms             = row.NrOfRooms;
    entry.SortOrder             = row.SortOrder;
    entry.HasRoomTypeAutoName   = row.HasRoomTypeAutoName;

    return entry;
};

RQService.Pms.GetRoomTypeStopSellData
    = RQImported.PmsGetRoomTypeStopSellData;

RQService.Pms.PopulateGetRoomTypeStopSellDataRow = function (row) {
    var entry = { };

    entry.RoomTypeID    = row.RoomTypeID;
    entry.RoomTypeName  = row.RoomTypeName;
    entry.ResDay        = row.ResDay;
    entry.HasRateData   = row.HasRateData;
    entry.StopSell      = row.StopSell;
    entry.Availability  = row.Availability;
    entry.NumRooms      = row.NumRooms;

    return entry;
};

RQService.Pms.GetShiftLog
    = RQImported.PmsGetShiftLog;

RQService.Pms.PopulateGetShiftLogRow = function (row) {
    var entry = { };

    entry.ShiftID         = row.ShiftID;
    entry.ShiftStart      = row.ShiftStart;
    entry.ShiftEnd        = row.ShiftEnd;
    entry.IsCurrentShift  = row.IsCurrentShift;
    entry.BusinessDay     = row.BusinessDay;
    entry.Users           = row.Users;

    return entry;
};

RQService.Pms.GetShiftsByBusinessDay
    = RQImported.PmsGetShiftsByBusinessDay;

RQService.Pms.PopulateGetShiftsByBusinessDayRow = function (row) {
    var entry = { };

    entry.ShiftID      = row.ShiftID;
    entry.ShiftStart   = row.ShiftStart;
    entry.ShiftEnd     = row.ShiftEnd;
    entry.BusinessDay  = row.BusinessDay;

    return entry;
};

RQService.Pms.GetSMTPServer
    = RQImported.PmsGetSMTPServer;

RQService.Pms.PopulateGetSMTPServerRow = function (row) {
    var entry = { };

    entry.SMTPServerID    = row.SMTPServerID;
    entry.Description     = row.Description;
    entry.ServerName      = row.ServerName;
    entry.Port            = row.Port;
    entry.EnableSSL       = row.EnableSSL;
    entry.UseCredentials  = row.UseCredentials;
    entry.Username        = row.Username;
    entry.Password        = row.Password;
    entry.IsPrimary       = row.IsPrimary;
    entry.Created         = row.Created;

    return entry;
};

RQService.Pms.GetSMTPServers
    = RQImported.PmsGetSMTPServers;

RQService.Pms.PopulateGetSMTPServersRow = function (row) {
    var entry = { };

    entry.SMTPServerID    = row.SMTPServerID;
    entry.Description     = row.Description;
    entry.ServerName      = row.ServerName;
    entry.Port            = row.Port;
    entry.EnableSSL       = row.EnableSSL;
    entry.UseCredentials  = row.UseCredentials;
    entry.Username        = row.Username;
    entry.Password        = row.Password;
    entry.IsPrimary       = row.IsPrimary;
    entry.Created         = row.Created;

    return entry;
};

RQService.Pms.GetSplittingData
    = RQImported.PmsGetSplittingData;

RQService.Pms.PopulateGetSplittingDataRow = function (row) {
    var entry = { };

    entry.RoomID                = row.RoomID;
    entry.RoomNumber            = row.RoomNumber;
    entry.RoomTypeName          = row.RoomTypeName;
    entry.PersonsNormal         = row.PersonsNormal;
    entry.ResDay                = row.ResDay;
    entry.IsAttachedRoomResDay  = row.IsAttachedRoomResDay;
    entry.IsDetachedRoomResDay  = row.IsDetachedRoomResDay;
    entry.IsReservedByThisRes   = row.IsReservedByThisRes;
    entry.IsReservedByOtherRes  = row.IsReservedByOtherRes;
    entry.IsAvailable           = row.IsAvailable;
    entry.IsOpenForSwap         = row.IsOpenForSwap;

    return entry;
};

RQService.Pms.GetTemplate
    = RQImported.PmsGetTemplate;

RQService.Pms.PopulateGetTemplateRow = function (row) {
    var entry = { };

    entry.TemplateID  = row.TemplateID;
    entry.LangID      = row.LangID;
    entry.Title       = row.Title;
    entry.Subject     = row.Subject;
    entry.FileName    = row.FileName;
    entry.Created     = row.Created;

    return entry;
};

RQService.Pms.GetTemplates
    = RQImported.PmsGetTemplates;

RQService.Pms.PopulateGetTemplatesRow = function (row) {
    var entry = { };

    entry.TemplateID  = row.TemplateID;
    entry.LangID      = row.LangID;
    entry.Title       = row.Title;
    entry.Subject     = row.Subject;
    entry.FileName    = row.FileName;
    entry.Created     = row.Created;

    return entry;
};

RQService.Pms.GetThirdPartyModificationTime
    = RQImported.PmsGetThirdPartyModificationTime;

RQService.Pms.PopulateGetThirdPartyModificationTimeRow = function (row) {
    var entry = { };

    entry.ThirdPartyModificationTime  = row.ThirdPartyModificationTime;

    return entry;
};

RQService.Pms.GetTotalVisitorsPerCountry
    = RQImported.PmsGetTotalVisitorsPerCountry;

RQService.Pms.PopulateGetTotalVisitorsPerCountryRow = function (row) {
    var entry = { };

    entry.Country              = row.Country;
    entry.TotalPersonsCountry  = row.TotalPersonsCountry;
    entry.TotalRooms           = row.TotalRooms;
    entry.TotalNights          = row.TotalNights;

    return entry;
};

RQService.Pms.GetTotalVisitorsPerCountryUnassigned
    = RQImported.PmsGetTotalVisitorsPerCountryUnassigned;

RQService.Pms.PopulateGetTotalVisitorsPerCountryUnassignedRow = function (row) {
    var entry = { };

    entry.ReservationID          = row.ReservationID;
    entry.ExternalReservationID  = row.ExternalReservationID;
    entry.LastName               = row.LastName;

    return entry;
};

RQService.Pms.GetUnassignedGuestsForRoomReservation
    = RQImported.PmsGetUnassignedGuestsForRoomReservation;

RQService.Pms.PopulateGetUnassignedGuestsForRoomReservationRow = function (row) {
    var entry = { };

    entry.HotelID                 = row.HotelID;
    entry.GuestID                 = row.GuestID;
    entry.GuestTitleID            = row.GuestTitleID;
    entry.Gender                  = row.Gender;
    entry.Minor                   = row.Minor;
    entry.FirstName               = row.FirstName;
    entry.LastName                = row.LastName;
    entry.Company                 = row.Company;
    entry.CompanyVAT              = row.CompanyVAT;
    entry.CountryID               = row.CountryID;
    entry.Address                 = row.Address;
    entry.Location                = row.Location;
    entry.PostCode                = row.PostCode;
    entry.Telephone               = row.Telephone;
    entry.TelephoneAlt            = row.TelephoneAlt;
    entry.Mobile                  = row.Mobile;
    entry.Fax                     = row.Fax;
    entry.Email                   = row.Email;
    entry.BirthPlace              = row.BirthPlace;
    entry.DateOfBirth             = row.DateOfBirth;
    entry.IdentificationTypeID    = row.IdentificationTypeID;
    entry.Identification          = row.Identification;
    entry.NationalIDNo            = row.NationalIDNo;
    entry.IDRegistrationCity      = row.IDRegistrationCity;
    entry.IDRegistrationDistrict  = row.IDRegistrationDistrict;
    entry.TaxIdentification       = row.TaxIdentification;
    entry.MothersName             = row.MothersName;
    entry.FathersName             = row.FathersName;
    entry.Occupation              = row.Occupation;
    entry.Notes                   = row.Notes;
    entry.CCTypeID                = row.CCTypeID;
    entry.CCNumber                = row.CCNumber;
    entry.CCName                  = row.CCName;
    entry.CCExpiryYear            = row.CCExpiryYear;
    entry.CCExpiryMonth           = row.CCExpiryMonth;
    entry.CCCVC                   = row.CCCVC;
    entry.Created                 = row.Created;
    entry.FullGuestName           = row.FullGuestName;
    entry.IsOwningGuest           = row.IsOwningGuest;
    entry.Country                 = row.Country;
    entry.InternetCode            = row.InternetCode;
    entry.CCType                  = row.CCType;
    entry.GuestTitleName          = row.GuestTitleName;
    entry.HasTaxExemption         = row.HasTaxExemption;

    return entry;
};

RQService.Pms.GetUnassignedPartnersForOfferType
    = RQImported.PmsGetUnassignedPartnersForOfferType;

RQService.Pms.PopulateGetUnassignedPartnersForOfferTypeRow = function (row) {
    var entry = { };

    entry.HotelID                     = row.HotelID;
    entry.PartnerID                   = row.PartnerID;
    entry.Partner                     = row.Partner;
    entry.Expired                     = row.Expired;
    entry.Builtin                     = row.Builtin;
    entry.IsRemote                    = row.IsRemote;
    entry.RemotePropertyID            = row.RemotePropertyID;
    entry.SupportsMLOS                = row.SupportsMLOS;
    entry.SupportsMaxStay             = row.SupportsMaxStay;
    entry.SupportsAdvanceDays         = row.SupportsAdvanceDays;
    entry.SupportsNoArr               = row.SupportsNoArr;
    entry.SupportsNoDep               = row.SupportsNoDep;
    entry.SupportsMaxPersons          = row.SupportsMaxPersons;
    entry.CommissionPrepaid           = row.CommissionPrepaid;
    entry.CommissionPercentage        = row.CommissionPercentage;
    entry.CommissionPerReservation    = row.CommissionPerReservation;
    entry.CommissionVAT               = row.CommissionVAT;
    entry.UserName                    = row.UserName;
    entry.Credentials                 = row.Credentials;
    entry.LastPull                    = row.LastPull;
    entry.NeedsExplicitMap            = row.NeedsExplicitMap;
    entry.Deactivated                 = row.Deactivated;
    entry.PushWithoutAdditionalTaxes  = row.PushWithoutAdditionalTaxes;
    entry.PushActive                  = row.PushActive;
    entry.PullActive                  = row.PullActive;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Pms.GetUser
    = RQImported.PmsGetUser;

RQService.Pms.PopulateGetUserRow = function (row) {
    var entry = { };

    entry.UserID            = row.UserID;
    entry.UserName          = row.UserName;
    entry.Admin             = row.Admin;
    entry.CanCloseJournal   = row.CanCloseJournal;
    entry.CanReopenJournal  = row.CanReopenJournal;
    entry.IsAuditor         = row.IsAuditor;
    entry.Created           = row.Created;

    return entry;
};

RQService.Pms.GetUserActions
    = RQImported.PmsGetUserActions;

RQService.Pms.PopulateGetUserActionsRow = function (row) {
    var entry = { };

    entry.LogActionID    = row.LogActionID;
    entry.LogActionName  = row.LogActionName;

    return entry;
};

RQService.Pms.GetUsers
    = RQImported.PmsGetUsers;

RQService.Pms.PopulateGetUsersRow = function (row) {
    var entry = { };

    entry.UserID            = row.UserID;
    entry.UserName          = row.UserName;
    entry.Admin             = row.Admin;
    entry.CanCloseJournal   = row.CanCloseJournal;
    entry.CanReopenJournal  = row.CanReopenJournal;
    entry.IsAuditor         = row.IsAuditor;
    entry.Created           = row.Created;

    return entry;
};

RQService.Pms.GetWuBookRCodesByReservationID
    = RQImported.PmsGetWuBookRCodesByReservationID;

RQService.Pms.PopulateGetWuBookRCodesByReservationIDRow = function (row) {
    var entry = { };

    entry.ReservationID  = row.ReservationID;
    entry.WuBookRCode    = row.WuBookRCode;
    entry.Cancelled      = row.Cancelled;

    return entry;
};

RQService.Pms.GrantProductAPIKey
    = RQImported.PmsGrantProductAPIKey;

RQService.Pms.HarnessTest
    = RQImported.PmsHarnessTest;

RQService.Pms.PopulateHarnessTestRow = function (row) {
    var entry = { };

    entry.SymbolInt       = row.SymbolInt;
    entry.SymbolNVarChar  = row.SymbolNVarChar;
    entry.SymbolDate      = row.SymbolDate;
    entry.SymbolDecimal   = row.SymbolDecimal;
    entry.SymbolReal      = row.SymbolReal;

    return entry;
};

RQService.Pms.HotelAcceptsOTAChannelUpdates
    = RQImported.PmsHotelAcceptsOTAChannelUpdates;

RQService.Pms.PopulateHotelAcceptsOTAChannelUpdatesRow = function (row) {
    var entry = { };

    entry.AcceptOTAChannelUpdates  = row.AcceptOTAChannelUpdates;

    return entry;
};

RQService.Pms.HotelHasCacheData
    = RQImported.PmsHotelHasCacheData;

RQService.Pms.PopulateHotelHasCacheDataRow = function (row) {
    var entry = { };

    entry.HasCacheData  = row.HasCacheData;

    return entry;
};

RQService.Pms.IndexLastMinuteDiscountsAll
    = RQImported.PmsIndexLastMinuteDiscountsAll;

RQService.Pms.IndexMixedRateHotelPeriod
    = RQImported.PmsIndexMixedRateHotelPeriod;

RQService.Pms.InitOTAHotelCTMAccount
    = RQImported.PmsInitOTAHotelCTMAccount;

RQService.Pms.InspectRoomTypeActivityLog
    = RQImported.PmsInspectRoomTypeActivityLog;

RQService.Pms.PopulateInspectRoomTypeActivityLogRow = function (row) {
    var entry = { };

    entry.SlotEventID           = row.SlotEventID;
    entry.ResDay                = row.ResDay;
    entry.SlotEventTime         = row.SlotEventTime;
    entry.SlotActionID          = row.SlotActionID;
    entry.SlotActionName        = row.SlotActionName;
    entry.RoomTypeID            = row.RoomTypeID;
    entry.RoomTypeName          = row.RoomTypeName;
    entry.RoomID                = row.RoomID;
    entry.RoomNumber            = row.RoomNumber;
    entry.ReservationID         = row.ReservationID;
    entry.IsRelease             = row.IsRelease;
    entry.RoomTypeAvailability  = row.RoomTypeAvailability;
    entry.UserID                = row.UserID;
    entry.UserName              = row.UserName;

    return entry;
};

RQService.Pms.LoadFormElementTextTranslations
    = RQImported.PmsLoadFormElementTextTranslations;

RQService.Pms.PopulateLoadFormElementTextTranslationsRow = function (row) {
    var entry = { };

    entry.FormID           = row.FormID;
    entry.FormElementID    = row.FormElementID;
    entry.FormName         = row.FormName;
    entry.FormElementName  = row.FormElementName;
    entry.English          = row.English;
    entry.Translation      = row.Translation;
    entry.NeedsReview      = row.NeedsReview;

    return entry;
};

RQService.Pms.LoadGuiMessages
    = RQImported.PmsLoadGuiMessages;

RQService.Pms.PopulateLoadGuiMessagesRow = function (row) {
    var entry = { };

    entry.GuiMessageID   = row.GuiMessageID;
    entry.GuiKey         = row.GuiKey;
    entry.GuiMessage     = row.GuiMessage;
    entry.NoTranslation  = row.NoTranslation;

    return entry;
};

RQService.Pms.LoadReportTextsPivotedByID
    = RQImported.PmsLoadReportTextsPivotedByID;

RQService.Pms.PopulateLoadReportTextsPivotedByIDRow = function (row) {
    var entry = { };

    entry.T1    = row.T1;
    entry.T2    = row.T2;
    entry.T3    = row.T3;
    entry.T4    = row.T4;
    entry.T5    = row.T5;
    entry.T6    = row.T6;
    entry.T7    = row.T7;
    entry.T8    = row.T8;
    entry.T9    = row.T9;
    entry.T10   = row.T10;
    entry.T11   = row.T11;
    entry.T12   = row.T12;
    entry.T13   = row.T13;
    entry.T14   = row.T14;
    entry.T15   = row.T15;
    entry.T16   = row.T16;
    entry.T17   = row.T17;
    entry.T18   = row.T18;
    entry.T19   = row.T19;
    entry.T20   = row.T20;
    entry.T21   = row.T21;
    entry.T22   = row.T22;
    entry.T23   = row.T23;
    entry.T24   = row.T24;
    entry.T25   = row.T25;
    entry.T26   = row.T26;
    entry.T27   = row.T27;
    entry.T28   = row.T28;
    entry.T29   = row.T29;
    entry.T30   = row.T30;
    entry.T31   = row.T31;
    entry.T32   = row.T32;
    entry.T33   = row.T33;
    entry.T34   = row.T34;
    entry.T35   = row.T35;
    entry.T36   = row.T36;
    entry.T37   = row.T37;
    entry.T38   = row.T38;
    entry.T39   = row.T39;
    entry.T40   = row.T40;
    entry.T41   = row.T41;
    entry.T42   = row.T42;
    entry.T43   = row.T43;
    entry.T44   = row.T44;
    entry.T45   = row.T45;
    entry.T46   = row.T46;
    entry.T47   = row.T47;
    entry.T48   = row.T48;
    entry.T49   = row.T49;
    entry.T50   = row.T50;
    entry.T51   = row.T51;
    entry.T52   = row.T52;
    entry.T53   = row.T53;
    entry.T54   = row.T54;
    entry.T55   = row.T55;
    entry.T56   = row.T56;
    entry.T57   = row.T57;
    entry.T58   = row.T58;
    entry.T59   = row.T59;
    entry.T60   = row.T60;
    entry.T61   = row.T61;
    entry.T62   = row.T62;
    entry.T63   = row.T63;
    entry.T64   = row.T64;
    entry.T65   = row.T65;
    entry.T66   = row.T66;
    entry.T67   = row.T67;
    entry.T68   = row.T68;
    entry.T69   = row.T69;
    entry.T70   = row.T70;
    entry.T71   = row.T71;
    entry.T72   = row.T72;
    entry.T73   = row.T73;
    entry.T74   = row.T74;
    entry.T75   = row.T75;
    entry.T76   = row.T76;
    entry.T77   = row.T77;
    entry.T78   = row.T78;
    entry.T79   = row.T79;
    entry.T80   = row.T80;
    entry.T81   = row.T81;
    entry.T82   = row.T82;
    entry.T83   = row.T83;
    entry.T84   = row.T84;
    entry.T85   = row.T85;
    entry.T86   = row.T86;
    entry.T87   = row.T87;
    entry.T88   = row.T88;
    entry.T89   = row.T89;
    entry.T90   = row.T90;
    entry.T91   = row.T91;
    entry.T92   = row.T92;
    entry.T93   = row.T93;
    entry.T94   = row.T94;
    entry.T95   = row.T95;
    entry.T96   = row.T96;
    entry.T97   = row.T97;
    entry.T98   = row.T98;
    entry.T99   = row.T99;
    entry.T100  = row.T100;

    return entry;
};

RQService.Pms.LogReservationCorrespondenceAction
    = RQImported.PmsLogReservationCorrespondenceAction;

RQService.Pms.MakeReservation
    = RQImported.PmsMakeReservation;

RQService.Pms.MakeReservationViaGateway
    = RQImported.PmsMakeReservationViaGateway;

RQService.Pms.MakeRoomReservation
    = RQImported.PmsMakeRoomReservation;

RQService.Pms.MakeRoomReservationGroup
    = RQImported.PmsMakeRoomReservationGroup;

RQService.Pms.MakeRoomReservationGroupWithDiscount
    = RQImported.PmsMakeRoomReservationGroupWithDiscount;

RQService.Pms.MarkFormAsSeen
    = RQImported.PmsMarkFormAsSeen;

RQService.Pms.MarkFormElementAsSeen
    = RQImported.PmsMarkFormElementAsSeen;

RQService.Pms.MigrateRoom
    = RQImported.PmsMigrateRoom;

RQService.Pms.MonitorChannelManagerStatus
    = RQImported.PmsMonitorChannelManagerStatus;

RQService.Pms.PopulateMonitorChannelManagerStatusRow = function (row) {
    var entry = { };

    entry.LeastChannelActionCreated  = row.LeastChannelActionCreated;
    entry.LeastLastPull              = row.LeastLastPull;

    return entry;
};

RQService.Pms.MonitorEmergencyPartnerDeactivation
    = RQImported.PmsMonitorEmergencyPartnerDeactivation;

RQService.Pms.PopulateMonitorEmergencyPartnerDeactivationRow = function (row) {
    var entry = { };

    entry.HasEmergencyDeactivations  = row.HasEmergencyDeactivations;

    return entry;
};

RQService.Pms.NewExhibitionPeriod
    = RQImported.PmsNewExhibitionPeriod;

RQService.Pms.NewGuest
    = RQImported.PmsNewGuest;

RQService.Pms.NewOfferType
    = RQImported.PmsNewOfferType;

RQService.Pms.NewOfferTypeAsDiscount
    = RQImported.PmsNewOfferTypeAsDiscount;

RQService.Pms.NewOfferTypeAsDiscountOTA
    = RQImported.PmsNewOfferTypeAsDiscountOTA;

RQService.Pms.NewOfferTypeOTA
    = RQImported.PmsNewOfferTypeOTA;

RQService.Pms.NewPartner
    = RQImported.PmsNewPartner;

RQService.Pms.NewRackRate
    = RQImported.PmsNewRackRate;

RQService.Pms.NewRackRatePeriod
    = RQImported.PmsNewRackRatePeriod;

RQService.Pms.NewRoom
    = RQImported.PmsNewRoom;

RQService.Pms.NewRoomPeriodNote
    = RQImported.PmsNewRoomPeriodNote;

RQService.Pms.NewRoomType
    = RQImported.PmsNewRoomType;

RQService.Pms.NewRoomTypeName
    = RQImported.PmsNewRoomTypeName;

RQService.Pms.NewRoomTypeWithAutoName
    = RQImported.PmsNewRoomTypeWithAutoName;

RQService.Pms.NewSMTPServer
    = RQImported.PmsNewSMTPServer;

RQService.Pms.NewTemplate
    = RQImported.PmsNewTemplate;

RQService.Pms.NewUser
    = RQImported.PmsNewUser;

RQService.Pms.Notify
    = RQImported.PmsNotify;

RQService.Pms.NotifyChannelModDoubleChecks
    = RQImported.PmsNotifyChannelModDoubleChecks;

RQService.Pms.NotifyOutstandingCheckouts
    = RQImported.PmsNotifyOutstandingCheckouts;

RQService.Pms.NotifyOutstandingOTAXMLActivations
    = RQImported.PmsNotifyOutstandingOTAXMLActivations;

RQService.Pms.PopulateNotifyOutstandingOTAXMLActivationsRow = function (row) {
    var entry = { };

    entry.HotelID  = row.HotelID;

    return entry;
};

RQService.Pms.NotifyTodaysPriorityNotes
    = RQImported.PmsNotifyTodaysPriorityNotes;

RQService.Pms.OTAXMLTestAccountViewAvailability
    = RQImported.PmsOTAXMLTestAccountViewAvailability;

RQService.Pms.PopulateOTAXMLTestAccountViewAvailabilityRow = function (row) {
    var entry = { };

    entry.ResDay        = row.ResDay;
    entry.Availability  = row.Availability;

    return entry;
};

RQService.Pms.OTAXMLTestAccountViewRates
    = RQImported.PmsOTAXMLTestAccountViewRates;

RQService.Pms.PopulateOTAXMLTestAccountViewRatesRow = function (row) {
    var entry = { };

    entry.CDay                  = row.CDay;
    entry.Price                 = row.Price;
    entry.MLOS                  = row.MLOS;
    entry.MaxStay               = row.MaxStay;
    entry.AdvanceDays           = row.AdvanceDays;
    entry.NoArr                 = row.NoArr;
    entry.NoDep                 = row.NoDep;
    entry.Allotment             = row.Allotment;
    entry.Uptake                = row.Uptake;
    entry.Capacity              = row.Capacity;
    entry.FreeSale              = row.FreeSale;
    entry.StopSell              = row.StopSell;
    entry.Availability          = row.Availability;
    entry.IsFineTunedRateDay    = row.IsFineTunedRateDay;
    entry.ExhibitionPeriodID    = row.ExhibitionPeriodID;
    entry.ExhibitionPeriodName  = row.ExhibitionPeriodName;
    entry.WeekDayNumber         = row.WeekDayNumber;
    entry.WeekDayName           = row.WeekDayName;
    entry.WeekDayShort          = row.WeekDayShort;

    return entry;
};

RQService.Pms.PopulateOTAExternalRoomReservationIDs
    = RQImported.PmsPopulateOTAExternalRoomReservationIDs;

RQService.Pms.ProduceChannelManagerExceptionDigest
    = RQImported.PmsProduceChannelManagerExceptionDigest;

RQService.Pms.PopulateProduceChannelManagerExceptionDigestRow = function (row) {
    var entry = { };

    entry.HotelID        = row.HotelID;
    entry.CMExceptionID  = row.CMExceptionID;
    entry.PartnerID      = row.PartnerID;
    entry.InPull         = row.InPull;
    entry.ExceptionText  = row.ExceptionText;
    entry.StackTrace     = row.StackTrace;
    entry.Priority       = row.Priority;
    entry.Generated      = row.Generated;
    entry.Scheduled      = row.Scheduled;
    entry.Alerted        = row.Alerted;

    return entry;
};

RQService.Pms.ProduceDailyActionSchedule
    = RQImported.PmsProduceDailyActionSchedule;

RQService.Pms.PopulateProduceDailyActionScheduleRow = function (row) {
    var entry = { };

    entry.RoomID                        = row.RoomID;
    entry.RoomNumber                    = row.RoomNumber;
    entry.ReservationID                 = row.ReservationID;
    entry.RoomReservationID             = row.RoomReservationID;
    entry.NumRoomRes                    = row.NumRoomRes;
    entry.RoomNumberList                = row.RoomNumberList;
    entry.IsNewRoomDay                  = row.IsNewRoomDay;
    entry.IsCheckedIn                   = row.IsCheckedIn;
    entry.IsCheckoutDay                 = row.IsCheckoutDay;
    entry.IsEarlyCheckout               = row.IsEarlyCheckout;
    entry.IsCancelled                   = row.IsCancelled;
    entry.IsNoShow                      = row.IsNoShow;
    entry.IsArr                         = row.IsArr;
    entry.IsDep                         = row.IsDep;
    entry.IsIn                          = row.IsIn;
    entry.PartnerID                     = row.PartnerID;
    entry.Partner                       = row.Partner;
    entry.ReservationStatusID           = row.ReservationStatusID;
    entry.ReservationStatusName         = row.ReservationStatusName;
    entry.OwningGuestID                 = row.OwningGuestID;
    entry.OwningGuestFullName           = row.OwningGuestFullName;
    entry.NrOfNights                    = row.NrOfNights;
    entry.PersonsNormal                 = row.PersonsNormal;
    entry.RoomCharge                    = row.RoomCharge;
    entry.NightsPassedString            = row.NightsPassedString;
    entry.CumulativeRoomCharges         = row.CumulativeRoomCharges;
    entry.Payments                      = row.Payments;
    entry.PaymentSummary                = row.PaymentSummary;
    entry.AmountOwingString             = row.AmountOwingString;
    entry.PaymentSchemeName             = row.PaymentSchemeName;
    entry.IsGuaranteed                  = row.IsGuaranteed;
    entry.HasDeferredPayments           = row.HasDeferredPayments;
    entry.HasPaymentsEnteredOnOtherDay  = row.HasPaymentsEnteredOnOtherDay;

    return entry;
};

RQService.Pms.ProduceDailyExtraPaymentList
    = RQImported.PmsProduceDailyExtraPaymentList;

RQService.Pms.PopulateProduceDailyExtraPaymentListRow = function (row) {
    var entry = { };

    entry.ReservationID          = row.ReservationID;
    entry.NumRoomRes             = row.NumRoomRes;
    entry.FirstArr               = row.FirstArr;
    entry.LastDep                = row.LastDep;
    entry.RoomTypeList           = row.RoomTypeList;
    entry.RoomNumberList         = row.RoomNumberList;
    entry.ReservationStatusID    = row.ReservationStatusID;
    entry.ReservationStatusName  = row.ReservationStatusName;
    entry.PartnerID              = row.PartnerID;
    entry.Partner                = row.Partner;
    entry.OwningGuestID          = row.OwningGuestID;
    entry.OwningGuestFullName    = row.OwningGuestFullName;
    entry.Payments               = row.Payments;
    entry.TransactionID          = row.TransactionID;
    entry.UserName               = row.UserName;
    entry.Amount                 = row.Amount;
    entry.AccountName            = row.AccountName;
    entry.IsDeferred             = row.IsDeferred;
    entry.EnteredOnOtherDay      = row.EnteredOnOtherDay;
    entry.EnteredForOtherDay     = row.EnteredForOtherDay;
    entry.EnteredOn              = row.EnteredOn;
    entry.DeferredTo             = row.DeferredTo;
    entry.EnteredByUserName      = row.EnteredByUserName;
    entry.AmountOwing            = row.AmountOwing;
    entry.PaymentSchemeName      = row.PaymentSchemeName;
    entry.Guaranteed             = row.Guaranteed;

    return entry;
};

RQService.Pms.ProduceMonitorHeartbeatDigest
    = RQImported.PmsProduceMonitorHeartbeatDigest;

RQService.Pms.PopulateProduceMonitorHeartbeatDigestRow = function (row) {
    var entry = { };

    entry.MonitorTick    = row.MonitorTick;
    entry.MonitorStatus  = row.MonitorStatus;

    return entry;
};

RQService.Pms.ProducePMSExceptionDigest
    = RQImported.PmsProducePMSExceptionDigest;

RQService.Pms.PopulateProducePMSExceptionDigestRow = function (row) {
    var entry = { };

    entry.HotelID         = row.HotelID;
    entry.PMSExceptionID  = row.PMSExceptionID;
    entry.IPAddress       = row.IPAddress;
    entry.ExceptionText   = row.ExceptionText;
    entry.StackTrace      = row.StackTrace;
    entry.Priority        = row.Priority;
    entry.Generated       = row.Generated;
    entry.Scheduled       = row.Scheduled;
    entry.Alerted         = row.Alerted;

    return entry;
};

RQService.Pms.ProduceSyncTestHeartbeatDigest
    = RQImported.PmsProduceSyncTestHeartbeatDigest;

RQService.Pms.PopulateProduceSyncTestHeartbeatDigestRow = function (row) {
    var entry = { };

    entry.SyncTestTick                 = row.SyncTestTick;
    entry.TimesPushQueueFoundNonEmpty  = row.TimesPushQueueFoundNonEmpty;
    entry.TimesTestWasDeferred         = row.TimesTestWasDeferred;
    entry.MismatchDays                 = row.MismatchDays;
    entry.CompletionTime               = row.CompletionTime;
    entry.SyncTestStatus               = row.SyncTestStatus;

    return entry;
};

RQService.Pms.PruneExpiredPartners
    = RQImported.PmsPruneExpiredPartners;

RQService.Pms.PopulatePruneExpiredPartnersRow = function (row) {
    var entry = { };

    entry.NumExpiredPartners  = row.NumExpiredPartners;

    return entry;
};

RQService.Pms.RecordThirdPartyModificationTime
    = RQImported.PmsRecordThirdPartyModificationTime;

RQService.Pms.RegisterChannelManagerException
    = RQImported.PmsRegisterChannelManagerException;

RQService.Pms.PopulateRegisterChannelManagerExceptionRow = function (row) {
    var entry = { };

    entry.CMExceptionID  = row.CMExceptionID;

    return entry;
};

RQService.Pms.RegisterChannelManagerExceptionsAlerted
    = RQImported.PmsRegisterChannelManagerExceptionsAlerted;

RQService.Pms.RegisterMonitorHeartbeatInit
    = RQImported.PmsRegisterMonitorHeartbeatInit;

RQService.Pms.PopulateRegisterMonitorHeartbeatInitRow = function (row) {
    var entry = { };

    entry.MonitorTickID  = row.MonitorTickID;

    return entry;
};

RQService.Pms.RegisterMonitorHeartbeatStatus
    = RQImported.PmsRegisterMonitorHeartbeatStatus;

RQService.Pms.RegisterPMSException
    = RQImported.PmsRegisterPMSException;

RQService.Pms.PopulateRegisterPMSExceptionRow = function (row) {
    var entry = { };

    entry.PMSExceptionID  = row.PMSExceptionID;

    return entry;
};

RQService.Pms.RegisterPMSExceptionsAlerted
    = RQImported.PmsRegisterPMSExceptionsAlerted;

RQService.Pms.RegisterSyncTestHeartbeatInit
    = RQImported.PmsRegisterSyncTestHeartbeatInit;

RQService.Pms.PopulateRegisterSyncTestHeartbeatInitRow = function (row) {
    var entry = { };

    entry.SyncTestTickID  = row.SyncTestTickID;

    return entry;
};

RQService.Pms.RegisterSyncTestHeartbeatStatus
    = RQImported.PmsRegisterSyncTestHeartbeatStatus;

RQService.Pms.RegisterThirdPartyEditFailure
    = RQImported.PmsRegisterThirdPartyEditFailure;

RQService.Pms.ReleaseOutOfOrderRoom
    = RQImported.PmsReleaseOutOfOrderRoom;

RQService.Pms.ReportCancelConfirmedToThirdParty
    = RQImported.PmsReportCancelConfirmedToThirdParty;

RQService.Pms.ReportChannelActionAttempt
    = RQImported.PmsReportChannelActionAttempt;

RQService.Pms.ReportChannelActionSuccess
    = RQImported.PmsReportChannelActionSuccess;

RQService.Pms.ReportChannelPull
    = RQImported.PmsReportChannelPull;

RQService.Pms.ReportChannelUpdateCycle
    = RQImported.PmsReportChannelUpdateCycle;

RQService.Pms.ReportResConfirmedToThirdParty
    = RQImported.PmsReportResConfirmedToThirdParty;

RQService.Pms.RequestProductAPIKey
    = RQImported.PmsRequestProductAPIKey;

RQService.Pms.RestoreRackRates
    = RQImported.PmsRestoreRackRates;

RQService.Pms.RetrieveCorrespondenceAction
    = RQImported.PmsRetrieveCorrespondenceAction;

RQService.Pms.PopulateRetrieveCorrespondenceActionRow = function (row) {
    var entry = { };

    entry.LogActionName  = row.LogActionName;
    entry.Title          = row.Title;
    entry.Subject        = row.Subject;
    entry.Body           = row.Body;

    return entry;
};

RQService.Pms.RetrieveOTAReservations
    = RQImported.PmsRetrieveOTAReservations;

RQService.Pms.PopulateRetrieveOTAReservationsRow = function (row) {
    var entry = { };

    entry.ReservationID              = row.ReservationID;
    entry.RoomReservationID          = row.RoomReservationID;
    entry.ExternalReservationID      = row.ExternalReservationID;
    entry.ExternalRoomReservationID  = row.ExternalRoomReservationID;
    entry.RoomTypeID                 = row.RoomTypeID;
    entry.OfferTypeID                = row.OfferTypeID;
    entry.MaxPersons                 = row.MaxPersons;
    entry.PersonsNormal              = row.PersonsNormal;
    entry.Arr                        = row.Arr;
    entry.Dep                        = row.Dep;
    entry.RoomTotal                  = row.RoomTotal;
    entry.ServiceTotal               = row.ServiceTotal;
    entry.OTANewModifiedCancelled    = row.OTANewModifiedCancelled;
    entry.OTARetrievalConfirmed      = row.OTARetrievalConfirmed;
    entry.ReservationOwningGuestID   = row.ReservationOwningGuestID;
    entry.OwningGuestID              = row.OwningGuestID;
    entry.Currency                   = row.Currency;
    entry.Notes                      = row.Notes;
    entry.Modified                   = row.Modified;
    entry.OTAPartnerConfToken        = row.OTAPartnerConfToken;

    return entry;
};

RQService.Pms.RetrieveOTAReservationsCancel
    = RQImported.PmsRetrieveOTAReservationsCancel;

RQService.Pms.PopulateRetrieveOTAReservationsCancelRow = function (row) {
    var entry = { };

    entry.ReservationID              = row.ReservationID;
    entry.RoomReservationID          = row.RoomReservationID;
    entry.ExternalReservationID      = row.ExternalReservationID;
    entry.ExternalRoomReservationID  = row.ExternalRoomReservationID;
    entry.RoomTypeID                 = row.RoomTypeID;
    entry.OfferTypeID                = row.OfferTypeID;
    entry.MaxPersons                 = row.MaxPersons;
    entry.PersonsNormal              = row.PersonsNormal;
    entry.Arr                        = row.Arr;
    entry.Dep                        = row.Dep;
    entry.RoomTotal                  = row.RoomTotal;
    entry.ServiceTotal               = row.ServiceTotal;
    entry.OTANewModifiedCancelled    = row.OTANewModifiedCancelled;
    entry.OTARetrievalConfirmed      = row.OTARetrievalConfirmed;
    entry.ReservationOwningGuestID   = row.ReservationOwningGuestID;
    entry.OwningGuestID              = row.OwningGuestID;
    entry.Currency                   = row.Currency;
    entry.Notes                      = row.Notes;
    entry.Modified                   = row.Modified;
    entry.OTAPartnerConfToken        = row.OTAPartnerConfToken;

    return entry;
};

RQService.Pms.RetrieveOTAReservationsModify
    = RQImported.PmsRetrieveOTAReservationsModify;

RQService.Pms.PopulateRetrieveOTAReservationsModifyRow = function (row) {
    var entry = { };

    entry.ReservationID              = row.ReservationID;
    entry.RoomReservationID          = row.RoomReservationID;
    entry.ExternalReservationID      = row.ExternalReservationID;
    entry.ExternalRoomReservationID  = row.ExternalRoomReservationID;
    entry.RoomTypeID                 = row.RoomTypeID;
    entry.OfferTypeID                = row.OfferTypeID;
    entry.MaxPersons                 = row.MaxPersons;
    entry.PersonsNormal              = row.PersonsNormal;
    entry.Arr                        = row.Arr;
    entry.Dep                        = row.Dep;
    entry.RoomTotal                  = row.RoomTotal;
    entry.ServiceTotal               = row.ServiceTotal;
    entry.OTANewModifiedCancelled    = row.OTANewModifiedCancelled;
    entry.OTARetrievalConfirmed      = row.OTARetrievalConfirmed;
    entry.ReservationOwningGuestID   = row.ReservationOwningGuestID;
    entry.OwningGuestID              = row.OwningGuestID;
    entry.Currency                   = row.Currency;
    entry.Notes                      = row.Notes;
    entry.Modified                   = row.Modified;
    entry.OTAPartnerConfToken        = row.OTAPartnerConfToken;

    return entry;
};

RQService.Pms.RetrieveOTAReservationsNew
    = RQImported.PmsRetrieveOTAReservationsNew;

RQService.Pms.PopulateRetrieveOTAReservationsNewRow = function (row) {
    var entry = { };

    entry.ReservationID              = row.ReservationID;
    entry.RoomReservationID          = row.RoomReservationID;
    entry.ExternalReservationID      = row.ExternalReservationID;
    entry.ExternalRoomReservationID  = row.ExternalRoomReservationID;
    entry.RoomTypeID                 = row.RoomTypeID;
    entry.OfferTypeID                = row.OfferTypeID;
    entry.MaxPersons                 = row.MaxPersons;
    entry.PersonsNormal              = row.PersonsNormal;
    entry.Arr                        = row.Arr;
    entry.Dep                        = row.Dep;
    entry.RoomTotal                  = row.RoomTotal;
    entry.ServiceTotal               = row.ServiceTotal;
    entry.OTANewModifiedCancelled    = row.OTANewModifiedCancelled;
    entry.OTARetrievalConfirmed      = row.OTARetrievalConfirmed;
    entry.ReservationOwningGuestID   = row.ReservationOwningGuestID;
    entry.OwningGuestID              = row.OwningGuestID;
    entry.Currency                   = row.Currency;
    entry.Notes                      = row.Notes;
    entry.Modified                   = row.Modified;
    entry.OTAPartnerConfToken        = row.OTAPartnerConfToken;

    return entry;
};

RQService.Pms.RetrieveReservationActions
    = RQImported.PmsRetrieveReservationActions;

RQService.Pms.PopulateRetrieveReservationActionsRow = function (row) {
    var entry = { };

    entry.LogEventID       = row.LogEventID;
    entry.LogEventTime     = row.LogEventTime;
    entry.LogActionID      = row.LogActionID;
    entry.IsPartnerAction  = row.IsPartnerAction;
    entry.PartnerID        = row.PartnerID;
    entry.Partner          = row.Partner;
    entry.UserID           = row.UserID;
    entry.UserName         = row.UserName;
    entry.LogActionName    = row.LogActionName;

    return entry;
};

RQService.Pms.RetrieveReservationCorrespondenceActions
    = RQImported.PmsRetrieveReservationCorrespondenceActions;

RQService.Pms.PopulateRetrieveReservationCorrespondenceActionsRow = function (row) {
    var entry = { };

    entry.LogEventID       = row.LogEventID;
    entry.LogEventTime     = row.LogEventTime;
    entry.LogActionID      = row.LogActionID;
    entry.IsPartnerAction  = row.IsPartnerAction;
    entry.PartnerID        = row.PartnerID;
    entry.Partner          = row.Partner;
    entry.UserID           = row.UserID;
    entry.UserName         = row.UserName;
    entry.LogActionName    = row.LogActionName;

    return entry;
};

RQService.Pms.SaveFormElementText
    = RQImported.PmsSaveFormElementText;

RQService.Pms.ScheduleChannelActionsByRoomType
    = RQImported.PmsScheduleChannelActionsByRoomType;

RQService.Pms.ScheduleCompleteRateActionSync
    = RQImported.PmsScheduleCompleteRateActionSync;

RQService.Pms.SearchGuests
    = RQImported.PmsSearchGuests;

RQService.Pms.PopulateSearchGuestsRow = function (row) {
    var entry = { };

    entry.HotelID                 = row.HotelID;
    entry.GuestID                 = row.GuestID;
    entry.GuestTitleID            = row.GuestTitleID;
    entry.Gender                  = row.Gender;
    entry.Minor                   = row.Minor;
    entry.FirstName               = row.FirstName;
    entry.LastName                = row.LastName;
    entry.Company                 = row.Company;
    entry.CompanyVAT              = row.CompanyVAT;
    entry.CountryID               = row.CountryID;
    entry.Address                 = row.Address;
    entry.Location                = row.Location;
    entry.PostCode                = row.PostCode;
    entry.Telephone               = row.Telephone;
    entry.TelephoneAlt            = row.TelephoneAlt;
    entry.Mobile                  = row.Mobile;
    entry.Fax                     = row.Fax;
    entry.Email                   = row.Email;
    entry.BirthPlace              = row.BirthPlace;
    entry.DateOfBirth             = row.DateOfBirth;
    entry.IdentificationTypeID    = row.IdentificationTypeID;
    entry.Identification          = row.Identification;
    entry.NationalIDNo            = row.NationalIDNo;
    entry.IDRegistrationCity      = row.IDRegistrationCity;
    entry.IDRegistrationDistrict  = row.IDRegistrationDistrict;
    entry.TaxIdentification       = row.TaxIdentification;
    entry.MothersName             = row.MothersName;
    entry.FathersName             = row.FathersName;
    entry.Occupation              = row.Occupation;
    entry.Notes                   = row.Notes;
    entry.CCTypeID                = row.CCTypeID;
    entry.CCNumber                = row.CCNumber;
    entry.CCName                  = row.CCName;
    entry.CCExpiryYear            = row.CCExpiryYear;
    entry.CCExpiryMonth           = row.CCExpiryMonth;
    entry.CCCVC                   = row.CCCVC;
    entry.Created                 = row.Created;
    entry.FullGuestName           = row.FullGuestName;
    entry.IsOwningGuest           = row.IsOwningGuest;
    entry.Country                 = row.Country;
    entry.InternetCode            = row.InternetCode;
    entry.CCType                  = row.CCType;
    entry.GuestTitleName          = row.GuestTitleName;
    entry.HasTaxExemption         = row.HasTaxExemption;

    return entry;
};

RQService.Pms.SearchReservations
    = RQImported.PmsSearchReservations;

RQService.Pms.PopulateSearchReservationsRow = function (row) {
    var entry = { };

    entry.ReservationID          = row.ReservationID;
    entry.ExternalReservationID  = row.ExternalReservationID;
    entry.NumRoomReservations    = row.NumRoomReservations;
    entry.FirstArr               = row.FirstArr;
    entry.LastDep                = row.LastDep;
    entry.RoomNumberList         = row.RoomNumberList;
    entry.HasHoldUntil           = row.HasHoldUntil;
    entry.FirstHoldUntil         = row.FirstHoldUntil;
    entry.OwningGuestID          = row.OwningGuestID;
    entry.Gender                 = row.Gender;
    entry.FullGuestName          = row.FullGuestName;
    entry.ReservationStatusID    = row.ReservationStatusID;
    entry.ReservationStatusName  = row.ReservationStatusName;
    entry.PaymentSchemeID        = row.PaymentSchemeID;
    entry.PaymentSchemeName      = row.PaymentSchemeName;
    entry.ServiceTotal           = row.ServiceTotal;
    entry.SumRoomTotal           = row.SumRoomTotal;
    entry.ReservationTotal       = row.ReservationTotal;
    entry.Balance                = row.Balance;
    entry.PartnerID              = row.PartnerID;
    entry.Partner                = row.Partner;
    entry.PriorityNotes          = row.PriorityNotes;
    entry.NotePriorityLevel      = row.NotePriorityLevel;
    entry.NeedsCheckIn           = row.NeedsCheckIn;
    entry.NeedsCheckOut          = row.NeedsCheckOut;
    entry.IsBroken               = row.IsBroken;

    return entry;
};

RQService.Pms.SetBookingDotComDeviceCookie
    = RQImported.PmsSetBookingDotComDeviceCookie;

RQService.Pms.SetExternalRoomReservationID
    = RQImported.PmsSetExternalRoomReservationID;

RQService.Pms.SetGuestTouristFeeExemption
    = RQImported.PmsSetGuestTouristFeeExemption;

RQService.Pms.SetOfferTypeMemberDiscount
    = RQImported.PmsSetOfferTypeMemberDiscount;

RQService.Pms.SetOfferTypeMemberDiscountDays
    = RQImported.PmsSetOfferTypeMemberDiscountDays;

RQService.Pms.SetReservationStatus
    = RQImported.PmsSetReservationStatus;

RQService.Pms.SetRoomReservationNoShow
    = RQImported.PmsSetRoomReservationNoShow;

RQService.Pms.ShuffleRoomOrder
    = RQImported.PmsShuffleRoomOrder;

RQService.Pms.ShuffleRoomTypeOrder
    = RQImported.PmsShuffleRoomTypeOrder;

RQService.Pms.SignalEmergencyPartnerDeactivation
    = RQImported.PmsSignalEmergencyPartnerDeactivation;

RQService.Pms.SyncCachesToConfig
    = RQImported.PmsSyncCachesToConfig;

RQService.Pms.UnassignGuestFromReservation
    = RQImported.PmsUnassignGuestFromReservation;

RQService.Pms.UnassignGuestFromRoomByRoomReservation
    = RQImported.PmsUnassignGuestFromRoomByRoomReservation;

RQService.Pms.UnassignPartnerFromChannel
    = RQImported.PmsUnassignPartnerFromChannel;

RQService.Pms.UndoRoomReservationCheckIn
    = RQImported.PmsUndoRoomReservationCheckIn;

RQService.Pms.UndoRoomReservationCheckOut
    = RQImported.PmsUndoRoomReservationCheckOut;

RQService.Pms.UndoRoomReservationNoShow
    = RQImported.PmsUndoRoomReservationNoShow;

RQService.Pms.UpdateWuBookRCodes
    = RQImported.PmsUpdateWuBookRCodes;

RQService.Pms.ValidateCheckIn
    = RQImported.PmsValidateCheckIn;

RQService.Pms.ValidateCheckOut
    = RQImported.PmsValidateCheckOut;

RQService.Pms.ValidateNoShow
    = RQImported.PmsValidateNoShow;

RQService.Pms.ValidateRoomResGroupRequest
    = RQImported.PmsValidateRoomResGroupRequest;

RQService.Pms.VerifyCacheCoverage
    = RQImported.PmsVerifyCacheCoverage;

RQService.Pms.PopulateVerifyCacheCoverageRow = function (row) {
    var entry = { };

    entry.CacheCoverageConsistent  = row.CacheCoverageConsistent;

    return entry;
};

RQService.Pms.VerifyNoRecentOverbookings
    = RQImported.PmsVerifyNoRecentOverbookings;

RQService.Pms.PopulateVerifyNoRecentOverbookingsRow = function (row) {
    var entry = { };

    entry.NoRecentOverbookings  = row.NoRecentOverbookings;

    return entry;
};

RQService.Pms.VerifyNotificationEvent
    = RQImported.PmsVerifyNotificationEvent;

RQService.Pms.VerifyNotificationEventsByReservation
    = RQImported.PmsVerifyNotificationEventsByReservation;

RQService.Pms.VerifyNotificationEventsByReservationID
    = RQImported.PmsVerifyNotificationEventsByReservationID;

RQService.Pms.VerifyRackRateAllotmentClamping
    = RQImported.PmsVerifyRackRateAllotmentClamping;

RQService.Pms.PopulateVerifyRackRateAllotmentClampingRow = function (row) {
    var entry = { };

    entry.RackRateAllotmentClampingConsistent  = row.RackRateAllotmentClampingConsistent;

    return entry;
};

RQService.Pms.VerifyRackRateCapacityConsistency
    = RQImported.PmsVerifyRackRateCapacityConsistency;

RQService.Pms.PopulateVerifyRackRateCapacityConsistencyRow = function (row) {
    var entry = { };

    entry.RackRateCapacityConsistent  = row.RackRateCapacityConsistent;

    return entry;
};

RQService.Pms.VerifyRackRateDayCoverage
    = RQImported.PmsVerifyRackRateDayCoverage;

RQService.Pms.PopulateVerifyRackRateDayCoverageRow = function (row) {
    var entry = { };

    entry.RackRateDayCoverageConsistent  = row.RackRateDayCoverageConsistent;

    return entry;
};

RQService.Pms.VerifyRoomAvailabilityConsistency
    = RQImported.PmsVerifyRoomAvailabilityConsistency;

RQService.Pms.PopulateVerifyRoomAvailabilityConsistencyRow = function (row) {
    var entry = { };

    entry.RoomAvailabilityConsistent  = row.RoomAvailabilityConsistent;

    return entry;
};

RQService.Pms.VerifyRoomResAssignmentConsistency
    = RQImported.PmsVerifyRoomResAssignmentConsistency;

RQService.Pms.PopulateVerifyRoomResAssignmentConsistencyRow = function (row) {
    var entry = { };

    entry.RoomResAssignmentConsistent  = row.RoomResAssignmentConsistent;

    return entry;
};

RQService.Pms.VerifyRoomResBreakdownConsistency
    = RQImported.PmsVerifyRoomResBreakdownConsistency;

RQService.Pms.PopulateVerifyRoomResBreakdownConsistencyRow = function (row) {
    var entry = { };

    entry.RoomResBreakdownConsistent  = row.RoomResBreakdownConsistent;

    return entry;
};

RQService.Pms.VerifyRoomResBreakdownMissingOK
    = RQImported.PmsVerifyRoomResBreakdownMissingOK;

RQService.Pms.PopulateVerifyRoomResBreakdownMissingOKRow = function (row) {
    var entry = { };

    entry.RoomResBreakdownMissingOK  = row.RoomResBreakdownMissingOK;

    return entry;
};

RQService.Pms.VerifyThirdPartyEditConsistency
    = RQImported.PmsVerifyThirdPartyEditConsistency;

RQService.Pms.PopulateVerifyThirdPartyEditConsistencyRow = function (row) {
    var entry = { };

    entry.ThirdPartyEditsConsistent  = row.ThirdPartyEditsConsistent;

    return entry;
};

RQService.Accounts
    = { };

RQService.Accounts.AddBillingSnapshotGuest
    = RQImported.AccountsAddBillingSnapshotGuest;

RQService.Accounts.AddCustomerInvoiceGuest
    = RQImported.AccountsAddCustomerInvoiceGuest;

RQService.Accounts.CloseBill
    = RQImported.AccountsCloseBill;

RQService.Accounts.CloseFolioBill
    = RQImported.AccountsCloseFolioBill;

RQService.Accounts.CloseJournalSegment
    = RQImported.AccountsCloseJournalSegment;

RQService.Accounts.ClosePMSBill
    = RQImported.AccountsClosePMSBill;

RQService.Accounts.ClosePOSBill
    = RQImported.AccountsClosePOSBill;

RQService.Accounts.CounterPOSBill
    = RQImported.AccountsCounterPOSBill;

RQService.Accounts.CreateCounterInvoice
    = RQImported.AccountsCreateCounterInvoice;

RQService.Accounts.CreateCustomerInvoice
    = RQImported.AccountsCreateCustomerInvoice;

RQService.Accounts.DeleteProduct
    = RQImported.AccountsDeleteProduct;

RQService.Accounts.DeleteTransaction
    = RQImported.AccountsDeleteTransaction;

RQService.Accounts.EditFolioDetails
    = RQImported.AccountsEditFolioDetails;

RQService.Accounts.EditProduct
    = RQImported.AccountsEditProduct;

RQService.Accounts.EditTransaction
    = RQImported.AccountsEditTransaction;

RQService.Accounts.GetAccount
    = RQImported.AccountsGetAccount;

RQService.Accounts.PopulateGetAccountRow = function (row) {
    var entry = { };

    entry.AccountID        = row.AccountID;
    entry.AccountCode      = row.AccountCode;
    entry.AccountName      = row.AccountName;
    entry.AccountTypeID    = row.AccountTypeID;
    entry.AccountTypeName  = row.AccountTypeName;
    entry.TaxID            = row.TaxID;
    entry.TaxName          = row.TaxName;

    return entry;
};

RQService.Accounts.GetAccounts
    = RQImported.AccountsGetAccounts;

RQService.Accounts.PopulateGetAccountsRow = function (row) {
    var entry = { };

    entry.AccountID        = row.AccountID;
    entry.AccountCode      = row.AccountCode;
    entry.AccountName      = row.AccountName;
    entry.AccountTypeID    = row.AccountTypeID;
    entry.AccountTypeName  = row.AccountTypeName;
    entry.TaxID            = row.TaxID;
    entry.TaxName          = row.TaxName;

    return entry;
};

RQService.Accounts.GetAccountTypes
    = RQImported.AccountsGetAccountTypes;

RQService.Accounts.PopulateGetAccountTypesRow = function (row) {
    var entry = { };

    entry.AccountTypeID    = row.AccountTypeID;
    entry.AccountTypeName  = row.AccountTypeName;

    return entry;
};

RQService.Accounts.GetActivePaymentTills
    = RQImported.AccountsGetActivePaymentTills;

RQService.Accounts.PopulateGetActivePaymentTillsRow = function (row) {
    var entry = { };

    entry.TillID          = row.TillID;
    entry.TillName        = row.TillName;
    entry.IsPOS           = row.IsPOS;
    entry.IsMultiUser     = row.IsMultiUser;
    entry.AllowsAllUsers  = row.AllowsAllUsers;
    entry.Expired         = row.Expired;
    entry.Created         = row.Created;

    return entry;
};

RQService.Accounts.GetAllProducts
    = RQImported.AccountsGetAllProducts;

RQService.Accounts.PopulateGetAllProductsRow = function (row) {
    var entry = { };

    entry.ProductID                = row.ProductID;
    entry.AccountID                = row.AccountID;
    entry.AccountName              = row.AccountName;
    entry.Product                  = row.Product;
    entry.Amount                   = row.Amount;
    entry.TypeID                   = row.TypeID;
    entry.SubTypeID                = row.SubTypeID;
    entry.ProductBillingGroupID    = row.ProductBillingGroupID;
    entry.ProductBillingGroupName  = row.ProductBillingGroupName;
    entry.VariablePrice            = row.VariablePrice;
    entry.Label                    = row.Label;

    return entry;
};

RQService.Accounts.GetAuditTrailBillResnapshotAggregates
    = RQImported.AccountsGetAuditTrailBillResnapshotAggregates;

RQService.Accounts.PopulateGetAuditTrailBillResnapshotAggregatesRow = function (row) {
    var entry = { };

    entry.UserID         = row.UserID;
    entry.UserName       = row.UserName;
    entry.IsUserExpired  = row.IsUserExpired;
    entry.IsUserAdmin    = row.IsUserAdmin;
    entry.IsPOSBill      = row.IsPOSBill;
    entry.NumReclosed    = row.NumReclosed;

    return entry;
};

RQService.Accounts.GetAuditTrailBillResnapshotData
    = RQImported.AccountsGetAuditTrailBillResnapshotData;

RQService.Accounts.PopulateGetAuditTrailBillResnapshotDataRow = function (row) {
    var entry = { };

    entry.UserID             = row.UserID;
    entry.UserName           = row.UserName;
    entry.IsUserExpired      = row.IsUserExpired;
    entry.IsUserAdmin        = row.IsUserAdmin;
    entry.IsPOSBill          = row.IsPOSBill;
    entry.ReservationID      = row.ReservationID;
    entry.OwningGuestID      = row.OwningGuestID;
    entry.FirstName          = row.FirstName;
    entry.LastName           = row.LastName;
    entry.PartnerID          = row.PartnerID;
    entry.Partner            = row.Partner;
    entry.BillingID          = row.BillingID;
    entry.BillingName        = row.BillingName;
    entry.BillingNumber      = row.BillingNumber;
    entry.Comment            = row.Comment;
    entry.ResnapshottedWhen  = row.ResnapshottedWhen;

    return entry;
};

RQService.Accounts.GetAuditTrailCounterInvoiceAggregates
    = RQImported.AccountsGetAuditTrailCounterInvoiceAggregates;

RQService.Accounts.PopulateGetAuditTrailCounterInvoiceAggregatesRow = function (row) {
    var entry = { };

    entry.UserID         = row.UserID;
    entry.UserName       = row.UserName;
    entry.IsUserExpired  = row.IsUserExpired;
    entry.IsUserAdmin    = row.IsUserAdmin;
    entry.IsPOSBill      = row.IsPOSBill;
    entry.NumCounters    = row.NumCounters;

    return entry;
};

RQService.Accounts.GetAuditTrailCounterInvoiceData
    = RQImported.AccountsGetAuditTrailCounterInvoiceData;

RQService.Accounts.PopulateGetAuditTrailCounterInvoiceDataRow = function (row) {
    var entry = { };

    entry.UserID                        = row.UserID;
    entry.UserName                      = row.UserName;
    entry.IsUserExpired                 = row.IsUserExpired;
    entry.IsUserAdmin                   = row.IsUserAdmin;
    entry.IsPOSBill                     = row.IsPOSBill;
    entry.ReservationID                 = row.ReservationID;
    entry.OwningGuestID                 = row.OwningGuestID;
    entry.FirstName                     = row.FirstName;
    entry.LastName                      = row.LastName;
    entry.PartnerID                     = row.PartnerID;
    entry.Partner                       = row.Partner;
    entry.BillingID                     = row.BillingID;
    entry.BillingName                   = row.BillingName;
    entry.CustomerInvoiceID             = row.CustomerInvoiceID;
    entry.CustomerInvoiceNumber         = row.CustomerInvoiceNumber;
    entry.CounterCustomerInvoiceID      = row.CounterCustomerInvoiceID;
    entry.CounterCustomerInvoiceNumber  = row.CounterCustomerInvoiceNumber;
    entry.TotalCountered                = row.TotalCountered;
    entry.CounteredWhen                 = row.CounteredWhen;

    return entry;
};

RQService.Accounts.GetAuditTrailCounterReceiptAggregates
    = RQImported.AccountsGetAuditTrailCounterReceiptAggregates;

RQService.Accounts.PopulateGetAuditTrailCounterReceiptAggregatesRow = function (row) {
    var entry = { };

    entry.UserID         = row.UserID;
    entry.UserName       = row.UserName;
    entry.IsUserExpired  = row.IsUserExpired;
    entry.IsUserAdmin    = row.IsUserAdmin;
    entry.IsPOSBill      = row.IsPOSBill;
    entry.NumCounters    = row.NumCounters;

    return entry;
};

RQService.Accounts.GetAuditTrailCounterReceiptData
    = RQImported.AccountsGetAuditTrailCounterReceiptData;

RQService.Accounts.PopulateGetAuditTrailCounterReceiptDataRow = function (row) {
    var entry = { };

    entry.UserID                = row.UserID;
    entry.UserName              = row.UserName;
    entry.IsUserExpired         = row.IsUserExpired;
    entry.IsUserAdmin           = row.IsUserAdmin;
    entry.IsPOSBill             = row.IsPOSBill;
    entry.ReservationID         = row.ReservationID;
    entry.OwningGuestID         = row.OwningGuestID;
    entry.FirstName             = row.FirstName;
    entry.LastName              = row.LastName;
    entry.PartnerID             = row.PartnerID;
    entry.Partner               = row.Partner;
    entry.BillingID             = row.BillingID;
    entry.BillingName           = row.BillingName;
    entry.ReceiptID             = row.ReceiptID;
    entry.ReceiptNumber         = row.ReceiptNumber;
    entry.CounterReceiptID      = row.CounterReceiptID;
    entry.CounterReceiptNumber  = row.CounterReceiptNumber;
    entry.TotalCountered        = row.TotalCountered;
    entry.CounteredWhen         = row.CounteredWhen;

    return entry;
};

RQService.Accounts.GetAuditTrailRefundAggregates
    = RQImported.AccountsGetAuditTrailRefundAggregates;

RQService.Accounts.PopulateGetAuditTrailRefundAggregatesRow = function (row) {
    var entry = { };

    entry.UserID         = row.UserID;
    entry.UserName       = row.UserName;
    entry.IsUserExpired  = row.IsUserExpired;
    entry.IsUserAdmin    = row.IsUserAdmin;
    entry.IsPOSBill      = row.IsPOSBill;
    entry.NumRefunds     = row.NumRefunds;

    return entry;
};

RQService.Accounts.GetAuditTrailRefundData
    = RQImported.AccountsGetAuditTrailRefundData;

RQService.Accounts.PopulateGetAuditTrailRefundDataRow = function (row) {
    var entry = { };

    entry.UserID                   = row.UserID;
    entry.UserName                 = row.UserName;
    entry.IsUserExpired            = row.IsUserExpired;
    entry.IsUserAdmin              = row.IsUserAdmin;
    entry.IsPOSBill                = row.IsPOSBill;
    entry.TransactionID            = row.TransactionID;
    entry.ReservationID            = row.ReservationID;
    entry.OwningGuestID            = row.OwningGuestID;
    entry.FirstName                = row.FirstName;
    entry.LastName                 = row.LastName;
    entry.PartnerID                = row.PartnerID;
    entry.Partner                  = row.Partner;
    entry.BillingID                = row.BillingID;
    entry.BillingName              = row.BillingName;
    entry.ReceiptID                = row.ReceiptID;
    entry.ReceiptNumber            = row.ReceiptNumber;
    entry.ReceiptingUserName       = row.ReceiptingUserName;
    entry.IsReceiptingUserExpired  = row.IsReceiptingUserExpired;
    entry.IsReceiptingUserAdmin    = row.IsReceiptingUserAdmin;
    entry.TotalRefund              = row.TotalRefund;
    entry.ReceiptIssuedWhen        = row.ReceiptIssuedWhen;

    return entry;
};

RQService.Accounts.GetAuditTrailSegmentResnapshotAggregates
    = RQImported.AccountsGetAuditTrailSegmentResnapshotAggregates;

RQService.Accounts.PopulateGetAuditTrailSegmentResnapshotAggregatesRow = function (row) {
    var entry = { };

    entry.UserID         = row.UserID;
    entry.UserName       = row.UserName;
    entry.IsUserExpired  = row.IsUserExpired;
    entry.IsUserAdmin    = row.IsUserAdmin;
    entry.TillID         = row.TillID;
    entry.NumReclosed    = row.NumReclosed;

    return entry;
};

RQService.Accounts.GetAuditTrailSegmentResnapshotData
    = RQImported.AccountsGetAuditTrailSegmentResnapshotData;

RQService.Accounts.PopulateGetAuditTrailSegmentResnapshotDataRow = function (row) {
    var entry = { };

    entry.UserID                = row.UserID;
    entry.UserName              = row.UserName;
    entry.IsUserExpired         = row.IsUserExpired;
    entry.IsUserAdmin           = row.IsUserAdmin;
    entry.TillID                = row.TillID;
    entry.JournalSegmentID      = row.JournalSegmentID;
    entry.SegmentStart          = row.SegmentStart;
    entry.SegmentEnd            = row.SegmentEnd;
    entry.JournalSummaryNumber  = row.JournalSummaryNumber;
    entry.ResnapshottedWhen     = row.ResnapshottedWhen;

    return entry;
};

RQService.Accounts.GetBalanceSummaryCharges
    = RQImported.AccountsGetBalanceSummaryCharges;

RQService.Accounts.PopulateGetBalanceSummaryChargesRow = function (row) {
    var entry = { };

    entry.SumRoomCharges  = row.SumRoomCharges;
    entry.SumRoomTax      = row.SumRoomTax;
    entry.SumRoomTotal    = row.SumRoomTotal;
    entry.ServiceCharges  = row.ServiceCharges;
    entry.ServiceTax      = row.ServiceTax;
    entry.ServiceTotal    = row.ServiceTotal;
    entry.ResCharges      = row.ResCharges;
    entry.ResTax          = row.ResTax;
    entry.ResTotal        = row.ResTotal;

    return entry;
};

RQService.Accounts.GetBillingBalance
    = RQImported.AccountsGetBillingBalance;

RQService.Accounts.PopulateGetBillingBalanceRow = function (row) {
    var entry = { };

    entry.Charges        = row.Charges;
    entry.Payments       = row.Payments;
    entry.Balance        = row.Balance;
    entry.NumReceipts    = row.NumReceipts;
    entry.BillingNumber  = row.BillingNumber;

    return entry;
};

RQService.Accounts.GetBillingBalanceTotalOnly
    = RQImported.AccountsGetBillingBalanceTotalOnly;

RQService.Accounts.GetBillingGuestName
    = RQImported.AccountsGetBillingGuestName;

RQService.Accounts.PopulateGetBillingGuestNameRow = function (row) {
    var entry = { };

    entry.GuestID            = row.GuestID;
    entry.GuestTitleID       = row.GuestTitleID;
    entry.Gender             = row.Gender;
    entry.FirstName          = row.FirstName;
    entry.LastName           = row.LastName;
    entry.Company            = row.Company;
    entry.CompanyVAT         = row.CompanyVAT;
    entry.CountryID          = row.CountryID;
    entry.Address            = row.Address;
    entry.Location           = row.Location;
    entry.PostCode           = row.PostCode;
    entry.Telephone          = row.Telephone;
    entry.TelephoneAlt       = row.TelephoneAlt;
    entry.Mobile             = row.Mobile;
    entry.Fax                = row.Fax;
    entry.Email              = row.Email;
    entry.Identification     = row.Identification;
    entry.TaxIdentification  = row.TaxIdentification;
    entry.Notes              = row.Notes;
    entry.CCTypeID           = row.CCTypeID;
    entry.CCNumber           = row.CCNumber;
    entry.CCName             = row.CCName;
    entry.CCExpiryYear       = row.CCExpiryYear;
    entry.CCExpiryMonth      = row.CCExpiryMonth;
    entry.CCCVC              = row.CCCVC;
    entry.Created            = row.Created;

    return entry;
};

RQService.Accounts.GetBillingSnapshot
    = RQImported.AccountsGetBillingSnapshot;

RQService.Accounts.PopulateGetBillingSnapshotRow = function (row) {
    var entry = { };

    entry.BillingSnapshotID  = row.BillingSnapshotID;
    entry.BillingID          = row.BillingID;
    entry.BillingName        = row.BillingName;
    entry.BillingNumber      = row.BillingNumber;
    entry.Superceded         = row.Superceded;
    entry.ClosedByUserName   = row.ClosedByUserName;
    entry.TotalCharges       = row.TotalCharges;
    entry.TotalPayments      = row.TotalPayments;
    entry.JournalSegmentID   = row.JournalSegmentID;
    entry.Comment            = row.Comment;
    entry.Created            = row.Created;

    return entry;
};

RQService.Accounts.GetBillingSnapshotAncillaryGuests
    = RQImported.AccountsGetBillingSnapshotAncillaryGuests;

RQService.Accounts.PopulateGetBillingSnapshotAncillaryGuestsRow = function (row) {
    var entry = { };

    entry.GuestID            = row.GuestID;
    entry.GuestTitleID       = row.GuestTitleID;
    entry.Gender             = row.Gender;
    entry.FirstName          = row.FirstName;
    entry.LastName           = row.LastName;
    entry.Company            = row.Company;
    entry.CompanyVAT         = row.CompanyVAT;
    entry.CountryID          = row.CountryID;
    entry.Address            = row.Address;
    entry.Location           = row.Location;
    entry.PostCode           = row.PostCode;
    entry.Telephone          = row.Telephone;
    entry.TelephoneAlt       = row.TelephoneAlt;
    entry.Mobile             = row.Mobile;
    entry.Fax                = row.Fax;
    entry.Email              = row.Email;
    entry.Identification     = row.Identification;
    entry.TaxIdentification  = row.TaxIdentification;
    entry.Notes              = row.Notes;
    entry.CCTypeID           = row.CCTypeID;
    entry.CCNumber           = row.CCNumber;
    entry.CCName             = row.CCName;
    entry.CCExpiryYear       = row.CCExpiryYear;
    entry.CCExpiryMonth      = row.CCExpiryMonth;
    entry.CCCVC              = row.CCCVC;
    entry.Created            = row.Created;

    return entry;
};

RQService.Accounts.GetBillingSnapshotBalance
    = RQImported.AccountsGetBillingSnapshotBalance;

RQService.Accounts.PopulateGetBillingSnapshotBalanceRow = function (row) {
    var entry = { };

    entry.Charges        = row.Charges;
    entry.Payments       = row.Payments;
    entry.Balance        = row.Balance;
    entry.NumReceipts    = row.NumReceipts;
    entry.BillingNumber  = row.BillingNumber;

    return entry;
};

RQService.Accounts.GetBillingSnapshotInvoiceAccounts
    = RQImported.AccountsGetBillingSnapshotInvoiceAccounts;

RQService.Accounts.PopulateGetBillingSnapshotInvoiceAccountsRow = function (row) {
    var entry = { };

    entry.GroupID       = row.GroupID;
    entry.InvoiceID     = row.InvoiceID;
    entry.AccountID     = row.AccountID;
    entry.AccountCode   = row.AccountCode;
    entry.AccountName   = row.AccountName;
    entry.RoomTypeID    = row.RoomTypeID;
    entry.RoomTypeName  = row.RoomTypeName;
    entry.NumRooms      = row.NumRooms;
    entry.Arr           = row.Arr;
    entry.Dep           = row.Dep;
    entry.BaseCharge    = row.BaseCharge;
    entry.Tax           = row.Tax;
    entry.Total         = row.Total;
    entry.TaxID         = row.TaxID;
    entry.Percentage    = row.Percentage;
    entry.TaxName       = row.TaxName;
    entry.Created       = row.Created;

    return entry;
};

RQService.Accounts.GetBillingSnapshotInvoiceCharges
    = RQImported.AccountsGetBillingSnapshotInvoiceCharges;

RQService.Accounts.PopulateGetBillingSnapshotInvoiceChargesRow = function (row) {
    var entry = { };

    entry.InvoiceID          = row.InvoiceID;
    entry.AccountID          = row.AccountID;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.Name               = row.Name;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.RoomChargeGroupID  = row.RoomChargeGroupID;
    entry.Arr                = row.Arr;
    entry.Dep                = row.Dep;
    entry.NumDays            = row.NumDays;
    entry.AmountTotal        = row.AmountTotal;
    entry.TaxID              = row.TaxID;
    entry.Percentage         = row.Percentage;
    entry.TaxName            = row.TaxName;
    entry.Created            = row.Created;

    return entry;
};

RQService.Accounts.GetBillingSnapshotInvoices
    = RQImported.AccountsGetBillingSnapshotInvoices;

RQService.Accounts.PopulateGetBillingSnapshotInvoicesRow = function (row) {
    var entry = { };

    entry.InvoiceID              = row.InvoiceID;
    entry.InvoiceNumber          = row.InvoiceNumber;
    entry.CounterInvoiceID       = row.CounterInvoiceID;
    entry.FolioID                = row.FolioID;
    entry.BillingID              = row.BillingID;
    entry.BillingName            = row.BillingName;
    entry.IsSubInvoice           = row.IsSubInvoice;
    entry.SumRoomCharges         = row.SumRoomCharges;
    entry.SumRoomTax             = row.SumRoomTax;
    entry.SumRoomTotal           = row.SumRoomTotal;
    entry.ServiceCharges         = row.ServiceCharges;
    entry.ServiceTax             = row.ServiceTax;
    entry.ServiceTotal           = row.ServiceTotal;
    entry.ResCharges             = row.ResCharges;
    entry.ResTax                 = row.ResTax;
    entry.ResTotal               = row.ResTotal;
    entry.ResBalance             = row.ResBalance;
    entry.TotalPayments          = row.TotalPayments;
    entry.Comment                = row.Comment;
    entry.Created                = row.Created;
    entry.CountersInvoiceID      = row.CountersInvoiceID;
    entry.CountersInvoiceNumber  = row.CountersInvoiceNumber;
    entry.ReservationID          = row.ReservationID;
    entry.UserName               = row.UserName;

    return entry;
};

RQService.Accounts.GetBillingSnapshotInvoiceTaxes
    = RQImported.AccountsGetBillingSnapshotInvoiceTaxes;

RQService.Accounts.PopulateGetBillingSnapshotInvoiceTaxesRow = function (row) {
    var entry = { };

    entry.InvoiceID   = row.InvoiceID;
    entry.TaxID       = row.TaxID;
    entry.Percentage  = row.Percentage;
    entry.TaxName     = row.TaxName;
    entry.TotalTax    = row.TotalTax;
    entry.Created     = row.Created;

    return entry;
};

RQService.Accounts.GetBillingSnapshotReceiptAccounts
    = RQImported.AccountsGetBillingSnapshotReceiptAccounts;

RQService.Accounts.PopulateGetBillingSnapshotReceiptAccountsRow = function (row) {
    var entry = { };

    entry.ReceiptID    = row.ReceiptID;
    entry.AccountID    = row.AccountID;
    entry.AccountCode  = row.AccountCode;
    entry.AccountName  = row.AccountName;
    entry.AmountTotal  = row.AmountTotal;
    entry.Created      = row.Created;

    return entry;
};

RQService.Accounts.GetBillingSnapshotReceiptPayments
    = RQImported.AccountsGetBillingSnapshotReceiptPayments;

RQService.Accounts.PopulateGetBillingSnapshotReceiptPaymentsRow = function (row) {
    var entry = { };

    entry.ReceiptID    = row.ReceiptID;
    entry.AccountID    = row.AccountID;
    entry.AccountCode  = row.AccountCode;
    entry.AccountName  = row.AccountName;
    entry.GuestName    = row.GuestName;
    entry.AmountTotal  = row.AmountTotal;
    entry.Created      = row.Created;

    return entry;
};

RQService.Accounts.GetBillingSnapshotReceipts
    = RQImported.AccountsGetBillingSnapshotReceipts;

RQService.Accounts.PopulateGetBillingSnapshotReceiptsRow = function (row) {
    var entry = { };

    entry.ReceiptID              = row.ReceiptID;
    entry.ReceiptNumber          = row.ReceiptNumber;
    entry.CounterReceiptID       = row.CounterReceiptID;
    entry.FolioID                = row.FolioID;
    entry.BillingID              = row.BillingID;
    entry.BillingName            = row.BillingName;
    entry.IsPartialPayment       = row.IsPartialPayment;
    entry.TotalAmount            = row.TotalAmount;
    entry.Created                = row.Created;
    entry.CountersReceiptID      = row.CountersReceiptID;
    entry.CountersReceiptNumber  = row.CountersReceiptNumber;
    entry.ReservationID          = row.ReservationID;
    entry.UserName               = row.UserName;

    return entry;
};

RQService.Accounts.GetBillingSnapshots
    = RQImported.AccountsGetBillingSnapshots;

RQService.Accounts.PopulateGetBillingSnapshotsRow = function (row) {
    var entry = { };

    entry.BillingSnapshotID  = row.BillingSnapshotID;
    entry.BillingID          = row.BillingID;
    entry.BillingName        = row.BillingName;
    entry.BillingNumber      = row.BillingNumber;
    entry.Superceded         = row.Superceded;
    entry.ClosedByUserName   = row.ClosedByUserName;
    entry.TotalCharges       = row.TotalCharges;
    entry.TotalPayments      = row.TotalPayments;
    entry.JournalSegmentID   = row.JournalSegmentID;
    entry.Comment            = row.Comment;
    entry.Created            = row.Created;

    return entry;
};

RQService.Accounts.GetBillingStatus
    = RQImported.AccountsGetBillingStatus;

RQService.Accounts.PopulateGetBillingStatusRow = function (row) {
    var entry = { };

    entry.BillingID          = row.BillingID;
    entry.BillingSnapshotID  = row.BillingSnapshotID;
    entry.BillIsClosed       = row.BillIsClosed;
    entry.BillHasSnapshot    = row.BillHasSnapshot;

    return entry;
};

RQService.Accounts.GetBillingTransactions
    = RQImported.AccountsGetBillingTransactions;

RQService.Accounts.PopulateGetBillingTransactionsRow = function (row) {
    var entry = { };

    entry.HotelID            = row.HotelID;
    entry.TransactionID      = row.TransactionID;
    entry.RevenueDay         = row.RevenueDay;
    entry.ProductID          = row.ProductID;
    entry.AccountID          = row.AccountID;
    entry.Description        = row.Description;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.AmountTotal        = row.AmountTotal;
    entry.Active             = row.Active;
    entry.Invoiced           = row.Invoiced;
    entry.InvoicingStatus    = row.InvoicingStatus;
    entry.Countered          = row.Countered;
    entry.Historical         = row.Historical;
    entry.TillID             = row.TillID;
    entry.UserID             = row.UserID;
    entry.Created            = row.Created;
    entry.Product            = row.Product;
    entry.UserName           = row.UserName;
    entry.DefferalSegmentID  = row.DefferalSegmentID;
    entry.OnBehalfOfUserID   = row.OnBehalfOfUserID;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.AccountTypeID      = row.AccountTypeID;
    entry.AccountTypeName    = row.AccountTypeName;
    entry.TaxName            = row.TaxName;
    entry.BillIsClosed       = row.BillIsClosed;

    return entry;
};

RQService.Accounts.GetBills
    = RQImported.AccountsGetBills;

RQService.Accounts.PopulateGetBillsRow = function (row) {
    var entry = { };

    entry.BillingID    = row.BillingID;
    entry.BillingName  = row.BillingName;
    entry.Balance      = row.Balance;
    entry.IsOpen       = row.IsOpen;
    entry.UserName     = row.UserName;
    entry.Created      = row.Created;

    return entry;
};

RQService.Accounts.GetBreakfastSummary
    = RQImported.AccountsGetBreakfastSummary;

RQService.Accounts.PopulateGetBreakfastSummaryRow = function (row) {
    var entry = { };

    entry.ResDay        = row.ResDay;
    entry.NumBreakfast  = row.NumBreakfast;

    return entry;
};

RQService.Accounts.GetChargeAccounts
    = RQImported.AccountsGetChargeAccounts;

RQService.Accounts.PopulateGetChargeAccountsRow = function (row) {
    var entry = { };

    entry.AccountID        = row.AccountID;
    entry.AccountCode      = row.AccountCode;
    entry.AccountName      = row.AccountName;
    entry.AccountTypeID    = row.AccountTypeID;
    entry.AccountTypeName  = row.AccountTypeName;
    entry.TaxID            = row.TaxID;
    entry.TaxName          = row.TaxName;

    return entry;
};

RQService.Accounts.GetCurrentJournalSegmentSnapshotID
    = RQImported.AccountsGetCurrentJournalSegmentSnapshotID;

RQService.Accounts.PopulateGetCurrentJournalSegmentSnapshotIDRow = function (row) {
    var entry = { };

    entry.JournalSegmentSnapshotID  = row.JournalSegmentSnapshotID;

    return entry;
};

RQService.Accounts.GetCurrentSegmentStartDay
    = RQImported.AccountsGetCurrentSegmentStartDay;

RQService.Accounts.PopulateGetCurrentSegmentStartDayRow = function (row) {
    var entry = { };

    entry.JournalSegmentID  = row.JournalSegmentID;
    entry.SegmentStart      = row.SegmentStart;

    return entry;
};

RQService.Accounts.GetCustomerInvoicableTransactions
    = RQImported.AccountsGetCustomerInvoicableTransactions;

RQService.Accounts.PopulateGetCustomerInvoicableTransactionsRow = function (row) {
    var entry = { };

    entry.TransactionID      = row.TransactionID;
    entry.RevenueDay         = row.RevenueDay;
    entry.ProductID          = row.ProductID;
    entry.AccountID          = row.AccountID;
    entry.Description        = row.Description;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.AmountTotal        = row.AmountTotal;
    entry.Active             = row.Active;
    entry.Invoiced           = row.Invoiced;
    entry.InvoicingStatus    = row.InvoicingStatus;
    entry.Countered          = row.Countered;
    entry.Historical         = row.Historical;
    entry.TillID             = row.TillID;
    entry.UserID             = row.UserID;
    entry.Created            = row.Created;
    entry.RoomReservationID  = row.RoomReservationID;
    entry.SortOrder          = row.SortOrder;
    entry.RoomNumber         = row.RoomNumber;
    entry.RoomTypeName       = row.RoomTypeName;
    entry.MaxPersons         = row.MaxPersons;
    entry.Arr                = row.Arr;
    entry.Dep                = row.Dep;
    entry.Total              = row.Total;
    entry.Product            = row.Product;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.TaxName            = row.TaxName;
    entry.FolioID            = row.FolioID;
    entry.BillingID          = row.BillingID;

    return entry;
};

RQService.Accounts.GetCustomerInvoice
    = RQImported.AccountsGetCustomerInvoice;

RQService.Accounts.PopulateGetCustomerInvoiceRow = function (row) {
    var entry = { };

    entry.InvoiceID              = row.InvoiceID;
    entry.InvoiceNumber          = row.InvoiceNumber;
    entry.CounterInvoiceID       = row.CounterInvoiceID;
    entry.FolioID                = row.FolioID;
    entry.BillingID              = row.BillingID;
    entry.BillingName            = row.BillingName;
    entry.IsSubInvoice           = row.IsSubInvoice;
    entry.SumRoomCharges         = row.SumRoomCharges;
    entry.SumRoomTax             = row.SumRoomTax;
    entry.SumRoomTotal           = row.SumRoomTotal;
    entry.ServiceCharges         = row.ServiceCharges;
    entry.ServiceTax             = row.ServiceTax;
    entry.ServiceTotal           = row.ServiceTotal;
    entry.ResCharges             = row.ResCharges;
    entry.ResTax                 = row.ResTax;
    entry.ResTotal               = row.ResTotal;
    entry.ResBalance             = row.ResBalance;
    entry.TotalPayments          = row.TotalPayments;
    entry.Comment                = row.Comment;
    entry.Created                = row.Created;
    entry.CountersInvoiceID      = row.CountersInvoiceID;
    entry.CountersInvoiceNumber  = row.CountersInvoiceNumber;
    entry.ReservationID          = row.ReservationID;
    entry.UserName               = row.UserName;

    return entry;
};

RQService.Accounts.GetCustomerInvoiceAccounts
    = RQImported.AccountsGetCustomerInvoiceAccounts;

RQService.Accounts.PopulateGetCustomerInvoiceAccountsRow = function (row) {
    var entry = { };

    entry.InvoiceID    = row.InvoiceID;
    entry.AccountID    = row.AccountID;
    entry.AccountCode  = row.AccountCode;
    entry.AccountName  = row.AccountName;
    entry.BaseCharge   = row.BaseCharge;
    entry.Tax          = row.Tax;
    entry.Total        = row.Total;
    entry.TaxID        = row.TaxID;
    entry.Percentage   = row.Percentage;
    entry.TaxName      = row.TaxName;
    entry.Created      = row.Created;

    return entry;
};

RQService.Accounts.GetCustomerInvoiceAncillaryGuests
    = RQImported.AccountsGetCustomerInvoiceAncillaryGuests;

RQService.Accounts.PopulateGetCustomerInvoiceAncillaryGuestsRow = function (row) {
    var entry = { };

    entry.GuestID            = row.GuestID;
    entry.GuestTitleID       = row.GuestTitleID;
    entry.Gender             = row.Gender;
    entry.FirstName          = row.FirstName;
    entry.LastName           = row.LastName;
    entry.Company            = row.Company;
    entry.CompanyVAT         = row.CompanyVAT;
    entry.CountryID          = row.CountryID;
    entry.Address            = row.Address;
    entry.Location           = row.Location;
    entry.PostCode           = row.PostCode;
    entry.Telephone          = row.Telephone;
    entry.TelephoneAlt       = row.TelephoneAlt;
    entry.Mobile             = row.Mobile;
    entry.Fax                = row.Fax;
    entry.Email              = row.Email;
    entry.Identification     = row.Identification;
    entry.TaxIdentification  = row.TaxIdentification;
    entry.Notes              = row.Notes;
    entry.CCTypeID           = row.CCTypeID;
    entry.CCNumber           = row.CCNumber;
    entry.CCName             = row.CCName;
    entry.CCExpiryYear       = row.CCExpiryYear;
    entry.CCExpiryMonth      = row.CCExpiryMonth;
    entry.CCCVC              = row.CCCVC;
    entry.Created            = row.Created;

    return entry;
};

RQService.Accounts.GetCustomerInvoiceBreakdownAndAccounts
    = RQImported.AccountsGetCustomerInvoiceBreakdownAndAccounts;

RQService.Accounts.PopulateGetCustomerInvoiceBreakdownAndAccountsRow = function (row) {
    var entry = { };

    entry.GroupID       = row.GroupID;
    entry.InvoiceID     = row.InvoiceID;
    entry.AccountID     = row.AccountID;
    entry.AccountCode   = row.AccountCode;
    entry.AccountName   = row.AccountName;
    entry.RoomTypeID    = row.RoomTypeID;
    entry.RoomTypeName  = row.RoomTypeName;
    entry.NumRooms      = row.NumRooms;
    entry.Arr           = row.Arr;
    entry.Dep           = row.Dep;
    entry.BaseCharge    = row.BaseCharge;
    entry.Tax           = row.Tax;
    entry.Total         = row.Total;
    entry.TaxID         = row.TaxID;
    entry.Percentage    = row.Percentage;
    entry.TaxName       = row.TaxName;
    entry.Created       = row.Created;

    return entry;
};

RQService.Accounts.GetCustomerInvoiceGuestName
    = RQImported.AccountsGetCustomerInvoiceGuestName;

RQService.Accounts.PopulateGetCustomerInvoiceGuestNameRow = function (row) {
    var entry = { };

    entry.GuestID            = row.GuestID;
    entry.GuestTitleID       = row.GuestTitleID;
    entry.Gender             = row.Gender;
    entry.FirstName          = row.FirstName;
    entry.LastName           = row.LastName;
    entry.Company            = row.Company;
    entry.CompanyVAT         = row.CompanyVAT;
    entry.CountryID          = row.CountryID;
    entry.Address            = row.Address;
    entry.Location           = row.Location;
    entry.PostCode           = row.PostCode;
    entry.Telephone          = row.Telephone;
    entry.TelephoneAlt       = row.TelephoneAlt;
    entry.Mobile             = row.Mobile;
    entry.Fax                = row.Fax;
    entry.Email              = row.Email;
    entry.Identification     = row.Identification;
    entry.TaxIdentification  = row.TaxIdentification;
    entry.Notes              = row.Notes;
    entry.CCTypeID           = row.CCTypeID;
    entry.CCNumber           = row.CCNumber;
    entry.CCName             = row.CCName;
    entry.CCExpiryYear       = row.CCExpiryYear;
    entry.CCExpiryMonth      = row.CCExpiryMonth;
    entry.CCCVC              = row.CCCVC;
    entry.Created            = row.Created;

    return entry;
};

RQService.Accounts.GetCustomerInvoiceRoomTypeBreakdown
    = RQImported.AccountsGetCustomerInvoiceRoomTypeBreakdown;

RQService.Accounts.PopulateGetCustomerInvoiceRoomTypeBreakdownRow = function (row) {
    var entry = { };

    entry.InvoiceID     = row.InvoiceID;
    entry.RoomTypeID    = row.RoomTypeID;
    entry.Arr           = row.Arr;
    entry.Dep           = row.Dep;
    entry.RoomTypeName  = row.RoomTypeName;
    entry.NumRooms      = row.NumRooms;
    entry.BaseCharge    = row.BaseCharge;
    entry.Tax           = row.Tax;
    entry.Total         = row.Total;
    entry.Percentage    = row.Percentage;
    entry.Created       = row.Created;

    return entry;
};

RQService.Accounts.GetFolioTransactions
    = RQImported.AccountsGetFolioTransactions;

RQService.Accounts.PopulateGetFolioTransactionsRow = function (row) {
    var entry = { };

    entry.HotelID            = row.HotelID;
    entry.TransactionID      = row.TransactionID;
    entry.RevenueDay         = row.RevenueDay;
    entry.TaxDay             = row.TaxDay;
    entry.ProductID          = row.ProductID;
    entry.AccountID          = row.AccountID;
    entry.Description        = row.Description;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.AmountTotal        = row.AmountTotal;
    entry.Active             = row.Active;
    entry.Invoiced           = row.Invoiced;
    entry.InvoicingStatus    = row.InvoicingStatus;
    entry.Countered          = row.Countered;
    entry.Historical         = row.Historical;
    entry.TillID             = row.TillID;
    entry.UserID             = row.UserID;
    entry.IsAddon            = row.IsAddon;
    entry.Created            = row.Created;
    entry.UserName           = row.UserName;
    entry.RoomReservationID  = row.RoomReservationID;
    entry.SortOrder          = row.SortOrder;
    entry.RoomNumber         = row.RoomNumber;
    entry.RoomTypeName       = row.RoomTypeName;
    entry.MaxPersons         = row.MaxPersons;
    entry.Arr                = row.Arr;
    entry.Dep                = row.Dep;
    entry.Total              = row.Total;
    entry.OnBehalfOfUserID   = row.OnBehalfOfUserID;
    entry.DeferralSegmentID  = row.DeferralSegmentID;
    entry.Handled            = row.Handled;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.AccountTypeID      = row.AccountTypeID;
    entry.AccountTypeName    = row.AccountTypeName;
    entry.TaxName            = row.TaxName;
    entry.Product            = row.Product;
    entry.BusinessDay        = row.BusinessDay;
    entry.IsLocked           = row.IsLocked;
    entry.IsExpired          = row.IsExpired;
    entry.FolioID            = row.FolioID;
    entry.BillingID          = row.BillingID;
    entry.HasEditHistory     = row.HasEditHistory;
    entry.GuestID            = row.GuestID;

    return entry;
};

RQService.Accounts.GetInvoicableTransactions
    = RQImported.AccountsGetInvoicableTransactions;

RQService.Accounts.PopulateGetInvoicableTransactionsRow = function (row) {
    var entry = { };

    entry.TransactionID      = row.TransactionID;
    entry.RevenueDay         = row.RevenueDay;
    entry.ProductID          = row.ProductID;
    entry.AccountID          = row.AccountID;
    entry.Description        = row.Description;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.AmountTotal        = row.AmountTotal;
    entry.Active             = row.Active;
    entry.Invoiced           = row.Invoiced;
    entry.InvoicingStatus    = row.InvoicingStatus;
    entry.Countered          = row.Countered;
    entry.Historical         = row.Historical;
    entry.TillID             = row.TillID;
    entry.UserID             = row.UserID;
    entry.Created            = row.Created;
    entry.RoomReservationID  = row.RoomReservationID;
    entry.SortOrder          = row.SortOrder;
    entry.RoomNumber         = row.RoomNumber;
    entry.RoomTypeName       = row.RoomTypeName;
    entry.MaxPersons         = row.MaxPersons;
    entry.Arr                = row.Arr;
    entry.Dep                = row.Dep;
    entry.Total              = row.Total;
    entry.Product            = row.Product;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.TaxName            = row.TaxName;
    entry.FolioID            = row.FolioID;
    entry.BillingID          = row.BillingID;

    return entry;
};

RQService.Accounts.GetInvoice
    = RQImported.AccountsGetInvoice;

RQService.Accounts.PopulateGetInvoiceRow = function (row) {
    var entry = { };

    entry.InvoiceID              = row.InvoiceID;
    entry.InvoiceNumber          = row.InvoiceNumber;
    entry.CounterInvoiceID       = row.CounterInvoiceID;
    entry.FolioID                = row.FolioID;
    entry.BillingID              = row.BillingID;
    entry.BillingName            = row.BillingName;
    entry.IsSubInvoice           = row.IsSubInvoice;
    entry.SumRoomCharges         = row.SumRoomCharges;
    entry.SumRoomTax             = row.SumRoomTax;
    entry.SumRoomTotal           = row.SumRoomTotal;
    entry.ServiceCharges         = row.ServiceCharges;
    entry.ServiceTax             = row.ServiceTax;
    entry.ServiceTotal           = row.ServiceTotal;
    entry.ResCharges             = row.ResCharges;
    entry.ResTax                 = row.ResTax;
    entry.ResTotal               = row.ResTotal;
    entry.ResBalance             = row.ResBalance;
    entry.TotalPayments          = row.TotalPayments;
    entry.Comment                = row.Comment;
    entry.Created                = row.Created;
    entry.CountersInvoiceID      = row.CountersInvoiceID;
    entry.CountersInvoiceNumber  = row.CountersInvoiceNumber;
    entry.ReservationID          = row.ReservationID;
    entry.UserName               = row.UserName;

    return entry;
};

RQService.Accounts.GetInvoiceAccounts
    = RQImported.AccountsGetInvoiceAccounts;

RQService.Accounts.PopulateGetInvoiceAccountsRow = function (row) {
    var entry = { };

    entry.InvoiceID    = row.InvoiceID;
    entry.AccountID    = row.AccountID;
    entry.AccountCode  = row.AccountCode;
    entry.AccountName  = row.AccountName;
    entry.BaseCharge   = row.BaseCharge;
    entry.Tax          = row.Tax;
    entry.Total        = row.Total;
    entry.TaxID        = row.TaxID;
    entry.Percentage   = row.Percentage;
    entry.TaxName      = row.TaxName;
    entry.Created      = row.Created;

    return entry;
};

RQService.Accounts.GetInvoiceBreakdownAndAccounts
    = RQImported.AccountsGetInvoiceBreakdownAndAccounts;

RQService.Accounts.PopulateGetInvoiceBreakdownAndAccountsRow = function (row) {
    var entry = { };

    entry.GroupID       = row.GroupID;
    entry.InvoiceID     = row.InvoiceID;
    entry.AccountID     = row.AccountID;
    entry.AccountCode   = row.AccountCode;
    entry.AccountName   = row.AccountName;
    entry.RoomTypeID    = row.RoomTypeID;
    entry.RoomTypeName  = row.RoomTypeName;
    entry.NumRooms      = row.NumRooms;
    entry.Arr           = row.Arr;
    entry.Dep           = row.Dep;
    entry.BaseCharge    = row.BaseCharge;
    entry.Tax           = row.Tax;
    entry.Total         = row.Total;
    entry.TaxID         = row.TaxID;
    entry.Percentage    = row.Percentage;
    entry.TaxName       = row.TaxName;
    entry.Created       = row.Created;

    return entry;
};

RQService.Accounts.GetInvoiceGuestName
    = RQImported.AccountsGetInvoiceGuestName;

RQService.Accounts.PopulateGetInvoiceGuestNameRow = function (row) {
    var entry = { };

    entry.GuestID            = row.GuestID;
    entry.GuestTitleID       = row.GuestTitleID;
    entry.Gender             = row.Gender;
    entry.FirstName          = row.FirstName;
    entry.LastName           = row.LastName;
    entry.Company            = row.Company;
    entry.CompanyVAT         = row.CompanyVAT;
    entry.CountryID          = row.CountryID;
    entry.Address            = row.Address;
    entry.Location           = row.Location;
    entry.PostCode           = row.PostCode;
    entry.Telephone          = row.Telephone;
    entry.TelephoneAlt       = row.TelephoneAlt;
    entry.Mobile             = row.Mobile;
    entry.Fax                = row.Fax;
    entry.Email              = row.Email;
    entry.Identification     = row.Identification;
    entry.TaxIdentification  = row.TaxIdentification;
    entry.Notes              = row.Notes;
    entry.CCTypeID           = row.CCTypeID;
    entry.CCNumber           = row.CCNumber;
    entry.CCName             = row.CCName;
    entry.CCExpiryYear       = row.CCExpiryYear;
    entry.CCExpiryMonth      = row.CCExpiryMonth;
    entry.CCCVC              = row.CCCVC;
    entry.Created            = row.Created;

    return entry;
};

RQService.Accounts.GetInvoiceRoomTypeBreakdown
    = RQImported.AccountsGetInvoiceRoomTypeBreakdown;

RQService.Accounts.PopulateGetInvoiceRoomTypeBreakdownRow = function (row) {
    var entry = { };

    entry.InvoiceID     = row.InvoiceID;
    entry.RoomTypeID    = row.RoomTypeID;
    entry.Arr           = row.Arr;
    entry.Dep           = row.Dep;
    entry.RoomTypeName  = row.RoomTypeName;
    entry.NumRooms      = row.NumRooms;
    entry.BaseCharge    = row.BaseCharge;
    entry.Tax           = row.Tax;
    entry.Total         = row.Total;
    entry.Percentage    = row.Percentage;
    entry.Created       = row.Created;

    return entry;
};

RQService.Accounts.GetJournalPeriodSnapshotBillingGroups
    = RQImported.AccountsGetJournalPeriodSnapshotBillingGroups;

RQService.Accounts.PopulateGetJournalPeriodSnapshotBillingGroupsRow = function (row) {
    var entry = { };

    entry.ProductBillingGroupID    = row.ProductBillingGroupID;
    entry.ProductBillingGroupName  = row.ProductBillingGroupName;
    entry.Quantity                 = row.Quantity;
    entry.RoomChargeGroupID        = row.RoomChargeGroupID;
    entry.Total                    = row.Total;

    return entry;
};

RQService.Accounts.GetJournalPeriodSnapshotCharges
    = RQImported.AccountsGetJournalPeriodSnapshotCharges;

RQService.Accounts.PopulateGetJournalPeriodSnapshotChargesRow = function (row) {
    var entry = { };

    entry.AccountID          = row.AccountID;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.Name               = row.Name;
    entry.Quantity           = row.Quantity;
    entry.RoomChargeGroupID  = row.RoomChargeGroupID;
    entry.AmountTotal        = row.AmountTotal;
    entry.TaxID              = row.TaxID;
    entry.Percentage         = row.Percentage;
    entry.TaxName            = row.TaxName;

    return entry;
};

RQService.Accounts.GetJournalSegment
    = RQImported.AccountsGetJournalSegment;

RQService.Accounts.PopulateGetJournalSegmentRow = function (row) {
    var entry = { };

    entry.JournalSegmentID  = row.JournalSegmentID;
    entry.TillID            = row.TillID;
    entry.TillName          = row.TillName;
    entry.UserID            = row.UserID;
    entry.UserName          = row.UserName;
    entry.SegmentStart      = row.SegmentStart;
    entry.SegmentEnd        = row.SegmentEnd;
    entry.IsClosed          = row.IsClosed;

    return entry;
};

RQService.Accounts.GetJournalSegmentEndTimesByDay
    = RQImported.AccountsGetJournalSegmentEndTimesByDay;

RQService.Accounts.PopulateGetJournalSegmentEndTimesByDayRow = function (row) {
    var entry = { };

    entry.JournalSegmentID  = row.JournalSegmentID;
    entry.SegmentEnd        = row.SegmentEnd;

    return entry;
};

RQService.Accounts.GetJournalSegmentsByTill
    = RQImported.AccountsGetJournalSegmentsByTill;

RQService.Accounts.PopulateGetJournalSegmentsByTillRow = function (row) {
    var entry = { };

    entry.JournalSegmentID  = row.JournalSegmentID;
    entry.TillID            = row.TillID;
    entry.TillName          = row.TillName;
    entry.UserID            = row.UserID;
    entry.UserName          = row.UserName;
    entry.SegmentStart      = row.SegmentStart;
    entry.SegmentEnd        = row.SegmentEnd;
    entry.IsClosed          = row.IsClosed;

    return entry;
};

RQService.Accounts.GetJournalSegmentSnapshot
    = RQImported.AccountsGetJournalSegmentSnapshot;

RQService.Accounts.PopulateGetJournalSegmentSnapshotRow = function (row) {
    var entry = { };

    entry.JournalSegmentID           = row.JournalSegmentID;
    entry.JournalSegmentSnapshotID   = row.JournalSegmentSnapshotID;
    entry.JournalSummaryNumber       = row.JournalSummaryNumber;
    entry.TillID                     = row.TillID;
    entry.UserID                     = row.UserID;
    entry.UserName                   = row.UserName;
    entry.SegmentStart               = row.SegmentStart;
    entry.SegmentEnd                 = row.SegmentEnd;
    entry.Superceded                 = row.Superceded;
    entry.ClosedByUserID             = row.ClosedByUserID;
    entry.ClosedByUserName           = row.ClosedByUserName;
    entry.TotalPayments              = row.TotalPayments;
    entry.PaymentsFromOtherSegments  = row.PaymentsFromOtherSegments;
    entry.CashBalance                = row.CashBalance;
    entry.Created                    = row.Created;

    return entry;
};

RQService.Accounts.GetJournalSegmentSnapshotBillingGroups
    = RQImported.AccountsGetJournalSegmentSnapshotBillingGroups;

RQService.Accounts.PopulateGetJournalSegmentSnapshotBillingGroupsRow = function (row) {
    var entry = { };

    entry.ProductBillingGroupID    = row.ProductBillingGroupID;
    entry.ProductBillingGroupName  = row.ProductBillingGroupName;
    entry.Quantity                 = row.Quantity;
    entry.RoomChargeGroupID        = row.RoomChargeGroupID;
    entry.Total                    = row.Total;

    return entry;
};

RQService.Accounts.GetJournalSegmentSnapshotCharges
    = RQImported.AccountsGetJournalSegmentSnapshotCharges;

RQService.Accounts.PopulateGetJournalSegmentSnapshotChargesRow = function (row) {
    var entry = { };

    entry.AccountID          = row.AccountID;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.Name               = row.Name;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.RoomChargeGroupID  = row.RoomChargeGroupID;
    entry.AmountTotal        = row.AmountTotal;
    entry.TaxID              = row.TaxID;
    entry.Percentage         = row.Percentage;
    entry.TaxName            = row.TaxName;

    return entry;
};

RQService.Accounts.GetJournalSegmentSnapshotClosedPayments
    = RQImported.AccountsGetJournalSegmentSnapshotClosedPayments;

RQService.Accounts.PopulateGetJournalSegmentSnapshotClosedPaymentsRow = function (row) {
    var entry = { };

    entry.AccountID     = row.AccountID;
    entry.AccountCode   = row.AccountCode;
    entry.AccountName   = row.AccountName;
    entry.Quantity      = row.Quantity;
    entry.AmountTotal   = row.AmountTotal;
    entry.IsDeffered    = row.IsDeffered;
    entry.IsCorrection  = row.IsCorrection;

    return entry;
};

RQService.Accounts.GetJournalSegmentSnapshotOpenPayments
    = RQImported.AccountsGetJournalSegmentSnapshotOpenPayments;

RQService.Accounts.PopulateGetJournalSegmentSnapshotOpenPaymentsRow = function (row) {
    var entry = { };

    entry.AccountID     = row.AccountID;
    entry.AccountCode   = row.AccountCode;
    entry.AccountName   = row.AccountName;
    entry.Quantity      = row.Quantity;
    entry.AmountTotal   = row.AmountTotal;
    entry.IsDeffered    = row.IsDeffered;
    entry.IsCorrection  = row.IsCorrection;

    return entry;
};

RQService.Accounts.GetJournalSegmentSnapshots
    = RQImported.AccountsGetJournalSegmentSnapshots;

RQService.Accounts.PopulateGetJournalSegmentSnapshotsRow = function (row) {
    var entry = { };

    entry.JournalSegmentID           = row.JournalSegmentID;
    entry.JournalSegmentSnapshotID   = row.JournalSegmentSnapshotID;
    entry.JournalSummaryNumber       = row.JournalSummaryNumber;
    entry.TillID                     = row.TillID;
    entry.UserID                     = row.UserID;
    entry.UserName                   = row.UserName;
    entry.SegmentStart               = row.SegmentStart;
    entry.SegmentEnd                 = row.SegmentEnd;
    entry.Superceded                 = row.Superceded;
    entry.ClosedByUserID             = row.ClosedByUserID;
    entry.ClosedByUserName           = row.ClosedByUserName;
    entry.TotalPayments              = row.TotalPayments;
    entry.PaymentsFromOtherSegments  = row.PaymentsFromOtherSegments;
    entry.CashBalance                = row.CashBalance;
    entry.Created                    = row.Created;

    return entry;
};

RQService.Accounts.GetJournalSegmentSnapshotSalesBillingGroups
    = RQImported.AccountsGetJournalSegmentSnapshotSalesBillingGroups;

RQService.Accounts.PopulateGetJournalSegmentSnapshotSalesBillingGroupsRow = function (row) {
    var entry = { };

    entry.ProductBillingGroupID    = row.ProductBillingGroupID;
    entry.ProductBillingGroupName  = row.ProductBillingGroupName;
    entry.Quantity                 = row.Quantity;
    entry.RoomChargeGroupID        = row.RoomChargeGroupID;
    entry.Total                    = row.Total;

    return entry;
};

RQService.Accounts.GetJournalSegmentSnapshotSalesCharges
    = RQImported.AccountsGetJournalSegmentSnapshotSalesCharges;

RQService.Accounts.PopulateGetJournalSegmentSnapshotSalesChargesRow = function (row) {
    var entry = { };

    entry.AccountID          = row.AccountID;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.Name               = row.Name;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.RoomChargeGroupID  = row.RoomChargeGroupID;
    entry.AmountTotal        = row.AmountTotal;
    entry.TaxID              = row.TaxID;
    entry.Percentage         = row.Percentage;
    entry.TaxName            = row.TaxName;

    return entry;
};

RQService.Accounts.GetJournalSegmentStartTimesByDay
    = RQImported.AccountsGetJournalSegmentStartTimesByDay;

RQService.Accounts.PopulateGetJournalSegmentStartTimesByDayRow = function (row) {
    var entry = { };

    entry.JournalSegmentID  = row.JournalSegmentID;
    entry.SegmentStart      = row.SegmentStart;

    return entry;
};

RQService.Accounts.GetOccupiedRooms
    = RQImported.AccountsGetOccupiedRooms;

RQService.Accounts.PopulateGetOccupiedRoomsRow = function (row) {
    var entry = { };

    entry.RoomReservationID      = row.RoomReservationID;
    entry.RoomID                 = row.RoomID;
    entry.RoomNumber             = row.RoomNumber;
    entry.GuestFullName          = row.GuestFullName;
    entry.IsArr                  = row.IsArr;
    entry.IsDep                  = row.IsDep;
    entry.Arr                    = row.Arr;
    entry.Dep                    = row.Dep;
    entry.PartnerID              = row.PartnerID;
    entry.Partner                = row.Partner;
    entry.ExternalReservationID  = row.ExternalReservationID;
    entry.RoomTotal              = row.RoomTotal;
    entry.ServiceTotal           = row.ServiceTotal;
    entry.Notes                  = row.Notes;
    entry.NotePriorityLevel      = row.NotePriorityLevel;
    entry.PriorityNotes          = row.PriorityNotes;

    return entry;
};

RQService.Accounts.GetPaymentAccounts
    = RQImported.AccountsGetPaymentAccounts;

RQService.Accounts.PopulateGetPaymentAccountsRow = function (row) {
    var entry = { };

    entry.AccountID        = row.AccountID;
    entry.AccountCode      = row.AccountCode;
    entry.AccountName      = row.AccountName;
    entry.AccountTypeID    = row.AccountTypeID;
    entry.AccountTypeName  = row.AccountTypeName;

    return entry;
};

RQService.Accounts.GetPaymentGuests
    = RQImported.AccountsGetPaymentGuests;

RQService.Accounts.PopulateGetPaymentGuestsRow = function (row) {
    var entry = { };

    entry.GuestID              = row.GuestID;
    entry.FirstName            = row.FirstName;
    entry.LastName             = row.LastName;
    entry.FullGuestName        = row.FullGuestName;
    entry.HasCompany           = row.HasCompany;
    entry.Company              = row.Company;
    entry.IsReservationHolder  = row.IsReservationHolder;
    entry.IsPaymentHolder      = row.IsPaymentHolder;
    entry.IsExternalHolder     = row.IsExternalHolder;

    return entry;
};

RQService.Accounts.GetPrimaryReservationBillingID
    = RQImported.AccountsGetPrimaryReservationBillingID;

RQService.Accounts.PopulateGetPrimaryReservationBillingIDRow = function (row) {
    var entry = { };

    entry.BillingID  = row.BillingID;

    return entry;
};

RQService.Accounts.GetProduct
    = RQImported.AccountsGetProduct;

RQService.Accounts.PopulateGetProductRow = function (row) {
    var entry = { };

    entry.ProductID                = row.ProductID;
    entry.AccountID                = row.AccountID;
    entry.AccountName              = row.AccountName;
    entry.Product                  = row.Product;
    entry.Amount                   = row.Amount;
    entry.TypeID                   = row.TypeID;
    entry.SubTypeID                = row.SubTypeID;
    entry.ProductBillingGroupID    = row.ProductBillingGroupID;
    entry.ProductBillingGroupName  = row.ProductBillingGroupName;
    entry.VariablePrice            = row.VariablePrice;
    entry.Label                    = row.Label;

    return entry;
};

RQService.Accounts.GetProductBillingGroups
    = RQImported.AccountsGetProductBillingGroups;

RQService.Accounts.PopulateGetProductBillingGroupsRow = function (row) {
    var entry = { };

    entry.ProductBillingGroupID    = row.ProductBillingGroupID;
    entry.ProductBillingGroupName  = row.ProductBillingGroupName;

    return entry;
};

RQService.Accounts.GetProducts
    = RQImported.AccountsGetProducts;

RQService.Accounts.PopulateGetProductsRow = function (row) {
    var entry = { };

    entry.ProductID      = row.ProductID;
    entry.AccountID      = row.AccountID;
    entry.Product        = row.Product;
    entry.Amount         = row.Amount;
    entry.VariablePrice  = row.VariablePrice;
    entry.Label          = row.Label;

    return entry;
};

RQService.Accounts.GetProductsByType
    = RQImported.AccountsGetProductsByType;

RQService.Accounts.PopulateGetProductsByTypeRow = function (row) {
    var entry = { };

    entry.ProductID      = row.ProductID;
    entry.AccountID      = row.AccountID;
    entry.Product        = row.Product;
    entry.Amount         = row.Amount;
    entry.VariablePrice  = row.VariablePrice;
    entry.Label          = row.Label;

    return entry;
};

RQService.Accounts.GetProvisionalBillingBalance
    = RQImported.AccountsGetProvisionalBillingBalance;

RQService.Accounts.PopulateGetProvisionalBillingBalanceRow = function (row) {
    var entry = { };

    entry.Charges        = row.Charges;
    entry.Payments       = row.Payments;
    entry.Balance        = row.Balance;
    entry.NumReceipts    = row.NumReceipts;
    entry.BillingNumber  = row.BillingNumber;

    return entry;
};

RQService.Accounts.GetReceipt
    = RQImported.AccountsGetReceipt;

RQService.Accounts.PopulateGetReceiptRow = function (row) {
    var entry = { };

    entry.ReceiptID              = row.ReceiptID;
    entry.ReceiptNumber          = row.ReceiptNumber;
    entry.CounterReceiptID       = row.CounterReceiptID;
    entry.FolioID                = row.FolioID;
    entry.BillingID              = row.BillingID;
    entry.BillingName            = row.BillingName;
    entry.IsPartialPayment       = row.IsPartialPayment;
    entry.TotalAmount            = row.TotalAmount;
    entry.Created                = row.Created;
    entry.CountersReceiptID      = row.CountersReceiptID;
    entry.CountersReceiptNumber  = row.CountersReceiptNumber;
    entry.ReservationID          = row.ReservationID;
    entry.UserName               = row.UserName;

    return entry;
};

RQService.Accounts.GetReceiptAccounts
    = RQImported.AccountsGetReceiptAccounts;

RQService.Accounts.PopulateGetReceiptAccountsRow = function (row) {
    var entry = { };

    entry.ReceiptID    = row.ReceiptID;
    entry.AccountID    = row.AccountID;
    entry.AccountCode  = row.AccountCode;
    entry.AccountName  = row.AccountName;
    entry.AmountTotal  = row.AmountTotal;
    entry.Created      = row.Created;

    return entry;
};

RQService.Accounts.GetReceiptGuestName
    = RQImported.AccountsGetReceiptGuestName;

RQService.Accounts.PopulateGetReceiptGuestNameRow = function (row) {
    var entry = { };

    entry.GuestID            = row.GuestID;
    entry.GuestTitleID       = row.GuestTitleID;
    entry.Gender             = row.Gender;
    entry.FirstName          = row.FirstName;
    entry.LastName           = row.LastName;
    entry.Company            = row.Company;
    entry.CompanyVAT         = row.CompanyVAT;
    entry.CountryID          = row.CountryID;
    entry.Address            = row.Address;
    entry.Location           = row.Location;
    entry.PostCode           = row.PostCode;
    entry.Telephone          = row.Telephone;
    entry.TelephoneAlt       = row.TelephoneAlt;
    entry.Mobile             = row.Mobile;
    entry.Fax                = row.Fax;
    entry.Email              = row.Email;
    entry.Identification     = row.Identification;
    entry.TaxIdentification  = row.TaxIdentification;
    entry.Notes              = row.Notes;
    entry.CCTypeID           = row.CCTypeID;
    entry.CCNumber           = row.CCNumber;
    entry.CCName             = row.CCName;
    entry.CCExpiryYear       = row.CCExpiryYear;
    entry.CCExpiryMonth      = row.CCExpiryMonth;
    entry.CCCVC              = row.CCCVC;
    entry.Created            = row.Created;

    return entry;
};

RQService.Accounts.GetReceiptInvoiceAccounts
    = RQImported.AccountsGetReceiptInvoiceAccounts;

RQService.Accounts.PopulateGetReceiptInvoiceAccountsRow = function (row) {
    var entry = { };

    entry.GroupID       = row.GroupID;
    entry.InvoiceID     = row.InvoiceID;
    entry.AccountID     = row.AccountID;
    entry.AccountCode   = row.AccountCode;
    entry.AccountName   = row.AccountName;
    entry.RoomTypeID    = row.RoomTypeID;
    entry.RoomTypeName  = row.RoomTypeName;
    entry.NumRooms      = row.NumRooms;
    entry.Arr           = row.Arr;
    entry.Dep           = row.Dep;
    entry.BaseCharge    = row.BaseCharge;
    entry.Tax           = row.Tax;
    entry.Total         = row.Total;
    entry.TaxID         = row.TaxID;
    entry.Percentage    = row.Percentage;
    entry.TaxName       = row.TaxName;
    entry.Created       = row.Created;

    return entry;
};

RQService.Accounts.GetReceiptInvoiceCharges
    = RQImported.AccountsGetReceiptInvoiceCharges;

RQService.Accounts.PopulateGetReceiptInvoiceChargesRow = function (row) {
    var entry = { };

    entry.InvoiceID          = row.InvoiceID;
    entry.AccountID          = row.AccountID;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.Name               = row.Name;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.RoomChargeGroupID  = row.RoomChargeGroupID;
    entry.Arr                = row.Arr;
    entry.Dep                = row.Dep;
    entry.NumDays            = row.NumDays;
    entry.AmountTotal        = row.AmountTotal;
    entry.TaxID              = row.TaxID;
    entry.Percentage         = row.Percentage;
    entry.TaxName            = row.TaxName;
    entry.Created            = row.Created;

    return entry;
};

RQService.Accounts.GetReceiptInvoiceTaxes
    = RQImported.AccountsGetReceiptInvoiceTaxes;

RQService.Accounts.PopulateGetReceiptInvoiceTaxesRow = function (row) {
    var entry = { };

    entry.InvoiceID   = row.InvoiceID;
    entry.TaxID       = row.TaxID;
    entry.Percentage  = row.Percentage;
    entry.TaxName     = row.TaxName;
    entry.TotalTax    = row.TotalTax;
    entry.Created     = row.Created;

    return entry;
};

RQService.Accounts.GetReceiptPayments
    = RQImported.AccountsGetReceiptPayments;

RQService.Accounts.PopulateGetReceiptPaymentsRow = function (row) {
    var entry = { };

    entry.ReceiptID    = row.ReceiptID;
    entry.AccountID    = row.AccountID;
    entry.AccountCode  = row.AccountCode;
    entry.AccountName  = row.AccountName;
    entry.GuestName    = row.GuestName;
    entry.AmountTotal  = row.AmountTotal;
    entry.Created      = row.Created;

    return entry;
};

RQService.Accounts.GetRegisterablePayments
    = RQImported.AccountsGetRegisterablePayments;

RQService.Accounts.PopulateGetRegisterablePaymentsRow = function (row) {
    var entry = { };

    entry.TransactionID    = row.TransactionID;
    entry.AccountName      = row.AccountName;
    entry.GuestName        = row.GuestName;
    entry.AmountTotal      = row.AmountTotal;
    entry.InvoicingStatus  = row.InvoicingStatus;
    entry.FolioID          = row.FolioID;
    entry.BillingID        = row.BillingID;

    return entry;
};

RQService.Accounts.GetReleasableTransactions
    = RQImported.AccountsGetReleasableTransactions;

RQService.Accounts.PopulateGetReleasableTransactionsRow = function (row) {
    var entry = { };

    entry.TransactionID      = row.TransactionID;
    entry.RevenueDay         = row.RevenueDay;
    entry.ProductID          = row.ProductID;
    entry.AccountID          = row.AccountID;
    entry.Description        = row.Description;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.AmountTotal        = row.AmountTotal;
    entry.Active             = row.Active;
    entry.Invoiced           = row.Invoiced;
    entry.InvoicingStatus    = row.InvoicingStatus;
    entry.Countered          = row.Countered;
    entry.Historical         = row.Historical;
    entry.TillID             = row.TillID;
    entry.UserID             = row.UserID;
    entry.Created            = row.Created;
    entry.RoomReservationID  = row.RoomReservationID;
    entry.SortOrder          = row.SortOrder;
    entry.RoomNumber         = row.RoomNumber;
    entry.RoomTypeName       = row.RoomTypeName;
    entry.MaxPersons         = row.MaxPersons;
    entry.Arr                = row.Arr;
    entry.Dep                = row.Dep;
    entry.Total              = row.Total;
    entry.Product            = row.Product;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.TaxName            = row.TaxName;
    entry.FolioID            = row.FolioID;
    entry.BillingID          = row.BillingID;

    return entry;
};

RQService.Accounts.GetReservationBalance
    = RQImported.AccountsGetReservationBalance;

RQService.Accounts.PopulateGetReservationBalanceRow = function (row) {
    var entry = { };

    entry.Charges      = row.Charges;
    entry.Payments     = row.Payments;
    entry.Balance      = row.Balance;
    entry.NumReceipts  = row.NumReceipts;
    entry.ReceiptNo    = row.ReceiptNo;

    return entry;
};

RQService.Accounts.GetReservationBillingStatus
    = RQImported.AccountsGetReservationBillingStatus;

RQService.Accounts.PopulateGetReservationBillingStatusRow = function (row) {
    var entry = { };

    entry.BillingID          = row.BillingID;
    entry.BillingSnapshotID  = row.BillingSnapshotID;
    entry.BillIsClosed       = row.BillIsClosed;
    entry.BillHasSnapshot    = row.BillHasSnapshot;

    return entry;
};

RQService.Accounts.GetReservationBills
    = RQImported.AccountsGetReservationBills;

RQService.Accounts.PopulateGetReservationBillsRow = function (row) {
    var entry = { };

    entry.BillingID      = row.BillingID;
    entry.FolioID        = row.FolioID;
    entry.BillingName    = row.BillingName;
    entry.FolioName      = row.FolioName;
    entry.Comment        = row.Comment;
    entry.GuestID        = row.GuestID;
    entry.FullGuestName  = row.FullGuestName;
    entry.ToCompany      = row.ToCompany;
    entry.Company        = row.Company;
    entry.Charges        = row.Charges;
    entry.Payments       = row.Payments;
    entry.Balance        = row.Balance;
    entry.Closed         = row.Closed;
    entry.UserID         = row.UserID;
    entry.UserName       = row.UserName;
    entry.Created        = row.Created;
    entry.ClosedWhen     = row.ClosedWhen;
    entry.ClosedBy       = row.ClosedBy;

    return entry;
};

RQService.Accounts.GetReservationCustomerInvoices
    = RQImported.AccountsGetReservationCustomerInvoices;

RQService.Accounts.PopulateGetReservationCustomerInvoicesRow = function (row) {
    var entry = { };

    entry.InvoiceID              = row.InvoiceID;
    entry.InvoiceNumber          = row.InvoiceNumber;
    entry.CounterInvoiceID       = row.CounterInvoiceID;
    entry.FolioID                = row.FolioID;
    entry.BillingID              = row.BillingID;
    entry.BillingName            = row.BillingName;
    entry.IsSubInvoice           = row.IsSubInvoice;
    entry.SumRoomCharges         = row.SumRoomCharges;
    entry.SumRoomTax             = row.SumRoomTax;
    entry.SumRoomTotal           = row.SumRoomTotal;
    entry.ServiceCharges         = row.ServiceCharges;
    entry.ServiceTax             = row.ServiceTax;
    entry.ServiceTotal           = row.ServiceTotal;
    entry.ResCharges             = row.ResCharges;
    entry.ResTax                 = row.ResTax;
    entry.ResTotal               = row.ResTotal;
    entry.ResBalance             = row.ResBalance;
    entry.TotalPayments          = row.TotalPayments;
    entry.Comment                = row.Comment;
    entry.Created                = row.Created;
    entry.CountersInvoiceID      = row.CountersInvoiceID;
    entry.CountersInvoiceNumber  = row.CountersInvoiceNumber;
    entry.ReservationID          = row.ReservationID;
    entry.UserName               = row.UserName;

    return entry;
};

RQService.Accounts.GetReservationFolios
    = RQImported.AccountsGetReservationFolios;

RQService.Accounts.PopulateGetReservationFoliosRow = function (row) {
    var entry = { };

    entry.FolioID           = row.FolioID;
    entry.CurrentBillingID  = row.CurrentBillingID;
    entry.BillingName       = row.BillingName;
    entry.FolioName         = row.FolioName;
    entry.Comment           = row.Comment;
    entry.GuestID           = row.GuestID;
    entry.FullGuestName     = row.FullGuestName;
    entry.ToCompany         = row.ToCompany;
    entry.Company           = row.Company;
    entry.Charges           = row.Charges;
    entry.Payments          = row.Payments;
    entry.Balance           = row.Balance;
    entry.Closed            = row.Closed;
    entry.UserID            = row.UserID;
    entry.UserName          = row.UserName;
    entry.NumBills          = row.NumBills;
    entry.Created           = row.Created;

    return entry;
};

RQService.Accounts.GetReservationInclusiveRoomTotal
    = RQImported.AccountsGetReservationInclusiveRoomTotal;

RQService.Accounts.PopulateGetReservationInclusiveRoomTotalRow = function (row) {
    var entry = { };

    entry.SumRoomCharges  = row.SumRoomCharges;

    return entry;
};

RQService.Accounts.GetReservationInvoices
    = RQImported.AccountsGetReservationInvoices;

RQService.Accounts.PopulateGetReservationInvoicesRow = function (row) {
    var entry = { };

    entry.InvoiceID              = row.InvoiceID;
    entry.InvoiceNumber          = row.InvoiceNumber;
    entry.CounterInvoiceID       = row.CounterInvoiceID;
    entry.FolioID                = row.FolioID;
    entry.BillingID              = row.BillingID;
    entry.BillingName            = row.BillingName;
    entry.IsSubInvoice           = row.IsSubInvoice;
    entry.SumRoomCharges         = row.SumRoomCharges;
    entry.SumRoomTax             = row.SumRoomTax;
    entry.SumRoomTotal           = row.SumRoomTotal;
    entry.ServiceCharges         = row.ServiceCharges;
    entry.ServiceTax             = row.ServiceTax;
    entry.ServiceTotal           = row.ServiceTotal;
    entry.ResCharges             = row.ResCharges;
    entry.ResTax                 = row.ResTax;
    entry.ResTotal               = row.ResTotal;
    entry.ResBalance             = row.ResBalance;
    entry.TotalPayments          = row.TotalPayments;
    entry.Comment                = row.Comment;
    entry.Created                = row.Created;
    entry.CountersInvoiceID      = row.CountersInvoiceID;
    entry.CountersInvoiceNumber  = row.CountersInvoiceNumber;
    entry.ReservationID          = row.ReservationID;
    entry.UserName               = row.UserName;

    return entry;
};

RQService.Accounts.GetReservationReceipts
    = RQImported.AccountsGetReservationReceipts;

RQService.Accounts.PopulateGetReservationReceiptsRow = function (row) {
    var entry = { };

    entry.ReceiptID              = row.ReceiptID;
    entry.ReceiptNumber          = row.ReceiptNumber;
    entry.CounterReceiptID       = row.CounterReceiptID;
    entry.FolioID                = row.FolioID;
    entry.BillingID              = row.BillingID;
    entry.BillingName            = row.BillingName;
    entry.IsPartialPayment       = row.IsPartialPayment;
    entry.TotalAmount            = row.TotalAmount;
    entry.Created                = row.Created;
    entry.CountersReceiptID      = row.CountersReceiptID;
    entry.CountersReceiptNumber  = row.CountersReceiptNumber;
    entry.ReservationID          = row.ReservationID;
    entry.UserName               = row.UserName;

    return entry;
};

RQService.Accounts.GetReservationTransactions
    = RQImported.AccountsGetReservationTransactions;

RQService.Accounts.PopulateGetReservationTransactionsRow = function (row) {
    var entry = { };

    entry.TransactionID      = row.TransactionID;
    entry.RevenueDay         = row.RevenueDay;
    entry.ProductID          = row.ProductID;
    entry.AccountID          = row.AccountID;
    entry.Description        = row.Description;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.AmountTotal        = row.AmountTotal;
    entry.Active             = row.Active;
    entry.Invoiced           = row.Invoiced;
    entry.InvoicingStatus    = row.InvoicingStatus;
    entry.Countered          = row.Countered;
    entry.Historical         = row.Historical;
    entry.TillID             = row.TillID;
    entry.UserID             = row.UserID;
    entry.Created            = row.Created;
    entry.UserName           = row.UserName;
    entry.RoomReservationID  = row.RoomReservationID;
    entry.SortOrder          = row.SortOrder;
    entry.RoomNumber         = row.RoomNumber;
    entry.RoomTypeName       = row.RoomTypeName;
    entry.MaxPersons         = row.MaxPersons;
    entry.Arr                = row.Arr;
    entry.Dep                = row.Dep;
    entry.Total              = row.Total;
    entry.OnBehalfOfUserID   = row.OnBehalfOfUserID;
    entry.DeferralSegmentID  = row.DeferralSegmentID;
    entry.Handled            = row.Handled;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.AccountTypeID      = row.AccountTypeID;
    entry.AccountTypeName    = row.AccountTypeName;
    entry.TaxName            = row.TaxName;
    entry.Product            = row.Product;
    entry.BusinessDay        = row.BusinessDay;
    entry.IsLocked           = row.IsLocked;
    entry.IsExpired          = row.IsExpired;

    return entry;
};

RQService.Accounts.GetRevenuePeriodAggregates
    = RQImported.AccountsGetRevenuePeriodAggregates;

RQService.Accounts.PopulateGetRevenuePeriodAggregatesRow = function (row) {
    var entry = { };

    entry.AccountID       = row.AccountID;
    entry.AccountCode     = row.AccountCode;
    entry.AccountName     = row.AccountName;
    entry.Quantity        = row.Quantity;
    entry.AmountTotal     = row.AmountTotal;
    entry.TaxName         = row.TaxName;
    entry.PercentageRate  = row.PercentageRate;

    return entry;
};

RQService.Accounts.GetRevenuePeriodChargeBreakdown
    = RQImported.AccountsGetRevenuePeriodChargeBreakdown;

RQService.Accounts.PopulateGetRevenuePeriodChargeBreakdownRow = function (row) {
    var entry = { };

    entry.ReservationID          = row.ReservationID;
    entry.FirstArr               = row.FirstArr;
    entry.LastDep                = row.LastDep;
    entry.ExternalReservationID  = row.ExternalReservationID;
    entry.OwningGuestID          = row.OwningGuestID;
    entry.FullGuestName          = row.FullGuestName;
    entry.ReservationStatusID    = row.ReservationStatusID;
    entry.ReservationStatusName  = row.ReservationStatusName;
    entry.PaymentSchemeID        = row.PaymentSchemeID;
    entry.PaymentSchemeName      = row.PaymentSchemeName;
    entry.ReservationTotal       = row.ReservationTotal;
    entry.PartnerID              = row.PartnerID;
    entry.Partner                = row.Partner;
    entry.RevenueDay             = row.RevenueDay;
    entry.AccountID              = row.AccountID;
    entry.AccountCode            = row.AccountCode;
    entry.Quantity               = row.Quantity;
    entry.AmountTotal            = row.AmountTotal;
    entry.ProductID              = row.ProductID;
    entry.Product                = row.Product;
    entry.TaxName                = row.TaxName;
    entry.PercentageRate         = row.PercentageRate;
    entry.HasProduct             = row.HasProduct;

    return entry;
};

RQService.Accounts.GetRevenuePeriodCharges
    = RQImported.AccountsGetRevenuePeriodCharges;

RQService.Accounts.PopulateGetRevenuePeriodChargesRow = function (row) {
    var entry = { };

    entry.AccountID       = row.AccountID;
    entry.AccountCode     = row.AccountCode;
    entry.Quantity        = row.Quantity;
    entry.AmountTotal     = row.AmountTotal;
    entry.ProductID       = row.ProductID;
    entry.Product         = row.Product;
    entry.TaxName         = row.TaxName;
    entry.PercentageRate  = row.PercentageRate;

    return entry;
};

RQService.Accounts.GetRoomReservationAdditionalTaxTotal
    = RQImported.AccountsGetRoomReservationAdditionalTaxTotal;

RQService.Accounts.PopulateGetRoomReservationAdditionalTaxTotalRow = function (row) {
    var entry = { };

    entry.AdditionalTaxTotal  = row.AdditionalTaxTotal;

    return entry;
};

RQService.Accounts.GetRoomReservationList
    = RQImported.AccountsGetRoomReservationList;

RQService.Accounts.PopulateGetRoomReservationListRow = function (row) {
    var entry = { };

    entry.RoomReservationID          = row.RoomReservationID;
    entry.RoomID                     = row.RoomID;
    entry.Arr                        = row.Arr;
    entry.Dep                        = row.Dep;
    entry.RoomReservationStatusID    = row.RoomReservationStatusID;
    entry.RoomReservationStatusName  = row.RoomReservationStatusName;
    entry.OfferTypeID                = row.OfferTypeID;
    entry.ExclusiveRatePeriodID      = row.ExclusiveRatePeriodID;
    entry.RoomTypeName               = row.RoomTypeName;
    entry.SortOrder                  = row.SortOrder;
    entry.RoomNumber                 = row.RoomNumber;
    entry.RoomTotal                  = row.RoomTotal;
    entry.ServiceTotal               = row.ServiceTotal;
    entry.Label                      = row.Label;
    entry.IsCheckedIn                = row.IsCheckedIn;
    entry.CheckedIn                  = row.CheckedIn;
    entry.IsCheckedOut               = row.IsCheckedOut;
    entry.CheckedOut                 = row.CheckedOut;
    entry.NumPersonsStaying          = row.NumPersonsStaying;
    entry.NumPersonsHavingBreakfast  = row.NumPersonsHavingBreakfast;
    entry.OwningGuestID              = row.OwningGuestID;
    entry.OwningGuestFullName        = row.OwningGuestFullName;

    return entry;
};

RQService.Accounts.GetRoomServiceCharges
    = RQImported.AccountsGetRoomServiceCharges;

RQService.Accounts.PopulateGetRoomServiceChargesRow = function (row) {
    var entry = { };

    entry.HotelID            = row.HotelID;
    entry.TransactionID      = row.TransactionID;
    entry.RevenueDay         = row.RevenueDay;
    entry.ProductID          = row.ProductID;
    entry.AccountID          = row.AccountID;
    entry.Description        = row.Description;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.AmountTotal        = row.AmountTotal;
    entry.Active             = row.Active;
    entry.Invoiced           = row.Invoiced;
    entry.InvoicingStatus    = row.InvoicingStatus;
    entry.Countered          = row.Countered;
    entry.Historical         = row.Historical;
    entry.TillID             = row.TillID;
    entry.UserID             = row.UserID;
    entry.Created            = row.Created;
    entry.Product            = row.Product;
    entry.UserName           = row.UserName;
    entry.DefferalSegmentID  = row.DefferalSegmentID;
    entry.OnBehalfOfUserID   = row.OnBehalfOfUserID;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.AccountTypeID      = row.AccountTypeID;
    entry.AccountTypeName    = row.AccountTypeName;
    entry.TaxName            = row.TaxName;
    entry.BillIsClosed       = row.BillIsClosed;

    return entry;
};

RQService.Accounts.GetTax
    = RQImported.AccountsGetTax;

RQService.Accounts.PopulateGetTaxRow = function (row) {
    var entry = { };

    entry.TaxID       = row.TaxID;
    entry.Percentage  = row.Percentage;
    entry.TaxName     = row.TaxName;

    return entry;
};

RQService.Accounts.GetTaxes
    = RQImported.AccountsGetTaxes;

RQService.Accounts.PopulateGetTaxesRow = function (row) {
    var entry = { };

    entry.TaxID       = row.TaxID;
    entry.Percentage  = row.Percentage;
    entry.TaxName     = row.TaxName;

    return entry;
};

RQService.Accounts.GetTill
    = RQImported.AccountsGetTill;

RQService.Accounts.PopulateGetTillRow = function (row) {
    var entry = { };

    entry.HotelID         = row.HotelID;
    entry.TillID          = row.TillID;
    entry.TillName        = row.TillName;
    entry.IsPOS           = row.IsPOS;
    entry.IsMultiUser     = row.IsMultiUser;
    entry.AllowsAllUsers  = row.AllowsAllUsers;
    entry.Expired         = row.Expired;
    entry.Created         = row.Created;

    return entry;
};

RQService.Accounts.GetTills
    = RQImported.AccountsGetTills;

RQService.Accounts.PopulateGetTillsRow = function (row) {
    var entry = { };

    entry.HotelID         = row.HotelID;
    entry.TillID          = row.TillID;
    entry.TillName        = row.TillName;
    entry.IsPOS           = row.IsPOS;
    entry.IsMultiUser     = row.IsMultiUser;
    entry.AllowsAllUsers  = row.AllowsAllUsers;
    entry.Expired         = row.Expired;
    entry.Created         = row.Created;

    return entry;
};

RQService.Accounts.GetTotalIntervalTurnover
    = RQImported.AccountsGetTotalIntervalTurnover;

RQService.Accounts.PopulateGetTotalIntervalTurnoverRow = function (row) {
    var entry = { };

    entry.Turnover               = row.Turnover;
    entry.CashBalance            = row.CashBalance;
    entry.EnteredForOtherPeriod  = row.EnteredForOtherPeriod;

    return entry;
};

RQService.Accounts.GetTotalPeriodCommission
    = RQImported.AccountsGetTotalPeriodCommission;

RQService.Accounts.PopulateGetTotalPeriodCommissionRow = function (row) {
    var entry = { };

    entry.PartnerID   = row.PartnerID;
    entry.Commission  = row.Commission;

    return entry;
};

RQService.Accounts.GetTotalPeriodTurnover
    = RQImported.AccountsGetTotalPeriodTurnover;

RQService.Accounts.PopulateGetTotalPeriodTurnoverRow = function (row) {
    var entry = { };

    entry.Turnover               = row.Turnover;
    entry.CashBalance            = row.CashBalance;
    entry.EnteredForOtherPeriod  = row.EnteredForOtherPeriod;

    return entry;
};

RQService.Accounts.GetTransaction
    = RQImported.AccountsGetTransaction;

RQService.Accounts.PopulateGetTransactionRow = function (row) {
    var entry = { };

    entry.TransactionID      = row.TransactionID;
    entry.RevenueDay         = row.RevenueDay;
    entry.ProductID          = row.ProductID;
    entry.AccountID          = row.AccountID;
    entry.Description        = row.Description;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.AmountTotal        = row.AmountTotal;
    entry.Active             = row.Active;
    entry.Invoiced           = row.Invoiced;
    entry.InvoicingStatus    = row.InvoicingStatus;
    entry.Countered          = row.Countered;
    entry.Historical         = row.Historical;
    entry.TillID             = row.TillID;
    entry.UserID             = row.UserID;
    entry.Created            = row.Created;
    entry.Product            = row.Product;
    entry.UserName           = row.UserName;
    entry.BillingID          = row.BillingID;
    entry.ReservationID      = row.ReservationID;
    entry.RoomReservationID  = row.RoomReservationID;
    entry.BusinessDay        = row.BusinessDay;
    entry.OnBehalfOfUserID   = row.OnBehalfOfUserID;
    entry.DefferedSegmentID  = row.DefferedSegmentID;
    entry.Handled            = row.Handled;
    entry.GuestID            = row.GuestID;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.AccountTypeID      = row.AccountTypeID;
    entry.AccountTypeName    = row.AccountTypeName;
    entry.TaxName            = row.TaxName;
    entry.IsLocked           = row.IsLocked;

    return entry;
};

RQService.Accounts.GetTransactionHistory
    = RQImported.AccountsGetTransactionHistory;

RQService.Accounts.PopulateGetTransactionHistoryRow = function (row) {
    var entry = { };

    entry.LogEventID         = row.LogEventID;
    entry.LogEventTime       = row.LogEventTime;
    entry.LogActionID        = row.LogActionID;
    entry.LogActionName      = row.LogActionName;
    entry.HotelID            = row.HotelID;
    entry.TransactionID      = row.TransactionID;
    entry.RevenueDay         = row.RevenueDay;
    entry.TaxDay             = row.TaxDay;
    entry.ProductID          = row.ProductID;
    entry.AccountID          = row.AccountID;
    entry.Description        = row.Description;
    entry.Quantity           = row.Quantity;
    entry.AmountPerUnit      = row.AmountPerUnit;
    entry.AmountTotal        = row.AmountTotal;
    entry.Active             = row.Active;
    entry.Invoiced           = row.Invoiced;
    entry.InvoicingStatus    = row.InvoicingStatus;
    entry.Countered          = row.Countered;
    entry.Historical         = row.Historical;
    entry.TillID             = row.TillID;
    entry.UserID             = row.UserID;
    entry.IsAddon            = row.IsAddon;
    entry.Created            = row.Created;
    entry.UserName           = row.UserName;
    entry.RoomReservationID  = row.RoomReservationID;
    entry.SortOrder          = row.SortOrder;
    entry.RoomNumber         = row.RoomNumber;
    entry.RoomTypeName       = row.RoomTypeName;
    entry.MaxPersons         = row.MaxPersons;
    entry.Arr                = row.Arr;
    entry.Dep                = row.Dep;
    entry.Total              = row.Total;
    entry.AccountCode        = row.AccountCode;
    entry.AccountName        = row.AccountName;
    entry.AccountTypeID      = row.AccountTypeID;
    entry.AccountTypeName    = row.AccountTypeName;
    entry.TaxName            = row.TaxName;
    entry.Product            = row.Product;
    entry.IsLocked           = row.IsLocked;
    entry.IsExpired          = row.IsExpired;

    return entry;
};

RQService.Accounts.InspectPeriodDeferrments
    = RQImported.AccountsInspectPeriodDeferrments;

RQService.Accounts.PopulateInspectPeriodDeferrmentsRow = function (row) {
    var entry = { };

    entry.HasDeferredToSamePeriod   = row.HasDeferredToSamePeriod;
    entry.HasEnteredOnOtherPeriod   = row.HasEnteredOnOtherPeriod;
    entry.HasEnteredForOtherPeriod  = row.HasEnteredForOtherPeriod;

    return entry;
};

RQService.Accounts.InspectShiftDeferrments
    = RQImported.AccountsInspectShiftDeferrments;

RQService.Accounts.PopulateInspectShiftDeferrmentsRow = function (row) {
    var entry = { };

    entry.ErrorCode                = row.ErrorCode;
    entry.HasDeferredToSameShift   = row.HasDeferredToSameShift;
    entry.HasEnteredOnOtherShift   = row.HasEnteredOnOtherShift;
    entry.HasEnteredForOtherShift  = row.HasEnteredForOtherShift;

    return entry;
};

RQService.Accounts.IssueCounterCustomerInvoice
    = RQImported.AccountsIssueCounterCustomerInvoice;

RQService.Accounts.IssueCounterInvoice
    = RQImported.AccountsIssueCounterInvoice;

RQService.Accounts.IssueCounterReceipt
    = RQImported.AccountsIssueCounterReceipt;

RQService.Accounts.IssueCustomerInvoice
    = RQImported.AccountsIssueCustomerInvoice;

RQService.Accounts.IssueInvoice
    = RQImported.AccountsIssueInvoice;

RQService.Accounts.IssueReceipt
    = RQImported.AccountsIssueReceipt;

RQService.Accounts.MarkTransactionForBillingSplit
    = RQImported.AccountsMarkTransactionForBillingSplit;

RQService.Accounts.MonitorJournalIntegrity
    = RQImported.AccountsMonitorJournalIntegrity;

RQService.Accounts.PopulateMonitorJournalIntegrityRow = function (row) {
    var entry = { };

    entry.JournalIntegrityOK  = row.JournalIntegrityOK;

    return entry;
};

RQService.Accounts.NewBillingTransaction
    = RQImported.AccountsNewBillingTransaction;

RQService.Accounts.NewFolioTransaction
    = RQImported.AccountsNewFolioTransaction;

RQService.Accounts.NewPOSPayment
    = RQImported.AccountsNewPOSPayment;

RQService.Accounts.NewProduct
    = RQImported.AccountsNewProduct;

RQService.Accounts.NewReservationFolio
    = RQImported.AccountsNewReservationFolio;

RQService.Accounts.NewRoomServiceTransaction
    = RQImported.AccountsNewRoomServiceTransaction;

RQService.Accounts.NewServiceBill
    = RQImported.AccountsNewServiceBill;

RQService.Accounts.NewTransaction
    = RQImported.AccountsNewTransaction;

RQService.Accounts.PreviewJournalSegment
    = RQImported.AccountsPreviewJournalSegment;

RQService.Accounts.PopulatePreviewJournalSegmentRow = function (row) {
    var entry = { };

    entry.JournalSegmentID             = row.JournalSegmentID;
    entry.JournalSegmentSnapshotID     = row.JournalSegmentSnapshotID;
    entry.JournalSummaryNumber         = row.JournalSummaryNumber;
    entry.TillID                       = row.TillID;
    entry.UserID                       = row.UserID;
    entry.UserName                     = row.UserName;
    entry.SegmentStart                 = row.SegmentStart;
    entry.SegmentEnd                   = row.SegmentEnd;
    entry.Superceded                   = row.Superceded;
    entry.ClosedByUserID               = row.ClosedByUserID;
    entry.TotalPayments                = row.TotalPayments;
    entry.PaymentsFromOtherSegments    = row.PaymentsFromOtherSegments;
    entry.Created                      = row.Created;
    entry.IsSalesChargeAccount         = row.IsSalesChargeAccount;
    entry.IsSalesBillingGroupSummary   = row.IsSalesBillingGroupSummary;
    entry.IsClosedChargeAccount        = row.IsClosedChargeAccount;
    entry.IsClosedBillingGroupSummary  = row.IsClosedBillingGroupSummary;
    entry.IsOpenChargeAccount          = row.IsOpenChargeAccount;
    entry.IsOpenBillingGroupSummary    = row.IsOpenBillingGroupSummary;
    entry.IsClosedPaymentAccount       = row.IsClosedPaymentAccount;
    entry.IsOpenPaymentAccount         = row.IsOpenPaymentAccount;
    entry.ProductBillingGroupID        = row.ProductBillingGroupID;
    entry.ProductBillingGroupName      = row.ProductBillingGroupName;
    entry.ChargeAccountID              = row.ChargeAccountID;
    entry.ChargeAccountCode            = row.ChargeAccountCode;
    entry.ChargeAccountName            = row.ChargeAccountName;
    entry.Name                         = row.Name;
    entry.ChargeQuantity               = row.ChargeQuantity;
    entry.AmountPerUnit                = row.AmountPerUnit;
    entry.RoomChargeGroupID            = row.RoomChargeGroupID;
    entry.ChargeAmountTotal            = row.ChargeAmountTotal;
    entry.TaxID                        = row.TaxID;
    entry.Percentage                   = row.Percentage;
    entry.TaxName                      = row.TaxName;
    entry.AccountID                    = row.AccountID;
    entry.AccountCode                  = row.AccountCode;
    entry.AccountName                  = row.AccountName;
    entry.Quantity                     = row.Quantity;
    entry.AmountTotal                  = row.AmountTotal;
    entry.IsDeffered                   = row.IsDeffered;

    return entry;
};

RQService.Accounts.ProduceJournalIntervalTurnoverReport
    = RQImported.AccountsProduceJournalIntervalTurnoverReport;

RQService.Accounts.PopulateProduceJournalIntervalTurnoverReportRow = function (row) {
    var entry = { };

    entry.HandledByUserID        = row.HandledByUserID;
    entry.HandledByUserName      = row.HandledByUserName;
    entry.AccountID              = row.AccountID;
    entry.AccountCode            = row.AccountCode;
    entry.AccountName            = row.AccountName;
    entry.IsDeferred             = row.IsDeferred;
    entry.EnteredOnOtherPeriod   = row.EnteredOnOtherPeriod;
    entry.EnteredForOtherPeriod  = row.EnteredForOtherPeriod;
    entry.EnteredByUserID        = row.EnteredByUserID;
    entry.EnteredByUserName      = row.EnteredByUserName;
    entry.Turnover               = row.Turnover;

    return entry;
};

RQService.Accounts.ProduceJournalIntervalTurnoverReportWithResBreakdown
    = RQImported.AccountsProduceJournalIntervalTurnoverReportWithResBreakdown;

RQService.Accounts.PopulateProduceJournalIntervalTurnoverReportWithResBreakdownRow = function (row) {
    var entry = { };

    entry.ReservationID                  = row.ReservationID;
    entry.ExternalReservationID          = row.ExternalReservationID;
    entry.PartnerID                      = row.PartnerID;
    entry.ReservationSource              = row.ReservationSource;
    entry.NumRoomRes                     = row.NumRoomRes;
    entry.Arr                            = row.Arr;
    entry.Dep                            = row.Dep;
    entry.ReservationRoomNumberList      = row.ReservationRoomNumberList;
    entry.GuestID                        = row.GuestID;
    entry.GuestName                      = row.GuestName;
    entry.ReservationStatusID            = row.ReservationStatusID;
    entry.ReservationStatusName          = row.ReservationStatusName;
    entry.PaymentSchemeID                = row.PaymentSchemeID;
    entry.PaymentSchemeName              = row.PaymentSchemeName;
    entry.RoomReservationID              = row.RoomReservationID;
    entry.RoomID                         = row.RoomID;
    entry.RoomNumber                     = row.RoomNumber;
    entry.RoomTypeID                     = row.RoomTypeID;
    entry.RoomTypeName                   = row.RoomTypeName;
    entry.RoomReservationRoomNumberList  = row.RoomReservationRoomNumberList;
    entry.RoomReservationStatusID        = row.RoomReservationStatusID;
    entry.RoomReservationStatusName      = row.RoomReservationStatusName;
    entry.AccountID                      = row.AccountID;
    entry.AccountCode                    = row.AccountCode;
    entry.AccountName                    = row.AccountName;
    entry.IsDeferred                     = row.IsDeferred;
    entry.EnteredOnOtherPeriod           = row.EnteredOnOtherPeriod;
    entry.EnteredForOtherPeriod          = row.EnteredForOtherPeriod;
    entry.EnteredOnBusinessDay           = row.EnteredOnBusinessDay;
    entry.DeferredToBusinessDay          = row.DeferredToBusinessDay;
    entry.EnteredByUserID                = row.EnteredByUserID;
    entry.EnteredByUserName              = row.EnteredByUserName;
    entry.HandledByUserID                = row.HandledByUserID;
    entry.HandledByUserName              = row.HandledByUserName;
    entry.Turnover                       = row.Turnover;

    return entry;
};

RQService.Accounts.ProducePeriodTurnoverReport
    = RQImported.AccountsProducePeriodTurnoverReport;

RQService.Accounts.PopulateProducePeriodTurnoverReportRow = function (row) {
    var entry = { };

    entry.HandledByUserID        = row.HandledByUserID;
    entry.HandledByUserName      = row.HandledByUserName;
    entry.AccountID              = row.AccountID;
    entry.AccountCode            = row.AccountCode;
    entry.AccountName            = row.AccountName;
    entry.IsDeferred             = row.IsDeferred;
    entry.EnteredOnOtherPeriod   = row.EnteredOnOtherPeriod;
    entry.EnteredForOtherPeriod  = row.EnteredForOtherPeriod;
    entry.EnteredByUserID        = row.EnteredByUserID;
    entry.EnteredByUserName      = row.EnteredByUserName;
    entry.Turnover               = row.Turnover;

    return entry;
};

RQService.Accounts.ProducePeriodTurnoverReportWithResBreakdown
    = RQImported.AccountsProducePeriodTurnoverReportWithResBreakdown;

RQService.Accounts.PopulateProducePeriodTurnoverReportWithResBreakdownRow = function (row) {
    var entry = { };

    entry.ReservationID                  = row.ReservationID;
    entry.ExternalReservationID          = row.ExternalReservationID;
    entry.PartnerID                      = row.PartnerID;
    entry.ReservationSource              = row.ReservationSource;
    entry.NumRoomRes                     = row.NumRoomRes;
    entry.Arr                            = row.Arr;
    entry.Dep                            = row.Dep;
    entry.ReservationRoomNumberList      = row.ReservationRoomNumberList;
    entry.GuestID                        = row.GuestID;
    entry.GuestName                      = row.GuestName;
    entry.ReservationStatusID            = row.ReservationStatusID;
    entry.ReservationStatusName          = row.ReservationStatusName;
    entry.PaymentSchemeID                = row.PaymentSchemeID;
    entry.PaymentSchemeName              = row.PaymentSchemeName;
    entry.RoomReservationID              = row.RoomReservationID;
    entry.RoomID                         = row.RoomID;
    entry.RoomNumber                     = row.RoomNumber;
    entry.RoomTypeID                     = row.RoomTypeID;
    entry.RoomTypeName                   = row.RoomTypeName;
    entry.RoomReservationRoomNumberList  = row.RoomReservationRoomNumberList;
    entry.RoomReservationStatusID        = row.RoomReservationStatusID;
    entry.RoomReservationStatusName      = row.RoomReservationStatusName;
    entry.AccountID                      = row.AccountID;
    entry.AccountCode                    = row.AccountCode;
    entry.AccountName                    = row.AccountName;
    entry.IsDeferred                     = row.IsDeferred;
    entry.EnteredOnOtherPeriod           = row.EnteredOnOtherPeriod;
    entry.EnteredForOtherPeriod          = row.EnteredForOtherPeriod;
    entry.EnteredOnBusinessDay           = row.EnteredOnBusinessDay;
    entry.DeferredToBusinessDay          = row.DeferredToBusinessDay;
    entry.EnteredByUserID                = row.EnteredByUserID;
    entry.EnteredByUserName              = row.EnteredByUserName;
    entry.HandledByUserID                = row.HandledByUserID;
    entry.HandledByUserName              = row.HandledByUserName;
    entry.Turnover                       = row.Turnover;

    return entry;
};

RQService.Accounts.ReCloseBill
    = RQImported.AccountsReCloseBill;

RQService.Accounts.ReCloseBillAndSegment
    = RQImported.AccountsReCloseBillAndSegment;

RQService.Accounts.ReCloseJournalSegment
    = RQImported.AccountsReCloseJournalSegment;

RQService.Accounts.ReOpenBill
    = RQImported.AccountsReOpenBill;

RQService.Accounts.ReOpenBillAndSegment
    = RQImported.AccountsReOpenBillAndSegment;

RQService.Accounts.ReOpenJournalSegment
    = RQImported.AccountsReOpenJournalSegment;

RQService.Accounts.SaveCustomerInvoiceComment
    = RQImported.AccountsSaveCustomerInvoiceComment;

RQService.Accounts.SetTransactionActiveStatus
    = RQImported.AccountsSetTransactionActiveStatus;

RQService.Accounts.SetTransactionInvoicingStatus
    = RQImported.AccountsSetTransactionInvoicingStatus;

RQService.Accounts.SplitIntoNewBill
    = RQImported.AccountsSplitIntoNewBill;

RQService.Accounts.TransferBillToRoom
    = RQImported.AccountsTransferBillToRoom;

RQService.Tasks
    = { };

RQService.Tasks.AssignTaskToStaffMember
    = RQImported.TasksAssignTaskToStaffMember;

RQService.Tasks.ChangeRoomCleanStatus
    = RQImported.TasksChangeRoomCleanStatus;

RQService.Tasks.ChangeRoomOccupancyStatus
    = RQImported.TasksChangeRoomOccupancyStatus;

RQService.Tasks.ChangeTaskPriority
    = RQImported.TasksChangeTaskPriority;

RQService.Tasks.DeleteStaff
    = RQImported.TasksDeleteStaff;

RQService.Tasks.EditStaffPIN
    = RQImported.TasksEditStaffPIN;

RQService.Tasks.ExtGetAllRoomCleaningTasks
    = RQImported.TasksExtGetAllRoomCleaningTasks;

RQService.Tasks.PopulateExtGetAllRoomCleaningTasksRow = function (row) {
    var entry = { };

    entry.LocationID                  = row.LocationID;
    entry.CDay                        = row.CDay;
    entry.TaskID                      = row.TaskID;
    entry.StaffID                     = row.StaffID;
    entry.StaffName                   = row.StaffName;
    entry.TaskTypeID                  = row.TaskTypeID;
    entry.ExtraReservationTaskID      = row.ExtraReservationTaskID;
    entry.TaskName                    = row.TaskName;
    entry.TaskNameShort               = row.TaskNameShort;
    entry.TaskDescription             = row.TaskDescription;
    entry.HandledStatusID             = row.HandledStatusID;
    entry.HandledStatusName           = row.HandledStatusName;
    entry.RoomID                      = row.RoomID;
    entry.RoomNumber                  = row.RoomNumber;
    entry.RoomTypeID                  = row.RoomTypeID;
    entry.RoomTypeName                = row.RoomTypeName;
    entry.OccupancyStatusID           = row.OccupancyStatusID;
    entry.RoomOccupancyStatusName     = row.RoomOccupancyStatusName;
    entry.RoomCleanStatusID           = row.RoomCleanStatusID;
    entry.RoomCleanStatusName         = row.RoomCleanStatusName;
    entry.RoomDoNotDisturbStatusID    = row.RoomDoNotDisturbStatusID;
    entry.RoomDoNotDisturbStatusName  = row.RoomDoNotDisturbStatusName;
    entry.OwningReservationID         = row.OwningReservationID;
    entry.GuestNameFull               = row.GuestNameFull;
    entry.NightOfStay                 = row.NightOfStay;
    entry.NightsRemaining             = row.NightsRemaining;
    entry.PriorityID                  = row.PriorityID;
    entry.PriorityName                = row.PriorityName;
    entry.HasSameDayArrival           = row.HasSameDayArrival;
    entry.CantOpenBefore              = row.CantOpenBefore;
    entry.ShouldCloseBy               = row.ShouldCloseBy;
    entry.Opened                      = row.Opened;
    entry.Closed                      = row.Closed;
    entry.HoursTaken                  = row.HoursTaken;
    entry.MinutesTaken                = row.MinutesTaken;
    entry.SecondsTaken                = row.SecondsTaken;
    entry.TimeTaken                   = row.TimeTaken;
    entry.HasRemainder                = row.HasRemainder;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Tasks.ExtSetRoomCleaningTaskState
    = RQImported.TasksExtSetRoomCleaningTaskState;

RQService.Tasks.GetCleaningTasksStaffData
    = RQImported.TasksGetCleaningTasksStaffData;

RQService.Tasks.PopulateGetCleaningTasksStaffDataRow = function (row) {
    var entry = { };

    entry.LocationID                  = row.LocationID;
    entry.CDay                        = row.CDay;
    entry.TaskID                      = row.TaskID;
    entry.StaffID                     = row.StaffID;
    entry.StaffName                   = row.StaffName;
    entry.TaskTypeID                  = row.TaskTypeID;
    entry.ExtraReservationTaskID      = row.ExtraReservationTaskID;
    entry.TaskName                    = row.TaskName;
    entry.TaskNameShort               = row.TaskNameShort;
    entry.TaskDescription             = row.TaskDescription;
    entry.HandledStatusID             = row.HandledStatusID;
    entry.HandledStatusName           = row.HandledStatusName;
    entry.RoomID                      = row.RoomID;
    entry.RoomNumber                  = row.RoomNumber;
    entry.RoomTypeID                  = row.RoomTypeID;
    entry.RoomTypeName                = row.RoomTypeName;
    entry.OccupancyStatusID           = row.OccupancyStatusID;
    entry.RoomOccupancyStatusName     = row.RoomOccupancyStatusName;
    entry.RoomCleanStatusID           = row.RoomCleanStatusID;
    entry.RoomCleanStatusName         = row.RoomCleanStatusName;
    entry.RoomDoNotDisturbStatusID    = row.RoomDoNotDisturbStatusID;
    entry.RoomDoNotDisturbStatusName  = row.RoomDoNotDisturbStatusName;
    entry.OwningReservationID         = row.OwningReservationID;
    entry.GuestNameFull               = row.GuestNameFull;
    entry.NightOfStay                 = row.NightOfStay;
    entry.NightsRemaining             = row.NightsRemaining;
    entry.PriorityID                  = row.PriorityID;
    entry.PriorityName                = row.PriorityName;
    entry.HasSameDayArrival           = row.HasSameDayArrival;
    entry.CantOpenBefore              = row.CantOpenBefore;
    entry.ShouldCloseBy               = row.ShouldCloseBy;
    entry.Opened                      = row.Opened;
    entry.Closed                      = row.Closed;
    entry.HoursTaken                  = row.HoursTaken;
    entry.MinutesTaken                = row.MinutesTaken;
    entry.SecondsTaken                = row.SecondsTaken;
    entry.TimeTaken                   = row.TimeTaken;
    entry.HasRemainder                = row.HasRemainder;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Tasks.GetCleaningTasksStaffSummary
    = RQImported.TasksGetCleaningTasksStaffSummary;

RQService.Tasks.PopulateGetCleaningTasksStaffSummaryRow = function (row) {
    var entry = { };

    entry.StaffID                   = row.StaffID;
    entry.StaffName                 = row.StaffName;
    entry.TaskTypeID                = row.TaskTypeID;
    entry.TaskTypeName              = row.TaskTypeName;
    entry.ExtraReservationTaskID    = row.ExtraReservationTaskID;
    entry.ExtraReservationTaskName  = row.ExtraReservationTaskName;
    entry.RoomTypeID                = row.RoomTypeID;
    entry.RoomTypeName              = row.RoomTypeName;
    entry.NumTasksTotal             = row.NumTasksTotal;
    entry.NumTasksClosed            = row.NumTasksClosed;
    entry.NumTasksAutoClosed        = row.NumTasksAutoClosed;
    entry.NumTasksSkipped           = row.NumTasksSkipped;
    entry.AvgHoursTaken             = row.AvgHoursTaken;
    entry.AvgMinutesTaken           = row.AvgMinutesTaken;
    entry.AvgSecondsTaken           = row.AvgSecondsTaken;
    entry.AvgTimeTaken              = row.AvgTimeTaken;
    entry.MedHoursTaken             = row.MedHoursTaken;
    entry.MedMinutesTaken           = row.MedMinutesTaken;
    entry.MedSecondsTaken           = row.MedSecondsTaken;
    entry.MedTimeTaken              = row.MedTimeTaken;

    return entry;
};

RQService.Tasks.GetCleaningTaskTypes
    = RQImported.TasksGetCleaningTaskTypes;

RQService.Tasks.PopulateGetCleaningTaskTypesRow = function (row) {
    var entry = { };

    entry.TaskTypeID              = row.TaskTypeID;
    entry.ExtraReservationTaskID  = row.ExtraReservationTaskID;
    entry.TaskTypeName            = row.TaskTypeName;

    return entry;
};

RQService.Tasks.GetCleaningTaskWorkflowConfig
    = RQImported.TasksGetCleaningTaskWorkflowConfig;

RQService.Tasks.PopulateGetCleaningTaskWorkflowConfigRow = function (row) {
    var entry = { };

    entry.AllowStaffQuickClose  = row.AllowStaffQuickClose;
    entry.ItemsStartChecked     = row.ItemsStartChecked;
    entry.AutoAssignRemainders  = row.AutoAssignRemainders;
    entry.DeviceRefreshTime     = row.DeviceRefreshTime;
    entry.ExtranetWorkflow      = row.ExtranetWorkflow;

    return entry;
};

RQService.Tasks.GetClearMakeUpRoomConfig
    = RQImported.TasksGetClearMakeUpRoomConfig;

RQService.Tasks.PopulateGetClearMakeUpRoomConfigRow = function (row) {
    var entry = { };

    entry.ClearMakeUpRoomHour    = row.ClearMakeUpRoomHour;
    entry.ClearMakeUpRoomMinute  = row.ClearMakeUpRoomMinute;

    return entry;
};

RQService.Tasks.GetExtraReservationTaskMenu
    = RQImported.TasksGetExtraReservationTaskMenu;

RQService.Tasks.PopulateGetExtraReservationTaskMenuRow = function (row) {
    var entry = { };

    entry.RoomDoNotDisturbStatusID   = row.RoomDoNotDisturbStatusID;
    entry.NumMenuItems               = row.NumMenuItems;
    entry.IsEnabled                  = row.IsEnabled;
    entry.CanChangeSelection         = row.CanChangeSelection;
    entry.AppliesToTomorrow          = row.AppliesToTomorrow;
    entry.ExtraReservationTaskID     = row.ExtraReservationTaskID;
    entry.ExtraReservationTaskName   = row.ExtraReservationTaskName;
    entry.ExtraReservationTaskDescr  = row.ExtraReservationTaskDescr;
    entry.Precedence                 = row.Precedence;
    entry.IsSelected                 = row.IsSelected;

    return entry;
};

RQService.Tasks.GetHandledStatuses
    = RQImported.TasksGetHandledStatuses;

RQService.Tasks.PopulateGetHandledStatusesRow = function (row) {
    var entry = { };

    entry.HandledStatusID    = row.HandledStatusID;
    entry.HandledStatusName  = row.HandledStatusName;

    return entry;
};

RQService.Tasks.GetLocationDayCleaningTasks
    = RQImported.TasksGetLocationDayCleaningTasks;

RQService.Tasks.PopulateGetLocationDayCleaningTasksRow = function (row) {
    var entry = { };

    entry.LocationID                  = row.LocationID;
    entry.CDay                        = row.CDay;
    entry.TaskID                      = row.TaskID;
    entry.StaffID                     = row.StaffID;
    entry.StaffName                   = row.StaffName;
    entry.TaskTypeID                  = row.TaskTypeID;
    entry.ExtraReservationTaskID      = row.ExtraReservationTaskID;
    entry.TaskName                    = row.TaskName;
    entry.TaskNameShort               = row.TaskNameShort;
    entry.TaskDescription             = row.TaskDescription;
    entry.HandledStatusID             = row.HandledStatusID;
    entry.HandledStatusName           = row.HandledStatusName;
    entry.RoomID                      = row.RoomID;
    entry.RoomNumber                  = row.RoomNumber;
    entry.RoomTypeID                  = row.RoomTypeID;
    entry.RoomTypeName                = row.RoomTypeName;
    entry.OccupancyStatusID           = row.OccupancyStatusID;
    entry.RoomOccupancyStatusName     = row.RoomOccupancyStatusName;
    entry.RoomCleanStatusID           = row.RoomCleanStatusID;
    entry.RoomCleanStatusName         = row.RoomCleanStatusName;
    entry.RoomDoNotDisturbStatusID    = row.RoomDoNotDisturbStatusID;
    entry.RoomDoNotDisturbStatusName  = row.RoomDoNotDisturbStatusName;
    entry.OwningReservationID         = row.OwningReservationID;
    entry.GuestNameFull               = row.GuestNameFull;
    entry.NightOfStay                 = row.NightOfStay;
    entry.NightsRemaining             = row.NightsRemaining;
    entry.PriorityID                  = row.PriorityID;
    entry.PriorityName                = row.PriorityName;
    entry.HasSameDayArrival           = row.HasSameDayArrival;
    entry.CantOpenBefore              = row.CantOpenBefore;
    entry.ShouldCloseBy               = row.ShouldCloseBy;
    entry.Opened                      = row.Opened;
    entry.Closed                      = row.Closed;
    entry.HoursTaken                  = row.HoursTaken;
    entry.MinutesTaken                = row.MinutesTaken;
    entry.SecondsTaken                = row.SecondsTaken;
    entry.TimeTaken                   = row.TimeTaken;
    entry.HasRemainder                = row.HasRemainder;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Tasks.GetLocationDayTask
    = RQImported.TasksGetLocationDayTask;

RQService.Tasks.PopulateGetLocationDayTaskRow = function (row) {
    var entry = { };

    entry.LocationID                  = row.LocationID;
    entry.CDay                        = row.CDay;
    entry.TaskID                      = row.TaskID;
    entry.StaffID                     = row.StaffID;
    entry.StaffName                   = row.StaffName;
    entry.TaskTypeID                  = row.TaskTypeID;
    entry.ExtraReservationTaskID      = row.ExtraReservationTaskID;
    entry.TaskName                    = row.TaskName;
    entry.TaskNameShort               = row.TaskNameShort;
    entry.TaskDescription             = row.TaskDescription;
    entry.HandledStatusID             = row.HandledStatusID;
    entry.HandledStatusName           = row.HandledStatusName;
    entry.RoomID                      = row.RoomID;
    entry.RoomNumber                  = row.RoomNumber;
    entry.RoomTypeID                  = row.RoomTypeID;
    entry.RoomTypeName                = row.RoomTypeName;
    entry.OccupancyStatusID           = row.OccupancyStatusID;
    entry.RoomOccupancyStatusName     = row.RoomOccupancyStatusName;
    entry.RoomCleanStatusID           = row.RoomCleanStatusID;
    entry.RoomCleanStatusName         = row.RoomCleanStatusName;
    entry.RoomDoNotDisturbStatusID    = row.RoomDoNotDisturbStatusID;
    entry.RoomDoNotDisturbStatusName  = row.RoomDoNotDisturbStatusName;
    entry.OwningReservationID         = row.OwningReservationID;
    entry.GuestNameFull               = row.GuestNameFull;
    entry.NightOfStay                 = row.NightOfStay;
    entry.NightsRemaining             = row.NightsRemaining;
    entry.PriorityID                  = row.PriorityID;
    entry.PriorityName                = row.PriorityName;
    entry.HasSameDayArrival           = row.HasSameDayArrival;
    entry.CantOpenBefore              = row.CantOpenBefore;
    entry.ShouldCloseBy               = row.ShouldCloseBy;
    entry.Opened                      = row.Opened;
    entry.Closed                      = row.Closed;
    entry.HoursTaken                  = row.HoursTaken;
    entry.MinutesTaken                = row.MinutesTaken;
    entry.SecondsTaken                = row.SecondsTaken;
    entry.TimeTaken                   = row.TimeTaken;
    entry.HasRemainder                = row.HasRemainder;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Tasks.GetLocationDayTaskHistory
    = RQImported.TasksGetLocationDayTaskHistory;

RQService.Tasks.PopulateGetLocationDayTaskHistoryRow = function (row) {
    var entry = { };

    entry.TaskLogEventID     = row.TaskLogEventID;
    entry.TaskLogActionID    = row.TaskLogActionID;
    entry.TaskLogActionName  = row.TaskLogActionName;
    entry.UserID             = row.UserID;
    entry.UserName           = row.UserName;
    entry.StaffID            = row.StaffID;
    entry.StaffName          = row.StaffName;
    entry.TaskLogEventTime   = row.TaskLogEventTime;

    return entry;
};

RQService.Tasks.GetReservationByRoomKeyParams
    = RQImported.TasksGetReservationByRoomKeyParams;

RQService.Tasks.PopulateGetReservationByRoomKeyParamsRow = function (row) {
    var entry = { };

    entry.ReservationID      = row.ReservationID;
    entry.RoomReservationID  = row.RoomReservationID;

    return entry;
};

RQService.Tasks.GetRoomDoNotDisturbStatuses
    = RQImported.TasksGetRoomDoNotDisturbStatuses;

RQService.Tasks.PopulateGetRoomDoNotDisturbStatusesRow = function (row) {
    var entry = { };

    entry.RoomDoNotDisturbStatusID    = row.RoomDoNotDisturbStatusID;
    entry.RoomDoNotDisturbStatusName  = row.RoomDoNotDisturbStatusName;

    return entry;
};

RQService.Tasks.GetRoomDoNotDisturbStatusID
    = RQImported.TasksGetRoomDoNotDisturbStatusID;

RQService.Tasks.PopulateGetRoomDoNotDisturbStatusIDRow = function (row) {
    var entry = { };

    entry.RoomDoNotDisturbStatusID  = row.RoomDoNotDisturbStatusID;

    return entry;
};

RQService.Tasks.GetRoomKeyConfigByAPIKey
    = RQImported.TasksGetRoomKeyConfigByAPIKey;

RQService.Tasks.PopulateGetRoomKeyConfigByAPIKeyRow = function (row) {
    var entry = { };

    entry.APIKey       = row.APIKey;
    entry.ServerIP     = row.ServerIP;
    entry.ServerPort   = row.ServerPort;
    entry.Destination  = row.Destination;
    entry.Source       = row.Source;

    return entry;
};

RQService.Tasks.GetRoomKeyIssueParameters
    = RQImported.TasksGetRoomKeyIssueParameters;

RQService.Tasks.PopulateGetRoomKeyIssueParametersRow = function (row) {
    var entry = { };

    entry.CanIssueStatus  = row.CanIssueStatus;
    entry.RoomID          = row.RoomID;
    entry.RoomNumber      = row.RoomNumber;
    entry.MoveInDate      = row.MoveInDate;
    entry.MoveOutDate     = row.MoveOutDate;
    entry.IssueNumber     = row.IssueNumber;

    return entry;
};

RQService.Tasks.GetRoomKeyIssuesByRoomReservationID
    = RQImported.TasksGetRoomKeyIssuesByRoomReservationID;

RQService.Tasks.PopulateGetRoomKeyIssuesByRoomReservationIDRow = function (row) {
    var entry = { };

    entry.HotelID             = row.HotelID;
    entry.RoomReservationID   = row.RoomReservationID;
    entry.RoomID              = row.RoomID;
    entry.RoomNumber          = row.RoomNumber;
    entry.MoveInDate          = row.MoveInDate;
    entry.MoveOutDate         = row.MoveOutDate;
    entry.IssueNumber         = row.IssueNumber;
    entry.GuestID             = row.GuestID;
    entry.GuestName           = row.GuestName;
    entry.IssuedByUserID      = row.IssuedByUserID;
    entry.IssuedByUserName    = row.IssuedByUserName;
    entry.Issued              = row.Issued;
    entry.ReturnedByUserID    = row.ReturnedByUserID;
    entry.ReturnedByUserName  = row.ReturnedByUserName;
    entry.Returned            = row.Returned;

    return entry;
};

RQService.Tasks.GetStaff
    = RQImported.TasksGetStaff;

RQService.Tasks.PopulateGetStaffRow = function (row) {
    var entry = { };

    entry.StaffID    = row.StaffID;
    entry.StaffName  = row.StaffName;
    entry.Created    = row.Created;

    return entry;
};

RQService.Tasks.GetStaffAssignedDayCleaningTasks
    = RQImported.TasksGetStaffAssignedDayCleaningTasks;

RQService.Tasks.PopulateGetStaffAssignedDayCleaningTasksRow = function (row) {
    var entry = { };

    entry.LocationID                  = row.LocationID;
    entry.CDay                        = row.CDay;
    entry.TaskID                      = row.TaskID;
    entry.StaffID                     = row.StaffID;
    entry.StaffName                   = row.StaffName;
    entry.TaskTypeID                  = row.TaskTypeID;
    entry.ExtraReservationTaskID      = row.ExtraReservationTaskID;
    entry.TaskName                    = row.TaskName;
    entry.TaskNameShort               = row.TaskNameShort;
    entry.TaskDescription             = row.TaskDescription;
    entry.HandledStatusID             = row.HandledStatusID;
    entry.HandledStatusName           = row.HandledStatusName;
    entry.RoomID                      = row.RoomID;
    entry.RoomNumber                  = row.RoomNumber;
    entry.RoomTypeID                  = row.RoomTypeID;
    entry.RoomTypeName                = row.RoomTypeName;
    entry.OccupancyStatusID           = row.OccupancyStatusID;
    entry.RoomOccupancyStatusName     = row.RoomOccupancyStatusName;
    entry.RoomCleanStatusID           = row.RoomCleanStatusID;
    entry.RoomCleanStatusName         = row.RoomCleanStatusName;
    entry.RoomDoNotDisturbStatusID    = row.RoomDoNotDisturbStatusID;
    entry.RoomDoNotDisturbStatusName  = row.RoomDoNotDisturbStatusName;
    entry.OwningReservationID         = row.OwningReservationID;
    entry.GuestNameFull               = row.GuestNameFull;
    entry.NightOfStay                 = row.NightOfStay;
    entry.NightsRemaining             = row.NightsRemaining;
    entry.PriorityID                  = row.PriorityID;
    entry.PriorityName                = row.PriorityName;
    entry.HasSameDayArrival           = row.HasSameDayArrival;
    entry.CantOpenBefore              = row.CantOpenBefore;
    entry.ShouldCloseBy               = row.ShouldCloseBy;
    entry.Opened                      = row.Opened;
    entry.Closed                      = row.Closed;
    entry.HoursTaken                  = row.HoursTaken;
    entry.MinutesTaken                = row.MinutesTaken;
    entry.SecondsTaken                = row.SecondsTaken;
    entry.TimeTaken                   = row.TimeTaken;
    entry.HasRemainder                = row.HasRemainder;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Tasks.GetTaskChecklistItem
    = RQImported.TasksGetTaskChecklistItem;

RQService.Tasks.PopulateGetTaskChecklistItemRow = function (row) {
    var entry = { };

    entry.ChecklistItemID    = row.ChecklistItemID;
    entry.ChecklistItemName  = row.ChecklistItemName;
    entry.Checked            = row.Checked;
    entry.MarkedMissing      = row.MarkedMissing;

    return entry;
};

RQService.Tasks.GetTaskChecklistItems
    = RQImported.TasksGetTaskChecklistItems;

RQService.Tasks.PopulateGetTaskChecklistItemsRow = function (row) {
    var entry = { };

    entry.ChecklistItemID    = row.ChecklistItemID;
    entry.ChecklistItemName  = row.ChecklistItemName;
    entry.Checked            = row.Checked;
    entry.MarkedMissing      = row.MarkedMissing;

    return entry;
};

RQService.Tasks.GetTaskDataWindow
    = RQImported.TasksGetTaskDataWindow;

RQService.Tasks.PopulateGetTaskDataWindowRow = function (row) {
    var entry = { };

    entry.RoomID                      = row.RoomID;
    entry.SortOrder                   = row.SortOrder;
    entry.RoomNumber                  = row.RoomNumber;
    entry.RoomTypeID                  = row.RoomTypeID;
    entry.PersonsNormal               = row.PersonsNormal;
    entry.RoomTypeName                = row.RoomTypeName;
    entry.ResDay                      = row.ResDay;
    entry.OccupancyStatusID           = row.OccupancyStatusID;
    entry.RoomOccupancyStatusName     = row.RoomOccupancyStatusName;
    entry.RoomCleanStatusID           = row.RoomCleanStatusID;
    entry.RoomCleanStatusName         = row.RoomCleanStatusName;
    entry.RoomDoNotDisturbStatusID    = row.RoomDoNotDisturbStatusID;
    entry.RoomDoNotDisturbStatusName  = row.RoomDoNotDisturbStatusName;
    entry.TaskID                      = row.TaskID;
    entry.StaffID                     = row.StaffID;
    entry.StaffName                   = row.StaffName;
    entry.TaskTypeID                  = row.TaskTypeID;
    entry.ExtraReservationTaskID      = row.ExtraReservationTaskID;
    entry.TaskName                    = row.TaskName;
    entry.TaskNameShort               = row.TaskNameShort;
    entry.TaskDescription             = row.TaskDescription;
    entry.HandledStatusID             = row.HandledStatusID;
    entry.HandledStatusName           = row.HandledStatusName;
    entry.OwningReservationID         = row.OwningReservationID;
    entry.GuestNameFull               = row.GuestNameFull;
    entry.NightOfStay                 = row.NightOfStay;
    entry.NightsRemaining             = row.NightsRemaining;
    entry.PriorityID                  = row.PriorityID;
    entry.PriorityName                = row.PriorityName;
    entry.HasSameDayArrival           = row.HasSameDayArrival;
    entry.CantOpenBefore              = row.CantOpenBefore;
    entry.ShouldCloseBy               = row.ShouldCloseBy;
    entry.HasRemainder                = row.HasRemainder;

    return entry;
};

RQService.Tasks.GetTaskMissingChecklistItems
    = RQImported.TasksGetTaskMissingChecklistItems;

RQService.Tasks.PopulateGetTaskMissingChecklistItemsRow = function (row) {
    var entry = { };

    entry.ChecklistItemID    = row.ChecklistItemID;
    entry.ChecklistItemName  = row.ChecklistItemName;
    entry.Checked            = row.Checked;
    entry.MarkedMissing      = row.MarkedMissing;

    return entry;
};

RQService.Tasks.GetTaskPriorities
    = RQImported.TasksGetTaskPriorities;

RQService.Tasks.PopulateGetTaskPrioritiesRow = function (row) {
    var entry = { };

    entry.PriorityID    = row.PriorityID;
    entry.PriorityName  = row.PriorityName;

    return entry;
};

RQService.Tasks.GuestAlterExtraReservationTask
    = RQImported.TasksGuestAlterExtraReservationTask;

RQService.Tasks.GuestChangeRoomDoNotDisturbStatus
    = RQImported.TasksGuestChangeRoomDoNotDisturbStatus;

RQService.Tasks.HandleCleaningStaffShiftEnd
    = RQImported.TasksHandleCleaningStaffShiftEnd;

RQService.Tasks.IssueRoomKey
    = RQImported.TasksIssueRoomKey;

RQService.Tasks.NewStaff
    = RQImported.TasksNewStaff;

RQService.Tasks.NotifyOutstandingCTMActivations
    = RQImported.TasksNotifyOutstandingCTMActivations;

RQService.Tasks.PopulateNotifyOutstandingCTMActivationsRow = function (row) {
    var entry = { };

    entry.HotelID  = row.HotelID;

    return entry;
};

RQService.Tasks.PumpAllMissingGuestMoveNotifications
    = RQImported.TasksPumpAllMissingGuestMoveNotifications;

RQService.Tasks.QuickCloseCleaningTask
    = RQImported.TasksQuickCloseCleaningTask;

RQService.Tasks.ReceptionChangeRoomDoNotDisturbStatus
    = RQImported.TasksReceptionChangeRoomDoNotDisturbStatus;

RQService.Tasks.ReturnRoomKey
    = RQImported.TasksReturnRoomKey;

RQService.Tasks.StaffMemberCheckAllItems
    = RQImported.TasksStaffMemberCheckAllItems;

RQService.Tasks.StaffMemberClearRoomBusyHint
    = RQImported.TasksStaffMemberClearRoomBusyHint;

RQService.Tasks.StaffMemberCloseCleaningTask
    = RQImported.TasksStaffMemberCloseCleaningTask;

RQService.Tasks.StaffMemberCloseExtraReservationTask
    = RQImported.TasksStaffMemberCloseExtraReservationTask;

RQService.Tasks.StaffMemberCloseTask
    = RQImported.TasksStaffMemberCloseTask;

RQService.Tasks.StaffMemberOpenCleaningTask
    = RQImported.TasksStaffMemberOpenCleaningTask;

RQService.Tasks.StaffMemberOpenExtraReservationTask
    = RQImported.TasksStaffMemberOpenExtraReservationTask;

RQService.Tasks.StaffMemberOpenTask
    = RQImported.TasksStaffMemberOpenTask;

RQService.Tasks.StaffMemberSetChecklistItemMissing
    = RQImported.TasksStaffMemberSetChecklistItemMissing;

RQService.Tasks.StaffMemberSetChecklistItemState
    = RQImported.TasksStaffMemberSetChecklistItemState;

RQService.Tasks.StaffMemberSetRoomBusyHint
    = RQImported.TasksStaffMemberSetRoomBusyHint;

RQService.Tasks.StaffMemberUncheckAllItems
    = RQImported.TasksStaffMemberUncheckAllItems;

RQService.Tasks.StaffMemberUndoCloseCleaningTask
    = RQImported.TasksStaffMemberUndoCloseCleaningTask;

RQService.Tasks.StaffMemberUndoCloseExtraReservationTask
    = RQImported.TasksStaffMemberUndoCloseExtraReservationTask;

RQService.Tasks.StaffMemberUndoCloseTask
    = RQImported.TasksStaffMemberUndoCloseTask;

RQService.Tasks.StaffMemberUndoOpenCleaningTask
    = RQImported.TasksStaffMemberUndoOpenCleaningTask;

RQService.Tasks.StaffMemberUndoOpenExtraReservationTask
    = RQImported.TasksStaffMemberUndoOpenExtraReservationTask;

RQService.Tasks.StaffMemberUndoOpenTask
    = RQImported.TasksStaffMemberUndoOpenTask;

RQService.Ota
    = { };

RQService.Ota.ActivateHotelAccountFromNearbyPlace
    = RQImported.OtaActivateHotelAccountFromNearbyPlace;

RQService.Ota.Addgplace
    = RQImported.OtaAddgplace;

RQService.Ota.AddGPlaceFromNearbyPlace
    = RQImported.OtaAddGPlaceFromNearbyPlace;

RQService.Ota.AddHotelDoc
    = RQImported.OtaAddHotelDoc;

RQService.Ota.AddHotelMap
    = RQImported.OtaAddHotelMap;

RQService.Ota.AddHotelPhoto
    = RQImported.OtaAddHotelPhoto;

RQService.Ota.AssignHotelPhotoToRoomType
    = RQImported.OtaAssignHotelPhotoToRoomType;

RQService.Ota.AssignHotelToChain
    = RQImported.OtaAssignHotelToChain;

RQService.Ota.BuildHotelRatings
    = RQImported.OtaBuildHotelRatings;

RQService.Ota.BuildSearchLocations
    = RQImported.OtaBuildSearchLocations;

RQService.Ota.CheckHotelConfig
    = RQImported.OtaCheckHotelConfig;

RQService.Ota.PopulateCheckHotelConfigRow = function (row) {
    var entry = { };

    entry.NoLastName             = row.NoLastName;
    entry.NoRoomTypes            = row.NoRoomTypes;
    entry.RoomTypesWithNoRates   = row.RoomTypesWithNoRates;
    entry.NoFutureRates          = row.NoFutureRates;
    entry.NoFacilities           = row.NoFacilities;
    entry.NoDescription          = row.NoDescription;
    entry.ShortDescription       = row.ShortDescription;
    entry.NoCancellationPolicy   = row.NoCancellationPolicy;
    entry.NoPictures             = row.NoPictures;
    entry.LessThanThreePictures  = row.LessThanThreePictures;
    entry.NoGeoCoords            = row.NoGeoCoords;

    return entry;
};

RQService.Ota.ClearSubPayPeriod
    = RQImported.OtaClearSubPayPeriod;

RQService.Ota.Corres_GetSelectedHotelCor
    = RQImported.OtaCorres_GetSelectedHotelCor;

RQService.Ota.PopulateCorres_GetSelectedHotelCorRow = function (row) {
    var entry = { };

    entry.CorrespondenceID  = row.CorrespondenceID;
    entry.HotelID           = row.HotelID;
    entry.EmployeeID        = row.EmployeeID;
    entry.Sender            = row.Sender;
    entry.Recipient         = row.Recipient;
    entry.CreationDateTime  = row.CreationDateTime;
    entry.Subject           = row.Subject;
    entry.Body              = row.Body;

    return entry;
};

RQService.Ota.CorresGetSelectedHotelCor
    = RQImported.OtaCorresGetSelectedHotelCor;

RQService.Ota.PopulateCorresGetSelectedHotelCorRow = function (row) {
    var entry = { };

    entry.CorrespondenceID  = row.CorrespondenceID;
    entry.HotelID           = row.HotelID;
    entry.EmployeeID        = row.EmployeeID;
    entry.Sender            = row.Sender;
    entry.Recipient         = row.Recipient;
    entry.CreationDateTime  = row.CreationDateTime;
    entry.Subject           = row.Subject;
    entry.Body              = row.Body;

    return entry;
};

RQService.Ota.CorresInsertCorrLetter
    = RQImported.OtaCorresInsertCorrLetter;

RQService.Ota.PopulateCorresInsertCorrLetterRow = function (row) {
    var entry = { };

    entry.CorrespondenceID  = row.CorrespondenceID;

    return entry;
};

RQService.Ota.DeleteHotelDoc
    = RQImported.OtaDeleteHotelDoc;

RQService.Ota.DeleteHotelMap
    = RQImported.OtaDeleteHotelMap;

RQService.Ota.DeleteHotelPhoto
    = RQImported.OtaDeleteHotelPhoto;

RQService.Ota.DeleteLocationGeoCode
    = RQImported.OtaDeleteLocationGeoCode;

RQService.Ota.EditHotelChainInfo
    = RQImported.OtaEditHotelChainInfo;

RQService.Ota.EditHotelChainPassword
    = RQImported.OtaEditHotelChainPassword;

RQService.Ota.EditHotelDescription
    = RQImported.OtaEditHotelDescription;

RQService.Ota.EditHotelDetails
    = RQImported.OtaEditHotelDetails;

RQService.Ota.EditHotelDocDescription
    = RQImported.OtaEditHotelDocDescription;

RQService.Ota.EditHotelEngineServiceTemplate
    = RQImported.OtaEditHotelEngineServiceTemplate;

RQService.Ota.EditHotelMapDescription
    = RQImported.OtaEditHotelMapDescription;

RQService.Ota.EditHotelPhotoDescription
    = RQImported.OtaEditHotelPhotoDescription;

RQService.Ota.EditHotelRouteDescription
    = RQImported.OtaEditHotelRouteDescription;

RQService.Ota.ExtractSearchLocationXML
    = RQImported.OtaExtractSearchLocationXML;

RQService.Ota.PopulateExtractSearchLocationXMLRow = function (row) {
    var entry = { };

    entry.SearchLocationXML  = row.SearchLocationXML;

    return entry;
};

RQService.Ota.FeedbackInsert
    = RQImported.OtaFeedbackInsert;

RQService.Ota.FinalizeGooglePromoSync
    = RQImported.OtaFinalizeGooglePromoSync;

RQService.Ota.FinalizeGooglePropertySync
    = RQImported.OtaFinalizeGooglePropertySync;

RQService.Ota.GetAccommodationStatuses
    = RQImported.OtaGetAccommodationStatuses;

RQService.Ota.PopulateGetAccommodationStatusesRow = function (row) {
    var entry = { };

    entry.PublishStatusID    = row.PublishStatusID;
    entry.LangID             = row.LangID;
    entry.PublishStatusName  = row.PublishStatusName;
    entry.Created            = row.Created;

    return entry;
};

RQService.Ota.GetAccommodationTypes
    = RQImported.OtaGetAccommodationTypes;

RQService.Ota.PopulateGetAccommodationTypesRow = function (row) {
    var entry = { };

    entry.AccommodationTypeID    = row.AccommodationTypeID;
    entry.AccommodationTypeName  = row.AccommodationTypeName;

    return entry;
};

RQService.Ota.GetActiveConcentricRun
    = RQImported.OtaGetActiveConcentricRun;

RQService.Ota.PopulateGetActiveConcentricRunRow = function (row) {
    var entry = { };

    entry.ConcentricRunID  = row.ConcentricRunID;
    entry.QueryID          = row.QueryID;
    entry.Lat              = row.Lat;
    entry.Lng              = row.Lng;
    entry.Started          = row.Started;
    entry.Created          = row.Created;

    return entry;
};

RQService.Ota.GetActiveConcentricSearch
    = RQImported.OtaGetActiveConcentricSearch;

RQService.Ota.PopulateGetActiveConcentricSearchRow = function (row) {
    var entry = { };

    entry.ConcentricRunID  = row.ConcentricRunID;
    entry.Keyword          = row.Keyword;
    entry.Lat              = row.Lat;
    entry.Lng              = row.Lng;
    entry.QueryCap         = row.QueryCap;
    entry.Created          = row.Created;

    return entry;
};

RQService.Ota.GetActiveCountries
    = RQImported.OtaGetActiveCountries;

RQService.Ota.PopulateGetActiveCountriesRow = function (row) {
    var entry = { };

    entry.CountryID       = row.CountryID;
    entry.ISOCode         = row.ISOCode;
    entry.InternetCode    = row.InternetCode;
    entry.Alpha3Code      = row.Alpha3Code;
    entry.CountryCode     = row.CountryCode;
    entry.LangID          = row.LangID;
    entry.Country         = row.Country;
    entry.CountryPName    = row.CountryPName;
    entry.CountryENPName  = row.CountryENPName;
    entry.Lat             = row.Lat;
    entry.Lng             = row.Lng;

    return entry;
};

RQService.Ota.GetAllHotelPhotosAndDescriptions
    = RQImported.OtaGetAllHotelPhotosAndDescriptions;

RQService.Ota.PopulateGetAllHotelPhotosAndDescriptionsRow = function (row) {
    var entry = { };

    entry.HotelID       = row.HotelID;
    entry.RoomTypeID    = row.RoomTypeID;
    entry.HotelPhotoID  = row.HotelPhotoID;
    entry.Filename      = row.Filename;
    entry.LangID        = row.LangID;
    entry.Description   = row.Description;
    entry.Verified      = row.Verified;
    entry.SortOrder     = row.SortOrder;

    return entry;
};

RQService.Ota.GetBNPartner
    = RQImported.OtaGetBNPartner;

RQService.Ota.PopulateGetBNPartnerRow = function (row) {
    var entry = { };

    entry.BNPartnerID    = row.BNPartnerID;
    entry.BNPartnerName  = row.BNPartnerName;
    entry.Endpoint       = row.Endpoint;
    entry.UserName       = row.UserName;
    entry.Password       = row.Password;
    entry.RequestID      = row.RequestID;

    return entry;
};

RQService.Ota.GetCCTypeNameByID
    = RQImported.OtaGetCCTypeNameByID;

RQService.Ota.PopulateGetCCTypeNameByIDRow = function (row) {
    var entry = { };

    entry.CCTypeName  = row.CCTypeName;

    return entry;
};

RQService.Ota.GetChainReservationList
    = RQImported.OtaGetChainReservationList;

RQService.Ota.PopulateGetChainReservationListRow = function (row) {
    var entry = { };

    entry.HotelID                        = row.HotelID;
    entry.ReservationID                  = row.ReservationID;
    entry.ExternalReservationID          = row.ExternalReservationID;
    entry.NumRoomRes                     = row.NumRoomRes;
    entry.FirstArr                       = row.FirstArr;
    entry.LastDep                        = row.LastDep;
    entry.RoomNumberList                 = row.RoomNumberList;
    entry.HasHoldUntil                   = row.HasHoldUntil;
    entry.FirstHoldUntil                 = row.FirstHoldUntil;
    entry.OwningGuestID                  = row.OwningGuestID;
    entry.Gender                         = row.Gender;
    entry.FullGuestName                  = row.FullGuestName;
    entry.Telephone                      = row.Telephone;
    entry.Mobile                         = row.Mobile;
    entry.Email                          = row.Email;
    entry.ReservationStatusID            = row.ReservationStatusID;
    entry.ReservationStatusName          = row.ReservationStatusName;
    entry.PaymentSchemeID                = row.PaymentSchemeID;
    entry.PaymentSchemeName              = row.PaymentSchemeName;
    entry.ServiceTotal                   = row.ServiceTotal;
    entry.SumRoomTotal                   = row.SumRoomTotal;
    entry.ReservationTotal               = row.ReservationTotal;
    entry.LetterSent                     = row.LetterSent;
    entry.NotePriorityLevel              = row.NotePriorityLevel;
    entry.Notes                          = row.Notes;
    entry.PriorityNotes                  = row.PriorityNotes;
    entry.HousekeepingNotes              = row.HousekeepingNotes;
    entry.KitchenNotes                   = row.KitchenNotes;
    entry.EngineGuestComments            = row.EngineGuestComments;
    entry.PartnerID                      = row.PartnerID;
    entry.Partner                        = row.Partner;
    entry.IsEngineRes                    = row.IsEngineRes;
    entry.IsChannelRes                   = row.IsChannelRes;
    entry.ThirdPartyCancelReceived       = row.ThirdPartyCancelReceived;
    entry.ResConfirmedToThirdParty       = row.ResConfirmedToThirdParty;
    entry.CancelConfirmedToThirdParty    = row.CancelConfirmedToThirdParty;
    entry.HasLocalPMSEdit                = row.HasLocalPMSEdit;
    entry.HasLocalPMSEditAlerted         = row.HasLocalPMSEditAlerted;
    entry.HasThirdPartyGroupBookingEdit  = row.HasThirdPartyGroupBookingEdit;
    entry.ThirdPartyEditFailure          = row.ThirdPartyEditFailure;
    entry.Created                        = row.Created;
    entry.Modified                       = row.Modified;
    entry.IsBroken                       = row.IsBroken;

    return entry;
};

RQService.Ota.GetCountryLocationsAll
    = RQImported.OtaGetCountryLocationsAll;

RQService.Ota.PopulateGetCountryLocationsAllRow = function (row) {
    var entry = { };

    entry.LocationGeoCodeID  = row.LocationGeoCodeID;
    entry.LangID             = row.LangID;
    entry.LocationName       = row.LocationName;
    entry.LocationPName      = row.LocationPName;
    entry.LocationENPName    = row.LocationENPName;
    entry.Lat                = row.Lat;
    entry.Lng                = row.Lng;
    entry.LocationTypeID     = row.LocationTypeID;
    entry.Counted            = row.Counted;

    return entry;
};

RQService.Ota.GetCountryNameByID
    = RQImported.OtaGetCountryNameByID;

RQService.Ota.PopulateGetCountryNameByIDRow = function (row) {
    var entry = { };

    entry.CountryName    = row.CountryName;
    entry.CountryNameEN  = row.CountryNameEN;

    return entry;
};

RQService.Ota.GetCurrencies
    = RQImported.OtaGetCurrencies;

RQService.Ota.PopulateGetCurrenciesRow = function (row) {
    var entry = { };

    entry.CurrencyID       = row.CurrencyID;
    entry.CountryID        = row.CountryID;
    entry.Symbol           = row.Symbol;
    entry.CurrencyLongEn   = row.CurrencyLongEn;
    entry.CurrencyShortEn  = row.CurrencyShortEn;
    entry.ExchangeRate     = row.ExchangeRate;
    entry.CurrencyName     = row.CurrencyName;

    return entry;
};

RQService.Ota.GetCurrencyByID
    = RQImported.OtaGetCurrencyByID;

RQService.Ota.PopulateGetCurrencyByIDRow = function (row) {
    var entry = { };

    entry.CurrencyID       = row.CurrencyID;
    entry.CountryID        = row.CountryID;
    entry.Symbol           = row.Symbol;
    entry.CurrencyLongEn   = row.CurrencyLongEn;
    entry.CurrencyShortEn  = row.CurrencyShortEn;
    entry.ExchangeRate     = row.ExchangeRate;
    entry.CurrencyName     = row.CurrencyName;

    return entry;
};

RQService.Ota.GetCustomerPasswordByGuest
    = RQImported.OtaGetCustomerPasswordByGuest;

RQService.Ota.PopulateGetCustomerPasswordByGuestRow = function (row) {
    var entry = { };

    entry.Password  = row.Password;

    return entry;
};

RQService.Ota.GetCustomerReviews
    = RQImported.OtaGetCustomerReviews;

RQService.Ota.PopulateGetCustomerReviewsRow = function (row) {
    var entry = { };

    entry.FeedbackID          = row.FeedbackID;
    entry.HotelID             = row.HotelID;
    entry.HotelName           = row.HotelName;
    entry.CustomerID          = row.CustomerID;
    entry.Cleanliness         = row.Cleanliness;
    entry.Facilities          = row.Facilities;
    entry.DisabledFriendly    = row.DisabledFriendly;
    entry.Service             = row.Service;
    entry.Location            = row.Location;
    entry.Pricing             = row.Pricing;
    entry.CommentsPositive    = row.CommentsPositive;
    entry.CommentsNegative    = row.CommentsNegative;
    entry.CommentsGeneral     = row.CommentsGeneral;
    entry.Name                = row.Name;
    entry.DateDiffDays        = row.DateDiffDays;
    entry.CreaDate            = row.CreaDate;
    entry.Country             = row.Country;
    entry.City                = row.City;
    entry.TravelPurposeID     = row.TravelPurposeID;
    entry.GuestCategoryID     = row.GuestCategoryID;
    entry.TravelPurposeLabel  = row.TravelPurposeLabel;
    entry.GuestCategoryLabel  = row.GuestCategoryLabel;
    entry.OverallRating       = row.OverallRating;

    return entry;
};

RQService.Ota.GetDocTypes
    = RQImported.OtaGetDocTypes;

RQService.Ota.PopulateGetDocTypesRow = function (row) {
    var entry = { };

    entry.DocTypeID        = row.DocTypeID;
    entry.DocType          = row.DocType;
    entry.TypeDescription  = row.TypeDescription;

    return entry;
};

RQService.Ota.GetGoogleHotels
    = RQImported.OtaGetGoogleHotels;

RQService.Ota.PopulateGetGoogleHotelsRow = function (row) {
    var entry = { };

    entry.HotelID            = row.HotelID;
    entry.HotelName          = row.HotelName;
    entry.Lat                = row.Lat;
    entry.Lng                = row.Lng;
    entry.PostCode           = row.PostCode;
    entry.PhoneICode         = row.PhoneICode;
    entry.PhoneNumber        = row.PhoneNumber;
    entry.Telephone          = row.Telephone;
    entry.Email              = row.Email;
    entry.EmailGeneral       = row.EmailGeneral;
    entry.EmailReservations  = row.EmailReservations;
    entry.Address            = row.Address;
    entry.LocationName       = row.LocationName;
    entry.LocationANameKey   = row.LocationANameKey;
    entry.Province           = row.Province;
    entry.Country            = row.Country;
    entry.CountryCode        = row.CountryCode;
    entry.CountryID          = row.CountryID;
    entry.InternetCode       = row.InternetCode;
    entry.ISOCode            = row.ISOCode;

    return entry;
};

RQService.Ota.GetGooglePropertyID
    = RQImported.OtaGetGooglePropertyID;

RQService.Ota.PopulateGetGooglePropertyIDRow = function (row) {
    var entry = { };

    entry.GooglePropertyID  = row.GooglePropertyID;

    return entry;
};

RQService.Ota.GetGuestCategories
    = RQImported.OtaGetGuestCategories;

RQService.Ota.PopulateGetGuestCategoriesRow = function (row) {
    var entry = { };

    entry.GuestCategoryID     = row.GuestCategoryID;
    entry.GuestCategoryLabel  = row.GuestCategoryLabel;

    return entry;
};

RQService.Ota.GetHotelByID
    = RQImported.OtaGetHotelByID;

RQService.Ota.PopulateGetHotelByIDRow = function (row) {
    var entry = { };

    entry.HotelID                     = row.HotelID;
    entry.Lat                         = row.Lat;
    entry.Lng                         = row.Lng;
    entry.Zoom                        = row.Zoom;
    entry.HotelName                   = row.HotelName;
    entry.City                        = row.City;
    entry.Address                     = row.Address;
    entry.Zip                         = row.Zip;
    entry.Description                 = row.Description;
    entry.DescriptionLangID           = row.DescriptionLangID;
    entry.DescriptionViaGoogle        = row.DescriptionViaGoogle;
    entry.Classification              = row.Classification;
    entry.IconFileName                = row.IconFileName;
    entry.LocationGeoCodeID           = row.LocationGeoCodeID;
    entry.AccommodationTypeID         = row.AccommodationTypeID;
    entry.AccommodationTypeName       = row.AccommodationTypeName;
    entry.HotelCurrencyID             = row.HotelCurrencyID;
    entry.HotelCurrencySymbol         = row.HotelCurrencySymbol;
    entry.HotelCurrencyShortEn        = row.HotelCurrencyShortEn;
    entry.RouteDescription            = row.RouteDescription;
    entry.Policies                    = row.Policies;
    entry.Lang                        = row.Lang;
    entry.CountryPName                = row.CountryPName;
    entry.CityPName                   = row.CityPName;
    entry.HotelPName                  = row.HotelPName;
    entry.EmailGeneral                = row.EmailGeneral;
    entry.Password                    = row.Password;
    entry.Telephone                   = row.Telephone;
    entry.CountryML                   = row.CountryML;
    entry.CityML                      = row.CityML;
    entry.CPGender                    = row.CPGender;
    entry.CPFirstName                 = row.CPFirstName;
    entry.CPLastName                  = row.CPLastName;
    entry.NrOfRooms                   = row.NrOfRooms;
    entry.GooglePromoSyncAttempts     = row.GooglePromoSyncAttempts;
    entry.GooglePromoSyncFailed       = row.GooglePromoSyncFailed;
    entry.GooglePropertyID            = row.GooglePropertyID;
    entry.GooglePropertySyncAttempts  = row.GooglePropertySyncAttempts;
    entry.GooglePropertySyncFailed    = row.GooglePropertySyncFailed;
    entry.GooglePropertySyncOngoing   = row.GooglePropertySyncOngoing;
    entry.IsGoogleHotel               = row.IsGoogleHotel;
    entry.IsRetrievedByGoogle         = row.IsRetrievedByGoogle;
    entry.NeedsGooglePromoSync        = row.NeedsGooglePromoSync;
    entry.NeedsGooglePropertySync     = row.NeedsGooglePropertySync;
    entry.MinNrofNightsWknd           = row.MinNrofNightsWknd;
    entry.LastLoggedIn                = row.LastLoggedIn;
    entry.FaxICode                    = row.FaxICode;
    entry.FaxNo                       = row.FaxNo;
    entry.IsEngineCustomer            = row.IsEngineCustomer;
    entry.IsFullCMUser                = row.IsFullCMUser;
    entry.NeedsConfigCacheSync        = row.NeedsConfigCacheSync;
    entry.Web                         = row.Web;
    entry.ServiceTypeID               = row.ServiceTypeID;
    entry.OtaPublishRequest           = row.OtaPublishRequest;
    entry.OtaPublish                  = row.OtaPublish;
    entry.PublishStatus               = row.PublishStatus;
    entry.DeriveRatesFromTobookCache  = row.DeriveRatesFromTobookCache;
    entry.HotelHasEngineTemplate      = row.HotelHasEngineTemplate;
    entry.PolicyCheckInHour           = row.PolicyCheckInHour;
    entry.PolicyCheckInMinute         = row.PolicyCheckInMinute;
    entry.PolicyCheckOutHour          = row.PolicyCheckOutHour;
    entry.PolicyCheckOutMinute        = row.PolicyCheckOutMinute;
    entry.HotelChainID                = row.HotelChainID;
    entry.ChainName                   = row.ChainName;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Ota.GetHotelChainHotelList
    = RQImported.OtaGetHotelChainHotelList;

RQService.Ota.PopulateGetHotelChainHotelListRow = function (row) {
    var entry = { };

    entry.HotelID    = row.HotelID;
    entry.HotelName  = row.HotelName;
    entry.Location   = row.Location;

    return entry;
};

RQService.Ota.GetHotelChainInfo
    = RQImported.OtaGetHotelChainInfo;

RQService.Ota.PopulateGetHotelChainInfoRow = function (row) {
    var entry = { };

    entry.HotelChainID       = row.HotelChainID;
    entry.ChainName          = row.ChainName;
    entry.ChainEmailGeneral  = row.ChainEmailGeneral;
    entry.ChainURL           = row.ChainURL;
    entry.ChainLogin         = row.ChainLogin;
    entry.CCPFirstName       = row.CCPFirstName;
    entry.CCPLastName        = row.CCPLastName;
    entry.CCPGender          = row.CCPGender;
    entry.CCPFunction        = row.CCPFunction;
    entry.CCPTelephone       = row.CCPTelephone;
    entry.CCPEmail           = row.CCPEmail;
    entry.CCPFax             = row.CCPFax;
    entry.ContractDate       = row.ContractDate;

    return entry;
};

RQService.Ota.GetHotelChainXMLProviders
    = RQImported.OtaGetHotelChainXMLProviders;

RQService.Ota.PopulateGetHotelChainXMLProvidersRow = function (row) {
    var entry = { };

    entry.HotelChainID  = row.HotelChainID;
    entry.ChainName     = row.ChainName;
    entry.ChainURL      = row.ChainURL;

    return entry;
};

RQService.Ota.GetHotelCPolicy
    = RQImported.OtaGetHotelCPolicy;

RQService.Ota.PopulateGetHotelCPolicyRow = function (row) {
    var entry = { };

    entry.CPolicyText  = row.CPolicyText;

    return entry;
};

RQService.Ota.GetHotelCPolicyFreeUntil
    = RQImported.OtaGetHotelCPolicyFreeUntil;

RQService.Ota.PopulateGetHotelCPolicyFreeUntilRow = function (row) {
    var entry = { };

    entry.HasFreeCancellation  = row.HasFreeCancellation;
    entry.ThreshloldDay        = row.ThreshloldDay;
    entry.ThresholdHour        = row.ThresholdHour;

    return entry;
};

RQService.Ota.GetHotelDescriptions
    = RQImported.OtaGetHotelDescriptions;

RQService.Ota.PopulateGetHotelDescriptionsRow = function (row) {
    var entry = { };

    entry.LangID            = row.LangID;
    entry.Description       = row.Description;
    entry.RouteDescription  = row.RouteDescription;

    return entry;
};

RQService.Ota.GetHotelDetails
    = RQImported.OtaGetHotelDetails;

RQService.Ota.PopulateGetHotelDetailsRow = function (row) {
    var entry = { };

    entry.CPFirstName        = row.CPFirstName;
    entry.CPLastName         = row.CPLastName;
    entry.CPGender           = row.CPGender;
    entry.Telephone          = row.Telephone;
    entry.Fax                = row.Fax;
    entry.EmailGeneral       = row.EmailGeneral;
    entry.EmailReservations  = row.EmailReservations;
    entry.Web                = row.Web;
    entry.CurrencyID         = row.CurrencyID;
    entry.NrOfRooms          = row.NrOfRooms;

    return entry;
};

RQService.Ota.GetHotelDiscountSettingsStatus
    = RQImported.OtaGetHotelDiscountSettingsStatus;

RQService.Ota.PopulateGetHotelDiscountSettingsStatusRow = function (row) {
    var entry = { };

    entry.HasEntry               = row.HasEntry;
    entry.CanSetAutoNonRef       = row.CanSetAutoNonRef;
    entry.CanSetMemberOnly       = row.CanSetMemberOnly;
    entry.CanSetAutoEarlyBird    = row.CanSetAutoEarlyBird;
    entry.CanSetAutoWalkIn       = row.CanSetAutoWalkIn;
    entry.AllowAutoNonRef        = row.AllowAutoNonRef;
    entry.AllowAutoMemberOnly    = row.AllowAutoMemberOnly;
    entry.AllowAutoLastMintue    = row.AllowAutoLastMintue;
    entry.AllowAutoEarlyBird     = row.AllowAutoEarlyBird;
    entry.AllowAutoWalkIn        = row.AllowAutoWalkIn;
    entry.NonRefDiscount         = row.NonRefDiscount;
    entry.NonRefByCM             = row.NonRefByCM;
    entry.MemberOnlyDiscount     = row.MemberOnlyDiscount;
    entry.LastMinuteDiscount     = row.LastMinuteDiscount;
    entry.LastMinuteAvThreshold  = row.LastMinuteAvThreshold;
    entry.EarlyBirdDiscount      = row.EarlyBirdDiscount;
    entry.EarlyBirdAdvanceDays   = row.EarlyBirdAdvanceDays;
    entry.WalkInDiscount         = row.WalkInDiscount;
    entry.WalkInIsNonRef         = row.WalkInIsNonRef;

    return entry;
};

RQService.Ota.GetHotelDistanceFromCenter
    = RQImported.OtaGetHotelDistanceFromCenter;

RQService.Ota.PopulateGetHotelDistanceFromCenterRow = function (row) {
    var entry = { };

    entry.Distance  = row.Distance;

    return entry;
};

RQService.Ota.GetHotelDocs
    = RQImported.OtaGetHotelDocs;

RQService.Ota.PopulateGetHotelDocsRow = function (row) {
    var entry = { };

    entry.HotelID       = row.HotelID;
    entry.DocID         = row.DocID;
    entry.LangID        = row.LangID;
    entry.DocTypeID     = row.DocTypeID;
    entry.Filename      = row.Filename;
    entry.Description   = row.Description;
    entry.DocSortOrder  = row.DocSortOrder;

    return entry;
};

RQService.Ota.GetHotelEngineServiceTemplateSettings
    = RQImported.OtaGetHotelEngineServiceTemplateSettings;

RQService.Ota.PopulateGetHotelEngineServiceTemplateSettingsRow = function (row) {
    var entry = { };

    entry.HotelID                        = row.HotelID;
    entry.WithFontFamily                 = row.WithFontFamily;
    entry.WithDefaultButtonOverride      = row.WithDefaultButtonOverride;
    entry.WithInfoButtonOverride         = row.WithInfoButtonOverride;
    entry.WithSuccessButtonOverride      = row.WithSuccessButtonOverride;
    entry.WithWarningButtonOverride      = row.WithWarningButtonOverride;
    entry.WithDangerButtonOverride       = row.WithDangerButtonOverride;
    entry.WithOutlineInfoButtonOverride  = row.WithOutlineInfoButtonOverride;
    entry.FontFamily                     = row.FontFamily;
    entry.Background                     = row.Background;
    entry.MainText                       = row.MainText;
    entry.MutedText                      = row.MutedText;
    entry.DescriptionText                = row.DescriptionText;
    entry.MenuItemTickUnckecked          = row.MenuItemTickUnckecked;
    entry.ActionOK                       = row.ActionOK;
    entry.ActionWithNote                 = row.ActionWithNote;
    entry.DeleteAndWarning               = row.DeleteAndWarning;
    entry.SignInDividerBackground        = row.SignInDividerBackground;
    entry.SignInDividerText              = row.SignInDividerText;
    entry.SearchAndCartBackground        = row.SearchAndCartBackground;
    entry.SearchAndCartDivider           = row.SearchAndCartDivider;
    entry.SearchAndCartTitle             = row.SearchAndCartTitle;
    entry.DropdownBackground             = row.DropdownBackground;
    entry.CartSummaryBackground          = row.CartSummaryBackground;
    entry.CartSummaryBorder              = row.CartSummaryBorder;
    entry.OfferSelectedBackground        = row.OfferSelectedBackground;
    entry.OfferSelectedBorder            = row.OfferSelectedBorder;
    entry.UtilityLinkText                = row.UtilityLinkText;
    entry.ButtonDisabledBackground       = row.ButtonDisabledBackground;
    entry.ButtonDisabledBorder           = row.ButtonDisabledBorder;
    entry.ButtonDisabledText             = row.ButtonDisabledText;
    entry.DefaultButtonText              = row.DefaultButtonText;
    entry.DefaultButtonBackground        = row.DefaultButtonBackground;
    entry.DefaultButtonBackgroundHover   = row.DefaultButtonBackgroundHover;
    entry.DefaultButtonBorderHover       = row.DefaultButtonBorderHover;
    entry.DefaultButtonShadowRGB         = row.DefaultButtonShadowRGB;
    entry.DefaultButtonBorderActive      = row.DefaultButtonBorderActive;
    entry.InfoButtonText                 = row.InfoButtonText;
    entry.InfoButtonBackground           = row.InfoButtonBackground;
    entry.InfoButtonBackgroundHover      = row.InfoButtonBackgroundHover;
    entry.InfoButtonBorderHover          = row.InfoButtonBorderHover;
    entry.InfoButtonShadowRGB            = row.InfoButtonShadowRGB;
    entry.InfoButtonBorderActive         = row.InfoButtonBorderActive;
    entry.SuccessButtonText              = row.SuccessButtonText;
    entry.SuccessButtonBackground        = row.SuccessButtonBackground;
    entry.SuccessButtonBackgroundHover   = row.SuccessButtonBackgroundHover;
    entry.SuccessButtonBorderHover       = row.SuccessButtonBorderHover;
    entry.SuccessButtonShadowRGB         = row.SuccessButtonShadowRGB;
    entry.SuccessButtonBorderActive      = row.SuccessButtonBorderActive;
    entry.WarningButtonText              = row.WarningButtonText;
    entry.WarningButtonBackground        = row.WarningButtonBackground;
    entry.WarningButtonBackgroundHover   = row.WarningButtonBackgroundHover;
    entry.WarningButtonBorderHover       = row.WarningButtonBorderHover;
    entry.WarningButtonShadowRGB         = row.WarningButtonShadowRGB;
    entry.WarningButtonBorderActive      = row.WarningButtonBorderActive;
    entry.DangerButtonText               = row.DangerButtonText;
    entry.DangerButtonBackground         = row.DangerButtonBackground;
    entry.DangerButtonBackgroundHover    = row.DangerButtonBackgroundHover;
    entry.DangerButtonBorderHover        = row.DangerButtonBorderHover;
    entry.DangerButtonShadowRGB          = row.DangerButtonShadowRGB;
    entry.DangerButtonBorderActive       = row.DangerButtonBorderActive;
    entry.InfoOutlineButtonContent       = row.InfoOutlineButtonContent;
    entry.InfoOutlineButtonBackground    = row.InfoOutlineButtonBackground;
    entry.InfoOutlineButtonShadowRGB     = row.InfoOutlineButtonShadowRGB;

    return entry;
};

RQService.Ota.GetHotelFacilities
    = RQImported.OtaGetHotelFacilities;

RQService.Ota.PopulateGetHotelFacilitiesRow = function (row) {
    var entry = { };

    entry.FacilityID       = row.FacilityID;
    entry.Facility         = row.Facility;
    entry.FacilityGroupID  = row.FacilityGroupID;
    entry.Priority         = row.Priority;
    entry.FacilityIcon     = row.FacilityIcon;

    return entry;
};

RQService.Ota.GetHotelFacilitiesAll
    = RQImported.OtaGetHotelFacilitiesAll;

RQService.Ota.PopulateGetHotelFacilitiesAllRow = function (row) {
    var entry = { };

    entry.FacilityID       = row.FacilityID;
    entry.Facility         = row.Facility;
    entry.FacilityGroupID  = row.FacilityGroupID;
    entry.Priority         = row.Priority;
    entry.FacilityIcon     = row.FacilityIcon;
    entry.IsChecked        = row.IsChecked;

    return entry;
};

RQService.Ota.GetHotelFeedback
    = RQImported.OtaGetHotelFeedback;

RQService.Ota.PopulateGetHotelFeedbackRow = function (row) {
    var entry = { };

    entry.FeedbackID          = row.FeedbackID;
    entry.CustomerID          = row.CustomerID;
    entry.Cleanliness         = row.Cleanliness;
    entry.Facilities          = row.Facilities;
    entry.DisabledFriendly    = row.DisabledFriendly;
    entry.Service             = row.Service;
    entry.Location            = row.Location;
    entry.Pricing             = row.Pricing;
    entry.CommentsPositive    = row.CommentsPositive;
    entry.CommentsNegative    = row.CommentsNegative;
    entry.CommentsGeneral     = row.CommentsGeneral;
    entry.Name                = row.Name;
    entry.DateDiffDays        = row.DateDiffDays;
    entry.CreaDate            = row.CreaDate;
    entry.Country             = row.Country;
    entry.City                = row.City;
    entry.TravelPurposeLabel  = row.TravelPurposeLabel;
    entry.GuestCategoryLabel  = row.GuestCategoryLabel;
    entry.OverallRating       = row.OverallRating;
    entry.RankingSortKey      = row.RankingSortKey;

    return entry;
};

RQService.Ota.GetHotelInfo
    = RQImported.OtaGetHotelInfo;

RQService.Ota.PopulateGetHotelInfoRow = function (row) {
    var entry = { };

    entry.HotelID                     = row.HotelID;
    entry.Lat                         = row.Lat;
    entry.Lng                         = row.Lng;
    entry.Zoom                        = row.Zoom;
    entry.HotelName                   = row.HotelName;
    entry.City                        = row.City;
    entry.Address                     = row.Address;
    entry.Zip                         = row.Zip;
    entry.Description                 = row.Description;
    entry.DescriptionLangID           = row.DescriptionLangID;
    entry.DescriptionViaGoogle        = row.DescriptionViaGoogle;
    entry.Classification              = row.Classification;
    entry.IconFileName                = row.IconFileName;
    entry.LocationGeoCodeID           = row.LocationGeoCodeID;
    entry.AccommodationTypeID         = row.AccommodationTypeID;
    entry.AccommodationTypeName       = row.AccommodationTypeName;
    entry.HotelCurrencyID             = row.HotelCurrencyID;
    entry.HotelCurrencySymbol         = row.HotelCurrencySymbol;
    entry.HotelCurrencyShortEn        = row.HotelCurrencyShortEn;
    entry.RouteDescription            = row.RouteDescription;
    entry.Policies                    = row.Policies;
    entry.Lang                        = row.Lang;
    entry.CountryPName                = row.CountryPName;
    entry.CityPName                   = row.CityPName;
    entry.HotelPName                  = row.HotelPName;
    entry.EmailGeneral                = row.EmailGeneral;
    entry.Telephone                   = row.Telephone;
    entry.CountryML                   = row.CountryML;
    entry.CityML                      = row.CityML;
    entry.ServiceTypeID               = row.ServiceTypeID;
    entry.OtaPublishRequest           = row.OtaPublishRequest;
    entry.OtaPublish                  = row.OtaPublish;
    entry.PublishStatus               = row.PublishStatus;
    entry.DeriveRatesFromTobookCache  = row.DeriveRatesFromTobookCache;
    entry.HotelHasEngineTemplate      = row.HotelHasEngineTemplate;
    entry.PolicyCheckInHour           = row.PolicyCheckInHour;
    entry.PolicyCheckInMinute         = row.PolicyCheckInMinute;
    entry.PolicyCheckOutHour          = row.PolicyCheckOutHour;
    entry.PolicyCheckOutMinute        = row.PolicyCheckOutMinute;
    entry.EnginePartnerID             = row.EnginePartnerID;
    entry.PMSActive                   = row.PMSActive;
    entry.PMSAPIKey                   = row.PMSAPIKey;
    entry.IsNearbyActivation          = row.IsNearbyActivation;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Ota.GetHotelMemberDiscountPeriods
    = RQImported.OtaGetHotelMemberDiscountPeriods;

RQService.Ota.PopulateGetHotelMemberDiscountPeriodsRow = function (row) {
    var entry = { };

    entry.PromotionID         = row.PromotionID;
    entry.OfferTypeID         = row.OfferTypeID;
    entry.DiscountPercentage  = row.DiscountPercentage;
    entry.FromDate            = row.FromDate;
    entry.ToDate              = row.ToDate;

    return entry;
};

RQService.Ota.GetHotelPassword
    = RQImported.OtaGetHotelPassword;

RQService.Ota.PopulateGetHotelPasswordRow = function (row) {
    var entry = { };

    entry.Password  = row.Password;

    return entry;
};

RQService.Ota.GetHotelPhotos
    = RQImported.OtaGetHotelPhotos;

RQService.Ota.PopulateGetHotelPhotosRow = function (row) {
    var entry = { };

    entry.HotelID            = row.HotelID;
    entry.RoomTypeID         = row.RoomTypeID;
    entry.HotelPhotoID       = row.HotelPhotoID;
    entry.Filename           = row.Filename;
    entry.Description        = row.Description;
    entry.RoomTypeSortOrder  = row.RoomTypeSortOrder;
    entry.PhotoSortOrder     = row.PhotoSortOrder;

    return entry;
};

RQService.Ota.GetHotelPolicies
    = RQImported.OtaGetHotelPolicies;

RQService.Ota.PopulateGetHotelPoliciesRow = function (row) {
    var entry = { };

    entry.GroupID      = row.GroupID;
    entry.SentenceID   = row.SentenceID;
    entry.Description  = row.Description;

    return entry;
};

RQService.Ota.GetHotelRating
    = RQImported.OtaGetHotelRating;

RQService.Ota.PopulateGetHotelRatingRow = function (row) {
    var entry = { };

    entry.HotelID     = row.HotelID;
    entry.NumReviews  = row.NumReviews;
    entry.Rating      = row.Rating;

    return entry;
};

RQService.Ota.GetHotelReservationsEmail
    = RQImported.OtaGetHotelReservationsEmail;

RQService.Ota.PopulateGetHotelReservationsEmailRow = function (row) {
    var entry = { };

    entry.EmailFound          = row.EmailFound;
    entry.ReservationsEmail   = row.ReservationsEmail;
    entry.ReceiveOTAResMails  = row.ReceiveOTAResMails;

    return entry;
};

RQService.Ota.GetHotelsNeedingDiscountSettingsNotif
    = RQImported.OtaGetHotelsNeedingDiscountSettingsNotif;

RQService.Ota.PopulateGetHotelsNeedingDiscountSettingsNotifRow = function (row) {
    var entry = { };

    entry.HotelID  = row.HotelID;

    return entry;
};

RQService.Ota.GetHotelsNeedingGooglePromoSync
    = RQImported.OtaGetHotelsNeedingGooglePromoSync;

RQService.Ota.PopulateGetHotelsNeedingGooglePromoSyncRow = function (row) {
    var entry = { };

    entry.HotelID  = row.HotelID;

    return entry;
};

RQService.Ota.GetHotelsNeedingGooglePropertySync
    = RQImported.OtaGetHotelsNeedingGooglePropertySync;

RQService.Ota.PopulateGetHotelsNeedingGooglePropertySyncRow = function (row) {
    var entry = { };

    entry.HotelID  = row.HotelID;

    return entry;
};

RQService.Ota.GetHotelsNeedingSpotlightSettingsNotif
    = RQImported.OtaGetHotelsNeedingSpotlightSettingsNotif;

RQService.Ota.PopulateGetHotelsNeedingSpotlightSettingsNotifRow = function (row) {
    var entry = { };

    entry.HotelID  = row.HotelID;

    return entry;
};

RQService.Ota.GetHotelSpotlightDiscounts
    = RQImported.OtaGetHotelSpotlightDiscounts;

RQService.Ota.PopulateGetHotelSpotlightDiscountsRow = function (row) {
    var entry = { };

    entry.HasEntry            = row.HasEntry;
    entry.LastMinuteDiscount  = row.LastMinuteDiscount;
    entry.GeneralDiscount     = row.GeneralDiscount;
    entry.EarlyBirdDiscount   = row.EarlyBirdDiscount;
    entry.Updated             = row.Updated;

    return entry;
};

RQService.Ota.GetHotelSpotlightPriceStatus
    = RQImported.OtaGetHotelSpotlightPriceStatus;

RQService.Ota.PopulateGetHotelSpotlightPriceStatusRow = function (row) {
    var entry = { };

    entry.HasEntry             = row.HasEntry;
    entry.AllowSpotlightPrice  = row.AllowSpotlightPrice;

    return entry;
};

RQService.Ota.GetHotelsWithGoogleSyncFailure
    = RQImported.OtaGetHotelsWithGoogleSyncFailure;

RQService.Ota.PopulateGetHotelsWithGoogleSyncFailureRow = function (row) {
    var entry = { };

    entry.HotelID  = row.HotelID;

    return entry;
};

RQService.Ota.GetHotelXMLProvider
    = RQImported.OtaGetHotelXMLProvider;

RQService.Ota.PopulateGetHotelXMLProviderRow = function (row) {
    var entry = { };

    entry.HotelChainID  = row.HotelChainID;
    entry.ChainName     = row.ChainName;
    entry.ChainURL      = row.ChainURL;

    return entry;
};

RQService.Ota.GetLocationGeoCode
    = RQImported.OtaGetLocationGeoCode;

RQService.Ota.PopulateGetLocationGeoCodeRow = function (row) {
    var entry = { };

    entry.LocationGeoCodeID   = row.LocationGeoCodeID;
    entry.Country             = row.Country;
    entry.LocationName        = row.LocationName;
    entry.ParentGeoCodeID     = row.ParentGeoCodeID;
    entry.ParentLocationName  = row.ParentLocationName;

    return entry;
};

RQService.Ota.GetLocationGeoCodeDetails
    = RQImported.OtaGetLocationGeoCodeDetails;

RQService.Ota.PopulateGetLocationGeoCodeDetailsRow = function (row) {
    var entry = { };

    entry.LocationGeoCodeID  = row.LocationGeoCodeID;
    entry.LocationName       = row.LocationName;
    entry.GeoName            = row.GeoName;
    entry.Country            = row.Country;
    entry.Lat                = row.Lat;
    entry.Lng                = row.Lng;
    entry.CoordsUnknown      = row.CoordsUnknown;
    entry.Zoom               = row.Zoom;
    entry.WOEID              = row.WOEID;
    entry.Radius             = row.Radius;
    entry.Verified           = row.Verified;
    entry.LocationPName      = row.LocationPName;
    entry.CountryPName       = row.CountryPName;

    return entry;
};

RQService.Ota.GetLocationGeoCodeIDFromGPlaceID
    = RQImported.OtaGetLocationGeoCodeIDFromGPlaceID;

RQService.Ota.PopulateGetLocationGeoCodeIDFromGPlaceIDRow = function (row) {
    var entry = { };

    entry.LocationGeoCodeID  = row.LocationGeoCodeID;

    return entry;
};

RQService.Ota.GetLocationsByNameFragment
    = RQImported.OtaGetLocationsByNameFragment;

RQService.Ota.PopulateGetLocationsByNameFragmentRow = function (row) {
    var entry = { };

    entry.CountryID          = row.CountryID;
    entry.Countryname        = row.Countryname;
    entry.name               = row.name;
    entry.LocationGeoCodeID  = row.LocationGeoCodeID;

    return entry;
};

RQService.Ota.GetLocationsHotels
    = RQImported.OtaGetLocationsHotels;

RQService.Ota.PopulateGetLocationsHotelsRow = function (row) {
    var entry = { };

    entry.HotelID                = row.HotelID;
    entry.HotelName              = row.HotelName;
    entry.HotelPName             = row.HotelPName;
    entry.AccommodationTypeID    = row.AccommodationTypeID;
    entry.AccommodationType      = row.AccommodationType;
    entry.AccommodationTypeName  = row.AccommodationTypeName;
    entry.NrOfRooms              = row.NrOfRooms;
    entry.Classification         = row.Classification;
    entry.Lat                    = row.Lat;
    entry.Lng                    = row.Lng;
    entry.Address                = row.Address;
    entry.PhoneICode             = row.PhoneICode;
    entry.PhoneNumber            = row.PhoneNumber;
    entry.Email                  = row.Email;
    entry.Web                    = row.Web;
    entry.Active                 = row.Active;
    entry.Publish                = row.Publish;
    entry.OtaPublish             = row.OtaPublish;
    entry.IsEngineCustomer       = row.IsEngineCustomer;
    entry.ServiceTypeID          = row.ServiceTypeID;

    return entry;
};

RQService.Ota.GetLocationVAT
    = RQImported.OtaGetLocationVAT;

RQService.Ota.PopulateGetLocationVATRow = function (row) {
    var entry = { };

    entry.VAT  = row.VAT;

    return entry;
};

RQService.Ota.GetMatchingHotels
    = RQImported.OtaGetMatchingHotels;

RQService.Ota.PopulateGetMatchingHotelsRow = function (row) {
    var entry = { };

    entry.HotelID                     = row.HotelID;
    entry.Lat                         = row.Lat;
    entry.Lng                         = row.Lng;
    entry.Zoom                        = row.Zoom;
    entry.HotelName                   = row.HotelName;
    entry.City                        = row.City;
    entry.Address                     = row.Address;
    entry.Zip                         = row.Zip;
    entry.Description                 = row.Description;
    entry.DescriptionLangID           = row.DescriptionLangID;
    entry.DescriptionViaGoogle        = row.DescriptionViaGoogle;
    entry.Classification              = row.Classification;
    entry.IconFileName                = row.IconFileName;
    entry.LocationGeoCodeID           = row.LocationGeoCodeID;
    entry.AccommodationTypeID         = row.AccommodationTypeID;
    entry.AccommodationTypeName       = row.AccommodationTypeName;
    entry.HotelCurrencyID             = row.HotelCurrencyID;
    entry.HotelCurrencySymbol         = row.HotelCurrencySymbol;
    entry.HotelCurrencyShortEn        = row.HotelCurrencyShortEn;
    entry.RouteDescription            = row.RouteDescription;
    entry.Policies                    = row.Policies;
    entry.Lang                        = row.Lang;
    entry.CountryPName                = row.CountryPName;
    entry.CityPName                   = row.CityPName;
    entry.HotelPName                  = row.HotelPName;
    entry.EmailGeneral                = row.EmailGeneral;
    entry.Password                    = row.Password;
    entry.Telephone                   = row.Telephone;
    entry.CountryML                   = row.CountryML;
    entry.CityML                      = row.CityML;
    entry.ServiceTypeID               = row.ServiceTypeID;
    entry.OtaPublishRequest           = row.OtaPublishRequest;
    entry.OtaPublish                  = row.OtaPublish;
    entry.PublishStatus               = row.PublishStatus;
    entry.DeriveRatesFromTobookCache  = row.DeriveRatesFromTobookCache;
    entry.HotelHasEngineTemplate      = row.HotelHasEngineTemplate;
    entry.PolicyCheckInHour           = row.PolicyCheckInHour;
    entry.PolicyCheckInMinute         = row.PolicyCheckInMinute;
    entry.PolicyCheckOutHour          = row.PolicyCheckOutHour;
    entry.PolicyCheckOutMinute        = row.PolicyCheckOutMinute;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Ota.GetMLSearchLocations
    = RQImported.OtaGetMLSearchLocations;

RQService.Ota.PopulateGetMLSearchLocationsRow = function (row) {
    var entry = { };

    entry.LangID            = row.LangID;
    entry.SearchLocationID  = row.SearchLocationID;

    return entry;
};

RQService.Ota.GetNearbyPlaceDetails
    = RQImported.OtaGetNearbyPlaceDetails;

RQService.Ota.PopulateGetNearbyPlaceDetailsRow = function (row) {
    var entry = { };

    entry.GPlaceID                  = row.GPlaceID;
    entry.FromSearchLat             = row.FromSearchLat;
    entry.FromSearchLng             = row.FromSearchLng;
    entry.Lat                       = row.Lat;
    entry.Lng                       = row.Lng;
    entry.Name                      = row.Name;
    entry.Rating                    = row.Rating;
    entry.UserRatingsTotal          = row.UserRatingsTotal;
    entry.Vicinity                  = row.Vicinity;
    entry.BusinessStatus            = row.BusinessStatus;
    entry.Country                   = row.Country;
    entry.CountryShort              = row.CountryShort;
    entry.Region                    = row.Region;
    entry.Locality                  = row.Locality;
    entry.PostCode                  = row.PostCode;
    entry.FormattedAddress          = row.FormattedAddress;
    entry.FormattedPhoneNumber      = row.FormattedPhoneNumber;
    entry.InternationalPhoneNumber  = row.InternationalPhoneNumber;
    entry.WebSite                   = row.WebSite;
    entry.Email                     = row.Email;
    entry.EmailExtracted            = row.EmailExtracted;
    entry.HotelID                   = row.HotelID;

    return entry;
};

RQService.Ota.GetNearbyPlacesNeedingEmail
    = RQImported.OtaGetNearbyPlacesNeedingEmail;

RQService.Ota.PopulateGetNearbyPlacesNeedingEmailRow = function (row) {
    var entry = { };

    entry.GPlaceID  = row.GPlaceID;
    entry.WebSite   = row.WebSite;

    return entry;
};

RQService.Ota.GetNewUnpublishedHotels
    = RQImported.OtaGetNewUnpublishedHotels;

RQService.Ota.PopulateGetNewUnpublishedHotelsRow = function (row) {
    var entry = { };

    entry.HotelID                     = row.HotelID;
    entry.Lat                         = row.Lat;
    entry.Lng                         = row.Lng;
    entry.Zoom                        = row.Zoom;
    entry.HotelName                   = row.HotelName;
    entry.City                        = row.City;
    entry.Address                     = row.Address;
    entry.Zip                         = row.Zip;
    entry.Description                 = row.Description;
    entry.DescriptionLangID           = row.DescriptionLangID;
    entry.DescriptionViaGoogle        = row.DescriptionViaGoogle;
    entry.Classification              = row.Classification;
    entry.IconFileName                = row.IconFileName;
    entry.LocationGeoCodeID           = row.LocationGeoCodeID;
    entry.AccommodationTypeID         = row.AccommodationTypeID;
    entry.AccommodationTypeName       = row.AccommodationTypeName;
    entry.HotelCurrencyID             = row.HotelCurrencyID;
    entry.HotelCurrencySymbol         = row.HotelCurrencySymbol;
    entry.HotelCurrencyShortEn        = row.HotelCurrencyShortEn;
    entry.RouteDescription            = row.RouteDescription;
    entry.Policies                    = row.Policies;
    entry.Lang                        = row.Lang;
    entry.CountryPName                = row.CountryPName;
    entry.CityPName                   = row.CityPName;
    entry.HotelPName                  = row.HotelPName;
    entry.EmailGeneral                = row.EmailGeneral;
    entry.Password                    = row.Password;
    entry.Telephone                   = row.Telephone;
    entry.CountryML                   = row.CountryML;
    entry.CityML                      = row.CityML;
    entry.ServiceTypeID               = row.ServiceTypeID;
    entry.OtaPublishRequest           = row.OtaPublishRequest;
    entry.OtaPublish                  = row.OtaPublish;
    entry.PublishStatus               = row.PublishStatus;
    entry.DeriveRatesFromTobookCache  = row.DeriveRatesFromTobookCache;
    entry.HotelHasEngineTemplate      = row.HotelHasEngineTemplate;
    entry.PolicyCheckInHour           = row.PolicyCheckInHour;
    entry.PolicyCheckInMinute         = row.PolicyCheckInMinute;
    entry.PolicyCheckOutHour          = row.PolicyCheckOutHour;
    entry.PolicyCheckOutMinute        = row.PolicyCheckOutMinute;
    entry.Created                     = row.Created;

    return entry;
};

RQService.Ota.GetOfferTypeDetails
    = RQImported.OtaGetOfferTypeDetails;

RQService.Ota.PopulateGetOfferTypeDetailsRow = function (row) {
    var entry = { };

    entry.PaymentSchemeID           = row.PaymentSchemeID;
    entry.OfferTypeName             = row.OfferTypeName;
    entry.OfferTypeNameEN           = row.OfferTypeNameEN;
    entry.PaymentSchemeNameShort    = row.PaymentSchemeNameShort;
    entry.PaymentSchemeNameShortEN  = row.PaymentSchemeNameShortEN;
    entry.MaxPersonsRateName        = row.MaxPersonsRateName;
    entry.MaxPersonsRateNameEN      = row.MaxPersonsRateNameEN;
    entry.IsWalkIn                  = row.IsWalkIn;

    return entry;
};

RQService.Ota.GetOutstandingGoogleScheduleItems
    = RQImported.OtaGetOutstandingGoogleScheduleItems;

RQService.Ota.PopulateGetOutstandingGoogleScheduleItemsRow = function (row) {
    var entry = { };

    entry.HotelID                  = row.HotelID;
    entry.ActionID                 = row.ActionID;
    entry.GoogleEntityID           = row.GoogleEntityID;
    entry.GoogleBaseURI            = row.GoogleBaseURI;
    entry.LowestHeadlinePriceDate  = row.LowestHeadlinePriceDate;
    entry.Attempts                 = row.Attempts;
    entry.LastRun                  = row.LastRun;
    entry.Created                  = row.Created;

    return entry;
};

RQService.Ota.GetPasswordCustomer
    = RQImported.OtaGetPasswordCustomer;

RQService.Ota.GetPasswordHotel
    = RQImported.OtaGetPasswordHotel;

RQService.Ota.GetPhotosByHotelID
    = RQImported.OtaGetPhotosByHotelID;

RQService.Ota.PopulateGetPhotosByHotelIDRow = function (row) {
    var entry = { };

    entry.Filename     = row.Filename;
    entry.FileChecked  = row.FileChecked;
    entry.Verified     = row.Verified;

    return entry;
};

RQService.Ota.GetRegisteredProperty
    = RQImported.OtaGetRegisteredProperty;

RQService.Ota.PopulateGetRegisteredPropertyRow = function (row) {
    var entry = { };

    entry.HotelID                    = row.HotelID;
    entry.CPFirstName                = row.CPFirstName;
    entry.CPLastName                 = row.CPLastName;
    entry.CPGender                   = row.CPGender;
    entry.Telephone                  = row.Telephone;
    entry.Fax                        = row.Fax;
    entry.EmailGeneral               = row.EmailGeneral;
    entry.EmailReservations          = row.EmailReservations;
    entry.Web                        = row.Web;
    entry.CurrencyID                 = row.CurrencyID;
    entry.NrOfRooms                  = row.NrOfRooms;
    entry.LocationNameKey            = row.LocationNameKey;
    entry.LocationGeoCodeID          = row.LocationGeoCodeID;
    entry.RegisteredLocationGeoCode  = row.RegisteredLocationGeoCode;
    entry.RegisteredCity             = row.RegisteredCity;
    entry.CountryID                  = row.CountryID;
    entry.CountryPName               = row.CountryPName;
    entry.GPlaceID                   = row.GPlaceID;
    entry.Lat                        = row.Lat;
    entry.Lng                        = row.Lng;
    entry.locality                   = row.locality;
    entry.sublocality                = row.sublocality;
    entry.ColloquialArea             = row.ColloquialArea;
    entry.neighborhood               = row.neighborhood;
    entry.premise                    = row.premise;
    entry.NaturalFeature             = row.NaturalFeature;
    entry.airport                    = row.airport;
    entry.park                       = row.park;
    entry.PointOfInterest            = row.PointOfInterest;
    entry.ADML1                      = row.ADML1;
    entry.ADML2                      = row.ADML2;
    entry.ADML3                      = row.ADML3;
    entry.ADML4                      = row.ADML4;
    entry.ADML5                      = row.ADML5;
    entry.Creadate                   = row.Creadate;

    return entry;
};

RQService.Ota.GetRoomTypeDeletionWarningInHotelNativeLang
    = RQImported.OtaGetRoomTypeDeletionWarningInHotelNativeLang;

RQService.Ota.PopulateGetRoomTypeDeletionWarningInHotelNativeLangRow = function (row) {
    var entry = { };

    entry.DeletionWarningNative  = row.DeletionWarningNative;

    return entry;
};

RQService.Ota.GetRoomTypeNames
    = RQImported.OtaGetRoomTypeNames;

RQService.Ota.PopulateGetRoomTypeNamesRow = function (row) {
    var entry = { };

    entry.RoomTypeID      = row.RoomTypeID;
    entry.RoomTypeName    = row.RoomTypeName;
    entry.RoomTypeNameEN  = row.RoomTypeNameEN;

    return entry;
};

RQService.Ota.GetRoomTypeNamesAll
    = RQImported.OtaGetRoomTypeNamesAll;

RQService.Ota.PopulateGetRoomTypeNamesAllRow = function (row) {
    var entry = { };

    entry.RoomTypeID      = row.RoomTypeID;
    entry.LangID          = row.LangID;
    entry.LangISOCode     = row.LangISOCode;
    entry.RoomTypeName    = row.RoomTypeName;
    entry.RoomTypeNameEN  = row.RoomTypeNameEN;

    return entry;
};

RQService.Ota.GetRoomTypePhotoDescriptionsAll
    = RQImported.OtaGetRoomTypePhotoDescriptionsAll;

RQService.Ota.PopulateGetRoomTypePhotoDescriptionsAllRow = function (row) {
    var entry = { };

    entry.HotelID       = row.HotelID;
    entry.RoomTypeID    = row.RoomTypeID;
    entry.HotelPhotoID  = row.HotelPhotoID;
    entry.Filename      = row.Filename;
    entry.LangID        = row.LangID;
    entry.LangISOCode   = row.LangISOCode;
    entry.Description   = row.Description;

    return entry;
};

RQService.Ota.GetRoomTypePhotos
    = RQImported.OtaGetRoomTypePhotos;

RQService.Ota.PopulateGetRoomTypePhotosRow = function (row) {
    var entry = { };

    entry.HotelID       = row.HotelID;
    entry.RoomTypeID    = row.RoomTypeID;
    entry.HotelPhotoID  = row.HotelPhotoID;
    entry.Filename      = row.Filename;
    entry.Description   = row.Description;

    return entry;
};

RQService.Ota.GetRoomTypesCM
    = RQImported.OtaGetRoomTypesCM;

RQService.Ota.PopulateGetRoomTypesCMRow = function (row) {
    var entry = { };

    entry.RoomTypeID  = row.RoomTypeID;
    entry.RoomType    = row.RoomType;

    return entry;
};

RQService.Ota.GetSearchLocationsByNameFragment
    = RQImported.OtaGetSearchLocationsByNameFragment;

RQService.Ota.PopulateGetSearchLocationsByNameFragmentRow = function (row) {
    var entry = { };

    entry.CountryID         = row.CountryID;
    entry.Country           = row.Country;
    entry.name              = row.name;
    entry.SearchLocationID  = row.SearchLocationID;

    return entry;
};

RQService.Ota.GetStripePaymentStatus
    = RQImported.OtaGetStripePaymentStatus;

RQService.Ota.PopulateGetStripePaymentStatusRow = function (row) {
    var entry = { };

    entry.StripePaymentStatus  = row.StripePaymentStatus;

    return entry;
};

RQService.Ota.GetSubPayPeriods
    = RQImported.OtaGetSubPayPeriods;

RQService.Ota.PopulateGetSubPayPeriodsRow = function (row) {
    var entry = { };

    entry.HotelID          = row.HotelID;
    entry.PeriodYear       = row.PeriodYear;
    entry.PeriodMonth      = row.PeriodMonth;
    entry.ResReceived      = row.ResReceived;
    entry.NeedsPayment     = row.NeedsPayment;
    entry.PaymentRecieved  = row.PaymentRecieved;
    entry.StripeID         = row.StripeID;
    entry.Amount           = row.Amount;

    return entry;
};

RQService.Ota.GetTopGPlaceNeedingTranslation
    = RQImported.OtaGetTopGPlaceNeedingTranslation;

RQService.Ota.PopulateGetTopGPlaceNeedingTranslationRow = function (row) {
    var entry = { };

    entry.GPlaceID  = row.GPlaceID;
    entry.LangID    = row.LangID;

    return entry;
};

RQService.Ota.GetTopLocationGeoCodeForSearchLocID
    = RQImported.OtaGetTopLocationGeoCodeForSearchLocID;

RQService.Ota.PopulateGetTopLocationGeoCodeForSearchLocIDRow = function (row) {
    var entry = { };

    entry.LocationGeoCodeID  = row.LocationGeoCodeID;
    entry.LocationNameKey    = row.LocationNameKey;
    entry.LocationPNameKey   = row.LocationPNameKey;

    return entry;
};

RQService.Ota.GetTopSearchLocIDForLocationGeoCode
    = RQImported.OtaGetTopSearchLocIDForLocationGeoCode;

RQService.Ota.PopulateGetTopSearchLocIDForLocationGeoCodeRow = function (row) {
    var entry = { };

    entry.TopSearchLocID    = row.TopSearchLocID;
    entry.TopSearchLocName  = row.TopSearchLocName;

    return entry;
};

RQService.Ota.GetTravelPurposes
    = RQImported.OtaGetTravelPurposes;

RQService.Ota.PopulateGetTravelPurposesRow = function (row) {
    var entry = { };

    entry.TravelPurposeID     = row.TravelPurposeID;
    entry.TravelPurposeLabel  = row.TravelPurposeLabel;

    return entry;
};

RQService.Ota.GetUnverifiedLocationGeoCodeHotels
    = RQImported.OtaGetUnverifiedLocationGeoCodeHotels;

RQService.Ota.PopulateGetUnverifiedLocationGeoCodeHotelsRow = function (row) {
    var entry = { };

    entry.LocationGeoCodeID  = row.LocationGeoCodeID;
    entry.HotelID            = row.HotelID;
    entry.OtaPublish         = row.OtaPublish;

    return entry;
};

RQService.Ota.GetUnverifiedLocationGeoCodes
    = RQImported.OtaGetUnverifiedLocationGeoCodes;

RQService.Ota.PopulateGetUnverifiedLocationGeoCodesRow = function (row) {
    var entry = { };

    entry.LocationGeoCodeID  = row.LocationGeoCodeID;
    entry.CountryID          = row.CountryID;
    entry.CountryPName       = row.CountryPName;
    entry.Lat                = row.Lat;
    entry.Lng                = row.Lng;
    entry.Verified           = row.Verified;
    entry.ManualEntered      = row.ManualEntered;
    entry.Created            = row.Created;
    entry.LocationNameKey    = row.LocationNameKey;
    entry.NumLangEntries     = row.NumLangEntries;

    return entry;
};

RQService.Ota.GrantOrGetPMSAPIKey
    = RQImported.OtaGrantOrGetPMSAPIKey;

RQService.Ota.PopulateGrantOrGetPMSAPIKeyRow = function (row) {
    var entry = { };

    entry.APIKey  = row.APIKey;

    return entry;
};

RQService.Ota.HotelBelongsToChain
    = RQImported.OtaHotelBelongsToChain;

RQService.Ota.PopulateHotelBelongsToChainRow = function (row) {
    var entry = { };

    entry.HotelBelongsToChain  = row.HotelBelongsToChain;

    return entry;
};

RQService.Ota.HotelHasEngineTemplate
    = RQImported.OtaHotelHasEngineTemplate;

RQService.Ota.PopulateHotelHasEngineTemplateRow = function (row) {
    var entry = { };

    entry.HotelHasEngineTemplate  = row.HotelHasEngineTemplate;

    return entry;
};

RQService.Ota.HotelHasXMLProvider
    = RQImported.OtaHotelHasXMLProvider;

RQService.Ota.PopulateHotelHasXMLProviderRow = function (row) {
    var entry = { };

    entry.IsXMLHotel  = row.IsXMLHotel;

    return entry;
};

RQService.Ota.HotelNeedsDiscountSettingsAction
    = RQImported.OtaHotelNeedsDiscountSettingsAction;

RQService.Ota.PopulateHotelNeedsDiscountSettingsActionRow = function (row) {
    var entry = { };

    entry.HotelNeedsDiscountSettingsAction  = row.HotelNeedsDiscountSettingsAction;

    return entry;
};

RQService.Ota.IncrementBNPartnerRequestID
    = RQImported.OtaIncrementBNPartnerRequestID;

RQService.Ota.InitGooglePromoSync
    = RQImported.OtaInitGooglePromoSync;

RQService.Ota.InitGoogleProperySync
    = RQImported.OtaInitGoogleProperySync;

RQService.Ota.LogCMRequest
    = RQImported.OtaLogCMRequest;

RQService.Ota.MakeOTAPublishRequest
    = RQImported.OtaMakeOTAPublishRequest;

RQService.Ota.MarkConcentricRunQueryAsDone
    = RQImported.OtaMarkConcentricRunQueryAsDone;

RQService.Ota.MarkHotelAsRetrievedByGoogle
    = RQImported.OtaMarkHotelAsRetrievedByGoogle;

RQService.Ota.MarkReservationFromGoogle
    = RQImported.OtaMarkReservationFromGoogle;

RQService.Ota.mlGetAllLocationGeoCodeNames
    = RQImported.OtamlGetAllLocationGeoCodeNames;

RQService.Ota.PopulatemlGetAllLocationGeoCodeNamesRow = function (row) {
    var entry = { };

    entry.LangID         = row.LangID;
    entry.Country        = row.Country;
    entry.CountryPName   = row.CountryPName;
    entry.LocationName   = row.LocationName;
    entry.LocationPName  = row.LocationPName;

    return entry;
};

RQService.Ota.mlGetAllSearchLocationNames
    = RQImported.OtamlGetAllSearchLocationNames;

RQService.Ota.PopulatemlGetAllSearchLocationNamesRow = function (row) {
    var entry = { };

    entry.LangID         = row.LangID;
    entry.Country        = row.Country;
    entry.CountryPName   = row.CountryPName;
    entry.LocationName   = row.LocationName;
    entry.LocationPName  = row.LocationPName;

    return entry;
};

RQService.Ota.mlGetGuestCategory
    = RQImported.OtamlGetGuestCategory;

RQService.Ota.PopulatemlGetGuestCategoryRow = function (row) {
    var entry = { };

    entry.GuestCategoryLabelID  = row.GuestCategoryLabelID;
    entry.GuestCategoryID       = row.GuestCategoryID;
    entry.LangID                = row.LangID;
    entry.GuestCategoryLabel    = row.GuestCategoryLabel;
    entry.CreaDate              = row.CreaDate;

    return entry;
};

RQService.Ota.mlGetTravelPurposes
    = RQImported.OtamlGetTravelPurposes;

RQService.Ota.PopulatemlGetTravelPurposesRow = function (row) {
    var entry = { };

    entry.TravelPurposeLabelID  = row.TravelPurposeLabelID;
    entry.TravelPurposeID       = row.TravelPurposeID;
    entry.LangID                = row.LangID;
    entry.TravelPurposeLabel    = row.TravelPurposeLabel;
    entry.CreaDate              = row.CreaDate;

    return entry;
};

RQService.Ota.NewRegisterHotel
    = RQImported.OtaNewRegisterHotel;

RQService.Ota.NewRegisterHotelCheck
    = RQImported.OtaNewRegisterHotelCheck;

RQService.Ota.NewStripePayment
    = RQImported.OtaNewStripePayment;

RQService.Ota.NotifyDiscountSettingsChange
    = RQImported.OtaNotifyDiscountSettingsChange;

RQService.Ota.NotifyNewHotelChainAssignments
    = RQImported.OtaNotifyNewHotelChainAssignments;

RQService.Ota.PopulateNotifyNewHotelChainAssignmentsRow = function (row) {
    var entry = { };

    entry.HotelID            = row.HotelID;
    entry.HotelChainID       = row.HotelChainID;
    entry.HotelName          = row.HotelName;
    entry.HotelEmailGeneral  = row.HotelEmailGeneral;
    entry.LocationName       = row.LocationName;
    entry.Address            = row.Address;
    entry.ChainName          = row.ChainName;
    entry.ChainEmailGeneral  = row.ChainEmailGeneral;
    entry.ChainURL           = row.ChainURL;
    entry.AssignedWhen       = row.AssignedWhen;

    return entry;
};

RQService.Ota.NotifyOutstandingPMSActivations
    = RQImported.OtaNotifyOutstandingPMSActivations;

RQService.Ota.PopulateNotifyOutstandingPMSActivationsRow = function (row) {
    var entry = { };

    entry.HotelID  = row.HotelID;

    return entry;
};

RQService.Ota.NotifySpotlightSettingsChange
    = RQImported.OtaNotifySpotlightSettingsChange;

RQService.Ota.NudgeHotelDocSortOrder
    = RQImported.OtaNudgeHotelDocSortOrder;

RQService.Ota.NudgeHotelMapsSortOrder
    = RQImported.OtaNudgeHotelMapsSortOrder;

RQService.Ota.NudgeHotelPhotoSortOrder
    = RQImported.OtaNudgeHotelPhotoSortOrder;

RQService.Ota.PopulateGooglePriceSchdeule
    = RQImported.OtaPopulateGooglePriceSchdeule;

RQService.Ota.PopulateUnverifiedLocationGeoCodeNames
    = RQImported.OtaPopulateUnverifiedLocationGeoCodeNames;

RQService.Ota.PropagateCancellationToStardeck
    = RQImported.OtaPropagateCancellationToStardeck;

RQService.Ota.PropagateReservationToStardeck
    = RQImported.OtaPropagateReservationToStardeck;

RQService.Ota.PropagateRoomCancellationToStardeck
    = RQImported.OtaPropagateRoomCancellationToStardeck;

RQService.Ota.PublishHotel
    = RQImported.OtaPublishHotel;

RQService.Ota.QuestionaireIns
    = RQImported.OtaQuestionaireIns;

RQService.Ota.RecordGooglePriceCheckAttempt
    = RQImported.OtaRecordGooglePriceCheckAttempt;

RQService.Ota.RecordGooglePriceCheckResult
    = RQImported.OtaRecordGooglePriceCheckResult;

RQService.Ota.RegisterHotelDocFileName
    = RQImported.OtaRegisterHotelDocFileName;

RQService.Ota.RegisterHotelMapFileName
    = RQImported.OtaRegisterHotelMapFileName;

RQService.Ota.RegisterHotelPhotoFileName
    = RQImported.OtaRegisterHotelPhotoFileName;

RQService.Ota.RegisterWebException
    = RQImported.OtaRegisterWebException;

RQService.Ota.PopulateRegisterWebExceptionRow = function (row) {
    var entry = { };

    entry.WebExceptionID  = row.WebExceptionID;

    return entry;
};

RQService.Ota.RegisterWebExceptionExtended
    = RQImported.OtaRegisterWebExceptionExtended;

RQService.Ota.PopulateRegisterWebExceptionExtendedRow = function (row) {
    var entry = { };

    entry.WebExceptionID  = row.WebExceptionID;

    return entry;
};

RQService.Ota.ResetHotelOTAConfirmations
    = RQImported.OtaResetHotelOTAConfirmations;

RQService.Ota.SaveHotelDescriptionViaGoogle
    = RQImported.OtaSaveHotelDescriptionViaGoogle;

RQService.Ota.SelectMaps
    = RQImported.OtaSelectMaps;

RQService.Ota.PopulateSelectMapsRow = function (row) {
    var entry = { };

    entry.HotelID      = row.HotelID;
    entry.HotelMapID   = row.HotelMapID;
    entry.Filename     = row.Filename;
    entry.Description  = row.Description;
    entry.SortOrder    = row.SortOrder;
    entry.CreaDate     = row.CreaDate;

    return entry;
};

RQService.Ota.SetHotelDiscountSettingsStatus
    = RQImported.OtaSetHotelDiscountSettingsStatus;

RQService.Ota.SetHotelSpotlightPriceStatus
    = RQImported.OtaSetHotelSpotlightPriceStatus;

RQService.Ota.StoreNearbyPlacePhoto
    = RQImported.OtaStoreNearbyPlacePhoto;

RQService.Ota.StoreNearbyPlaceResult
    = RQImported.OtaStoreNearbyPlaceResult;

RQService.Ota.UnpublishHotel
    = RQImported.OtaUnpublishHotel;

RQService.Ota.UpdateFacility
    = RQImported.OtaUpdateFacility;

RQService.Ota.UpdateGPlaceMLNameCollection
    = RQImported.OtaUpdateGPlaceMLNameCollection;

RQService.Ota.UpdateNearbyPlacesEmail
    = RQImported.OtaUpdateNearbyPlacesEmail;

RQService.Ota.UpdateStripePaymentStatus
    = RQImported.OtaUpdateStripePaymentStatus;

RQService.Ota.UpdateViaCM
    = RQImported.OtaUpdateViaCM;

RQService.Ota.VerifyGoogleTranslateLimit
    = RQImported.OtaVerifyGoogleTranslateLimit;

RQService.Ota.PopulateVerifyGoogleTranslateLimitRow = function (row) {
    var entry = { };

    entry.DailyLimitReached  = row.DailyLimitReached;

    return entry;
};

RQService.Ota.VerifyLocationGeoCode
    = RQImported.OtaVerifyLocationGeoCode;

RQService.Ota.VerifyNearbyPlaceActivationStatus
    = RQImported.OtaVerifyNearbyPlaceActivationStatus;

RQService.Glocal
    = { };

RQService.Glocal.AddGlocalGeoLocation
    = RQImported.GlocalAddGlocalGeoLocation;

RQService.Glocal.AddUserLanguage
    = RQImported.GlocalAddUserLanguage;

RQService.Glocal.AddUserPhoto
    = RQImported.GlocalAddUserPhoto;

RQService.Glocal.AddUserProfilePicture
    = RQImported.GlocalAddUserProfilePicture;

RQService.Glocal.AlertGlocalSignUp
    = RQImported.GlocalAlertGlocalSignUp;

RQService.Glocal.DeleteUserPicture
    = RQImported.GlocalDeleteUserPicture;

RQService.Glocal.EditGlocalDetails
    = RQImported.GlocalEditGlocalDetails;

RQService.Glocal.EditUserPictureDescription
    = RQImported.GlocalEditUserPictureDescription;

RQService.Glocal.GetEventsByLocationGeoCodeID
    = RQImported.GlocalGetEventsByLocationGeoCodeID;

RQService.Glocal.PopulateGetEventsByLocationGeoCodeIDRow = function (row) {
    var entry = { };

    entry.EventID                 = row.EventID;
    entry.GuideCategoryID         = row.GuideCategoryID;
    entry.GuideCategoryNameEn     = row.GuideCategoryNameEn;
    entry.GuideCategoryName       = row.GuideCategoryName;
    entry.GuideCategoryPName      = row.GuideCategoryPName;
    entry.TitleEn                 = row.TitleEn;
    entry.DescriptionEn           = row.DescriptionEn;
    entry.Title                   = row.Title;
    entry.Description             = row.Description;
    entry.Description2            = row.Description2;
    entry.Picture1Title           = row.Picture1Title;
    entry.Picture2Title           = row.Picture2Title;
    entry.Picture1                = row.Picture1;
    entry.Picture2                = row.Picture2;
    entry.LocationNameKey         = row.LocationNameKey;
    entry.LocationPNameKey        = row.LocationPNameKey;
    entry.Annual                  = row.Annual;
    entry.StartDate               = row.StartDate;
    entry.EndDate                 = row.EndDate;
    entry.GuidePresentationOrder  = row.GuidePresentationOrder;
    entry.EventPresentationOrder  = row.EventPresentationOrder;
    entry.SortOrder               = row.SortOrder;

    return entry;
};

RQService.Glocal.GetGlocalDetails
    = RQImported.GlocalGetGlocalDetails;

RQService.Glocal.PopulateGetGlocalDetailsRow = function (row) {
    var entry = { };

    entry.CustomerID        = row.CustomerID;
    entry.GeoLocationID     = row.GeoLocationID;
    entry.DisplayName       = row.DisplayName;
    entry.IdentityVerified  = row.IdentityVerified;
    entry.Reviews           = row.Reviews;
    entry.Created           = row.Created;

    return entry;
};

RQService.Glocal.GetGlocalGeoLocations
    = RQImported.GlocalGetGlocalGeoLocations;

RQService.Glocal.PopulateGetGlocalGeoLocationsRow = function (row) {
    var entry = { };

    entry.GeoLocationID     = row.GeoLocationID;
    entry.LocationNameKey   = row.LocationNameKey;
    entry.LocationPNameKey  = row.LocationPNameKey;
    entry.Created           = row.Created;

    return entry;
};

RQService.Glocal.GetGlocalLanguagesByLocationGeoCodeID
    = RQImported.GlocalGetGlocalLanguagesByLocationGeoCodeID;

RQService.Glocal.PopulateGetGlocalLanguagesByLocationGeoCodeIDRow = function (row) {
    var entry = { };

    entry.HotelID      = row.HotelID;
    entry.CustomerID   = row.CustomerID;
    entry.LangID       = row.LangID;
    entry.Language     = row.Language;
    entry.LangISOCode  = row.LangISOCode;
    entry.Icon         = row.Icon;

    return entry;
};

RQService.Glocal.GetGlocalLanguagesBySearchLocation
    = RQImported.GlocalGetGlocalLanguagesBySearchLocation;

RQService.Glocal.PopulateGetGlocalLanguagesBySearchLocationRow = function (row) {
    var entry = { };

    entry.HotelID      = row.HotelID;
    entry.CustomerID   = row.CustomerID;
    entry.LangID       = row.LangID;
    entry.Language     = row.Language;
    entry.LangISOCode  = row.LangISOCode;
    entry.Icon         = row.Icon;

    return entry;
};

RQService.Glocal.GetGlocalsByLocationGeoCodeID
    = RQImported.GlocalGetGlocalsByLocationGeoCodeID;

RQService.Glocal.PopulateGetGlocalsByLocationGeoCodeIDRow = function (row) {
    var entry = { };

    entry.HotelID        = row.HotelID;
    entry.CustomerID     = row.CustomerID;
    entry.GeoLocationID  = row.GeoLocationID;
    entry.DisplayName    = row.DisplayName;
    entry.FirstName      = row.FirstName;
    entry.LastName       = row.LastName;
    entry.NumReviews     = row.NumReviews;
    entry.PictureID      = row.PictureID;
    entry.FileName       = row.FileName;
    entry.Label          = row.Label;
    entry.Description    = row.Description;
    entry.PictureRated   = row.PictureRated;
    entry.PictureViewed  = row.PictureViewed;
    entry.PictureShared  = row.PictureShared;
    entry.Created        = row.Created;

    return entry;
};

RQService.Glocal.GetGlocalsBySearchLocation
    = RQImported.GlocalGetGlocalsBySearchLocation;

RQService.Glocal.PopulateGetGlocalsBySearchLocationRow = function (row) {
    var entry = { };

    entry.HotelID        = row.HotelID;
    entry.CustomerID     = row.CustomerID;
    entry.GeoLocationID  = row.GeoLocationID;
    entry.DisplayName    = row.DisplayName;
    entry.FirstName      = row.FirstName;
    entry.LastName       = row.LastName;
    entry.NumReviews     = row.NumReviews;
    entry.PictureID      = row.PictureID;
    entry.FileName       = row.FileName;
    entry.Label          = row.Label;
    entry.Description    = row.Description;
    entry.PictureRated   = row.PictureRated;
    entry.PictureViewed  = row.PictureViewed;
    entry.PictureShared  = row.PictureShared;
    entry.Created        = row.Created;

    return entry;
};

RQService.Glocal.GetMessages
    = RQImported.GlocalGetMessages;

RQService.Glocal.PopulateGetMessagesRow = function (row) {
    var entry = { };

    entry.HotelID     = row.HotelID;
    entry.CustomerID  = row.CustomerID;
    entry.MessageID   = row.MessageID;
    entry.AmSender    = row.AmSender;
    entry.FirstName   = row.FirstName;
    entry.LastName    = row.LastName;
    entry.Message     = row.Message;
    entry.Alerted     = row.Alerted;
    entry.Created     = row.Created;

    return entry;
};

RQService.Glocal.GetNumUnreadMessages
    = RQImported.GlocalGetNumUnreadMessages;

RQService.Glocal.PopulateGetNumUnreadMessagesRow = function (row) {
    var entry = { };

    entry.NumUnreadMessages  = row.NumUnreadMessages;

    return entry;
};

RQService.Glocal.GetSpokenLanguages
    = RQImported.GlocalGetSpokenLanguages;

RQService.Glocal.PopulateGetSpokenLanguagesRow = function (row) {
    var entry = { };

    entry.LangID       = row.LangID;
    entry.Language     = row.Language;
    entry.LangISOCode  = row.LangISOCode;
    entry.Icon         = row.Icon;

    return entry;
};

RQService.Glocal.GetUnalertedGlocalSignUps
    = RQImported.GlocalGetUnalertedGlocalSignUps;

RQService.Glocal.PopulateGetUnalertedGlocalSignUpsRow = function (row) {
    var entry = { };

    entry.HotelID     = row.HotelID;
    entry.CustomerID  = row.CustomerID;
    entry.FirstName   = row.FirstName;
    entry.LastName    = row.LastName;
    entry.Email       = row.Email;

    return entry;
};

RQService.Glocal.GetUnalertedUserMessages
    = RQImported.GlocalGetUnalertedUserMessages;

RQService.Glocal.PopulateGetUnalertedUserMessagesRow = function (row) {
    var entry = { };

    entry.HotelID     = row.HotelID;
    entry.CustomerID  = row.CustomerID;
    entry.FirstName   = row.FirstName;
    entry.LastName    = row.LastName;
    entry.Email       = row.Email;

    return entry;
};

RQService.Glocal.GetUserInterests
    = RQImported.GlocalGetUserInterests;

RQService.Glocal.PopulateGetUserInterestsRow = function (row) {
    var entry = { };

    entry.InterestID           = row.InterestID;
    entry.InterestDescription  = row.InterestDescription;
    entry.Icon                 = row.Icon;

    return entry;
};

RQService.Glocal.GetUserInterestsByUser
    = RQImported.GlocalGetUserInterestsByUser;

RQService.Glocal.PopulateGetUserInterestsByUserRow = function (row) {
    var entry = { };

    entry.InterestID           = row.InterestID;
    entry.InterestDescription  = row.InterestDescription;
    entry.Icon                 = row.Icon;

    return entry;
};

RQService.Glocal.GetUserLanguages
    = RQImported.GlocalGetUserLanguages;

RQService.Glocal.PopulateGetUserLanguagesRow = function (row) {
    var entry = { };

    entry.HotelID      = row.HotelID;
    entry.CustomerID   = row.CustomerID;
    entry.LangID       = row.LangID;
    entry.Language     = row.Language;
    entry.LangISOCode  = row.LangISOCode;
    entry.Icon         = row.Icon;

    return entry;
};

RQService.Glocal.GetUserPictures
    = RQImported.GlocalGetUserPictures;

RQService.Glocal.PopulateGetUserPicturesRow = function (row) {
    var entry = { };

    entry.HotelID           = row.HotelID;
    entry.CustomerID        = row.CustomerID;
    entry.PictureID         = row.PictureID;
    entry.FileName          = row.FileName;
    entry.Label             = row.Label;
    entry.Description       = row.Description;
    entry.IsProfilePicture  = row.IsProfilePicture;
    entry.PictureRated      = row.PictureRated;
    entry.PictureViewed     = row.PictureViewed;
    entry.PictureShared     = row.PictureShared;
    entry.SortOrder         = row.SortOrder;
    entry.Expired           = row.Expired;
    entry.Created           = row.Created;

    return entry;
};

RQService.Glocal.IndicateProfilePicture
    = RQImported.GlocalIndicateProfilePicture;

RQService.Glocal.IndicateUserInterest
    = RQImported.GlocalIndicateUserInterest;

RQService.Glocal.MarkMessagesAsRead
    = RQImported.GlocalMarkMessagesAsRead;

RQService.Glocal.MarkMessagesAsReadByUser
    = RQImported.GlocalMarkMessagesAsReadByUser;

RQService.Glocal.MessageGlocal
    = RQImported.GlocalMessageGlocal;

RQService.Glocal.RegisterGlocal
    = RQImported.GlocalRegisterGlocal;

RQService.Glocal.RegisterUserPhotoFileName
    = RQImported.GlocalRegisterUserPhotoFileName;

RQService.Glocal.RemoveGlocalGeoLocation
    = RQImported.GlocalRemoveGlocalGeoLocation;

RQService.Glocal.RemoveUserLanguage
    = RQImported.GlocalRemoveUserLanguage;

RQService.Glocal.UnregisterGlocal
    = RQImported.GlocalUnregisterGlocal;



//////////////////
// WEBPACK FOOTER
// ./src/RQuery/RQueryRESTStdMethodBindings.js
// module id = 404
// module chunks = 0